// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud-IAM API
 * This is a Kakao Cloud IAM service API.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface DomainTokenEndpoint {
  id?: string;
  interface?: string;
  region?: string;
  region_id?: string;
  url?: string;
}
export interface DomainTokenLinks {
  next?: string;
  previous?: string;
  self?: string;
}
export interface DomainTokenRes {
  'OS-TRUST:trust'?: DomainTokenResOSTrust;
  application_credential?: DomainTokenResApplicationCredential;
  audit_ids?: Array<string>;
  catalog?: Array<DomainTokenResCatalog>;
  domain?: DomainTokenResDomain;
  expires_at?: string;
  is_domain?: boolean;
  issued_at?: string;
  methods?: Array<string>;
  project?: DomainTokenResProject;
  roles?: Array<DomainTokenResRole>;
  system?: DomainTokenResSystem;
  user?: DomainTokenResUser;
}
export interface DomainTokenResApplicationCredential {
  access_rules?: Array<GithubKakaoenterpriseInCloudPlatformCloudIamGoDomainAccessRule>;
  description?: string;
  expires_at?: string;
  id?: string;
  links?: DomainTokenLinks;
  name?: string;
  project_id?: string;
  restricted?: boolean;
  roles?: Array<DomainTokenResRole>;
  secret?: string;
  unrestricted?: boolean;
  user_id?: string;
}
export interface DomainTokenResCatalog {
  endpoints?: Array<DomainTokenEndpoint>;
  id?: string;
  name?: string;
  type?: string;
}
export interface DomainTokenResDomain {
  id?: string;
  name?: string;
}
export interface DomainTokenResOSTrust {
  id?: string;
  impersonation?: boolean;
  links?: DomainTokenLinks;
  trustee_user?: DomainTokenTrustUser;
  trustor_user?: DomainTokenTrustUser;
}
export interface DomainTokenResProject {
  domain?: DomainTokenResDomain;
  id?: string;
  name?: string;
}
export interface DomainTokenResRole {
  description?: string;
  domain_id?: string;
  id?: string;
  name?: string;
}
export interface DomainTokenResSystem {
  all?: boolean;
}
export interface DomainTokenResUser {
  domain?: DomainTokenResDomain;
  domain_id?: string;
  id?: string;
  name?: string;
  /**
   * internal use only
   */
  password?: string;
  password_expires_at?: string;
}
export interface DomainTokenTrustUser {
  id?: string;
  links?: DomainTokenLinks;
}
export interface GithubKakaoenterpriseInCloudPlatformCloudIamGoDomainAccessRule {
  id?: string;
  method?: string;
  path?: string;
  service?: string;
}
export interface RequestAccessGrantedIp {
  ip: string;
  label: string;
}
export interface RequestAccessGrantedIpCreateRequest {
  access_granted_ips: Array<RequestAccessGrantedIp>;
}
export interface RequestAddConsentRequest {
  agreement_version_id: string;
  api_id: string;
}
export interface RequestAddUserToGroupsRequest {
  group_ids: Array<string>;
}
export interface RequestAdminAssignmentCreateRequest {
  actor_ids: Array<string>;
  inherited?: boolean;
  role_ids: Array<string>;
  target_id: string;
  type: RequestAdminAssignmentCreateRequestTypeEnum;
}

export const RequestAdminAssignmentCreateRequestTypeEnum = {
  UserProject: 'UserProject',
  GroupProject: 'GroupProject',
  UserDomain: 'UserDomain',
  GroupDomain: 'GroupDomain',
} as const;

export type RequestAdminAssignmentCreateRequestTypeEnum =
  (typeof RequestAdminAssignmentCreateRequestTypeEnum)[keyof typeof RequestAdminAssignmentCreateRequestTypeEnum];

export interface RequestAdminSystemAssignmentCreateRequest {
  actor_ids: Array<string>;
  role_ids: Array<string>;
  type: RequestAdminSystemAssignmentCreateRequestTypeEnum;
}

export const RequestAdminSystemAssignmentCreateRequestTypeEnum = {
  UserSystem: 'UserSystem',
  GroupSystem: 'GroupSystem',
} as const;

export type RequestAdminSystemAssignmentCreateRequestTypeEnum =
  (typeof RequestAdminSystemAssignmentCreateRequestTypeEnum)[keyof typeof RequestAdminSystemAssignmentCreateRequestTypeEnum];

export interface RequestApplicationCredentialCreateRequest {
  description?: string;
  /**
   * default=\"\"
   */
  expires_at?: string;
  name: string;
  roles?: Array<RequestApplicationCredentialRole>;
}
export interface RequestApplicationCredentialRole {
  id: string;
  name?: string;
}
export interface RequestAssignGroupsToDomainRequest {
  group_ids: Array<string>;
  role_ids: Array<string>;
}
export interface RequestAssignGroupsToProjectRequest {
  group_ids: Array<string>;
  role_ids: Array<string>;
}
export interface RequestAssignOwnerRoleRequest {
  from_user_id: string;
  to_user_id: string;
}
export interface RequestAssignRolesToGroupRequest {
  role_names: Array<string>;
}
export interface RequestAssignRolesToUserRequest {
  role_names: Array<string>;
}
export interface RequestAssignToUsersOnDomainRequest {
  role_ids: Array<string>;
  user_ids: Array<string>;
}
export interface RequestAssignToUsersOnProjectRequest {
  role_ids: Array<string>;
  user_ids: Array<string>;
}
export interface RequestAuthenticateRbacRequest {
  client_ip?: string;
  current_endpoint_url?: string;
  current_host?: string;
  permission_id: string;
  target_domain_id?: string;
  target_domain_id_of_project?: string;
  target_project_id?: string;
  target_user_id?: string;
}
export interface RequestCheckPasswordRequest {
  password: string;
}
export interface RequestCheckPermissionForSystemRequest {
  client_ip?: string;
  current_endpoint_url?: string;
  current_host?: string;
  permission_id?: string;
  project_id?: string;
  user_id?: string;
}
export interface RequestCloudBasicAuthClientRequest {
  client_name: string;
}
export interface RequestCloudDomainCreateRequest {
  description?: string;
  /**
   * default: false
   */
  mfa_enabled?: boolean;
  name: string;
  owner: RequestCloudDomainCreateRequestOwner;
  /**
   * default: \"\"
   */
  project_default_endpoint_group?: string;
  /**
   * default: \"\"
   */
  use_type?: string;
}
export interface RequestCloudDomainCreateRequestOwner {
  name: string;
}
export interface RequestCloudDomainUpdateRequest {
  app_cred_limit: number;
  cred_limit: number;
  /**
   * default: \"\"
   */
  default_language_code?: string;
  description?: string;
  /**
   * default: false
   */
  enabled?: boolean;
  /**
   * default: false
   */
  ip_access_check_enabled?: boolean;
  /**
   * default: false
   */
  mfa_enabled?: boolean;
  name: string;
  /**
   * default: \"\"
   */
  project_default_endpoint_group?: string;
  /**
   * default: 0
   */
  project_limit?: number;
  pw_check_on_delete?: boolean;
  session_ttl_mins: number;
  src_ac_mode: string;
  /**
   * default: \"\"
   */
  use_type?: string;
  /**
   * default: 0
   */
  user_pw_ttl_days?: number;
}
export interface RequestCloudGOVUserPasswordSetRequest {
  after_email?: string;
  domain_name: string;
  email: string;
  name: string;
  new_password: string;
  phone_number: string;
  realname: string;
  req_id: string;
}
export interface RequestCloudGroupUsersRequest {
  user_ids: Array<string>;
}
export interface RequestCloudNoticeCreateRequest {
  contents: string;
  pub_end_at: string;
  pub_start_at: string;
  title: string;
}
export interface RequestCloudNoticeUpdateRequest {
  contents: string;
  pub_end_at: string;
  pub_start_at: string;
  title: string;
}
export interface RequestCloudProjectCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  domain_id: string;
  name: string;
  /**
   * default: \"\"
   */
  nickname?: string;
}
export interface RequestCloudProjectUpdateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  nickname?: string;
}
export interface RequestCloudRoleCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  /**
   * default: \"\"
   */
  domain_id?: string;
  extra?: Array<RequestRoleExtraCreateRequest>;
  name: string;
}
export interface RequestCloudRoleUpdateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  /**
   * default: []
   */
  extra?: Array<RequestRoleExtraUpdateRequest>;
  name: string;
}
export interface RequestCloudUserBulkCreateRequest {
  /**
   * default: \"\"
   */
  default_project_id?: string;
  domain_id: string;
  names: Array<string>;
}
export interface RequestCloudUserCreateRequest {
  /**
   * default: \"\"
   */
  default_project_id?: string;
  domain_id: string;
  /**
   * default: \"\"
   */
  email?: string;
  name: string;
  /**
   * default: \"\"
   */
  nickname?: string;
  /**
   * default: \"\"
   */
  realname?: string;
  /**
   * default: \"\"
   */
  telephone?: string;
}
export interface RequestCloudUserOverwritePasswordRequest {
  new_password: string;
  revoke_token?: boolean;
}
export interface RequestCloudUserPasswordResetEmailRequest {
  domain_name: string;
  name: string;
}
export interface RequestCloudUserPasswordSetRequest {
  after_email?: string;
  domain_name: string;
  name: string;
  new_password: string;
  req_id: string;
}
export interface RequestCloudUserUpdateAdminRequest {
  default_project_id?: string;
  email?: string;
  enabled?: boolean;
  language_code?: string;
  nickname?: string;
  phone_number?: string;
  realname?: string;
}
export interface RequestCloudUserUpdatePasswordRequest {
  new_password: string;
  old_password: string;
  revoke_token?: boolean;
}
export interface RequestCloudUserUpdateRequest {
  /**
   * default: \"\"
   */
  language_code?: string;
  /**
   * default: \"\"
   */
  nickname?: string;
  /**
   * default: \"\"
   */
  realname?: string;
}
export interface RequestCreatePermissionApisRequest {
  apis: Array<RequestPermissionApiCreateRequest>;
}
export interface RequestCredentialCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  name: string;
  /**
   * 영소문자+숫자 32자
   */
  project_id: string;
  /**
   * 영소문자+숫자 32자
   */
  user_id: string;
}
export interface RequestCredentialUpdateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  name: string;
}
export interface RequestDefaultProjectUpdateRequest {
  /**
   * default: \"\"
   */
  default_project_id?: string;
}
export interface RequestEncryptKeyIssueRequest {
  encrypt_type: string;
}
export interface RequestEndpointCreateRequest {
  endpoint: RequestEndpointRequest;
}
export interface RequestEndpointGroupCreateFilters {
  interface?: RequestEndpointGroupCreateFiltersInterfaceEnum;
  region_id?: string;
  service_id?: string;
}

export const RequestEndpointGroupCreateFiltersInterfaceEnum = {
  Public: 'public',
  Internal: 'internal',
  Admin: 'admin',
} as const;

export type RequestEndpointGroupCreateFiltersInterfaceEnum =
  (typeof RequestEndpointGroupCreateFiltersInterfaceEnum)[keyof typeof RequestEndpointGroupCreateFiltersInterfaceEnum];

export interface RequestEndpointGroupCreateRequest {
  description?: string;
  filters: RequestEndpointGroupCreateFilters;
  name: string;
}
export interface RequestEndpointRequest {
  interface: string;
  region_id: string;
  service_id: string;
  url: string;
}
export interface RequestEndpointUpdateRequest {
  endpoint: RequestEndpointRequest;
}
export interface RequestFederatedDomainCreateRequest {
  enabled?: boolean;
  idp_id: string;
  oauth_auth_url?: string;
  oauth_client_auth?: string;
  oauth_client_id?: string;
  oauth_client_secret?: string;
  oauth_token_url?: string;
  protocol_id: string;
  upn_suffix?: string;
}
export interface RequestFederatedDomainCreateSamlRequest {
  enabled?: boolean;
  idp_id: string;
  protocol_id: string;
  saml_cert: string;
  saml_entity_id?: string;
  saml_idp_meta_url: string;
  saml_key: string;
  upn_suffix?: string;
}
export interface RequestForceAssignOwnerRequest {
  to_user_id: string;
}
export interface RequestGroupCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  domain_id: string;
  name: string;
}
export interface RequestGroupUpdateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  name: string;
}
export interface RequestListByIdsRequest {
  user_ids?: Array<string>;
}
export interface RequestOAuthClientCreateRequest {
  description?: string;
  display_name: string;
  name: string;
  redirect_uris?: Array<string>;
  req_email: string;
  scopes?: Array<string>;
}
export interface RequestOAuthClientUpdateRequest {
  description?: string;
  display_name: string;
  name: string;
  redirect_uris?: Array<string>;
  req_email: string;
  scopes?: Array<string>;
}
export interface RequestPermissionApiCreateRequest {
  description?: string;
  http_method: string;
  path: string;
  permission_id: string;
}
export interface RequestPermissionApiRequest {
  description?: string;
  http_method: string;
  path: string;
}
export interface RequestPermissionBulkCreateRequest {
  permissions?: Array<RequestPermissionCreateRequest>;
  service_type: string;
}
export interface RequestPermissionCreateRequest {
  apis?: Array<RequestPermissionApiRequest>;
  default_role_name?: string;
  default_role_scope?: string;
  description?: string;
  id: string;
  target_user_check_enabled?: boolean;
}
export interface RequestPermissionCreateWithoutRole {
  apis?: Array<RequestPermissionApiRequest>;
  description?: string;
  id: string;
  target_user_check_enabled?: boolean;
}
export interface RequestPermissionCreateWithoutRoleRequest {
  permissions?: Array<RequestPermissionCreateWithoutRole>;
  service_type: string;
}
export interface RequestPermissionRoleBulkCreateRequest {
  permission_roles?: Array<RequestPermissionRoleCreateRequest>;
}
export interface RequestPermissionRoleCreateRequest {
  permission_id: string;
  role_name: string;
  scope: string;
}
export interface RequestPermissionUpdateRequest {
  apis?: Array<RequestPermissionApiRequest>;
  description?: string;
  target_user_check_enabled?: boolean;
}
export interface RequestProjectServiceAccountCreateRequest {
  name: string;
  /**
   * default: \"\"
   */
  nickname?: string;
  role_ids: Array<string>;
}
export interface RequestReinviteRequest {
  user_ids?: Array<string>;
}
export interface RequestReplaceProjectEndpointGroupsRequest {
  endpoint_group_ids: Array<string>;
}
export interface RequestRoleExtraBulkUpdateRequest {
  role_extra_list?: Array<RequestRoleExtraUpdateRequestWithId>;
}
export interface RequestRoleExtraCreateRequest {
  description_i18n_id: string;
  display_name_i18n_id: string;
  /**
   * default: 0
   */
  display_order?: number;
  role_type: string;
  scope: string;
}
export interface RequestRoleExtraUpdateRequest {
  description_i18n_id: string;
  display_name_i18n_id: string;
  /**
   * default: 0
   */
  display_order?: number;
  role_type: string;
  scope: string;
}
export interface RequestRoleExtraUpdateRequestWithId {
  description_i18n_id: string;
  display_name_i18n_id: string;
  /**
   * default: 0
   */
  display_order?: number;
  role_id: string;
  role_type: string;
  scope: string;
}
export interface RequestSendLoginAuthEmailRequest {
  mfa_type?: string;
}
export interface RequestSendMfaAlarmTalkRequest {
  phone_number: string;
}
export interface RequestSendMfaEmailRequest {
  email: string;
}
export interface RequestServiceAccountApplicationCredentialCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  /**
   * default: \"\"
   */
  expires_at?: string;
  name: string;
  roles?: Array<RequestApplicationCredentialRole>;
}
export interface RequestServiceAccountCredentialCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  name: string;
}
export interface RequestServiceAccountUpdateRequest {
  /**
   * default: false
   */
  enabled?: boolean;
}
export interface RequestServiceAgentCreateRequest {
  impersonation: boolean;
  project_id: string;
  role_ids?: Array<string>;
  service_type?: string;
}
export interface RequestServiceCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  name: string;
  nick_name: string;
  /**
   * default: []
   */
  trustee_ids?: Array<string>;
  type: string;
}
export interface RequestServiceManageUserCreateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  mng_dept: string;
  mng_ldap_id: string;
  project_name: string;
  /**
   * 생략하거나 빈 목록이면 역할을 부여하지 않습니다.
   */
  roles?: Array<string>;
  /**
   * default: \"\"
   */
  service_type?: string;
  user_name: string;
}
export interface RequestServiceManageUserUpdateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  mng_dept: string;
  mng_ldap_id: string;
  /**
   * default: \"\"
   */
  service_type?: string;
}
export interface RequestServiceUpdateRequest {
  /**
   * default: \"\"
   */
  description?: string;
  name: string;
  nick_name: string;
  /**
   * default: []
   */
  trustee_ids?: Array<string>;
}
export interface RequestSrcAcCreateRequest {
  enabled?: boolean;
  is_all_targets?: boolean;
  name: string;
  policy_type: string;
  source: string;
  targets?: Array<RequestSrcAcTargetSaveRequest>;
}
export interface RequestSrcAcPoolCreateRequest {
  host_pools: Array<RequestSrcAcPoolSaveRequest>;
}
export interface RequestSrcAcPoolSaveRequest {
  domain_id?: string;
  host: string;
  interface: string;
  is_openapi?: boolean;
  service_display_name: string;
}
export interface RequestSrcAcPoolUpdateRequest {
  domain_id?: string;
  host: string;
  interface: string;
  is_openapi?: boolean;
  service_display_name: string;
}
export interface RequestSrcAcTargetSaveRequest {
  target_host_pool_id: string;
}
export interface RequestSrcAcTargetUpdateRequest {
  is_all_targets?: boolean;
  targets?: Array<RequestSrcAcTargetSaveRequest>;
}
export interface RequestSrcAcUpdateRequest {
  enabled?: boolean;
  name: string;
}
export interface RequestTranslationContentCreateRequest {
  content_id: string;
  language_code: string;
  value: string;
}
export interface RequestTranslationContentUpdateRequest {
  value: string;
}
export interface RequestTranslationUpdateWithJsonRequest {
  contents?: { [key: string]: string };
  language_code: string;
}
export interface RequestUpdateEmailRequest {
  code: string;
  email: string;
}
export interface RequestUpdateIpAccessCheckRequest {
  /**
   * default: false
   */
  ip_access_check_enabled?: boolean;
}
export interface RequestUpdateLoginInfoRequest {
  /**
   * default: false
   */
  mfa_enabled?: boolean;
}
export interface RequestUpdatePermissionApisRequest {
  apis: Array<RequestPermissionApiCreateRequest>;
}
export interface RequestUpdatePhoneRequest {
  code: string;
  phone_number: string;
}
export interface RequestUpdateSecurityInfoRequest {
  /**
   * default: false
   */
  pw_check_on_delete?: boolean;
  session_ttl_mins: number;
  /**
   * default: 0
   */
  user_pw_ttl_days?: number;
}
export interface RequestUpdateSrcAcModeRequest {
  src_ac_mode: string;
}
export interface RequestUserConsentRequest {
  agreement_version_id: string;
  api_id: string;
  client_id: string;
}
export interface RequestValidateLoginEmailRequest {
  code?: string;
  mfa_type?: string;
}
export interface RequestValidateLoginPhoneRequest {
  code?: string;
}
export interface RequestValidateOtpRequest {
  code?: string;
}
export interface ResponseAccessGrantedIp {
  created_at?: string;
  domain_id?: string;
  ip?: string;
  label?: string;
  seq?: number;
}
export interface ResponseAccessGrantedIps {
  access_granted_ips?: Array<ResponseAccessGrantedIp>;
}
export interface ResponseAccessTokenInfoResponse {
  expires_at?: string;
  issue_at?: string;
  scope?: string;
  user_id?: string;
}
export interface ResponseAccessTokenResponse {
  access_token?: string;
  expires_in?: number;
  /**
   * scope에 openid 가 있는 경우 전달
   */
  id_token?: string;
  refresh_token?: string;
  scope?: string;
  token_type?: string;
}
export interface ResponseApplicationCredentialDeleteResponse {
  success?: number;
}
export interface ResponseApplicationCredentialUserResponse {
  id?: string;
  name?: string;
}
export interface ResponseAssignedRole {
  grant_types?: Array<ResponseAssignedRoleGrantType>;
  role?: ResponseAssignedRoleDisplay;
}
export interface ResponseAssignedRoleDisplay {
  description?: string;
  display_description?: string;
  display_name?: string;
  display_order?: number;
  domain_id?: string;
  id?: string;
  name?: string;
  role_type?: ResponseAssignedRoleDisplayRoleTypeEnum;
}

export const ResponseAssignedRoleDisplayRoleTypeEnum = {
  Basic: 'basic',
  Standard: 'standard',
  Custom: 'custom',
} as const;

export type ResponseAssignedRoleDisplayRoleTypeEnum =
  (typeof ResponseAssignedRoleDisplayRoleTypeEnum)[keyof typeof ResponseAssignedRoleDisplayRoleTypeEnum];

export interface ResponseAssignedRoleGrantType {
  actor_type?: ResponseAssignedRoleGrantTypeActorTypeEnum;
  group?: ResponseAssignedRoleGroup;
  inherited?: boolean;
}

export const ResponseAssignedRoleGrantTypeActorTypeEnum = {
  User: 'User',
  Group: 'Group',
} as const;

export type ResponseAssignedRoleGrantTypeActorTypeEnum =
  (typeof ResponseAssignedRoleGrantTypeActorTypeEnum)[keyof typeof ResponseAssignedRoleGrantTypeActorTypeEnum];

export interface ResponseAssignedRoleGroup {
  id?: string;
  name?: string;
}
export interface ResponseAssignedRoles {
  roles?: Array<ResponseAssignedRole>;
}
export interface ResponseAuthenticatePermissionResponse {
  allow?: boolean;
  token?: DomainTokenRes;
}
export interface ResponseBlobResponse {
  access?: string;
  access_token_id?: string;
  app_cred_id?: string;
  secret?: string;
  trust_id?: string;
}
export interface ResponseCatalog {
  endpoints?: Array<ResponseEndpoint>;
  id?: string;
  name?: string;
  type?: string;
}
export interface ResponseCheckPermissionForSystemResponse {
  allow?: boolean;
}
export interface ResponseCloudApplicationCredentialDisplayDto {
  created_at?: string;
  description?: string;
  expires_at?: string;
  id?: string;
  last_used_at?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  roles?: Array<ResponseAssignedRoleDisplay>;
  user?: ResponseApplicationCredentialUserResponse;
}
export interface ResponseCloudApplicationCredentialDto {
  created_at?: string;
  description?: string;
  expires_at?: string;
  id?: string;
  last_used_at?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  roles?: Array<ResponseCloudRole>;
  secret?: string;
  user?: ResponseApplicationCredentialUserResponse;
}
export interface ResponseCloudApplicationCredentialDtos {
  application_credentials?: Array<ResponseCloudApplicationCredentialListItemDto>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseCloudApplicationCredentialListItemDto {
  created_at?: string;
  description?: string;
  expires_at?: string;
  id?: string;
  last_used_at?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  user?: ResponseApplicationCredentialUserResponse;
}
export interface ResponseCloudAssignment {
  actor_id?: string;
  assignment_type?: ResponseCloudAssignmentAssignmentTypeEnum;
  domain_name?: string;
  group_name?: string;
  inherited?: boolean;
  project_name?: string;
  role_id?: string;
  role_name?: string;
  target_id?: string;
  user_name?: string;
}

export const ResponseCloudAssignmentAssignmentTypeEnum = {
  UserProject: 'UserProject',
  GroupProject: 'GroupProject',
  UserDomain: 'UserDomain',
  GroupDomain: 'GroupDomain',
} as const;

export type ResponseCloudAssignmentAssignmentTypeEnum =
  (typeof ResponseCloudAssignmentAssignmentTypeEnum)[keyof typeof ResponseCloudAssignmentAssignmentTypeEnum];

export interface ResponseCloudAssignmentList {
  assignments?: Array<ResponseCloudAssignment>;
  total?: number;
}
export interface ResponseCloudAuthResponse {
  logged_in?: boolean;
  mfa_enabled?: boolean;
  redirect_uri?: string;
  user_pw_ttl_days?: number;
}
export interface ResponseCloudBasicAuthClient {
  client_id?: string;
  client_name?: string;
  client_secret?: string;
  created_at?: string;
}
export interface ResponseCloudDeletedUser {
  deleted_at?: string;
  domain_id?: string;
  id?: string;
  name?: string;
}
export interface ResponseCloudDeletedUsers {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseCloudDeletedUser>;
}
export interface ResponseCloudDomain {
  app_cred_limit?: number;
  created_at?: string;
  cred_limit?: number;
  default_language_code?: ResponseCloudDomainDefaultLanguageCodeEnum;
  description?: string;
  disabled_at?: string;
  enabled?: boolean;
  federated_domain?: Array<ResponseFederatedDomainResponse>;
  id?: string;
  ip_access_check_enabled?: boolean;
  ip_access_check_updated_at?: string;
  kkek_updated_at?: string;
  mfa_enabled?: boolean;
  name?: string;
  owner_id?: string;
  project_default_endpoint_group?: string;
  project_limit?: number;
  pw_check_on_delete?: boolean;
  session_ttl_mins?: number;
  src_ac_mode?: ResponseCloudDomainSrcAcModeEnum;
  src_ac_mode_updated_at?: string;
  src_ac_policy_limit?: number;
  sso_enabled?: boolean;
  user_pw_ttl_days?: number;
}

export const ResponseCloudDomainDefaultLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseCloudDomainDefaultLanguageCodeEnum =
  (typeof ResponseCloudDomainDefaultLanguageCodeEnum)[keyof typeof ResponseCloudDomainDefaultLanguageCodeEnum];
export const ResponseCloudDomainSrcAcModeEnum = {
  On: 'ON',
  Off: 'OFF',
  Log: 'LOG',
} as const;

export type ResponseCloudDomainSrcAcModeEnum =
  (typeof ResponseCloudDomainSrcAcModeEnum)[keyof typeof ResponseCloudDomainSrcAcModeEnum];

export interface ResponseCloudNotice {
  contents?: string;
  created_at?: string;
  pub_end_at?: string;
  pub_start_at?: string;
  seq?: number;
  title?: string;
}
export interface ResponseCloudPermissionDetailDto {
  apis?: Array<ResponsePermissionApiDto>;
  created_at?: string;
  description?: string;
  display_service_name?: string;
  id?: string;
  roles?: Array<ResponseCloudPermissionRoleDto>;
  service_type?: string;
  target_user_check_enabled?: boolean;
}
export interface ResponseCloudPermissionDto {
  apis?: Array<ResponsePermissionApiDto>;
  created_at?: string;
  description?: string;
  display_service_name?: string;
  id?: string;
  service_type?: string;
  target_user_check_enabled?: boolean;
}
export interface ResponseCloudPermissionDtos {
  permissions?: Array<ResponseCloudPermissionDto>;
}
export interface ResponseCloudPermissionRoleDto {
  display_service_name?: string;
  permission_id?: string;
  role_id?: string;
  role_name?: string;
  scope?: ResponseCloudPermissionRoleDtoScopeEnum;
  service_type?: string;
}

export const ResponseCloudPermissionRoleDtoScopeEnum = {
  Domain: 'domain',
  Project: 'project',
  System: 'system',
  SystemRole: 'system_role',
} as const;

export type ResponseCloudPermissionRoleDtoScopeEnum =
  (typeof ResponseCloudPermissionRoleDtoScopeEnum)[keyof typeof ResponseCloudPermissionRoleDtoScopeEnum];

export interface ResponseCloudPermissionRoleDtos {
  permission_roles?: Array<ResponseCloudPermissionRoleDto>;
}
export interface ResponseCloudPermissionRolesList {
  offset?: number;
  permission_roles?: Array<ResponseCloudPermissionRoleDto>;
  size?: number;
  total?: number;
}
export interface ResponseCloudProject {
  created_at?: string;
  description?: string;
  disabled_at?: string;
  domain_id?: string;
  enabled?: boolean;
  endpoint_groups?: Array<ResponseEndpointGroup>;
  id?: string;
  name?: string;
  nickname?: string;
}
export interface ResponseCloudProjects {
  offset?: number;
  projects?: Array<ResponseCloudProject>;
  size?: number;
  total?: number;
}
export interface ResponseCloudRequestIdInfo {
  domain_name?: string;
  name?: string;
}
export interface ResponseCloudRole {
  /**
   * omitempty
   */
  description?: string;
  /**
   * omitempty
   */
  domain_id?: string;
  /**
   * omitempty
   */
  id?: string;
  /**
   * omitempty
   */
  name?: string;
}
export interface ResponseCloudRoleDisplayList {
  offset?: number;
  roles?: Array<ResponseCloudRoleWithDisplay>;
  size?: number;
  total?: number;
}
export interface ResponseCloudRoleExtra {
  description: string;
  description_i18n_id: string;
  display_name: string;
  display_name_i18n_id: string;
  display_order?: number;
  role_id?: string;
  role_type: ResponseCloudRoleExtraRoleTypeEnum;
  scope: ResponseCloudRoleExtraScopeEnum;
}

export const ResponseCloudRoleExtraRoleTypeEnum = {
  Basic: 'basic',
  Standard: 'standard',
  Custom: 'custom',
} as const;

export type ResponseCloudRoleExtraRoleTypeEnum =
  (typeof ResponseCloudRoleExtraRoleTypeEnum)[keyof typeof ResponseCloudRoleExtraRoleTypeEnum];
export const ResponseCloudRoleExtraScopeEnum = {
  Domain: 'domain',
  Project: 'project',
} as const;

export type ResponseCloudRoleExtraScopeEnum =
  (typeof ResponseCloudRoleExtraScopeEnum)[keyof typeof ResponseCloudRoleExtraScopeEnum];

export interface ResponseCloudRoleExtraList {
  role_extras?: Array<ResponseCloudRoleExtra>;
}
export interface ResponseCloudRoleWithDisplay {
  description?: string;
  domain_id?: string;
  extra?: ResponseCloudRoleExtra;
  id?: string;
  name?: string;
}
export interface ResponseCloudRoleWithExtra {
  description?: string;
  domain_id?: string;
  extra?: Array<ResponseCloudRoleExtra>;
  id?: string;
  name?: string;
}
export interface ResponseCloudRoleWithExtraList {
  roles?: Array<ResponseCloudRoleWithExtra>;
}
export interface ResponseCloudRoles {
  roles?: Array<ResponseCloudRole>;
}
export interface ResponseCloudServiceUserResponse {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  enabled?: boolean;
  id?: string;
  name?: string;
  nickname?: string;
  service_account_type?: ResponseCloudServiceUserResponseServiceAccountTypeEnum;
}

export const ResponseCloudServiceUserResponseServiceAccountTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseCloudServiceUserResponseServiceAccountTypeEnum =
  (typeof ResponseCloudServiceUserResponseServiceAccountTypeEnum)[keyof typeof ResponseCloudServiceUserResponseServiceAccountTypeEnum];

export interface ResponseCloudSystemAssignment {
  actor_id?: string;
  assignment_type?: ResponseCloudSystemAssignmentAssignmentTypeEnum;
  group_name?: string;
  project_name?: string;
  role_id?: string;
  role_name?: string;
  target_id?: string;
  user_name?: string;
}

export const ResponseCloudSystemAssignmentAssignmentTypeEnum = {
  UserProject: 'UserProject',
  GroupProject: 'GroupProject',
  UserSystem: 'UserSystem',
  GroupSystem: 'GroupSystem',
} as const;

export type ResponseCloudSystemAssignmentAssignmentTypeEnum =
  (typeof ResponseCloudSystemAssignmentAssignmentTypeEnum)[keyof typeof ResponseCloudSystemAssignmentAssignmentTypeEnum];

export interface ResponseCloudSystemAssignmentList {
  assignments?: Array<ResponseCloudSystemAssignment>;
  total?: number;
}
export interface ResponseCloudUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  group_names?: Array<string>;
  group_roles?: Array<string>;
  id?: string;
  language_code?: ResponseCloudUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  otp_enabled?: boolean;
  otp_enabled_at?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  roles?: Array<string>;
  service_account_type?: ResponseCloudUserServiceAccountTypeEnum;
  status?: ResponseCloudUserStatusEnum;
  telephone?: string;
  user_type?: ResponseCloudUserUserTypeEnum;
}

export const ResponseCloudUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseCloudUserLanguageCodeEnum =
  (typeof ResponseCloudUserLanguageCodeEnum)[keyof typeof ResponseCloudUserLanguageCodeEnum];
export const ResponseCloudUserServiceAccountTypeEnum = {
  All: 'All',
  User: 'User',
  Account: 'Account',
  Agent: 'Agent',
  Manage: 'Manage',
} as const;

export type ResponseCloudUserServiceAccountTypeEnum =
  (typeof ResponseCloudUserServiceAccountTypeEnum)[keyof typeof ResponseCloudUserServiceAccountTypeEnum];
export const ResponseCloudUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseCloudUserStatusEnum =
  (typeof ResponseCloudUserStatusEnum)[keyof typeof ResponseCloudUserStatusEnum];
export const ResponseCloudUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseCloudUserUserTypeEnum =
  (typeof ResponseCloudUserUserTypeEnum)[keyof typeof ResponseCloudUserUserTypeEnum];

export interface ResponseCloudUserIdMap {
  users?: { [key: string]: string };
}
export interface ResponseCloudUsers {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseCloudUser>;
}
export interface ResponseConfiguration {
  authorization_endpoint?: string;
  claims_supported?: Array<string>;
  grant_types_supported?: Array<string>;
  id_token_signing_alg_values_supported?: Array<string>;
  issuer?: string;
  response_types_supported?: Array<string>;
  scopes_supported?: Array<string>;
  subject_types_supported?: Array<string>;
  token_endpoint?: string;
  token_endpoint_auth_methods_supported?: Array<string>;
  userinfo_endpoint?: string;
}
export interface ResponseCredentialCreateResponse {
  blob?: ResponseBlobResponse;
  created_at?: string;
  description?: string;
  id?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  type?: string;
  user_id?: string;
  user_name?: string;
}
export interface ResponseCredentialGetResponse {
  blob?: ResponseBlobResponse;
  created_at?: string;
  description?: string;
  id?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  type?: string;
  user_id?: string;
  user_name?: string;
}
export interface ResponseCredentialListAllResponse {
  credentials?: Array<ResponseCredentialWithoutBlobResponse>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseCredentialListByDomainResponse {
  credentials?: Array<ResponseCredentialWithoutBlobResponse>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseCredentialListByUserResponse {
  credentials?: Array<ResponseCredentialWithoutBlobResponse>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseCredentialListByUserWithBlobResponse {
  credentials?: Array<ResponseUserCredentialWithBlobResponse>;
}
export interface ResponseCredentialWithoutBlobResponse {
  created_at?: string;
  description?: string;
  id?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  type?: string;
  user_id?: string;
  user_name?: string;
}
export interface ResponseDomainGetAuthTypeResponse {
  federated_auth?: ResponseFederatedAuth;
  redirect_uri?: string;
  sso_enabled?: boolean;
}
export interface ResponseDomainGetResponse {
  app_cred_limit?: number;
  created_at?: string;
  cred_limit?: number;
  default_language_code?: ResponseDomainGetResponseDefaultLanguageCodeEnum;
  description?: string;
  disabled_at?: string;
  enabled?: boolean;
  federated_domain?: ResponseFederatedDomainResponse;
  id?: string;
  ip_access_check_enabled?: boolean;
  ip_access_check_updated_at?: string;
  kkek_updated_at?: string;
  mfa_enabled?: boolean;
  name?: string;
  owner_id?: string;
  project_default_endpoint_group?: string;
  project_limit?: number;
  pw_check_on_delete?: boolean;
  session_ttl_mins?: number;
  src_ac_mode?: ResponseDomainGetResponseSrcAcModeEnum;
  src_ac_mode_updated_at?: string;
  src_ac_policy_limit?: number;
  sso_enabled?: boolean;
  user_pw_ttl_days?: number;
}

export const ResponseDomainGetResponseDefaultLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseDomainGetResponseDefaultLanguageCodeEnum =
  (typeof ResponseDomainGetResponseDefaultLanguageCodeEnum)[keyof typeof ResponseDomainGetResponseDefaultLanguageCodeEnum];
export const ResponseDomainGetResponseSrcAcModeEnum = {
  On: 'ON',
  Off: 'OFF',
  Log: 'LOG',
} as const;

export type ResponseDomainGetResponseSrcAcModeEnum =
  (typeof ResponseDomainGetResponseSrcAcModeEnum)[keyof typeof ResponseDomainGetResponseSrcAcModeEnum];

export interface ResponseDomainInheritedRoleGroup {
  created_at?: string;
  description?: string;
  domain?: ResponseSimpleCloudDomain;
  id?: string;
  name?: string;
  user_count?: number;
}
export interface ResponseDomainInheritedRoleUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseDomainInheritedRoleUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseDomainInheritedRoleUserStatusEnum;
  telephone?: string;
  user_type?: ResponseDomainInheritedRoleUserUserTypeEnum;
}

export const ResponseDomainInheritedRoleUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseDomainInheritedRoleUserLanguageCodeEnum =
  (typeof ResponseDomainInheritedRoleUserLanguageCodeEnum)[keyof typeof ResponseDomainInheritedRoleUserLanguageCodeEnum];
export const ResponseDomainInheritedRoleUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseDomainInheritedRoleUserStatusEnum =
  (typeof ResponseDomainInheritedRoleUserStatusEnum)[keyof typeof ResponseDomainInheritedRoleUserStatusEnum];
export const ResponseDomainInheritedRoleUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseDomainInheritedRoleUserUserTypeEnum =
  (typeof ResponseDomainInheritedRoleUserUserTypeEnum)[keyof typeof ResponseDomainInheritedRoleUserUserTypeEnum];

export interface ResponseDomainListElement {
  app_cred_limit?: number;
  created_at?: string;
  cred_limit?: number;
  default_language_code?: ResponseDomainListElementDefaultLanguageCodeEnum;
  description?: string;
  disabled_at?: string;
  enabled?: boolean;
  id?: string;
  ip_access_check_enabled?: boolean;
  ip_access_check_updated_at?: string;
  kkek_updated_at?: string;
  mfa_enabled?: boolean;
  name?: string;
  owner_id?: string;
  project_default_endpoint_group?: string;
  project_limit?: number;
  pw_check_on_delete?: boolean;
  session_ttl_mins?: number;
  src_ac_mode?: ResponseDomainListElementSrcAcModeEnum;
  src_ac_mode_updated_at?: string;
  src_ac_policy_limit?: number;
  sso_enabled?: boolean;
  user_pw_ttl_days?: number;
}

export const ResponseDomainListElementDefaultLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseDomainListElementDefaultLanguageCodeEnum =
  (typeof ResponseDomainListElementDefaultLanguageCodeEnum)[keyof typeof ResponseDomainListElementDefaultLanguageCodeEnum];
export const ResponseDomainListElementSrcAcModeEnum = {
  On: 'ON',
  Off: 'OFF',
  Log: 'LOG',
} as const;

export type ResponseDomainListElementSrcAcModeEnum =
  (typeof ResponseDomainListElementSrcAcModeEnum)[keyof typeof ResponseDomainListElementSrcAcModeEnum];

export interface ResponseDomainListResponse {
  domains?: Array<ResponseDomainListElement>;
  total?: number;
}
export interface ResponseDomainUpdateResponse {
  app_cred_limit?: number;
  created_at?: string;
  cred_limit?: number;
  default_language_code?: ResponseDomainUpdateResponseDefaultLanguageCodeEnum;
  description?: string;
  disabled_at?: string;
  enabled?: boolean;
  id?: string;
  ip_access_check_enabled?: boolean;
  ip_access_check_updated_at?: string;
  kkek_updated_at?: string;
  mfa_enabled?: boolean;
  name?: string;
  owner_id?: string;
  project_default_endpoint_group?: string;
  project_limit?: number;
  pw_check_on_delete?: boolean;
  session_ttl_mins?: number;
  src_ac_mode?: ResponseDomainUpdateResponseSrcAcModeEnum;
  src_ac_mode_updated_at?: string;
  src_ac_policy_limit?: number;
  sso_enabled?: boolean;
  user_pw_ttl_days?: number;
}

export const ResponseDomainUpdateResponseDefaultLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseDomainUpdateResponseDefaultLanguageCodeEnum =
  (typeof ResponseDomainUpdateResponseDefaultLanguageCodeEnum)[keyof typeof ResponseDomainUpdateResponseDefaultLanguageCodeEnum];
export const ResponseDomainUpdateResponseSrcAcModeEnum = {
  On: 'ON',
  Off: 'OFF',
  Log: 'LOG',
} as const;

export type ResponseDomainUpdateResponseSrcAcModeEnum =
  (typeof ResponseDomainUpdateResponseSrcAcModeEnum)[keyof typeof ResponseDomainUpdateResponseSrcAcModeEnum];

export interface ResponseEffectiveRolesDisplay {
  effective_roles_display?: Array<ResponseAssignedRoleDisplay>;
}
export interface ResponseEncryptKeyIssueResponse {
  encrypt_key?: string;
}
export interface ResponseEndpoint {
  id?: string;
  interface?: ResponseEndpointInterfaceEnum;
  region?: string;
  region_id?: string;
  url?: string;
}

export const ResponseEndpointInterfaceEnum = {
  Public: 'public',
  Internal: 'internal',
  Admin: 'admin',
} as const;

export type ResponseEndpointInterfaceEnum =
  (typeof ResponseEndpointInterfaceEnum)[keyof typeof ResponseEndpointInterfaceEnum];

export interface ResponseEndpointGroup {
  id?: string;
  name?: string;
}
export interface ResponseEndpointGroupDetail {
  description?: string;
  filters?: ResponseEndpointGroupFilters;
  id?: string;
  name?: string;
}
export interface ResponseEndpointGroupFilters {
  interface?: ResponseEndpointGroupFiltersInterfaceEnum;
  region_id?: string;
  service_id?: string;
}

export const ResponseEndpointGroupFiltersInterfaceEnum = {
  Public: 'public',
  Internal: 'internal',
  Admin: 'admin',
} as const;

export type ResponseEndpointGroupFiltersInterfaceEnum =
  (typeof ResponseEndpointGroupFiltersInterfaceEnum)[keyof typeof ResponseEndpointGroupFiltersInterfaceEnum];

export interface ResponseEndpointGroupGetResponse {
  endpoint_group?: ResponseEndpointGroupDetail;
}
export interface ResponseEndpointGroupListResponse {
  endpoint_group_list?: Array<ResponseEndpointGroup>;
}
export interface ResponseEndpointListResponse {
  endpoints?: Array<ResponseEndpointResponse>;
  total?: number;
}
export interface ResponseEndpointResponse {
  id?: string;
  interface?: ResponseEndpointResponseInterfaceEnum;
  region_id?: string;
  service_id?: string;
  service_name?: string;
  service_type?: string;
  url?: string;
}

export const ResponseEndpointResponseInterfaceEnum = {
  Public: 'public',
  Internal: 'internal',
  Admin: 'admin',
} as const;

export type ResponseEndpointResponseInterfaceEnum =
  (typeof ResponseEndpointResponseInterfaceEnum)[keyof typeof ResponseEndpointResponseInterfaceEnum];

export interface ResponseFederatedAuth {
  identity_provider?: ResponseIdentityProvider;
  login_uri?: string;
}
export interface ResponseFederatedDomainResponse {
  domain_id?: string;
  enabled?: boolean;
  idp_id?: string;
  oauth_auth_url?: string;
  oauth_client_auth?: ResponseFederatedDomainResponseOauthClientAuthEnum;
  oauth_client_id?: string;
  oauth_client_secret?: string;
  oauth_token_url?: string;
  protocol_id?: ResponseFederatedDomainResponseProtocolIdEnum;
  saml_entity_id?: string;
  saml_idp_meta_url?: string;
  seq?: number;
  unique_id?: string;
  upn_suffix?: string;
}

export const ResponseFederatedDomainResponseOauthClientAuthEnum = {
  Body: 'body',
  Header: 'header',
} as const;

export type ResponseFederatedDomainResponseOauthClientAuthEnum =
  (typeof ResponseFederatedDomainResponseOauthClientAuthEnum)[keyof typeof ResponseFederatedDomainResponseOauthClientAuthEnum];
export const ResponseFederatedDomainResponseProtocolIdEnum = {
  Openid: 'openid',
  Saml: 'saml',
} as const;

export type ResponseFederatedDomainResponseProtocolIdEnum =
  (typeof ResponseFederatedDomainResponseProtocolIdEnum)[keyof typeof ResponseFederatedDomainResponseProtocolIdEnum];

export interface ResponseFederatedDomainResponseWithIdp {
  domain_id?: string;
  enabled?: boolean;
  idp?: ResponseIdentityProvider;
  oauth_auth_url?: string;
  oauth_client_auth?: ResponseFederatedDomainResponseWithIdpOauthClientAuthEnum;
  oauth_client_id?: string;
  oauth_client_secret?: string;
  oauth_token_url?: string;
  protocol_id?: ResponseFederatedDomainResponseWithIdpProtocolIdEnum;
  saml_entity_id?: string;
  saml_idp_meta_url?: string;
  seq?: number;
  unique_id?: string;
  upn_suffix?: string;
}

export const ResponseFederatedDomainResponseWithIdpOauthClientAuthEnum = {
  Body: 'body',
  Header: 'header',
} as const;

export type ResponseFederatedDomainResponseWithIdpOauthClientAuthEnum =
  (typeof ResponseFederatedDomainResponseWithIdpOauthClientAuthEnum)[keyof typeof ResponseFederatedDomainResponseWithIdpOauthClientAuthEnum];
export const ResponseFederatedDomainResponseWithIdpProtocolIdEnum = {
  Openid: 'openid',
  Saml: 'saml',
} as const;

export type ResponseFederatedDomainResponseWithIdpProtocolIdEnum =
  (typeof ResponseFederatedDomainResponseWithIdpProtocolIdEnum)[keyof typeof ResponseFederatedDomainResponseWithIdpProtocolIdEnum];

export interface ResponseGenerateOtpResponse {
  otp_auth_url?: string;
  secret?: string;
}
export interface ResponseGetAllExtraResponse {
  app_cred_limit?: number;
  created_at?: string;
  created_by?: string;
  cred_limit?: number;
  default_language_code?: ResponseGetAllExtraResponseDefaultLanguageCodeEnum;
  description?: string;
  disabled_at?: string;
  enabled?: boolean;
  federated_domain?: ResponseFederatedDomainResponse;
  id?: string;
  ip_access_check_enabled?: boolean;
  ip_access_check_updated_at?: string;
  kkek_updated_at?: string;
  mfa_enabled?: boolean;
  name?: string;
  owner_id?: string;
  project_default_endpoint_group?: string;
  project_limit?: number;
  pw_check_on_delete?: boolean;
  session_ttl_mins?: number;
  src_ac_mode?: ResponseGetAllExtraResponseSrcAcModeEnum;
  src_ac_mode_updated_at?: string;
  src_ac_policy_limit?: number;
  sso_enabled?: boolean;
  use_type?: string;
  user_pw_ttl_days?: number;
}

export const ResponseGetAllExtraResponseDefaultLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseGetAllExtraResponseDefaultLanguageCodeEnum =
  (typeof ResponseGetAllExtraResponseDefaultLanguageCodeEnum)[keyof typeof ResponseGetAllExtraResponseDefaultLanguageCodeEnum];
export const ResponseGetAllExtraResponseSrcAcModeEnum = {
  On: 'ON',
  Off: 'OFF',
  Log: 'LOG',
} as const;

export type ResponseGetAllExtraResponseSrcAcModeEnum =
  (typeof ResponseGetAllExtraResponseSrcAcModeEnum)[keyof typeof ResponseGetAllExtraResponseSrcAcModeEnum];

export interface ResponseGetDomainStatistics {
  application_credential_count?: number;
  credential_count?: number;
  group_count?: number;
  project_count?: number;
  service_account_count?: number;
  service_agent_count?: number;
  src_ac_policy_count?: number;
  user_count?: number;
}
export interface ResponseGetGroupListByDomainResponse {
  groups?: Array<ResponseGroupDto>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseGetGroupListByProjectResponse {
  groups?: Array<ResponseGroupDto>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseGetGroupListByUserResponse {
  groups?: Array<ResponseGroupDto>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseGroupBulkDeleteResponse {
  success?: number;
}
export interface ResponseGroupDto {
  created_at?: string;
  description?: string;
  domain?: ResponseSimpleCloudDomain;
  id?: string;
  name?: string;
  user_count?: number;
}
export interface ResponseGroupListResponse {
  groups?: Array<ResponseGroupDto>;
  total?: number;
}
export interface ResponseIdentityProvider {
  description?: string;
  id?: string;
  image_url?: string;
  name?: string;
  protocol?: string;
}
export interface ResponseIdentityProviders {
  identity_providers?: Array<ResponseIdentityProvider>;
}
export interface ResponseListByDomainResponse {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseListByDomainUser>;
}
export interface ResponseListByDomainUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  /**
   * DomainRoleCount is the number of distinct UserDomain/GroupDomain roles with inherited=0.
   */
  domain_role_count?: number;
  email?: string;
  enabled?: boolean;
  group_count?: number;
  id?: string;
  language_code?: ResponseListByDomainUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseListByDomainUserStatusEnum;
  telephone?: string;
  user_type?: ResponseListByDomainUserUserTypeEnum;
}

export const ResponseListByDomainUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseListByDomainUserLanguageCodeEnum =
  (typeof ResponseListByDomainUserLanguageCodeEnum)[keyof typeof ResponseListByDomainUserLanguageCodeEnum];
export const ResponseListByDomainUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseListByDomainUserStatusEnum =
  (typeof ResponseListByDomainUserStatusEnum)[keyof typeof ResponseListByDomainUserStatusEnum];
export const ResponseListByDomainUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseListByDomainUserUserTypeEnum =
  (typeof ResponseListByDomainUserUserTypeEnum)[keyof typeof ResponseListByDomainUserUserTypeEnum];

export interface ResponseListByGroupUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseListByGroupUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseListByGroupUserStatusEnum;
  telephone?: string;
  user_type?: ResponseListByGroupUserUserTypeEnum;
}

export const ResponseListByGroupUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseListByGroupUserLanguageCodeEnum =
  (typeof ResponseListByGroupUserLanguageCodeEnum)[keyof typeof ResponseListByGroupUserLanguageCodeEnum];
export const ResponseListByGroupUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseListByGroupUserStatusEnum =
  (typeof ResponseListByGroupUserStatusEnum)[keyof typeof ResponseListByGroupUserStatusEnum];
export const ResponseListByGroupUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseListByGroupUserUserTypeEnum =
  (typeof ResponseListByGroupUserUserTypeEnum)[keyof typeof ResponseListByGroupUserUserTypeEnum];

export interface ResponseListByProjectMemberExcludeGroupResponse {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseListByProjectMemberExcludeGroupUser>;
}
export interface ResponseListByProjectMemberExcludeGroupUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseListByProjectMemberExcludeGroupUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseListByProjectMemberExcludeGroupUserStatusEnum;
  telephone?: string;
  user_type?: ResponseListByProjectMemberExcludeGroupUserUserTypeEnum;
}

export const ResponseListByProjectMemberExcludeGroupUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseListByProjectMemberExcludeGroupUserLanguageCodeEnum =
  (typeof ResponseListByProjectMemberExcludeGroupUserLanguageCodeEnum)[keyof typeof ResponseListByProjectMemberExcludeGroupUserLanguageCodeEnum];
export const ResponseListByProjectMemberExcludeGroupUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseListByProjectMemberExcludeGroupUserStatusEnum =
  (typeof ResponseListByProjectMemberExcludeGroupUserStatusEnum)[keyof typeof ResponseListByProjectMemberExcludeGroupUserStatusEnum];
export const ResponseListByProjectMemberExcludeGroupUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseListByProjectMemberExcludeGroupUserUserTypeEnum =
  (typeof ResponseListByProjectMemberExcludeGroupUserUserTypeEnum)[keyof typeof ResponseListByProjectMemberExcludeGroupUserUserTypeEnum];

export interface ResponseListInheritedRoleGroupsResponse {
  groups?: Array<ResponseDomainInheritedRoleGroup>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseListInheritedRoleUsersResponse {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseDomainInheritedRoleUser>;
}
export interface ResponseListPermissionsResponse {
  offset?: number;
  permissions?: Array<ResponseCloudPermissionDto>;
  size?: number;
  total?: number;
}
export interface ResponseListProjectMembersResponse {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseListProjectMembersUser>;
}
export interface ResponseListProjectMembersUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseListProjectMembersUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseListProjectMembersUserStatusEnum;
  telephone?: string;
  user_type?: ResponseListProjectMembersUserUserTypeEnum;
}

export const ResponseListProjectMembersUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseListProjectMembersUserLanguageCodeEnum =
  (typeof ResponseListProjectMembersUserLanguageCodeEnum)[keyof typeof ResponseListProjectMembersUserLanguageCodeEnum];
export const ResponseListProjectMembersUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseListProjectMembersUserStatusEnum =
  (typeof ResponseListProjectMembersUserStatusEnum)[keyof typeof ResponseListProjectMembersUserStatusEnum];
export const ResponseListProjectMembersUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseListProjectMembersUserUserTypeEnum =
  (typeof ResponseListProjectMembersUserUserTypeEnum)[keyof typeof ResponseListProjectMembersUserUserTypeEnum];

export interface ResponseListRoleWithImpliedResponse {
  roles?: Array<ResponseRoleWithImpliedResponse>;
}
export interface ResponseListUserAssignmentsByDomainResponse {
  users?: Array<ResponseListUserAssignmentsByDomainUser>;
}
export interface ResponseListUserAssignmentsByDomainUser {
  enabled?: boolean;
  id?: string;
  name?: string;
  role_ids?: Array<string>;
}
export interface ResponseListUserAssignmentsByProjectResponse {
  users?: Array<ResponseProjectRoleUser>;
}
export interface ResponseListUserByGroupResponse {
  offset?: number;
  size?: number;
  total?: number;
  users?: Array<ResponseListByGroupUser>;
}
export interface ResponseListUserProjectsResponse {
  offset?: number;
  projects?: Array<ResponseCloudProject>;
  size?: number;
  total?: number;
}
export interface ResponseLoginLog {
  ip?: string;
  time?: string;
  user_id?: string;
}
export interface ResponseMfaInfo {
  mfa_type?: ResponseMfaInfoMfaTypeEnum;
  value?: string;
}

export const ResponseMfaInfoMfaTypeEnum = {
  UserName: 'user_name',
  Email: 'email',
  Phone: 'phone',
  Otp: 'otp',
} as const;

export type ResponseMfaInfoMfaTypeEnum =
  (typeof ResponseMfaInfoMfaTypeEnum)[keyof typeof ResponseMfaInfoMfaTypeEnum];

export interface ResponseMfaInfoList {
  mfa_info?: Array<ResponseMfaInfo>;
}
export interface ResponseOAuthClient {
  client_id?: string;
  client_secret?: string;
  created_at?: string;
  description?: string;
  display_name?: string;
  name?: string;
  req_email?: string;
}
export interface ResponseOAuthClientDetail {
  client_id?: string;
  client_secret?: string;
  created_at?: string;
  description?: string;
  display_name?: string;
  name?: string;
  redirect_uris?: Array<string>;
  req_email?: string;
  scopes?: Array<string>;
}
export interface ResponseOAuthClientList {
  clients?: Array<ResponseOAuthClient>;
}
export interface ResponsePermissionApiDto {
  description?: string;
  http_method?: string;
  path?: string;
}
export interface ResponsePrincipalDto {
  catalog?: Array<ResponseCatalog>;
  domain?: ResponseSimpleCloudDomain;
  expires_at?: string;
  issued_at?: string;
  project?: ResponseSimpleCloudProjectDto;
  roles?: Array<ResponseCloudRole>;
  user?: ResponseCloudUser;
}
export interface ResponseProjectEndpointGroupsResponse {
  endpoint_groups?: Array<ResponseEndpointGroupDetail>;
}
export interface ResponseProjectForListByDomainResponse {
  created_at?: string;
  description?: string;
  disabled_at?: string;
  domain_id?: string;
  enabled?: boolean;
  endpoint_groups?: Array<ResponseEndpointGroup>;
  group_count?: number;
  id?: string;
  name?: string;
  nickname?: string;
  user_count?: number;
}
export interface ResponseProjectListByDomainResponse {
  offset?: number;
  projects?: Array<ResponseProjectForListByDomainResponse>;
  size?: number;
  total?: number;
}
export interface ResponseProjectListByGroupResponse {
  offset?: number;
  projects?: Array<ResponseCloudProject>;
  size?: number;
  total?: number;
}
export interface ResponseProjectListByUserResponse {
  offset?: number;
  projects?: Array<ResponseCloudProject>;
  size?: number;
  total?: number;
}
export interface ResponseProjectRoleUser {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseProjectRoleUserLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  role_ids?: Array<string>;
  status?: ResponseProjectRoleUserStatusEnum;
  telephone?: string;
  user_type?: ResponseProjectRoleUserUserTypeEnum;
}

export const ResponseProjectRoleUserLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseProjectRoleUserLanguageCodeEnum =
  (typeof ResponseProjectRoleUserLanguageCodeEnum)[keyof typeof ResponseProjectRoleUserLanguageCodeEnum];
export const ResponseProjectRoleUserStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseProjectRoleUserStatusEnum =
  (typeof ResponseProjectRoleUserStatusEnum)[keyof typeof ResponseProjectRoleUserStatusEnum];
export const ResponseProjectRoleUserUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseProjectRoleUserUserTypeEnum =
  (typeof ResponseProjectRoleUserUserTypeEnum)[keyof typeof ResponseProjectRoleUserUserTypeEnum];

export interface ResponseProjectSuggestResponse {
  projects?: Array<ResponseSuggestedProject>;
}
export interface ResponseProjectUserEffectiveRoles {
  roles?: Array<DomainTokenResRole>;
}
export interface ResponseProvidedLanguage {
  code?: string;
  display_name?: string;
  seq?: number;
}
export interface ResponseProvidedLanguageList {
  provided_languages?: Array<ResponseProvidedLanguage>;
}
export interface ResponseRegionListResponse {
  regions?: Array<ResponseRegionResponse>;
}
export interface ResponseRegionResponse {
  description?: string;
  id?: string;
}
export interface ResponseRemProject {
  deleted_at?: string;
  description?: string;
  domain_id?: string;
  id?: string;
  name?: string;
  seq?: number;
}
export interface ResponseRemProjects {
  offset?: number;
  projects?: Array<ResponseRemProject>;
  size?: number;
  total?: number;
}
export interface ResponseReplaceSessionResponse {
  redirect_uri?: string;
}
export interface ResponseRoleCreateResponse {
  description?: string;
  domain_id?: string;
  extra?: Array<ResponseRoleExtraCreateResponse>;
  id?: string;
  name?: string;
}
export interface ResponseRoleExtraCreateResponse {
  description_i18n_id: string;
  display_name_i18n_id: string;
  display_order?: number;
  role_id?: string;
  role_type: ResponseRoleExtraCreateResponseRoleTypeEnum;
  scope: ResponseRoleExtraCreateResponseScopeEnum;
}

export const ResponseRoleExtraCreateResponseRoleTypeEnum = {
  Basic: 'basic',
  Standard: 'standard',
  Custom: 'custom',
} as const;

export type ResponseRoleExtraCreateResponseRoleTypeEnum =
  (typeof ResponseRoleExtraCreateResponseRoleTypeEnum)[keyof typeof ResponseRoleExtraCreateResponseRoleTypeEnum];
export const ResponseRoleExtraCreateResponseScopeEnum = {
  Domain: 'domain',
  Project: 'project',
} as const;

export type ResponseRoleExtraCreateResponseScopeEnum =
  (typeof ResponseRoleExtraCreateResponseScopeEnum)[keyof typeof ResponseRoleExtraCreateResponseScopeEnum];

export interface ResponseRoleWithImpliedResponse {
  implied_roles?: Array<ResponseCloudRole>;
  prior_role?: ResponseCloudRole;
}
export interface ResponseService {
  created_at?: string;
  description?: string;
  id?: string;
  ids?: Array<string>;
  name?: string;
  nick_name?: string;
  type?: string;
}
export interface ResponseServiceManageUserListElement {
  created_at?: string;
  description?: string;
  mng_dept?: string;
  mng_ldap_id?: string;
  service_type?: string;
  user_id?: string;
  user_name?: string;
}
export interface ResponseServiceManageUserListResponse {
  offset?: number;
  service_manage_users?: Array<ResponseServiceManageUserListElement>;
  size?: number;
  total?: number;
}
export interface ResponseServiceManageUserResponse {
  created_at?: string;
  description?: string;
  mng_dept?: string;
  mng_ldap_id?: string;
  service_type?: string;
  status?: ResponseServiceManageUserResponseStatusEnum;
  user_id?: string;
  user_name?: string;
}

export const ResponseServiceManageUserResponseStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseServiceManageUserResponseStatusEnum =
  (typeof ResponseServiceManageUserResponseStatusEnum)[keyof typeof ResponseServiceManageUserResponseStatusEnum];

export interface ResponseServices {
  services?: Array<ResponseService>;
  total?: number;
}
export interface ResponseSimpleCloudDomain {
  id?: string;
  name?: string;
}
export interface ResponseSimpleCloudDomainList {
  domains?: Array<ResponseSimpleCloudDomain>;
}
export interface ResponseSimpleCloudProjectDto {
  domain?: ResponseSimpleCloudDomain;
  id?: string;
  name?: string;
}
export interface ResponseSrcAcGetResponse {
  created_at?: string;
  domain_id?: string;
  enabled?: boolean;
  is_all_targets?: boolean;
  name?: string;
  policy_id?: string;
  policy_type?: ResponseSrcAcGetResponsePolicyTypeEnum;
  source?: string;
  updated_at?: string;
}

export const ResponseSrcAcGetResponsePolicyTypeEnum = {
  IpHost: 'IPHost',
} as const;

export type ResponseSrcAcGetResponsePolicyTypeEnum =
  (typeof ResponseSrcAcGetResponsePolicyTypeEnum)[keyof typeof ResponseSrcAcGetResponsePolicyTypeEnum];

export interface ResponseSrcAcListElement {
  created_at?: string;
  domain_id?: string;
  enabled?: boolean;
  is_all_targets?: boolean;
  name?: string;
  policy_id?: string;
  policy_type?: ResponseSrcAcListElementPolicyTypeEnum;
  source?: string;
  target_count?: number;
  updated_at?: string;
}

export const ResponseSrcAcListElementPolicyTypeEnum = {
  IpHost: 'IPHost',
} as const;

export type ResponseSrcAcListElementPolicyTypeEnum =
  (typeof ResponseSrcAcListElementPolicyTypeEnum)[keyof typeof ResponseSrcAcListElementPolicyTypeEnum];

export interface ResponseSrcAcListResponse {
  offset?: number;
  policies?: Array<ResponseSrcAcListElement>;
  size?: number;
  total?: number;
}
export interface ResponseSrcAcPoolCreateResponse {
  host_pools?: Array<ResponseSrcAcPoolGetResponse>;
  total?: number;
}
export interface ResponseSrcAcPoolGetResponse {
  domain_id?: string;
  host?: string;
  host_pool_id?: string;
  interface?: ResponseSrcAcPoolGetResponseInterfaceEnum;
  is_openapi?: boolean;
  service_display_name?: string;
}

export const ResponseSrcAcPoolGetResponseInterfaceEnum = {
  Public: 'Public',
  Private: 'Private',
} as const;

export type ResponseSrcAcPoolGetResponseInterfaceEnum =
  (typeof ResponseSrcAcPoolGetResponseInterfaceEnum)[keyof typeof ResponseSrcAcPoolGetResponseInterfaceEnum];

export interface ResponseSrcAcPoolListForDomainResponse {
  host_pools?: Array<ResponseSrcAcPoolGetResponse>;
  total?: number;
}
export interface ResponseSrcAcPoolListResponse {
  host_pools?: Array<ResponseSrcAcPoolGetResponse>;
  offset?: number;
  size?: number;
  total?: number;
}
export interface ResponseSrcAcTarget {
  interface?: ResponseSrcAcTargetInterfaceEnum;
  is_openapi?: boolean;
  service_display_name?: string;
  target_host_pool_id?: string;
  value?: string;
}

export const ResponseSrcAcTargetInterfaceEnum = {
  Public: 'Public',
  Private: 'Private',
} as const;

export type ResponseSrcAcTargetInterfaceEnum =
  (typeof ResponseSrcAcTargetInterfaceEnum)[keyof typeof ResponseSrcAcTargetInterfaceEnum];

export interface ResponseSrcAcTargetListResponse {
  offset?: number;
  size?: number;
  targets?: Array<ResponseSrcAcTarget>;
  total?: number;
}
export interface ResponseSuggestedGroup {
  id?: string;
  name?: string;
}
export interface ResponseSuggestedGroups {
  groups?: Array<ResponseSuggestedGroup>;
}
export interface ResponseSuggestedProject {
  id?: string;
  name?: string;
}
export interface ResponseSuggestedUser {
  email?: string;
  id?: string;
  name?: string;
  nickname?: string;
  realname?: string;
}
export interface ResponseSuggestedUsers {
  users?: Array<ResponseSuggestedUser>;
}
export interface ResponseTerm {
  category?: string;
  code?: string;
  contents?: string;
  created_at?: string;
  published_at?: string;
  seq?: number;
  title?: string;
  updated_at?: string;
  updated_by?: string;
  version?: number;
}
export interface ResponseTermNotice {
  contents?: string;
  created_at?: string;
  email_sent?: boolean;
  seq?: number;
  title?: string;
  updated_at?: string;
  updated_by?: string;
}
export interface ResponseTermNoticeList {
  term_notices?: Array<ResponseTermNotice>;
  total?: number;
}
export interface ResponseTermVersion {
  published_at?: string;
  version?: number;
}
export interface ResponseTermWithVersions {
  term?: ResponseTerm;
  versions?: Array<ResponseTermVersion>;
}
export interface ResponseTokenResponse {
  token?: DomainTokenRes;
}
export interface ResponseTranslationContent {
  id: string;
  language_code: string;
  updated_at?: string;
  value: string;
}
export interface ResponseTranslationContentList {
  total?: number;
  translation_contents?: Array<ResponseTranslationContent>;
}
export interface ResponseTrusts {
  trust?: ResponseTrustsDto;
}
export interface ResponseTrustsDto {
  allow_redelegation?: boolean;
  expires_at?: string;
  id?: string;
  impersonation?: boolean;
  project_id?: string;
  roles?: Array<ResponseCloudRole>;
  trustee_user_id?: string;
  trustor_user_id?: string;
}
export interface ResponseUserConsent {
  client_Name?: string;
  client_id?: string;
  created_at?: string;
  user_id?: string;
}
export interface ResponseUserConsentResponse {
  consents?: Array<ResponseUserConsent>;
}
export interface ResponseUserCredentialWithBlobResponse {
  blob?: ResponseBlobResponse;
  id?: string;
  project_id?: string;
  type?: string;
  user_id?: string;
}
export interface ResponseUserGetByProjectResponse {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseUserGetByProjectResponseLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseUserGetByProjectResponseStatusEnum;
  telephone?: string;
  user_type?: ResponseUserGetByProjectResponseUserTypeEnum;
}

export const ResponseUserGetByProjectResponseLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseUserGetByProjectResponseLanguageCodeEnum =
  (typeof ResponseUserGetByProjectResponseLanguageCodeEnum)[keyof typeof ResponseUserGetByProjectResponseLanguageCodeEnum];
export const ResponseUserGetByProjectResponseStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseUserGetByProjectResponseStatusEnum =
  (typeof ResponseUserGetByProjectResponseStatusEnum)[keyof typeof ResponseUserGetByProjectResponseStatusEnum];
export const ResponseUserGetByProjectResponseUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseUserGetByProjectResponseUserTypeEnum =
  (typeof ResponseUserGetByProjectResponseUserTypeEnum)[keyof typeof ResponseUserGetByProjectResponseUserTypeEnum];

export interface ResponseUserInfoResponse {
  domain_id?: string;
  domain_name?: string;
  email?: string;
  email_verified?: boolean;
  name?: string;
  nickname?: string;
  phone_number?: string;
  phone_number_verified?: boolean;
  user_id?: string;
}
export interface ResponseUserListByIdsElement {
  created_at?: string;
  default_project_id?: string;
  disabled_at?: string;
  domain?: ResponseSimpleCloudDomain;
  email?: string;
  enabled?: boolean;
  id?: string;
  language_code?: ResponseUserListByIdsElementLanguageCodeEnum;
  last_login_at?: string;
  name?: string;
  nickname?: string;
  password_changed_at?: string;
  password_expires_at?: string;
  profile_url?: string;
  realname?: string;
  status?: ResponseUserListByIdsElementStatusEnum;
  telephone?: string;
  user_type?: ResponseUserListByIdsElementUserTypeEnum;
}

export const ResponseUserListByIdsElementLanguageCodeEnum = {
  Ko: 'ko',
  En: 'en',
} as const;

export type ResponseUserListByIdsElementLanguageCodeEnum =
  (typeof ResponseUserListByIdsElementLanguageCodeEnum)[keyof typeof ResponseUserListByIdsElementLanguageCodeEnum];
export const ResponseUserListByIdsElementStatusEnum = {
  Active: 'ACTIVE',
  Invited: 'INVITED',
  Blocked: 'BLOCKED',
} as const;

export type ResponseUserListByIdsElementStatusEnum =
  (typeof ResponseUserListByIdsElementStatusEnum)[keyof typeof ResponseUserListByIdsElementStatusEnum];
export const ResponseUserListByIdsElementUserTypeEnum = {
  All: 'all',
  User: 'user',
  Account: 'account',
  Agent: 'agent',
  Manage: 'manage',
} as const;

export type ResponseUserListByIdsElementUserTypeEnum =
  (typeof ResponseUserListByIdsElementUserTypeEnum)[keyof typeof ResponseUserListByIdsElementUserTypeEnum];

export interface ResponseUserListByIdsResponse {
  users?: Array<ResponseUserListByIdsElement>;
}
export interface ResponseValidateLoginResponse {
  logged_in?: boolean;
  redirect_uri?: string;
}
export interface RouterSwaggerAuth {
  identity?: RouterSwaggerIdPwd;
  scope?: RouterSwaggerScope;
}
export interface RouterSwaggerCredentials {
  access: string;
  headers?: RouterSwaggerS3Headers;
  signature: string;
  token: string;
}
export interface RouterSwaggerDomain {
  name?: string;
}
export interface RouterSwaggerIdPwd {
  methods?: Array<string>;
  password?: RouterSwaggerUserPassword;
}
export interface RouterSwaggerIdPwdRequest {
  auth?: RouterSwaggerAuth;
}
export interface RouterSwaggerPasswordUser {
  domain?: RouterSwaggerDomain;
  name?: string;
  password?: string;
}
export interface RouterSwaggerProject {
  domain?: RouterSwaggerDomain;
  name?: string;
}
export interface RouterSwaggerS3Headers {
  /**
   * RFC3339 형식의 입력만 가능
   */
  'X-Amz-Date'?: string;
}
export interface RouterSwaggerS3Request {
  credentials?: RouterSwaggerCredentials;
}
export interface RouterSwaggerScope {
  project?: RouterSwaggerProject;
}
export interface RouterSwaggerUserPassword {
  user?: RouterSwaggerPasswordUser;
}
export interface ServersBulkResponse {
  data?: Array<ServersDataResponse>;
  metadata?: ServersMetaDataResponse;
}
export interface ServersDataResponse {
  error?: string;
  item?: object;
  status?: number;
}
export interface ServersMetaDataResponse {
  failure?: number;
  success?: number;
  total?: number;
}

/**
 * AccessGrantedIpApi - axios parameter creator
 */
export const AccessGrantedIpApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * domain 콘솔 접근 아이피 전체 데이터 삭제
     * @summary 콘솔 접근 허용 아이피 일괄 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpDelete: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpDelete', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/access-granted-ip`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 콘솔 접근 아이피 목록 조회
     * @summary 콘솔 접근 허용 아이피 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpGet: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/access-granted-ip`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 콘솔 접근 아이피 삭제
     * @summary 콘솔 접근 허용 아이피 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {number} ipSeq 아이피 Seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete: async (
      xAuthToken: string,
      domainId: string,
      ipSeq: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete', 'domainId', domainId);
      // verify required parameter 'ipSeq' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete', 'ipSeq', ipSeq);
      const localVarPath = `/api/v1/domains/{domain_id}/access-granted-ip/{ip_seq}`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{ip_seq}', encodeURIComponent(String(ipSeq)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain별 콘솔 접근 아이피 일괄 등록
     * @summary 콘솔 접근 허용 아이피 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestAccessGrantedIpCreateRequest} accessGrantedIp 접근 허용 아이피 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpPost: async (
      xAuthToken: string,
      domainId: string,
      accessGrantedIp: RequestAccessGrantedIpCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpPost', 'domainId', domainId);
      // verify required parameter 'accessGrantedIp' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdAccessGrantedIpPost',
        'accessGrantedIp',
        accessGrantedIp,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/access-granted-ip`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGrantedIp,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain별 콘솔 접근 아이피 일괄 삭제 후 등록 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 콘솔 접근 허용 아이피 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestAccessGrantedIpCreateRequest} accessGrantedIp 접근 허용 아이피 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpPut: async (
      xAuthToken: string,
      domainId: string,
      accessGrantedIp: RequestAccessGrantedIpCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAccessGrantedIpPut', 'domainId', domainId);
      // verify required parameter 'accessGrantedIp' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdAccessGrantedIpPut',
        'accessGrantedIp',
        accessGrantedIp,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/access-granted-ip`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        accessGrantedIp,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AccessGrantedIpApi - functional programming interface
 */
export const AccessGrantedIpApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AccessGrantedIpApiAxiosParamCreator(configuration);
  return {
    /**
     * domain 콘솔 접근 아이피 전체 데이터 삭제
     * @summary 콘솔 접근 허용 아이피 일괄 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdAccessGrantedIpDelete(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdAccessGrantedIpDelete(
          xAuthToken,
          domainId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGrantedIpApi.apiV1DomainsDomainIdAccessGrantedIpDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 콘솔 접근 아이피 목록 조회
     * @summary 콘솔 접근 허용 아이피 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdAccessGrantedIpGet(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAccessGrantedIps>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdAccessGrantedIpGet(
          xAuthToken,
          domainId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGrantedIpApi.apiV1DomainsDomainIdAccessGrantedIpGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 콘솔 접근 아이피 삭제
     * @summary 콘솔 접근 허용 아이피 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {number} ipSeq 아이피 Seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
      xAuthToken: string,
      domainId: string,
      ipSeq: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
          xAuthToken,
          domainId,
          ipSeq,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGrantedIpApi.apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain별 콘솔 접근 아이피 일괄 등록
     * @summary 콘솔 접근 허용 아이피 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestAccessGrantedIpCreateRequest} accessGrantedIp 접근 허용 아이피 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdAccessGrantedIpPost(
      xAuthToken: string,
      domainId: string,
      accessGrantedIp: RequestAccessGrantedIpCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAccessGrantedIps>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdAccessGrantedIpPost(
          xAuthToken,
          domainId,
          accessGrantedIp,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGrantedIpApi.apiV1DomainsDomainIdAccessGrantedIpPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain별 콘솔 접근 아이피 일괄 삭제 후 등록 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 콘솔 접근 허용 아이피 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestAccessGrantedIpCreateRequest} accessGrantedIp 접근 허용 아이피 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdAccessGrantedIpPut(
      xAuthToken: string,
      domainId: string,
      accessGrantedIp: RequestAccessGrantedIpCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAccessGrantedIps>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdAccessGrantedIpPut(
          xAuthToken,
          domainId,
          accessGrantedIp,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessGrantedIpApi.apiV1DomainsDomainIdAccessGrantedIpPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AccessGrantedIpApi - factory interface
 */
export const AccessGrantedIpApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AccessGrantedIpApiFp(configuration);
  return {
    /**
     * domain 콘솔 접근 아이피 전체 데이터 삭제
     * @summary 콘솔 접근 허용 아이피 일괄 삭제
     * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpDelete(
      requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdAccessGrantedIpDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 콘솔 접근 아이피 목록 조회
     * @summary 콘솔 접근 허용 아이피 목록 조회
     * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpGet(
      requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAccessGrantedIps> {
      return localVarFp
        .apiV1DomainsDomainIdAccessGrantedIpGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 콘솔 접근 아이피 삭제
     * @summary 콘솔 접근 허용 아이피 삭제
     * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
      requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.ipSeq,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain별 콘솔 접근 아이피 일괄 등록
     * @summary 콘솔 접근 허용 아이피 생성
     * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpPost(
      requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAccessGrantedIps> {
      return localVarFp
        .apiV1DomainsDomainIdAccessGrantedIpPost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.accessGrantedIp,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain별 콘솔 접근 아이피 일괄 삭제 후 등록 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 콘솔 접근 허용 아이피 변경
     * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAccessGrantedIpPut(
      requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAccessGrantedIps> {
      return localVarFp
        .apiV1DomainsDomainIdAccessGrantedIpPut(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.accessGrantedIp,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AccessGrantedIpApi - interface
 */
export interface AccessGrantedIpApiInterface {
  /**
   * domain 콘솔 접근 아이피 전체 데이터 삭제
   * @summary 콘솔 접근 허용 아이피 일괄 삭제
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdAccessGrantedIpDelete(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 콘솔 접근 아이피 목록 조회
   * @summary 콘솔 접근 허용 아이피 목록 조회
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdAccessGrantedIpGet(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAccessGrantedIps>;

  /**
   * domain 콘솔 접근 아이피 삭제
   * @summary 콘솔 접근 허용 아이피 삭제
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain별 콘솔 접근 아이피 일괄 등록
   * @summary 콘솔 접근 허용 아이피 생성
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdAccessGrantedIpPost(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAccessGrantedIps>;

  /**
   * domain별 콘솔 접근 아이피 일괄 삭제 후 등록 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 콘솔 접근 허용 아이피 변경
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdAccessGrantedIpPut(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAccessGrantedIps>;
}

/**
 * Request parameters for apiV1DomainsDomainIdAccessGrantedIpDelete operation in AccessGrantedIpApi.
 */
export interface AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdAccessGrantedIpGet operation in AccessGrantedIpApi.
 */
export interface AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete operation in AccessGrantedIpApi.
 */
export interface AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
   */
  readonly domainId: string;

  /**
   * 아이피 Seq
   */
  readonly ipSeq: number;
}

/**
 * Request parameters for apiV1DomainsDomainIdAccessGrantedIpPost operation in AccessGrantedIpApi.
 */
export interface AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
   */
  readonly domainId: string;

  /**
   * 접근 허용 아이피 정보
   */
  readonly accessGrantedIp: RequestAccessGrantedIpCreateRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdAccessGrantedIpPut operation in AccessGrantedIpApi.
 */
export interface AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32 maxLength&#x3D;32
   */
  readonly domainId: string;

  /**
   * 접근 허용 아이피 정보
   */
  readonly accessGrantedIp: RequestAccessGrantedIpCreateRequest;
}

/**
 * AccessGrantedIpApi - object-oriented interface
 */
export class AccessGrantedIpApi extends BaseAPI implements AccessGrantedIpApiInterface {
  /**
   * domain 콘솔 접근 아이피 전체 데이터 삭제
   * @summary 콘솔 접근 허용 아이피 일괄 삭제
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdAccessGrantedIpDelete(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AccessGrantedIpApiFp(this.configuration)
      .apiV1DomainsDomainIdAccessGrantedIpDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 콘솔 접근 아이피 목록 조회
   * @summary 콘솔 접근 허용 아이피 목록 조회
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdAccessGrantedIpGet(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AccessGrantedIpApiFp(this.configuration)
      .apiV1DomainsDomainIdAccessGrantedIpGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 콘솔 접근 아이피 삭제
   * @summary 콘솔 접근 허용 아이피 삭제
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpIpSeqDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AccessGrantedIpApiFp(this.configuration)
      .apiV1DomainsDomainIdAccessGrantedIpIpSeqDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.ipSeq,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain별 콘솔 접근 아이피 일괄 등록
   * @summary 콘솔 접근 허용 아이피 생성
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdAccessGrantedIpPost(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AccessGrantedIpApiFp(this.configuration)
      .apiV1DomainsDomainIdAccessGrantedIpPost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.accessGrantedIp,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain별 콘솔 접근 아이피 일괄 삭제 후 등록 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 콘솔 접근 허용 아이피 변경
   * @param {AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdAccessGrantedIpPut(
    requestParameters: AccessGrantedIpApiApiV1DomainsDomainIdAccessGrantedIpPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AccessGrantedIpApiFp(this.configuration)
      .apiV1DomainsDomainIdAccessGrantedIpPut(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.accessGrantedIp,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ApplicationCredentialsApi - axios parameter creator
 */
export const ApplicationCredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 사용자의 지정한 application credential 삭제
     * @summary 사용자의 지정한 application credential 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {Array<string>} applicationCredentialIds ApplicationCredential ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11UsersUserIdApplicationCredentialsDelete: async (
      xAuthToken: string,
      userId: string,
      applicationCredentialIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11UsersUserIdApplicationCredentialsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV11UsersUserIdApplicationCredentialsDelete', 'userId', userId);
      // verify required parameter 'applicationCredentialIds' is not null or undefined
      assertParamExists(
        'apiV11UsersUserIdApplicationCredentialsDelete',
        'applicationCredentialIds',
        applicationCredentialIds,
      );
      const localVarPath = `/api/v1_1/users/{user_id}/application_credentials`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (applicationCredentialIds) {
        localVarQueryParameter['application_credential_ids'] = applicationCredentialIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 지정한 application credential 상세 조회. roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
     * @summary 사용자의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet: async (
      xAuthToken: string,
      userId: string,
      applicationCredentialId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet',
        'userId',
        userId,
      );
      // verify required parameter 'applicationCredentialId' is not null or undefined
      assertParamExists(
        'apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet',
        'applicationCredentialId',
        applicationCredentialId,
      );
      const localVarPath =
        `/api/v1_2/users/{user_id}/application_credentials/{application_credential_id}`
          .replace('{user_id}', encodeURIComponent(String(userId)))
          .replace(
            '{application_credential_id}',
            encodeURIComponent(String(applicationCredentialId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 조직의 application credential 목록 조회
     * @summary 조직의 application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId 조직 id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {number} [offset] offset((page-1) * size). row 시작 위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 *size ..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [id] application credential id, 영소문자+숫자 32자
     * @param {string} [projectName] application credential\&#39;s project name, 영대소문자+숫자 32자
     * @param {string} [userName] application credential creator\&#39;s name, 영소문자+숫자+이메일 사용 가능 특수문자 32자
     * @param {boolean} [expiredOnly] list expired applications only, default&#x3D;false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdApplicationCredentialsGet: async (
      xAuthToken: string,
      domainId: string,
      offset?: number,
      size?: number,
      id?: string,
      projectName?: string,
      userName?: string,
      expiredOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdApplicationCredentialsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdApplicationCredentialsGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/application_credentials`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (projectName !== undefined) {
        localVarQueryParameter['project_name'] = projectName;
      }

      if (userName !== undefined) {
        localVarQueryParameter['user_name'] = userName;
      }

      if (expiredOnly !== undefined) {
        localVarQueryParameter['expired_only'] = expiredOnly;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get 사용자의 지정한 application credential 정보 상세 조회 Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/users/{user_id}/application_credentials/{application_credential_id} 로 대체되었다.
     * @summary 사용자의 지정한 application credential 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet: async (
      xAuthToken: string,
      userId: string,
      applicationCredentialId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet',
        'userId',
        userId,
      );
      // verify required parameter 'applicationCredentialId' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet',
        'applicationCredentialId',
        applicationCredentialId,
      );
      const localVarPath =
        `/api/v1/users/{user_id}/application_credentials/{application_credential_id}`
          .replace('{user_id}', encodeURIComponent(String(userId)))
          .replace(
            '{application_credential_id}',
            encodeURIComponent(String(applicationCredentialId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 사용자의 application credential 목록 조회
     * @summary 지정한 사용자의 application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {number} [offset] offset((page-1) * size). row 시작 위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 *size ..., default&#x3D;0
     * @param {string} [id] application credential id, 영소문자+숫자 32자
     * @param {string} [projectName] application credential\&#39;s project name, 영대소문자+숫자 32자
     * @param {boolean} [expiredOnly] list expired applications only, default&#x3D;false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsGet: async (
      xAuthToken: string,
      userId: string,
      size?: number,
      offset?: number,
      id?: string,
      projectName?: string,
      expiredOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdApplicationCredentialsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdApplicationCredentialsGet', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}/application_credentials`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (projectName !== undefined) {
        localVarQueryParameter['project_name'] = projectName;
      }

      if (expiredOnly !== undefined) {
        localVarQueryParameter['expired_only'] = expiredOnly;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인. 동일한 이름이 존재하는 경우 http status 204, 아닌 경우 404
     * @summary 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} applicationCredentialName application_credential_name, 영대소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead: async (
      xAuthToken: string,
      userId: string,
      applicationCredentialName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead',
        'userId',
        userId,
      );
      // verify required parameter 'applicationCredentialName' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead',
        'applicationCredentialName',
        applicationCredentialName,
      );
      const localVarPath =
        `/api/v1/users/{user_id}/application_credentials/name/{application_credential_name}`
          .replace('{user_id}', encodeURIComponent(String(userId)))
          .replace(
            '{application_credential_name}',
            encodeURIComponent(String(applicationCredentialName)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 application credential 생성 credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
     * @summary 사용자의 application credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestApplicationCredentialCreateRequest} request Name(required), description(optional), expire_at(optional) and roles(optional, ID or name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsPost: async (
      xAuthToken: string,
      userId: string,
      request: RequestApplicationCredentialCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdApplicationCredentialsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdApplicationCredentialsPost', 'userId', userId);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1UsersUserIdApplicationCredentialsPost', 'request', request);
      const localVarPath = `/api/v1/users/{user_id}/application_credentials`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ApplicationCredentialsApi - functional programming interface
 */
export const ApplicationCredentialsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ApplicationCredentialsApiAxiosParamCreator(configuration);
  return {
    /**
     * 사용자의 지정한 application credential 삭제
     * @summary 사용자의 지정한 application credential 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {Array<string>} applicationCredentialIds ApplicationCredential ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11UsersUserIdApplicationCredentialsDelete(
      xAuthToken: string,
      userId: string,
      applicationCredentialIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseApplicationCredentialDeleteResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV11UsersUserIdApplicationCredentialsDelete(
          xAuthToken,
          userId,
          applicationCredentialIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ApplicationCredentialsApi.apiV11UsersUserIdApplicationCredentialsDelete'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 지정한 application credential 상세 조회. roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
     * @summary 사용자의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
      xAuthToken: string,
      userId: string,
      applicationCredentialId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDisplayDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
          xAuthToken,
          userId,
          applicationCredentialId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ApplicationCredentialsApi.apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 조직의 application credential 목록 조회
     * @summary 조직의 application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId 조직 id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {number} [offset] offset((page-1) * size). row 시작 위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 *size ..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [id] application credential id, 영소문자+숫자 32자
     * @param {string} [projectName] application credential\&#39;s project name, 영대소문자+숫자 32자
     * @param {string} [userName] application credential creator\&#39;s name, 영소문자+숫자+이메일 사용 가능 특수문자 32자
     * @param {boolean} [expiredOnly] list expired applications only, default&#x3D;false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdApplicationCredentialsGet(
      xAuthToken: string,
      domainId: string,
      offset?: number,
      size?: number,
      id?: string,
      projectName?: string,
      userName?: string,
      expiredOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDtos>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdApplicationCredentialsGet(
          xAuthToken,
          domainId,
          offset,
          size,
          id,
          projectName,
          userName,
          expiredOnly,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ApplicationCredentialsApi.apiV1DomainsDomainIdApplicationCredentialsGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get 사용자의 지정한 application credential 정보 상세 조회 Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/users/{user_id}/application_credentials/{application_credential_id} 로 대체되었다.
     * @summary 사용자의 지정한 application credential 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
      xAuthToken: string,
      userId: string,
      applicationCredentialId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
          xAuthToken,
          userId,
          applicationCredentialId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ApplicationCredentialsApi.apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 사용자의 application credential 목록 조회
     * @summary 지정한 사용자의 application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {number} [offset] offset((page-1) * size). row 시작 위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 *size ..., default&#x3D;0
     * @param {string} [id] application credential id, 영소문자+숫자 32자
     * @param {string} [projectName] application credential\&#39;s project name, 영대소문자+숫자 32자
     * @param {boolean} [expiredOnly] list expired applications only, default&#x3D;false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdApplicationCredentialsGet(
      xAuthToken: string,
      userId: string,
      size?: number,
      offset?: number,
      id?: string,
      projectName?: string,
      expiredOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDtos>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdApplicationCredentialsGet(
          xAuthToken,
          userId,
          size,
          offset,
          id,
          projectName,
          expiredOnly,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ApplicationCredentialsApi.apiV1UsersUserIdApplicationCredentialsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인. 동일한 이름이 존재하는 경우 http status 204, 아닌 경우 404
     * @summary 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} applicationCredentialName application_credential_name, 영대소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
      xAuthToken: string,
      userId: string,
      applicationCredentialName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
          xAuthToken,
          userId,
          applicationCredentialName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ApplicationCredentialsApi.apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 application credential 생성 credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
     * @summary 사용자의 application credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestApplicationCredentialCreateRequest} request Name(required), description(optional), expire_at(optional) and roles(optional, ID or name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdApplicationCredentialsPost(
      xAuthToken: string,
      userId: string,
      request: RequestApplicationCredentialCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdApplicationCredentialsPost(
          xAuthToken,
          userId,
          request,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ApplicationCredentialsApi.apiV1UsersUserIdApplicationCredentialsPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ApplicationCredentialsApi - factory interface
 */
export const ApplicationCredentialsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ApplicationCredentialsApiFp(configuration);
  return {
    /**
     * 사용자의 지정한 application credential 삭제
     * @summary 사용자의 지정한 application credential 삭제
     * @param {ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11UsersUserIdApplicationCredentialsDelete(
      requestParameters: ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseApplicationCredentialDeleteResponse> {
      return localVarFp
        .apiV11UsersUserIdApplicationCredentialsDelete(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.applicationCredentialIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 지정한 application credential 상세 조회. roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
     * @summary 사용자의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
     * @param {ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
      requestParameters: ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDisplayDto> {
      return localVarFp
        .apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.applicationCredentialId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 조직의 application credential 목록 조회
     * @summary 조직의 application credential 목록 조회
     * @param {ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdApplicationCredentialsGet(
      requestParameters: ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDtos> {
      return localVarFp
        .apiV1DomainsDomainIdApplicationCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.id,
          requestParameters.projectName,
          requestParameters.userName,
          requestParameters.expiredOnly,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Get 사용자의 지정한 application credential 정보 상세 조회 Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/users/{user_id}/application_credentials/{application_credential_id} 로 대체되었다.
     * @summary 사용자의 지정한 application credential 정보 상세 조회
     * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
      requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDto> {
      return localVarFp
        .apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.applicationCredentialId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 사용자의 application credential 목록 조회
     * @summary 지정한 사용자의 application credential 목록 조회
     * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsGet(
      requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDtos> {
      return localVarFp
        .apiV1UsersUserIdApplicationCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.id,
          requestParameters.projectName,
          requestParameters.expiredOnly,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인. 동일한 이름이 존재하는 경우 http status 204, 아닌 경우 404
     * @summary 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인
     * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
      requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.applicationCredentialName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 application credential 생성 credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
     * @summary 사용자의 application credential 생성
     * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdApplicationCredentialsPost(
      requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDto> {
      return localVarFp
        .apiV1UsersUserIdApplicationCredentialsPost(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ApplicationCredentialsApi - interface
 */
export interface ApplicationCredentialsApiInterface {
  /**
   * 사용자의 지정한 application credential 삭제
   * @summary 사용자의 지정한 application credential 삭제
   * @param {ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11UsersUserIdApplicationCredentialsDelete(
    requestParameters: ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseApplicationCredentialDeleteResponse>;

  /**
   * 사용자의 지정한 application credential 상세 조회. roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
   * @summary 사용자의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
   * @param {ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDisplayDto>;

  /**
   * 조직의 application credential 목록 조회
   * @summary 조직의 application credential 목록 조회
   * @param {ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdApplicationCredentialsGet(
    requestParameters: ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDtos>;

  /**
   * Get 사용자의 지정한 application credential 정보 상세 조회 Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/users/{user_id}/application_credentials/{application_credential_id} 로 대체되었다.
   * @summary 사용자의 지정한 application credential 정보 상세 조회
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDto>;

  /**
   * 지정한 사용자의 application credential 목록 조회
   * @summary 지정한 사용자의 application credential 목록 조회
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdApplicationCredentialsGet(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDtos>;

  /**
   * 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인. 동일한 이름이 존재하는 경우 http status 204, 아닌 경우 404
   * @summary 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 application credential 생성 credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
   * @summary 사용자의 application credential 생성
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdApplicationCredentialsPost(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDto>;
}

/**
 * Request parameters for apiV11UsersUserIdApplicationCredentialsDelete operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * ApplicationCredential ID, 영소문자+숫자 32자
   */
  readonly applicationCredentialIds: Array<string>;
}

/**
 * Request parameters for apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * application_credential_id, 영소문자+숫자 32자
   */
  readonly applicationCredentialId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdApplicationCredentialsGet operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 조직 id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * offset((page-1) * size). row 시작 위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 *size ..., default&#x3D;0
   */
  readonly offset?: number;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * application credential id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * application credential\&#39;s project name, 영대소문자+숫자 32자
   */
  readonly projectName?: string;

  /**
   * application credential creator\&#39;s name, 영소문자+숫자+이메일 사용 가능 특수문자 32자
   */
  readonly userName?: string;

  /**
   * list expired applications only, default&#x3D;false
   */
  readonly expiredOnly?: boolean;
}

/**
 * Request parameters for apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * application_credential_id, 영소문자+숫자 32자
   */
  readonly applicationCredentialId: string;
}

/**
 * Request parameters for apiV1UsersUserIdApplicationCredentialsGet operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * offset((page-1) * size). row 시작 위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 *size ..., default&#x3D;0
   */
  readonly offset?: number;

  /**
   * application credential id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * application credential\&#39;s project name, 영대소문자+숫자 32자
   */
  readonly projectName?: string;

  /**
   * list expired applications only, default&#x3D;false
   */
  readonly expiredOnly?: boolean;
}

/**
 * Request parameters for apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * application_credential_name, 영대소문자+숫자 32자
   */
  readonly applicationCredentialName: string;
}

/**
 * Request parameters for apiV1UsersUserIdApplicationCredentialsPost operation in ApplicationCredentialsApi.
 */
export interface ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * Name(required), description(optional), expire_at(optional) and roles(optional, ID or name)
   */
  readonly request: RequestApplicationCredentialCreateRequest;
}

/**
 * ApplicationCredentialsApi - object-oriented interface
 */
export class ApplicationCredentialsApi
  extends BaseAPI
  implements ApplicationCredentialsApiInterface
{
  /**
   * 사용자의 지정한 application credential 삭제
   * @summary 사용자의 지정한 application credential 삭제
   * @param {ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11UsersUserIdApplicationCredentialsDelete(
    requestParameters: ApplicationCredentialsApiApiV11UsersUserIdApplicationCredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV11UsersUserIdApplicationCredentialsDelete(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.applicationCredentialIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 지정한 application credential 상세 조회. roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
   * @summary 사용자의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
   * @param {ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ApplicationCredentialsApiApiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV12UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.applicationCredentialId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 조직의 application credential 목록 조회
   * @summary 조직의 application credential 목록 조회
   * @param {ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdApplicationCredentialsGet(
    requestParameters: ApplicationCredentialsApiApiV1DomainsDomainIdApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV1DomainsDomainIdApplicationCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.id,
        requestParameters.projectName,
        requestParameters.userName,
        requestParameters.expiredOnly,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get 사용자의 지정한 application credential 정보 상세 조회 Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/users/{user_id}/application_credentials/{application_credential_id} 로 대체되었다.
   * @summary 사용자의 지정한 application credential 정보 상세 조회
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV1UsersUserIdApplicationCredentialsApplicationCredentialIdGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.applicationCredentialId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 사용자의 application credential 목록 조회
   * @summary 지정한 사용자의 application credential 목록 조회
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdApplicationCredentialsGet(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV1UsersUserIdApplicationCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.id,
        requestParameters.projectName,
        requestParameters.expiredOnly,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인. 동일한 이름이 존재하는 경우 http status 204, 아닌 경우 404
   * @summary 사용자의 application credential 목록 중에 동일한 이름이 존재하는지 확인
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV1UsersUserIdApplicationCredentialsNameApplicationCredentialNameHead(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.applicationCredentialName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 application credential 생성 credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
   * @summary 사용자의 application credential 생성
   * @param {ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdApplicationCredentialsPost(
    requestParameters: ApplicationCredentialsApiApiV1UsersUserIdApplicationCredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ApplicationCredentialsApiFp(this.configuration)
      .apiV1UsersUserIdApplicationCredentialsPost(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 암호화 키 발급 요청. 현재 RSA만 지원
     * @summary 암호화 키 발급 요청
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {RequestEncryptKeyIssueRequest} request 발송 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1EncryptIssueKeyPost: async (
      authorization: string,
      request: RequestEncryptKeyIssueRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('accountV1EncryptIssueKeyPost', 'authorization', authorization);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('accountV1EncryptIssueKeyPost', 'request', request);
      const localVarPath = `/account/v1/encrypt/issue-key`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 도메인 리소스(user) 삭제 전 사용자의 비밀번호 재확인
     * @summary 도메인 리소스 삭제 전 사용자의 비밀번호 재확인
     * @param {string} xAuthToken authentication token
     * @param {RequestCheckPasswordRequest} checkPasswordRequest CheckPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthCheckPasswordForDeletionPost: async (
      xAuthToken: string,
      checkPasswordRequest: RequestCheckPasswordRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AuthCheckPasswordForDeletionPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'checkPasswordRequest' is not null or undefined
      assertParamExists(
        'apiV1AuthCheckPasswordForDeletionPost',
        'checkPasswordRequest',
        checkPasswordRequest,
      );
      const localVarPath = `/api/v1/auth/check-password/for-deletion`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 5분 이내에 사용자의 비밀번호 재확인 성공 여부가 존재하는지 확인
     * @summary 사용자의 비밀번호 재확인 성공 여부 조회
     * @param {string} xAuthToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthCheckPasswordHead: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AuthCheckPasswordHead', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/auth/check-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 비밀번호 재확인
     * @summary 사용자의 비밀번호 재확인
     * @param {string} xAuthToken authentication token
     * @param {RequestCheckPasswordRequest} checkPasswordRequest CheckPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthCheckPasswordPost: async (
      xAuthToken: string,
      checkPasswordRequest: RequestCheckPasswordRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AuthCheckPasswordPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'checkPasswordRequest' is not null or undefined
      assertParamExists('apiV1AuthCheckPasswordPost', 'checkPasswordRequest', checkPasswordRequest);
      const localVarPath = `/api/v1/auth/check-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * POST /auth/v1/tokens/issue API 의 서버용 버젼. 쿠키 처리 로직만 다름 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
     * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId] domain id
     * @param {string} [projectId] project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthTokensIssuePost: async (
      xAuthToken: string,
      domainId?: string,
      projectId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AuthTokensIssuePost', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/auth/tokens/issue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * permission id 에 대한 토큰 권한 확인. 권한 소유 여부와 함께 토큰 정보 전달 permission_id : 확인하고자 하는 permission id target_domain_id : 주어진 id와 토큰의 domain id의 일치여부를 추가적으로 검사 target_project_id : 주어진 id와 토큰의 project id의 일치여부를 추가적으로 검사 target_domain_id_of_project : 주어진 id와 토큰의 project의 domain id 일치여부를 추가적으로 검사 target_user_id : 본인 또는 리소스 소유자 확인시 사용(target_user_id와 token user id 일치여부). 일치하는 경우 permission, 역할과 관계없이 allow: true로 응답 current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사. 단 constants.ReturnCatalogForDomainScope 가 false 이면 domain/system scope 토큰은 catalog 를 조회하지 않아 이 검사를 수행하지 않음 (project scope 토큰만 검사) client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
     * @summary permission id 에 대한 토큰 권한 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [noCatalog] true인 경우 응답에서  token.catalog 정보를 생략
     * @param {RequestAuthenticateRbacRequest} [authenticateRbacRequest] AuthenticateRbacRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RbacAuthPost: async (
      xAuthToken: string,
      noCatalog?: string,
      authenticateRbacRequest?: RequestAuthenticateRbacRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RbacAuthPost', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/rbac/auth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (noCatalog !== undefined) {
        localVarQueryParameter['no_catalog'] = noCatalog;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        authenticateRbacRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * permission id 에 대한 유저의 프로젝트 권한 확인. 주어진 permission에 대해 request user가 필요한 project 권한을 가지고 있는지 확인. system reader 토큰 필요 permission_id : 확인하고자 하는 permission id user_id : 권한을 조회할 user id project_id : 권한을 조회할 project id current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사 client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
     * @summary permission id 에 대한 유저의 프로젝트 권한 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCheckPermissionForSystemRequest} [request] CheckPermissionForSystemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RbacSystemAuthPost: async (
      xAuthToken: string,
      request?: RequestCheckPermissionForSystemRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RbacSystemAuthPost', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/rbac/system/auth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OIDC 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
     * @summary OIDC 연동 테스트 URL
     * @param {string} clientAuth auth 방식(body or header). ex) body
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {string} authorizationUrl authorization url
     * @param {string} tokenUrl token url
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authOidcDryRunAuthorizationPost: async (
      clientAuth: string,
      clientId: string,
      clientSecret: string,
      authorizationUrl: string,
      tokenUrl: string,
      upnSuffix?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientAuth' is not null or undefined
      assertParamExists('authOidcDryRunAuthorizationPost', 'clientAuth', clientAuth);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('authOidcDryRunAuthorizationPost', 'clientId', clientId);
      // verify required parameter 'clientSecret' is not null or undefined
      assertParamExists('authOidcDryRunAuthorizationPost', 'clientSecret', clientSecret);
      // verify required parameter 'authorizationUrl' is not null or undefined
      assertParamExists('authOidcDryRunAuthorizationPost', 'authorizationUrl', authorizationUrl);
      // verify required parameter 'tokenUrl' is not null or undefined
      assertParamExists('authOidcDryRunAuthorizationPost', 'tokenUrl', tokenUrl);
      const localVarPath = `/auth/oidc/dry-run-authorization`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (clientAuth !== undefined) {
        localVarFormParams.append('client_auth', clientAuth as any);
      }

      if (clientId !== undefined) {
        localVarFormParams.append('client_id', clientId as any);
      }

      if (clientSecret !== undefined) {
        localVarFormParams.append('client_secret', clientSecret as any);
      }

      if (authorizationUrl !== undefined) {
        localVarFormParams.append('authorization_url', authorizationUrl as any);
      }

      if (tokenUrl !== undefined) {
        localVarFormParams.append('token_url', tokenUrl as any);
      }

      if (upnSuffix !== undefined) {
        localVarFormParams.append('upn_suffix', upnSuffix as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * deprecated. /auth/oidc/dry-run-authorization 를 사용하세요.
     * @summary (deprecated) OIDC 연동 테스트 URL
     * @param {string} clientAuth auth 방식(body or header). ex) body
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {string} authorizationUrl authorization url
     * @param {string} tokenUrl token url
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authOidcTestAuthorizationPost: async (
      clientAuth: string,
      clientId: string,
      clientSecret: string,
      authorizationUrl: string,
      tokenUrl: string,
      upnSuffix?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientAuth' is not null or undefined
      assertParamExists('authOidcTestAuthorizationPost', 'clientAuth', clientAuth);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('authOidcTestAuthorizationPost', 'clientId', clientId);
      // verify required parameter 'clientSecret' is not null or undefined
      assertParamExists('authOidcTestAuthorizationPost', 'clientSecret', clientSecret);
      // verify required parameter 'authorizationUrl' is not null or undefined
      assertParamExists('authOidcTestAuthorizationPost', 'authorizationUrl', authorizationUrl);
      // verify required parameter 'tokenUrl' is not null or undefined
      assertParamExists('authOidcTestAuthorizationPost', 'tokenUrl', tokenUrl);
      const localVarPath = `/auth/oidc/test-authorization`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (clientAuth !== undefined) {
        localVarFormParams.append('client_auth', clientAuth as any);
      }

      if (clientId !== undefined) {
        localVarFormParams.append('client_id', clientId as any);
      }

      if (clientSecret !== undefined) {
        localVarFormParams.append('client_secret', clientSecret as any);
      }

      if (authorizationUrl !== undefined) {
        localVarFormParams.append('authorization_url', authorizationUrl as any);
      }

      if (tokenUrl !== undefined) {
        localVarFormParams.append('token_url', tokenUrl as any);
      }

      if (upnSuffix !== undefined) {
        localVarFormParams.append('upn_suffix', upnSuffix as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * SAML 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
     * @summary SAML 연동 테스트 URL
     * @param {string} idpId idp id. ex) azuread
     * @param {string} samlIdpMetaUrl idp metadata url
     * @param {string} samlEntityId azuread의 경우 entity id(app id)
     * @param {string} samlKey saml key file string
     * @param {string} samlCert saml cert file string
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSamlDryRunAuthorizationPost: async (
      idpId: string,
      samlIdpMetaUrl: string,
      samlEntityId: string,
      samlKey: string,
      samlCert: string,
      upnSuffix?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'idpId' is not null or undefined
      assertParamExists('authSamlDryRunAuthorizationPost', 'idpId', idpId);
      // verify required parameter 'samlIdpMetaUrl' is not null or undefined
      assertParamExists('authSamlDryRunAuthorizationPost', 'samlIdpMetaUrl', samlIdpMetaUrl);
      // verify required parameter 'samlEntityId' is not null or undefined
      assertParamExists('authSamlDryRunAuthorizationPost', 'samlEntityId', samlEntityId);
      // verify required parameter 'samlKey' is not null or undefined
      assertParamExists('authSamlDryRunAuthorizationPost', 'samlKey', samlKey);
      // verify required parameter 'samlCert' is not null or undefined
      assertParamExists('authSamlDryRunAuthorizationPost', 'samlCert', samlCert);
      const localVarPath = `/auth/saml/dry-run-authorization`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (idpId !== undefined) {
        localVarFormParams.append('idp_id', idpId as any);
      }

      if (samlIdpMetaUrl !== undefined) {
        localVarFormParams.append('saml_idp_meta_url', samlIdpMetaUrl as any);
      }

      if (samlEntityId !== undefined) {
        localVarFormParams.append('saml_entity_id', samlEntityId as any);
      }

      if (samlKey !== undefined) {
        localVarFormParams.append('saml_key', samlKey as any);
      }

      if (samlCert !== undefined) {
        localVarFormParams.append('saml_cert', samlCert as any);
      }

      if (upnSuffix !== undefined) {
        localVarFormParams.append('upn_suffix', upnSuffix as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * deprecated. /auth/saml/dry-run-authorization 를 사용하세요.
     * @summary (deprecated) SAML 연동 테스트 URL
     * @param {string} idpId idp id. ex) azuread
     * @param {string} samlIdpMetaUrl idp metadata url
     * @param {string} samlEntityId azuread의 경우 entity id(app id)
     * @param {string} samlKey saml key file string
     * @param {string} samlCert saml cert file string
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authSamlTestAuthorizationPost: async (
      idpId: string,
      samlIdpMetaUrl: string,
      samlEntityId: string,
      samlKey: string,
      samlCert: string,
      upnSuffix?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'idpId' is not null or undefined
      assertParamExists('authSamlTestAuthorizationPost', 'idpId', idpId);
      // verify required parameter 'samlIdpMetaUrl' is not null or undefined
      assertParamExists('authSamlTestAuthorizationPost', 'samlIdpMetaUrl', samlIdpMetaUrl);
      // verify required parameter 'samlEntityId' is not null or undefined
      assertParamExists('authSamlTestAuthorizationPost', 'samlEntityId', samlEntityId);
      // verify required parameter 'samlKey' is not null or undefined
      assertParamExists('authSamlTestAuthorizationPost', 'samlKey', samlKey);
      // verify required parameter 'samlCert' is not null or undefined
      assertParamExists('authSamlTestAuthorizationPost', 'samlCert', samlCert);
      const localVarPath = `/auth/saml/test-authorization`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (idpId !== undefined) {
        localVarFormParams.append('idp_id', idpId as any);
      }

      if (samlIdpMetaUrl !== undefined) {
        localVarFormParams.append('saml_idp_meta_url', samlIdpMetaUrl as any);
      }

      if (samlEntityId !== undefined) {
        localVarFormParams.append('saml_entity_id', samlEntityId as any);
      }

      if (samlKey !== undefined) {
        localVarFormParams.append('saml_key', samlKey as any);
      }

      if (samlCert !== undefined) {
        localVarFormParams.append('saml_cert', samlCert as any);
      }

      if (upnSuffix !== undefined) {
        localVarFormParams.append('upn_suffix', upnSuffix as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * console 전용 API. 쿠키 기반으로 동작하기 때문에 host가 루트 도메인을 포함(서브 도메인)헤야 사용 가능. 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
     * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
     * @param {string} [domainId] domain id
     * @param {string} [projectId] project id
     * @param {boolean} [saveCookie] token 발급 시 쿠키에 저장여부. default&#x3D;true
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TokensIssuePost: async (
      domainId?: string,
      projectId?: string,
      saveCookie?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/v1/tokens/issue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId;
      }

      if (saveCookie !== undefined) {
        localVarQueryParameter['save_cookie'] = saveCookie;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
  return {
    /**
     * 암호화 키 발급 요청. 현재 RSA만 지원
     * @summary 암호화 키 발급 요청
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {RequestEncryptKeyIssueRequest} request 발송 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1EncryptIssueKeyPost(
      authorization: string,
      request: RequestEncryptKeyIssueRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEncryptKeyIssueResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1EncryptIssueKeyPost(
        authorization,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.accountV1EncryptIssueKeyPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 도메인 리소스(user) 삭제 전 사용자의 비밀번호 재확인
     * @summary 도메인 리소스 삭제 전 사용자의 비밀번호 재확인
     * @param {string} xAuthToken authentication token
     * @param {RequestCheckPasswordRequest} checkPasswordRequest CheckPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AuthCheckPasswordForDeletionPost(
      xAuthToken: string,
      checkPasswordRequest: RequestCheckPasswordRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AuthCheckPasswordForDeletionPost(
          xAuthToken,
          checkPasswordRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.apiV1AuthCheckPasswordForDeletionPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 5분 이내에 사용자의 비밀번호 재확인 성공 여부가 존재하는지 확인
     * @summary 사용자의 비밀번호 재확인 성공 여부 조회
     * @param {string} xAuthToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AuthCheckPasswordHead(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthCheckPasswordHead(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.apiV1AuthCheckPasswordHead']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 비밀번호 재확인
     * @summary 사용자의 비밀번호 재확인
     * @param {string} xAuthToken authentication token
     * @param {RequestCheckPasswordRequest} checkPasswordRequest CheckPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AuthCheckPasswordPost(
      xAuthToken: string,
      checkPasswordRequest: RequestCheckPasswordRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthCheckPasswordPost(
        xAuthToken,
        checkPasswordRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.apiV1AuthCheckPasswordPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * POST /auth/v1/tokens/issue API 의 서버용 버젼. 쿠키 처리 로직만 다름 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
     * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId] domain id
     * @param {string} [projectId] project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AuthTokensIssuePost(
      xAuthToken: string,
      domainId?: string,
      projectId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePrincipalDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthTokensIssuePost(
        xAuthToken,
        domainId,
        projectId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.apiV1AuthTokensIssuePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * permission id 에 대한 토큰 권한 확인. 권한 소유 여부와 함께 토큰 정보 전달 permission_id : 확인하고자 하는 permission id target_domain_id : 주어진 id와 토큰의 domain id의 일치여부를 추가적으로 검사 target_project_id : 주어진 id와 토큰의 project id의 일치여부를 추가적으로 검사 target_domain_id_of_project : 주어진 id와 토큰의 project의 domain id 일치여부를 추가적으로 검사 target_user_id : 본인 또는 리소스 소유자 확인시 사용(target_user_id와 token user id 일치여부). 일치하는 경우 permission, 역할과 관계없이 allow: true로 응답 current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사. 단 constants.ReturnCatalogForDomainScope 가 false 이면 domain/system scope 토큰은 catalog 를 조회하지 않아 이 검사를 수행하지 않음 (project scope 토큰만 검사) client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
     * @summary permission id 에 대한 토큰 권한 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [noCatalog] true인 경우 응답에서  token.catalog 정보를 생략
     * @param {RequestAuthenticateRbacRequest} [authenticateRbacRequest] AuthenticateRbacRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RbacAuthPost(
      xAuthToken: string,
      noCatalog?: string,
      authenticateRbacRequest?: RequestAuthenticateRbacRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseAuthenticatePermissionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RbacAuthPost(
        xAuthToken,
        noCatalog,
        authenticateRbacRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.apiV1RbacAuthPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * permission id 에 대한 유저의 프로젝트 권한 확인. 주어진 permission에 대해 request user가 필요한 project 권한을 가지고 있는지 확인. system reader 토큰 필요 permission_id : 확인하고자 하는 permission id user_id : 권한을 조회할 user id project_id : 권한을 조회할 project id current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사 client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
     * @summary permission id 에 대한 유저의 프로젝트 권한 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCheckPermissionForSystemRequest} [request] CheckPermissionForSystemRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RbacSystemAuthPost(
      xAuthToken: string,
      request?: RequestCheckPermissionForSystemRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCheckPermissionForSystemResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RbacSystemAuthPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.apiV1RbacSystemAuthPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OIDC 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
     * @summary OIDC 연동 테스트 URL
     * @param {string} clientAuth auth 방식(body or header). ex) body
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {string} authorizationUrl authorization url
     * @param {string} tokenUrl token url
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authOidcDryRunAuthorizationPost(
      clientAuth: string,
      clientId: string,
      clientSecret: string,
      authorizationUrl: string,
      tokenUrl: string,
      upnSuffix?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authOidcDryRunAuthorizationPost(
        clientAuth,
        clientId,
        clientSecret,
        authorizationUrl,
        tokenUrl,
        upnSuffix,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authOidcDryRunAuthorizationPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * deprecated. /auth/oidc/dry-run-authorization 를 사용하세요.
     * @summary (deprecated) OIDC 연동 테스트 URL
     * @param {string} clientAuth auth 방식(body or header). ex) body
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {string} authorizationUrl authorization url
     * @param {string} tokenUrl token url
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authOidcTestAuthorizationPost(
      clientAuth: string,
      clientId: string,
      clientSecret: string,
      authorizationUrl: string,
      tokenUrl: string,
      upnSuffix?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authOidcTestAuthorizationPost(
        clientAuth,
        clientId,
        clientSecret,
        authorizationUrl,
        tokenUrl,
        upnSuffix,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authOidcTestAuthorizationPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * SAML 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
     * @summary SAML 연동 테스트 URL
     * @param {string} idpId idp id. ex) azuread
     * @param {string} samlIdpMetaUrl idp metadata url
     * @param {string} samlEntityId azuread의 경우 entity id(app id)
     * @param {string} samlKey saml key file string
     * @param {string} samlCert saml cert file string
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authSamlDryRunAuthorizationPost(
      idpId: string,
      samlIdpMetaUrl: string,
      samlEntityId: string,
      samlKey: string,
      samlCert: string,
      upnSuffix?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authSamlDryRunAuthorizationPost(
        idpId,
        samlIdpMetaUrl,
        samlEntityId,
        samlKey,
        samlCert,
        upnSuffix,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authSamlDryRunAuthorizationPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * deprecated. /auth/saml/dry-run-authorization 를 사용하세요.
     * @summary (deprecated) SAML 연동 테스트 URL
     * @param {string} idpId idp id. ex) azuread
     * @param {string} samlIdpMetaUrl idp metadata url
     * @param {string} samlEntityId azuread의 경우 entity id(app id)
     * @param {string} samlKey saml key file string
     * @param {string} samlCert saml cert file string
     * @param {string} [upnSuffix] upn suffix. ex) google.com
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async authSamlTestAuthorizationPost(
      idpId: string,
      samlIdpMetaUrl: string,
      samlEntityId: string,
      samlKey: string,
      samlCert: string,
      upnSuffix?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authSamlTestAuthorizationPost(
        idpId,
        samlIdpMetaUrl,
        samlEntityId,
        samlKey,
        samlCert,
        upnSuffix,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authSamlTestAuthorizationPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * console 전용 API. 쿠키 기반으로 동작하기 때문에 host가 루트 도메인을 포함(서브 도메인)헤야 사용 가능. 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
     * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
     * @param {string} [domainId] domain id
     * @param {string} [projectId] project id
     * @param {boolean} [saveCookie] token 발급 시 쿠키에 저장여부. default&#x3D;true
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authV1TokensIssuePost(
      domainId?: string,
      projectId?: string,
      saveCookie?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePrincipalDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authV1TokensIssuePost(
        domainId,
        projectId,
        saveCookie,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authV1TokensIssuePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AuthApiFp(configuration);
  return {
    /**
     * 암호화 키 발급 요청. 현재 RSA만 지원
     * @summary 암호화 키 발급 요청
     * @param {AuthApiAccountV1EncryptIssueKeyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1EncryptIssueKeyPost(
      requestParameters: AuthApiAccountV1EncryptIssueKeyPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEncryptKeyIssueResponse> {
      return localVarFp
        .accountV1EncryptIssueKeyPost(
          requestParameters.authorization,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 도메인 리소스(user) 삭제 전 사용자의 비밀번호 재확인
     * @summary 도메인 리소스 삭제 전 사용자의 비밀번호 재확인
     * @param {AuthApiApiV1AuthCheckPasswordForDeletionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthCheckPasswordForDeletionPost(
      requestParameters: AuthApiApiV1AuthCheckPasswordForDeletionPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AuthCheckPasswordForDeletionPost(
          requestParameters.xAuthToken,
          requestParameters.checkPasswordRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 5분 이내에 사용자의 비밀번호 재확인 성공 여부가 존재하는지 확인
     * @summary 사용자의 비밀번호 재확인 성공 여부 조회
     * @param {AuthApiApiV1AuthCheckPasswordHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthCheckPasswordHead(
      requestParameters: AuthApiApiV1AuthCheckPasswordHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AuthCheckPasswordHead(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 비밀번호 재확인
     * @summary 사용자의 비밀번호 재확인
     * @param {AuthApiApiV1AuthCheckPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthCheckPasswordPost(
      requestParameters: AuthApiApiV1AuthCheckPasswordPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AuthCheckPasswordPost(
          requestParameters.xAuthToken,
          requestParameters.checkPasswordRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * POST /auth/v1/tokens/issue API 의 서버용 버젼. 쿠키 처리 로직만 다름 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
     * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
     * @param {AuthApiApiV1AuthTokensIssuePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthTokensIssuePost(
      requestParameters: AuthApiApiV1AuthTokensIssuePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponsePrincipalDto> {
      return localVarFp
        .apiV1AuthTokensIssuePost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * permission id 에 대한 토큰 권한 확인. 권한 소유 여부와 함께 토큰 정보 전달 permission_id : 확인하고자 하는 permission id target_domain_id : 주어진 id와 토큰의 domain id의 일치여부를 추가적으로 검사 target_project_id : 주어진 id와 토큰의 project id의 일치여부를 추가적으로 검사 target_domain_id_of_project : 주어진 id와 토큰의 project의 domain id 일치여부를 추가적으로 검사 target_user_id : 본인 또는 리소스 소유자 확인시 사용(target_user_id와 token user id 일치여부). 일치하는 경우 permission, 역할과 관계없이 allow: true로 응답 current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사. 단 constants.ReturnCatalogForDomainScope 가 false 이면 domain/system scope 토큰은 catalog 를 조회하지 않아 이 검사를 수행하지 않음 (project scope 토큰만 검사) client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
     * @summary permission id 에 대한 토큰 권한 확인
     * @param {AuthApiApiV1RbacAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RbacAuthPost(
      requestParameters: AuthApiApiV1RbacAuthPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAuthenticatePermissionResponse> {
      return localVarFp
        .apiV1RbacAuthPost(
          requestParameters.xAuthToken,
          requestParameters.noCatalog,
          requestParameters.authenticateRbacRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * permission id 에 대한 유저의 프로젝트 권한 확인. 주어진 permission에 대해 request user가 필요한 project 권한을 가지고 있는지 확인. system reader 토큰 필요 permission_id : 확인하고자 하는 permission id user_id : 권한을 조회할 user id project_id : 권한을 조회할 project id current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사 client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
     * @summary permission id 에 대한 유저의 프로젝트 권한 확인
     * @param {AuthApiApiV1RbacSystemAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RbacSystemAuthPost(
      requestParameters: AuthApiApiV1RbacSystemAuthPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCheckPermissionForSystemResponse> {
      return localVarFp
        .apiV1RbacSystemAuthPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
    /**
     * OIDC 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
     * @summary OIDC 연동 테스트 URL
     * @param {AuthApiAuthOidcDryRunAuthorizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authOidcDryRunAuthorizationPost(
      requestParameters: AuthApiAuthOidcDryRunAuthorizationPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .authOidcDryRunAuthorizationPost(
          requestParameters.clientAuth,
          requestParameters.clientId,
          requestParameters.clientSecret,
          requestParameters.authorizationUrl,
          requestParameters.tokenUrl,
          requestParameters.upnSuffix,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * deprecated. /auth/oidc/dry-run-authorization 를 사용하세요.
     * @summary (deprecated) OIDC 연동 테스트 URL
     * @param {AuthApiAuthOidcTestAuthorizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authOidcTestAuthorizationPost(
      requestParameters: AuthApiAuthOidcTestAuthorizationPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .authOidcTestAuthorizationPost(
          requestParameters.clientAuth,
          requestParameters.clientId,
          requestParameters.clientSecret,
          requestParameters.authorizationUrl,
          requestParameters.tokenUrl,
          requestParameters.upnSuffix,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * SAML 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
     * @summary SAML 연동 테스트 URL
     * @param {AuthApiAuthSamlDryRunAuthorizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSamlDryRunAuthorizationPost(
      requestParameters: AuthApiAuthSamlDryRunAuthorizationPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .authSamlDryRunAuthorizationPost(
          requestParameters.idpId,
          requestParameters.samlIdpMetaUrl,
          requestParameters.samlEntityId,
          requestParameters.samlKey,
          requestParameters.samlCert,
          requestParameters.upnSuffix,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * deprecated. /auth/saml/dry-run-authorization 를 사용하세요.
     * @summary (deprecated) SAML 연동 테스트 URL
     * @param {AuthApiAuthSamlTestAuthorizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    authSamlTestAuthorizationPost(
      requestParameters: AuthApiAuthSamlTestAuthorizationPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .authSamlTestAuthorizationPost(
          requestParameters.idpId,
          requestParameters.samlIdpMetaUrl,
          requestParameters.samlEntityId,
          requestParameters.samlKey,
          requestParameters.samlCert,
          requestParameters.upnSuffix,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * console 전용 API. 쿠키 기반으로 동작하기 때문에 host가 루트 도메인을 포함(서브 도메인)헤야 사용 가능. 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
     * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
     * @param {AuthApiAuthV1TokensIssuePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authV1TokensIssuePost(
      requestParameters: AuthApiAuthV1TokensIssuePostRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponsePrincipalDto> {
      return localVarFp
        .authV1TokensIssuePost(
          requestParameters.domainId,
          requestParameters.projectId,
          requestParameters.saveCookie,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AuthApi - interface
 */
export interface AuthApiInterface {
  /**
   * 암호화 키 발급 요청. 현재 RSA만 지원
   * @summary 암호화 키 발급 요청
   * @param {AuthApiAccountV1EncryptIssueKeyPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1EncryptIssueKeyPost(
    requestParameters: AuthApiAccountV1EncryptIssueKeyPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEncryptKeyIssueResponse>;

  /**
   * 도메인 리소스(user) 삭제 전 사용자의 비밀번호 재확인
   * @summary 도메인 리소스 삭제 전 사용자의 비밀번호 재확인
   * @param {AuthApiApiV1AuthCheckPasswordForDeletionPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AuthCheckPasswordForDeletionPost(
    requestParameters: AuthApiApiV1AuthCheckPasswordForDeletionPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 5분 이내에 사용자의 비밀번호 재확인 성공 여부가 존재하는지 확인
   * @summary 사용자의 비밀번호 재확인 성공 여부 조회
   * @param {AuthApiApiV1AuthCheckPasswordHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AuthCheckPasswordHead(
    requestParameters: AuthApiApiV1AuthCheckPasswordHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 비밀번호 재확인
   * @summary 사용자의 비밀번호 재확인
   * @param {AuthApiApiV1AuthCheckPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AuthCheckPasswordPost(
    requestParameters: AuthApiApiV1AuthCheckPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * POST /auth/v1/tokens/issue API 의 서버용 버젼. 쿠키 처리 로직만 다름 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
   * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
   * @param {AuthApiApiV1AuthTokensIssuePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AuthTokensIssuePost(
    requestParameters: AuthApiApiV1AuthTokensIssuePostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponsePrincipalDto>;

  /**
   * permission id 에 대한 토큰 권한 확인. 권한 소유 여부와 함께 토큰 정보 전달 permission_id : 확인하고자 하는 permission id target_domain_id : 주어진 id와 토큰의 domain id의 일치여부를 추가적으로 검사 target_project_id : 주어진 id와 토큰의 project id의 일치여부를 추가적으로 검사 target_domain_id_of_project : 주어진 id와 토큰의 project의 domain id 일치여부를 추가적으로 검사 target_user_id : 본인 또는 리소스 소유자 확인시 사용(target_user_id와 token user id 일치여부). 일치하는 경우 permission, 역할과 관계없이 allow: true로 응답 current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사. 단 constants.ReturnCatalogForDomainScope 가 false 이면 domain/system scope 토큰은 catalog 를 조회하지 않아 이 검사를 수행하지 않음 (project scope 토큰만 검사) client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
   * @summary permission id 에 대한 토큰 권한 확인
   * @param {AuthApiApiV1RbacAuthPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RbacAuthPost(
    requestParameters: AuthApiApiV1RbacAuthPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAuthenticatePermissionResponse>;

  /**
   * permission id 에 대한 유저의 프로젝트 권한 확인. 주어진 permission에 대해 request user가 필요한 project 권한을 가지고 있는지 확인. system reader 토큰 필요 permission_id : 확인하고자 하는 permission id user_id : 권한을 조회할 user id project_id : 권한을 조회할 project id current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사 client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
   * @summary permission id 에 대한 유저의 프로젝트 권한 확인
   * @param {AuthApiApiV1RbacSystemAuthPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RbacSystemAuthPost(
    requestParameters: AuthApiApiV1RbacSystemAuthPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCheckPermissionForSystemResponse>;

  /**
   * OIDC 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
   * @summary OIDC 연동 테스트 URL
   * @param {AuthApiAuthOidcDryRunAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  authOidcDryRunAuthorizationPost(
    requestParameters: AuthApiAuthOidcDryRunAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * deprecated. /auth/oidc/dry-run-authorization 를 사용하세요.
   * @summary (deprecated) OIDC 연동 테스트 URL
   * @param {AuthApiAuthOidcTestAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  authOidcTestAuthorizationPost(
    requestParameters: AuthApiAuthOidcTestAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * SAML 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
   * @summary SAML 연동 테스트 URL
   * @param {AuthApiAuthSamlDryRunAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  authSamlDryRunAuthorizationPost(
    requestParameters: AuthApiAuthSamlDryRunAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * deprecated. /auth/saml/dry-run-authorization 를 사용하세요.
   * @summary (deprecated) SAML 연동 테스트 URL
   * @param {AuthApiAuthSamlTestAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  authSamlTestAuthorizationPost(
    requestParameters: AuthApiAuthSamlTestAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * console 전용 API. 쿠키 기반으로 동작하기 때문에 host가 루트 도메인을 포함(서브 도메인)헤야 사용 가능. 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
   * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
   * @param {AuthApiAuthV1TokensIssuePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  authV1TokensIssuePost(
    requestParameters?: AuthApiAuthV1TokensIssuePostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponsePrincipalDto>;
}

/**
 * Request parameters for accountV1EncryptIssueKeyPost operation in AuthApi.
 */
export interface AuthApiAccountV1EncryptIssueKeyPostRequest {
  /**
   * Authorization: Basic base64(client id:Client Secret)
   */
  readonly authorization: string;

  /**
   * 발송 정보
   */
  readonly request: RequestEncryptKeyIssueRequest;
}

/**
 * Request parameters for apiV1AuthCheckPasswordForDeletionPost operation in AuthApi.
 */
export interface AuthApiApiV1AuthCheckPasswordForDeletionPostRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;

  /**
   * CheckPasswordRequest
   */
  readonly checkPasswordRequest: RequestCheckPasswordRequest;
}

/**
 * Request parameters for apiV1AuthCheckPasswordHead operation in AuthApi.
 */
export interface AuthApiApiV1AuthCheckPasswordHeadRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1AuthCheckPasswordPost operation in AuthApi.
 */
export interface AuthApiApiV1AuthCheckPasswordPostRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;

  /**
   * CheckPasswordRequest
   */
  readonly checkPasswordRequest: RequestCheckPasswordRequest;
}

/**
 * Request parameters for apiV1AuthTokensIssuePost operation in AuthApi.
 */
export interface AuthApiApiV1AuthTokensIssuePostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id
   */
  readonly domainId?: string;

  /**
   * project id
   */
  readonly projectId?: string;
}

/**
 * Request parameters for apiV1RbacAuthPost operation in AuthApi.
 */
export interface AuthApiApiV1RbacAuthPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * true인 경우 응답에서  token.catalog 정보를 생략
   */
  readonly noCatalog?: string;

  /**
   * AuthenticateRbacRequest
   */
  readonly authenticateRbacRequest?: RequestAuthenticateRbacRequest;
}

/**
 * Request parameters for apiV1RbacSystemAuthPost operation in AuthApi.
 */
export interface AuthApiApiV1RbacSystemAuthPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * CheckPermissionForSystemRequest
   */
  readonly request?: RequestCheckPermissionForSystemRequest;
}

/**
 * Request parameters for authOidcDryRunAuthorizationPost operation in AuthApi.
 */
export interface AuthApiAuthOidcDryRunAuthorizationPostRequest {
  /**
   * auth 방식(body or header). ex) body
   */
  readonly clientAuth: string;

  /**
   * client id
   */
  readonly clientId: string;

  /**
   * client secret
   */
  readonly clientSecret: string;

  /**
   * authorization url
   */
  readonly authorizationUrl: string;

  /**
   * token url
   */
  readonly tokenUrl: string;

  /**
   * upn suffix. ex) google.com
   */
  readonly upnSuffix?: string;
}

/**
 * Request parameters for authOidcTestAuthorizationPost operation in AuthApi.
 */
export interface AuthApiAuthOidcTestAuthorizationPostRequest {
  /**
   * auth 방식(body or header). ex) body
   */
  readonly clientAuth: string;

  /**
   * client id
   */
  readonly clientId: string;

  /**
   * client secret
   */
  readonly clientSecret: string;

  /**
   * authorization url
   */
  readonly authorizationUrl: string;

  /**
   * token url
   */
  readonly tokenUrl: string;

  /**
   * upn suffix. ex) google.com
   */
  readonly upnSuffix?: string;
}

/**
 * Request parameters for authSamlDryRunAuthorizationPost operation in AuthApi.
 */
export interface AuthApiAuthSamlDryRunAuthorizationPostRequest {
  /**
   * idp id. ex) azuread
   */
  readonly idpId: string;

  /**
   * idp metadata url
   */
  readonly samlIdpMetaUrl: string;

  /**
   * azuread의 경우 entity id(app id)
   */
  readonly samlEntityId: string;

  /**
   * saml key file string
   */
  readonly samlKey: string;

  /**
   * saml cert file string
   */
  readonly samlCert: string;

  /**
   * upn suffix. ex) google.com
   */
  readonly upnSuffix?: string;
}

/**
 * Request parameters for authSamlTestAuthorizationPost operation in AuthApi.
 */
export interface AuthApiAuthSamlTestAuthorizationPostRequest {
  /**
   * idp id. ex) azuread
   */
  readonly idpId: string;

  /**
   * idp metadata url
   */
  readonly samlIdpMetaUrl: string;

  /**
   * azuread의 경우 entity id(app id)
   */
  readonly samlEntityId: string;

  /**
   * saml key file string
   */
  readonly samlKey: string;

  /**
   * saml cert file string
   */
  readonly samlCert: string;

  /**
   * upn suffix. ex) google.com
   */
  readonly upnSuffix?: string;
}

/**
 * Request parameters for authV1TokensIssuePost operation in AuthApi.
 */
export interface AuthApiAuthV1TokensIssuePostRequest {
  /**
   * domain id
   */
  readonly domainId?: string;

  /**
   * project id
   */
  readonly projectId?: string;

  /**
   * token 발급 시 쿠키에 저장여부. default&#x3D;true
   */
  readonly saveCookie?: boolean;
}

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
  /**
   * 암호화 키 발급 요청. 현재 RSA만 지원
   * @summary 암호화 키 발급 요청
   * @param {AuthApiAccountV1EncryptIssueKeyPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1EncryptIssueKeyPost(
    requestParameters: AuthApiAccountV1EncryptIssueKeyPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .accountV1EncryptIssueKeyPost(
        requestParameters.authorization,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 도메인 리소스(user) 삭제 전 사용자의 비밀번호 재확인
   * @summary 도메인 리소스 삭제 전 사용자의 비밀번호 재확인
   * @param {AuthApiApiV1AuthCheckPasswordForDeletionPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AuthCheckPasswordForDeletionPost(
    requestParameters: AuthApiApiV1AuthCheckPasswordForDeletionPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .apiV1AuthCheckPasswordForDeletionPost(
        requestParameters.xAuthToken,
        requestParameters.checkPasswordRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 5분 이내에 사용자의 비밀번호 재확인 성공 여부가 존재하는지 확인
   * @summary 사용자의 비밀번호 재확인 성공 여부 조회
   * @param {AuthApiApiV1AuthCheckPasswordHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AuthCheckPasswordHead(
    requestParameters: AuthApiApiV1AuthCheckPasswordHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .apiV1AuthCheckPasswordHead(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 비밀번호 재확인
   * @summary 사용자의 비밀번호 재확인
   * @param {AuthApiApiV1AuthCheckPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AuthCheckPasswordPost(
    requestParameters: AuthApiApiV1AuthCheckPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .apiV1AuthCheckPasswordPost(
        requestParameters.xAuthToken,
        requestParameters.checkPasswordRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * POST /auth/v1/tokens/issue API 의 서버용 버젼. 쿠키 처리 로직만 다름 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
   * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
   * @param {AuthApiApiV1AuthTokensIssuePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AuthTokensIssuePost(
    requestParameters: AuthApiApiV1AuthTokensIssuePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .apiV1AuthTokensIssuePost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.projectId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * permission id 에 대한 토큰 권한 확인. 권한 소유 여부와 함께 토큰 정보 전달 permission_id : 확인하고자 하는 permission id target_domain_id : 주어진 id와 토큰의 domain id의 일치여부를 추가적으로 검사 target_project_id : 주어진 id와 토큰의 project id의 일치여부를 추가적으로 검사 target_domain_id_of_project : 주어진 id와 토큰의 project의 domain id 일치여부를 추가적으로 검사 target_user_id : 본인 또는 리소스 소유자 확인시 사용(target_user_id와 token user id 일치여부). 일치하는 경우 permission, 역할과 관계없이 allow: true로 응답 current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사. 단 constants.ReturnCatalogForDomainScope 가 false 이면 domain/system scope 토큰은 catalog 를 조회하지 않아 이 검사를 수행하지 않음 (project scope 토큰만 검사) client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
   * @summary permission id 에 대한 토큰 권한 확인
   * @param {AuthApiApiV1RbacAuthPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RbacAuthPost(
    requestParameters: AuthApiApiV1RbacAuthPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .apiV1RbacAuthPost(
        requestParameters.xAuthToken,
        requestParameters.noCatalog,
        requestParameters.authenticateRbacRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * permission id 에 대한 유저의 프로젝트 권한 확인. 주어진 permission에 대해 request user가 필요한 project 권한을 가지고 있는지 확인. system reader 토큰 필요 permission_id : 확인하고자 하는 permission id user_id : 권한을 조회할 user id project_id : 권한을 조회할 project id current_endpoint_url : 주어진 url이 해당 서비스의 token.catalog.endpoints 에 존재하는지 추가적으로 검사 client_ip : 출발지 기반 접근 제어에 사용될 client ip (단일 IP V4 형식) current_host : 출발지 기반 접근 제어에 사용될 요청 host [참고 위키] https://wiki.daumkakao.com/x/MRsBfg
   * @summary permission id 에 대한 유저의 프로젝트 권한 확인
   * @param {AuthApiApiV1RbacSystemAuthPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RbacSystemAuthPost(
    requestParameters: AuthApiApiV1RbacSystemAuthPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .apiV1RbacSystemAuthPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OIDC 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
   * @summary OIDC 연동 테스트 URL
   * @param {AuthApiAuthOidcDryRunAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authOidcDryRunAuthorizationPost(
    requestParameters: AuthApiAuthOidcDryRunAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .authOidcDryRunAuthorizationPost(
        requestParameters.clientAuth,
        requestParameters.clientId,
        requestParameters.clientSecret,
        requestParameters.authorizationUrl,
        requestParameters.tokenUrl,
        requestParameters.upnSuffix,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * deprecated. /auth/oidc/dry-run-authorization 를 사용하세요.
   * @summary (deprecated) OIDC 연동 테스트 URL
   * @param {AuthApiAuthOidcTestAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public authOidcTestAuthorizationPost(
    requestParameters: AuthApiAuthOidcTestAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .authOidcTestAuthorizationPost(
        requestParameters.clientAuth,
        requestParameters.clientId,
        requestParameters.clientSecret,
        requestParameters.authorizationUrl,
        requestParameters.tokenUrl,
        requestParameters.upnSuffix,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * SAML 연동 테스트 URL. Cookie의 token을 이용하여 사용자를 확인하기에 로그인된 상태에서 이용 가능.
   * @summary SAML 연동 테스트 URL
   * @param {AuthApiAuthSamlDryRunAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authSamlDryRunAuthorizationPost(
    requestParameters: AuthApiAuthSamlDryRunAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .authSamlDryRunAuthorizationPost(
        requestParameters.idpId,
        requestParameters.samlIdpMetaUrl,
        requestParameters.samlEntityId,
        requestParameters.samlKey,
        requestParameters.samlCert,
        requestParameters.upnSuffix,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * deprecated. /auth/saml/dry-run-authorization 를 사용하세요.
   * @summary (deprecated) SAML 연동 테스트 URL
   * @param {AuthApiAuthSamlTestAuthorizationPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public authSamlTestAuthorizationPost(
    requestParameters: AuthApiAuthSamlTestAuthorizationPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .authSamlTestAuthorizationPost(
        requestParameters.idpId,
        requestParameters.samlIdpMetaUrl,
        requestParameters.samlEntityId,
        requestParameters.samlKey,
        requestParameters.samlCert,
        requestParameters.upnSuffix,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * console 전용 API. 쿠키 기반으로 동작하기 때문에 host가 루트 도메인을 포함(서브 도메인)헤야 사용 가능. 사용자의 인증 token으로 권한이 있는 다른 scope의 인증 token 발급 및 token의 정보(사용자, domain, Project, role등의 정보)를 파싱하여 돌려준다. 만약 token의 scope와 요청하는 domain id 혹은 project id 와 일치하는 경우 신규로 발급 하지 않고 기존 token을 돌려준다. 개인 정보 항목은 값을 내려 주지 않음(email, telephone, realname, nickname, profile_url)
   * @summary 사용자의 인증 token으로 다른 scope의 인증 token 발급 및 token의 정보 리턴.
   * @param {AuthApiAuthV1TokensIssuePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authV1TokensIssuePost(
    requestParameters: AuthApiAuthV1TokensIssuePostRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return AuthApiFp(this.configuration)
      .authV1TokensIssuePost(
        requestParameters.domainId,
        requestParameters.projectId,
        requestParameters.saveCookie,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CiaApi - axios parameter creator
 */
export const CiaApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 지정한 domain 정보 상세 조회
     * @summary 지정한 domain 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11AdminDomainsDomainIdGet: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11AdminDomainsDomainIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV11AdminDomainsDomainIdGet', 'domainId', domainId);
      const localVarPath = `/api/v1_1/admin/domains/{domain_id}`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * application credential 목록 조회
     * @summary application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [id] credential search by credential id, maxLength&#x3D;32
     * @param {string} [name] credential search by credential name, maxLength&#x3D;64
     * @param {string} [userId] credential search by user id, maxLength&#x3D;32
     * @param {string} [projectId] credential search by project id, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminApplicationCredentialsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      id?: string,
      name?: string,
      userId?: string,
      projectId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminApplicationCredentialsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/admin/application_credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userId !== undefined) {
        localVarQueryParameter['user_id'] = userId;
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * assignment(프로젝트/도메인 권한) 한 건을 회수한다. inherited 로 일반 부여(false)와 상속 부여(true) 중 어느 쪽을 지울지 지정한다.
     * @summary 권한 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {ApiV1AdminAssignmentsDeleteTypeEnum} type assignment type
     * @param {string} targetId project id 또는 domain id, maxLength&#x3D;32
     * @param {string} actorId user id 또는 group id, maxLength&#x3D;32
     * @param {string} roleId role id, maxLength&#x3D;32
     * @param {boolean} [inherited] 상속 부여를 지울지 여부. 미지정 시 일반 부여만 지운다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminAssignmentsDelete: async (
      xAuthToken: string,
      type: ApiV1AdminAssignmentsDeleteTypeEnum,
      targetId: string,
      actorId: string,
      roleId: string,
      inherited?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsDelete', 'type', type);
      // verify required parameter 'targetId' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsDelete', 'targetId', targetId);
      // verify required parameter 'actorId' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsDelete', 'actorId', actorId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsDelete', 'roleId', roleId);
      const localVarPath = `/api/v1/admin/assignments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (targetId !== undefined) {
        localVarQueryParameter['target_id'] = targetId;
      }

      if (actorId !== undefined) {
        localVarQueryParameter['actor_id'] = actorId;
      }

      if (roleId !== undefined) {
        localVarQueryParameter['role_id'] = roleId;
      }

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 권한 목록 조회
     * @summary 권한 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [userId] user id, maxLength&#x3D;32
     * @param {string} [groupId] group id, maxLength&#x3D;32
     * @param {string} [domainId] target id, maxLength&#x3D;32
     * @param {string} [projectId] target id, maxLength&#x3D;32
     * @param {string} [domainName] assignment search by domain name, maxLength&#x3D;64
     * @param {string} [roleName] assignment search by role name, maxLength&#x3D;64
     * @param {boolean} [isSystemRole] assignment search on system_role scope only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminAssignmentsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      userId?: string,
      groupId?: string,
      domainId?: string,
      projectId?: string,
      domainName?: string,
      roleName?: string,
      isSystemRole?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/admin/assignments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (userId !== undefined) {
        localVarQueryParameter['user_id'] = userId;
      }

      if (groupId !== undefined) {
        localVarQueryParameter['group_id'] = groupId;
      }

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId;
      }

      if (domainName !== undefined) {
        localVarQueryParameter['domain_name'] = domainName;
      }

      if (roleName !== undefined) {
        localVarQueryParameter['role_name'] = roleName;
      }

      if (isSystemRole !== undefined) {
        localVarQueryParameter['is_system_role'] = isSystemRole;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * assignment(프로젝트/도메인 권한) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다. inherited=true 는 UserDomain/GroupDomain 에서만 유효하다 - 도메인 하위 전체 프로젝트에 적용되는 상속 부여를 만든다.
     * @summary 권한 일괄 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestAdminAssignmentCreateRequest} request 부여할 assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminAssignmentsPost: async (
      xAuthToken: string,
      request: RequestAdminAssignmentCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1AdminAssignmentsPost', 'request', request);
      const localVarPath = `/api/v1/admin/assignments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * credential 목록 조회
     * @summary credential 목록 조회.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [projectId] credential project id
     * @param {string} [userId] credential user id
     * @param {string} [id] credential id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminCredentialsGet: async (
      xAuthToken: string,
      offset?: number,
      size?: number,
      projectId?: string,
      userId?: string,
      id?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminCredentialsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/admin/credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (projectId !== undefined) {
        localVarQueryParameter['project_id'] = projectId;
      }

      if (userId !== undefined) {
        localVarQueryParameter['user_id'] = userId;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * WRITE_TARGET_FOR_ADMIN 권한 확인 후 대상 사용자를 도메인 소유자로 강제 변경한다. 대상 사용자는 해당 도메인 소속이어야 한다.
     * @summary 조직 소유자 강제 변경 (Admin)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestForceAssignOwnerRequest} forceAssignOwnerRequest to_user_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminDomainsDomainIdForceAssignOwnerPost: async (
      xAuthToken: string,
      domainId: string,
      forceAssignOwnerRequest: RequestForceAssignOwnerRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminDomainsDomainIdForceAssignOwnerPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1AdminDomainsDomainIdForceAssignOwnerPost', 'domainId', domainId);
      // verify required parameter 'forceAssignOwnerRequest' is not null or undefined
      assertParamExists(
        'apiV1AdminDomainsDomainIdForceAssignOwnerPost',
        'forceAssignOwnerRequest',
        forceAssignOwnerRequest,
      );
      const localVarPath = `/api/v1/admin/domains/{domain_id}/force-assign-owner`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        forceAssignOwnerRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹에게 system 권한 제거
     * @summary 그룹에게 system 권한 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminGroupsGroupIdRolesRoleIdDelete: async (
      xAuthToken: string,
      groupId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminGroupsGroupIdRolesRoleIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1AdminGroupsGroupIdRolesRoleIdDelete', 'groupId', groupId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1AdminGroupsGroupIdRolesRoleIdDelete', 'roleId', roleId);
      const localVarPath = `/api/v1/admin/groups/{group_id}/roles/{role_id}`
        .replace('{group_id}', encodeURIComponent(String(groupId)))
        .replace('{role_id}', encodeURIComponent(String(roleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹에게 system 권한 부여
     * @summary 그룹에게 system 권한 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminGroupsGroupIdRolesRoleIdPut: async (
      xAuthToken: string,
      groupId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminGroupsGroupIdRolesRoleIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1AdminGroupsGroupIdRolesRoleIdPut', 'groupId', groupId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1AdminGroupsGroupIdRolesRoleIdPut', 'roleId', roleId);
      const localVarPath = `/api/v1/admin/groups/{group_id}/roles/{role_id}`
        .replace('{group_id}', encodeURIComponent(String(groupId)))
        .replace('{role_id}', encodeURIComponent(String(roleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능. Default Role 생성을 원치않는 경우 사용 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러
     * @summary permission 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestPermissionCreateWithoutRoleRequest} request permission 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminPermissionsPost: async (
      xAuthToken: string,
      request: RequestPermissionCreateWithoutRoleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminPermissionsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1AdminPermissionsPost', 'request', request);
      const localVarPath = `/api/v1/admin/permissions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹에 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 그룹에 Project 의 role 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} groupId Group ID, maxLength&#x3D;32
     * @param {RequestAssignRolesToGroupRequest} assignRolesToGroupRequest role names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut: async (
      xAuthToken: string,
      projectId: string,
      groupId: string,
      assignRolesToGroupRequest: RequestAssignRolesToGroupRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut', 'projectId', projectId);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut', 'groupId', groupId);
      // verify required parameter 'assignRolesToGroupRequest' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut',
        'assignRolesToGroupRequest',
        assignRolesToGroupRequest,
      );
      const localVarPath = `/api/v1/admin/projects/{project_id}/groups/{group_id}/roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignRolesToGroupRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 Project role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} groupId User ID, maxLength&#x3D;32
     * @param {string} roleName User ID, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete: async (
      xAuthToken: string,
      projectId: string,
      groupId: string,
      roleName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete',
        'projectId',
        projectId,
      );
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete',
        'groupId',
        groupId,
      );
      // verify required parameter 'roleName' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete',
        'roleName',
        roleName,
      );
      const localVarPath = `/api/v1/admin/projects/{project_id}/groups/{group_id}/roles/{role_name}`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)))
        .replace('{role_name}', encodeURIComponent(String(roleName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자에게 Project 의 role 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} userId User ID, maxLength&#x3D;32
     * @param {RequestAssignRolesToUserRequest} assignRolesToUserRequest role names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdUsersUserIdRolesPut: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      assignRolesToUserRequest: RequestAssignRolesToUserRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminProjectsProjectIdUsersUserIdRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1AdminProjectsProjectIdUsersUserIdRolesPut', 'projectId', projectId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1AdminProjectsProjectIdUsersUserIdRolesPut', 'userId', userId);
      // verify required parameter 'assignRolesToUserRequest' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdUsersUserIdRolesPut',
        'assignRolesToUserRequest',
        assignRolesToUserRequest,
      );
      const localVarPath = `/api/v1/admin/projects/{project_id}/users/{user_id}/roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignRolesToUserRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 Project role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} userId User ID, maxLength&#x3D;32
     * @param {string} roleName User ID, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      roleName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete',
        'projectId',
        projectId,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete',
        'userId',
        userId,
      );
      // verify required parameter 'roleName' is not null or undefined
      assertParamExists(
        'apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete',
        'roleName',
        roleName,
      );
      const localVarPath = `/api/v1/admin/projects/{project_id}/users/{user_id}/roles/{role_name}`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)))
        .replace('{role_name}', encodeURIComponent(String(roleName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * system scope 권한(system_assignment) 한 건을 회수한다.
     * @summary 시스템 권한 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {ApiV1AdminSystemAssignmentsDeleteTypeEnum} type assignment type
     * @param {string} actorId user id 또는 group id, maxLength&#x3D;32
     * @param {string} roleId role id, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminSystemAssignmentsDelete: async (
      xAuthToken: string,
      type: ApiV1AdminSystemAssignmentsDeleteTypeEnum,
      actorId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'type' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsDelete', 'type', type);
      // verify required parameter 'actorId' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsDelete', 'actorId', actorId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsDelete', 'roleId', roleId);
      const localVarPath = `/api/v1/admin/system-assignments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      if (actorId !== undefined) {
        localVarQueryParameter['actor_id'] = actorId;
      }

      if (roleId !== undefined) {
        localVarQueryParameter['role_id'] = roleId;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 권한 목록 조회
     * @summary 시스템 권한 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [userId] user id, maxLength&#x3D;32
     * @param {string} [groupId] group id, maxLength&#x3D;32
     * @param {string} [roleName] assignment search by role name, maxLength&#x3D;64
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminSystemAssignmentsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      userId?: string,
      groupId?: string,
      roleName?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/admin/system-assignments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (userId !== undefined) {
        localVarQueryParameter['user_id'] = userId;
      }

      if (groupId !== undefined) {
        localVarQueryParameter['group_id'] = groupId;
      }

      if (roleName !== undefined) {
        localVarQueryParameter['role_name'] = roleName;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * system scope 권한(system_assignment) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다.
     * @summary 시스템 권한 일괄 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestAdminSystemAssignmentCreateRequest} request 부여할 시스템 권한
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminSystemAssignmentsPost: async (
      xAuthToken: string,
      request: RequestAdminSystemAssignmentCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1AdminSystemAssignmentsPost', 'request', request);
      const localVarPath = `/api/v1/admin/system-assignments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 전체 사용자 목록 조회
     * @summary 전체 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [domainId] user search by domain id, maxLength&#x3D;32
     * @param {string} [domainName] user search by domain name, maxLength&#x3D;64
     * @param {string} [id] user search by user id, maxLength&#x3D;32
     * @param {string} [name] user search by user name, maxLength&#x3D;64
     * @param {string} [userType] user search by user type (All, User, Account, Agent) default&#x3D;All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      domainId?: string,
      domainName?: string,
      id?: string,
      name?: string,
      userType?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminUsersGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/admin/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (domainName !== undefined) {
        localVarQueryParameter['domain_name'] = domainName;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 삭제
     * @summary 사용자 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdDelete: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdDelete', 'userId', userId);
      const localVarPath = `/api/v1/admin/users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 유저의 비밀번호 강제변경
     * @summary 유저의 비밀번호 강제변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestCloudUserOverwritePasswordRequest} passwordInfo 비밀번호 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdPasswordPost: async (
      xAuthToken: string,
      userId: string,
      passwordInfo: RequestCloudUserOverwritePasswordRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdPasswordPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdPasswordPost', 'userId', userId);
      // verify required parameter 'passwordInfo' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdPasswordPost', 'passwordInfo', passwordInfo);
      const localVarPath = `/api/v1/admin/users/{user_id}/password`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        passwordInfo,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 유저 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 유저 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32, maxLength&#x3D;32
     * @param {RequestCloudUserUpdateAdminRequest} cloudUserUpdateAdminRequest 사용자 정보 수정 내용(enabled 값이 없는 경우 default&#x3D;false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdPatch: async (
      xAuthToken: string,
      userId: string,
      cloudUserUpdateAdminRequest: RequestCloudUserUpdateAdminRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdPatch', 'userId', userId);
      // verify required parameter 'cloudUserUpdateAdminRequest' is not null or undefined
      assertParamExists(
        'apiV1AdminUsersUserIdPatch',
        'cloudUserUpdateAdminRequest',
        cloudUserUpdateAdminRequest,
      );
      const localVarPath = `/api/v1/admin/users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cloudUserUpdateAdminRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자에게 system 권한 제거
     * @summary 사용자에게 system 권한 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdRolesRoleIdDelete: async (
      xAuthToken: string,
      userId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdRolesRoleIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdRolesRoleIdDelete', 'userId', userId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdRolesRoleIdDelete', 'roleId', roleId);
      const localVarPath = `/api/v1/admin/users/{user_id}/roles/{role_id}`
        .replace('{user_id}', encodeURIComponent(String(userId)))
        .replace('{role_id}', encodeURIComponent(String(roleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자에게 system 권한 부여
     * @summary 사용자에게 system 권한 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdRolesRoleIdPut: async (
      xAuthToken: string,
      userId: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdRolesRoleIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdRolesRoleIdPut', 'userId', userId);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1AdminUsersUserIdRolesRoleIdPut', 'roleId', roleId);
      const localVarPath = `/api/v1/admin/users/{user_id}/roles/{role_id}`
        .replace('{user_id}', encodeURIComponent(String(userId)))
        .replace('{role_id}', encodeURIComponent(String(roleId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CiaApi - functional programming interface
 */
export const CiaApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CiaApiAxiosParamCreator(configuration);
  return {
    /**
     * 지정한 domain 정보 상세 조회
     * @summary 지정한 domain 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11AdminDomainsDomainIdGet(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetAllExtraResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11AdminDomainsDomainIdGet(
        xAuthToken,
        domainId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV11AdminDomainsDomainIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * application credential 목록 조회
     * @summary application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [id] credential search by credential id, maxLength&#x3D;32
     * @param {string} [name] credential search by credential name, maxLength&#x3D;64
     * @param {string} [userId] credential search by user id, maxLength&#x3D;32
     * @param {string} [projectId] credential search by project id, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminApplicationCredentialsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      id?: string,
      name?: string,
      userId?: string,
      projectId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDtos>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminApplicationCredentialsGet(
        xAuthToken,
        size,
        offset,
        id,
        name,
        userId,
        projectId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminApplicationCredentialsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * assignment(프로젝트/도메인 권한) 한 건을 회수한다. inherited 로 일반 부여(false)와 상속 부여(true) 중 어느 쪽을 지울지 지정한다.
     * @summary 권한 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {ApiV1AdminAssignmentsDeleteTypeEnum} type assignment type
     * @param {string} targetId project id 또는 domain id, maxLength&#x3D;32
     * @param {string} actorId user id 또는 group id, maxLength&#x3D;32
     * @param {string} roleId role id, maxLength&#x3D;32
     * @param {boolean} [inherited] 상속 부여를 지울지 여부. 미지정 시 일반 부여만 지운다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminAssignmentsDelete(
      xAuthToken: string,
      type: ApiV1AdminAssignmentsDeleteTypeEnum,
      targetId: string,
      actorId: string,
      roleId: string,
      inherited?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAssignmentsDelete(
        xAuthToken,
        type,
        targetId,
        actorId,
        roleId,
        inherited,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminAssignmentsDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 권한 목록 조회
     * @summary 권한 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [userId] user id, maxLength&#x3D;32
     * @param {string} [groupId] group id, maxLength&#x3D;32
     * @param {string} [domainId] target id, maxLength&#x3D;32
     * @param {string} [projectId] target id, maxLength&#x3D;32
     * @param {string} [domainName] assignment search by domain name, maxLength&#x3D;64
     * @param {string} [roleName] assignment search by role name, maxLength&#x3D;64
     * @param {boolean} [isSystemRole] assignment search on system_role scope only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminAssignmentsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      userId?: string,
      groupId?: string,
      domainId?: string,
      projectId?: string,
      domainName?: string,
      roleName?: string,
      isSystemRole?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudAssignmentList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAssignmentsGet(
        xAuthToken,
        size,
        offset,
        userId,
        groupId,
        domainId,
        projectId,
        domainName,
        roleName,
        isSystemRole,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminAssignmentsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * assignment(프로젝트/도메인 권한) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다. inherited=true 는 UserDomain/GroupDomain 에서만 유효하다 - 도메인 하위 전체 프로젝트에 적용되는 상속 부여를 만든다.
     * @summary 권한 일괄 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestAdminAssignmentCreateRequest} request 부여할 assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminAssignmentsPost(
      xAuthToken: string,
      request: RequestAdminAssignmentCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAssignmentsPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminAssignmentsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * credential 목록 조회
     * @summary credential 목록 조회.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [projectId] credential project id
     * @param {string} [userId] credential user id
     * @param {string} [id] credential id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminCredentialsGet(
      xAuthToken: string,
      offset?: number,
      size?: number,
      projectId?: string,
      userId?: string,
      id?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCredentialListAllResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminCredentialsGet(
        xAuthToken,
        offset,
        size,
        projectId,
        userId,
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminCredentialsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * WRITE_TARGET_FOR_ADMIN 권한 확인 후 대상 사용자를 도메인 소유자로 강제 변경한다. 대상 사용자는 해당 도메인 소속이어야 한다.
     * @summary 조직 소유자 강제 변경 (Admin)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestForceAssignOwnerRequest} forceAssignOwnerRequest to_user_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminDomainsDomainIdForceAssignOwnerPost(
      xAuthToken: string,
      domainId: string,
      forceAssignOwnerRequest: RequestForceAssignOwnerRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminDomainsDomainIdForceAssignOwnerPost(
          xAuthToken,
          domainId,
          forceAssignOwnerRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminDomainsDomainIdForceAssignOwnerPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹에게 system 권한 제거
     * @summary 그룹에게 system 권한 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminGroupsGroupIdRolesRoleIdDelete(
      xAuthToken: string,
      groupId: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminGroupsGroupIdRolesRoleIdDelete(
          xAuthToken,
          groupId,
          roleId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminGroupsGroupIdRolesRoleIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹에게 system 권한 부여
     * @summary 그룹에게 system 권한 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminGroupsGroupIdRolesRoleIdPut(
      xAuthToken: string,
      groupId: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminGroupsGroupIdRolesRoleIdPut(
          xAuthToken,
          groupId,
          roleId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminGroupsGroupIdRolesRoleIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능. Default Role 생성을 원치않는 경우 사용 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러
     * @summary permission 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestPermissionCreateWithoutRoleRequest} request permission 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminPermissionsPost(
      xAuthToken: string,
      request: RequestPermissionCreateWithoutRoleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudPermissionDtos>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPermissionsPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminPermissionsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹에 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 그룹에 Project 의 role 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} groupId Group ID, maxLength&#x3D;32
     * @param {RequestAssignRolesToGroupRequest} assignRolesToGroupRequest role names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
      xAuthToken: string,
      projectId: string,
      groupId: string,
      assignRolesToGroupRequest: RequestAssignRolesToGroupRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
          xAuthToken,
          projectId,
          groupId,
          assignRolesToGroupRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 Project role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} groupId User ID, maxLength&#x3D;32
     * @param {string} roleName User ID, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
      xAuthToken: string,
      projectId: string,
      groupId: string,
      roleName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
          xAuthToken,
          projectId,
          groupId,
          roleName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자에게 Project 의 role 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} userId User ID, maxLength&#x3D;32
     * @param {RequestAssignRolesToUserRequest} assignRolesToUserRequest role names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
      xAuthToken: string,
      projectId: string,
      userId: string,
      assignRolesToUserRequest: RequestAssignRolesToUserRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
          xAuthToken,
          projectId,
          userId,
          assignRolesToUserRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminProjectsProjectIdUsersUserIdRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 Project role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, maxLength&#x3D;32
     * @param {string} userId User ID, maxLength&#x3D;32
     * @param {string} roleName User ID, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
      xAuthToken: string,
      projectId: string,
      userId: string,
      roleName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
          xAuthToken,
          projectId,
          userId,
          roleName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * system scope 권한(system_assignment) 한 건을 회수한다.
     * @summary 시스템 권한 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {ApiV1AdminSystemAssignmentsDeleteTypeEnum} type assignment type
     * @param {string} actorId user id 또는 group id, maxLength&#x3D;32
     * @param {string} roleId role id, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminSystemAssignmentsDelete(
      xAuthToken: string,
      type: ApiV1AdminSystemAssignmentsDeleteTypeEnum,
      actorId: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSystemAssignmentsDelete(
        xAuthToken,
        type,
        actorId,
        roleId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminSystemAssignmentsDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 권한 목록 조회
     * @summary 시스템 권한 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [userId] user id, maxLength&#x3D;32
     * @param {string} [groupId] group id, maxLength&#x3D;32
     * @param {string} [roleName] assignment search by role name, maxLength&#x3D;64
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminSystemAssignmentsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      userId?: string,
      groupId?: string,
      roleName?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudSystemAssignmentList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSystemAssignmentsGet(
        xAuthToken,
        size,
        offset,
        userId,
        groupId,
        roleName,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminSystemAssignmentsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * system scope 권한(system_assignment) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다.
     * @summary 시스템 권한 일괄 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestAdminSystemAssignmentCreateRequest} request 부여할 시스템 권한
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminSystemAssignmentsPost(
      xAuthToken: string,
      request: RequestAdminSystemAssignmentCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminSystemAssignmentsPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminSystemAssignmentsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 전체 사용자 목록 조회
     * @summary 전체 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [domainId] user search by domain id, maxLength&#x3D;32
     * @param {string} [domainName] user search by domain name, maxLength&#x3D;64
     * @param {string} [id] user search by user id, maxLength&#x3D;32
     * @param {string} [name] user search by user name, maxLength&#x3D;64
     * @param {string} [userType] user search by user type (All, User, Account, Agent) default&#x3D;All
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminUsersGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      domainId?: string,
      domainName?: string,
      id?: string,
      name?: string,
      userType?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUsers>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersGet(
        xAuthToken,
        size,
        offset,
        domainId,
        domainName,
        id,
        name,
        userType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminUsersGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 삭제
     * @summary 사용자 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminUsersUserIdDelete(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdDelete(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminUsersUserIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 유저의 비밀번호 강제변경
     * @summary 유저의 비밀번호 강제변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {RequestCloudUserOverwritePasswordRequest} passwordInfo 비밀번호 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminUsersUserIdPasswordPost(
      xAuthToken: string,
      userId: string,
      passwordInfo: RequestCloudUserOverwritePasswordRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdPasswordPost(
        xAuthToken,
        userId,
        passwordInfo,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminUsersUserIdPasswordPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 유저 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 유저 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32, maxLength&#x3D;32
     * @param {RequestCloudUserUpdateAdminRequest} cloudUserUpdateAdminRequest 사용자 정보 수정 내용(enabled 값이 없는 경우 default&#x3D;false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminUsersUserIdPatch(
      xAuthToken: string,
      userId: string,
      cloudUserUpdateAdminRequest: RequestCloudUserUpdateAdminRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUser>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdPatch(
        xAuthToken,
        userId,
        cloudUserUpdateAdminRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminUsersUserIdPatch']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자에게 system 권한 제거
     * @summary 사용자에게 system 권한 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminUsersUserIdRolesRoleIdDelete(
      xAuthToken: string,
      userId: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1AdminUsersUserIdRolesRoleIdDelete(
          xAuthToken,
          userId,
          roleId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminUsersUserIdRolesRoleIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자에게 system 권한 부여
     * @summary 사용자에게 system 권한 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {string} roleId Role ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AdminUsersUserIdRolesRoleIdPut(
      xAuthToken: string,
      userId: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminUsersUserIdRolesRoleIdPut(
        xAuthToken,
        userId,
        roleId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CiaApi.apiV1AdminUsersUserIdRolesRoleIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CiaApi - factory interface
 */
export const CiaApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CiaApiFp(configuration);
  return {
    /**
     * 지정한 domain 정보 상세 조회
     * @summary 지정한 domain 정보 상세 조회
     * @param {CiaApiApiV11AdminDomainsDomainIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11AdminDomainsDomainIdGet(
      requestParameters: CiaApiApiV11AdminDomainsDomainIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGetAllExtraResponse> {
      return localVarFp
        .apiV11AdminDomainsDomainIdGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * application credential 목록 조회
     * @summary application credential 목록 조회
     * @param {CiaApiApiV1AdminApplicationCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminApplicationCredentialsGet(
      requestParameters: CiaApiApiV1AdminApplicationCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDtos> {
      return localVarFp
        .apiV1AdminApplicationCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.id,
          requestParameters.name,
          requestParameters.userId,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * assignment(프로젝트/도메인 권한) 한 건을 회수한다. inherited 로 일반 부여(false)와 상속 부여(true) 중 어느 쪽을 지울지 지정한다.
     * @summary 권한 회수
     * @param {CiaApiApiV1AdminAssignmentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminAssignmentsDelete(
      requestParameters: CiaApiApiV1AdminAssignmentsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminAssignmentsDelete(
          requestParameters.xAuthToken,
          requestParameters.type,
          requestParameters.targetId,
          requestParameters.actorId,
          requestParameters.roleId,
          requestParameters.inherited,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 권한 목록 조회
     * @summary 권한 목록 조회
     * @param {CiaApiApiV1AdminAssignmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminAssignmentsGet(
      requestParameters: CiaApiApiV1AdminAssignmentsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudAssignmentList> {
      return localVarFp
        .apiV1AdminAssignmentsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.userId,
          requestParameters.groupId,
          requestParameters.domainId,
          requestParameters.projectId,
          requestParameters.domainName,
          requestParameters.roleName,
          requestParameters.isSystemRole,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * assignment(프로젝트/도메인 권한) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다. inherited=true 는 UserDomain/GroupDomain 에서만 유효하다 - 도메인 하위 전체 프로젝트에 적용되는 상속 부여를 만든다.
     * @summary 권한 일괄 부여
     * @param {CiaApiApiV1AdminAssignmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminAssignmentsPost(
      requestParameters: CiaApiApiV1AdminAssignmentsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminAssignmentsPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
    /**
     * credential 목록 조회
     * @summary credential 목록 조회.
     * @param {CiaApiApiV1AdminCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminCredentialsGet(
      requestParameters: CiaApiApiV1AdminCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialListAllResponse> {
      return localVarFp
        .apiV1AdminCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.projectId,
          requestParameters.userId,
          requestParameters.id,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * WRITE_TARGET_FOR_ADMIN 권한 확인 후 대상 사용자를 도메인 소유자로 강제 변경한다. 대상 사용자는 해당 도메인 소속이어야 한다.
     * @summary 조직 소유자 강제 변경 (Admin)
     * @param {CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminDomainsDomainIdForceAssignOwnerPost(
      requestParameters: CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminDomainsDomainIdForceAssignOwnerPost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.forceAssignOwnerRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹에게 system 권한 제거
     * @summary 그룹에게 system 권한 제거
     * @param {CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminGroupsGroupIdRolesRoleIdDelete(
      requestParameters: CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminGroupsGroupIdRolesRoleIdDelete(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.roleId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹에게 system 권한 부여
     * @summary 그룹에게 system 권한 부여
     * @param {CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminGroupsGroupIdRolesRoleIdPut(
      requestParameters: CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminGroupsGroupIdRolesRoleIdPut(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.roleId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능. Default Role 생성을 원치않는 경우 사용 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러
     * @summary permission 생성
     * @param {CiaApiApiV1AdminPermissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminPermissionsPost(
      requestParameters: CiaApiApiV1AdminPermissionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudPermissionDtos> {
      return localVarFp
        .apiV1AdminPermissionsPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹에 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 그룹에 Project 의 role 부여
     * @param {CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
      requestParameters: CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.groupId,
          requestParameters.assignRolesToGroupRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 Project role 삭제
     * @param {CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
      requestParameters: CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.groupId,
          requestParameters.roleName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자에게 Project 의 role 부여
     * @param {CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
      requestParameters: CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          requestParameters.assignRolesToUserRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 Project role 삭제
     * @param {CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
      requestParameters: CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          requestParameters.roleName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * system scope 권한(system_assignment) 한 건을 회수한다.
     * @summary 시스템 권한 회수
     * @param {CiaApiApiV1AdminSystemAssignmentsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminSystemAssignmentsDelete(
      requestParameters: CiaApiApiV1AdminSystemAssignmentsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminSystemAssignmentsDelete(
          requestParameters.xAuthToken,
          requestParameters.type,
          requestParameters.actorId,
          requestParameters.roleId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 권한 목록 조회
     * @summary 시스템 권한 목록 조회
     * @param {CiaApiApiV1AdminSystemAssignmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminSystemAssignmentsGet(
      requestParameters: CiaApiApiV1AdminSystemAssignmentsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudSystemAssignmentList> {
      return localVarFp
        .apiV1AdminSystemAssignmentsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.userId,
          requestParameters.groupId,
          requestParameters.roleName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * system scope 권한(system_assignment) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다.
     * @summary 시스템 권한 일괄 부여
     * @param {CiaApiApiV1AdminSystemAssignmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminSystemAssignmentsPost(
      requestParameters: CiaApiApiV1AdminSystemAssignmentsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminSystemAssignmentsPost(
          requestParameters.xAuthToken,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 전체 사용자 목록 조회
     * @summary 전체 사용자 목록 조회
     * @param {CiaApiApiV1AdminUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersGet(
      requestParameters: CiaApiApiV1AdminUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUsers> {
      return localVarFp
        .apiV1AdminUsersGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.domainId,
          requestParameters.domainName,
          requestParameters.id,
          requestParameters.name,
          requestParameters.userType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 삭제
     * @summary 사용자 삭제
     * @param {CiaApiApiV1AdminUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdDelete(
      requestParameters: CiaApiApiV1AdminUsersUserIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminUsersUserIdDelete(
          requestParameters.xAuthToken,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 유저의 비밀번호 강제변경
     * @summary 유저의 비밀번호 강제변경
     * @param {CiaApiApiV1AdminUsersUserIdPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdPasswordPost(
      requestParameters: CiaApiApiV1AdminUsersUserIdPasswordPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminUsersUserIdPasswordPost(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.passwordInfo,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 유저 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 유저 정보 수정
     * @param {CiaApiApiV1AdminUsersUserIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdPatch(
      requestParameters: CiaApiApiV1AdminUsersUserIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUser> {
      return localVarFp
        .apiV1AdminUsersUserIdPatch(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.cloudUserUpdateAdminRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자에게 system 권한 제거
     * @summary 사용자에게 system 권한 제거
     * @param {CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdRolesRoleIdDelete(
      requestParameters: CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminUsersUserIdRolesRoleIdDelete(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.roleId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자에게 system 권한 부여
     * @summary 사용자에게 system 권한 부여
     * @param {CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AdminUsersUserIdRolesRoleIdPut(
      requestParameters: CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1AdminUsersUserIdRolesRoleIdPut(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.roleId,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CiaApi - interface
 */
export interface CiaApiInterface {
  /**
   * 지정한 domain 정보 상세 조회
   * @summary 지정한 domain 정보 상세 조회
   * @param {CiaApiApiV11AdminDomainsDomainIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11AdminDomainsDomainIdGet(
    requestParameters: CiaApiApiV11AdminDomainsDomainIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGetAllExtraResponse>;

  /**
   * application credential 목록 조회
   * @summary application credential 목록 조회
   * @param {CiaApiApiV1AdminApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminApplicationCredentialsGet(
    requestParameters: CiaApiApiV1AdminApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDtos>;

  /**
   * assignment(프로젝트/도메인 권한) 한 건을 회수한다. inherited 로 일반 부여(false)와 상속 부여(true) 중 어느 쪽을 지울지 지정한다.
   * @summary 권한 회수
   * @param {CiaApiApiV1AdminAssignmentsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminAssignmentsDelete(
    requestParameters: CiaApiApiV1AdminAssignmentsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 권한 목록 조회
   * @summary 권한 목록 조회
   * @param {CiaApiApiV1AdminAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminAssignmentsGet(
    requestParameters: CiaApiApiV1AdminAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudAssignmentList>;

  /**
   * assignment(프로젝트/도메인 권한) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다. inherited=true 는 UserDomain/GroupDomain 에서만 유효하다 - 도메인 하위 전체 프로젝트에 적용되는 상속 부여를 만든다.
   * @summary 권한 일괄 부여
   * @param {CiaApiApiV1AdminAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminAssignmentsPost(
    requestParameters: CiaApiApiV1AdminAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * credential 목록 조회
   * @summary credential 목록 조회.
   * @param {CiaApiApiV1AdminCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminCredentialsGet(
    requestParameters: CiaApiApiV1AdminCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialListAllResponse>;

  /**
   * WRITE_TARGET_FOR_ADMIN 권한 확인 후 대상 사용자를 도메인 소유자로 강제 변경한다. 대상 사용자는 해당 도메인 소속이어야 한다.
   * @summary 조직 소유자 강제 변경 (Admin)
   * @param {CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminDomainsDomainIdForceAssignOwnerPost(
    requestParameters: CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 그룹에게 system 권한 제거
   * @summary 그룹에게 system 권한 제거
   * @param {CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminGroupsGroupIdRolesRoleIdDelete(
    requestParameters: CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 그룹에게 system 권한 부여
   * @summary 그룹에게 system 권한 부여
   * @param {CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminGroupsGroupIdRolesRoleIdPut(
    requestParameters: CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능. Default Role 생성을 원치않는 경우 사용 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러
   * @summary permission 생성
   * @param {CiaApiApiV1AdminPermissionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminPermissionsPost(
    requestParameters: CiaApiApiV1AdminPermissionsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudPermissionDtos>;

  /**
   * 그룹에 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 그룹에 Project 의 role 부여
   * @param {CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자의 Project role 삭제
   * @param {CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자에게 Project 의 role 부여
   * @param {CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자의 Project role 삭제
   * @param {CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * system scope 권한(system_assignment) 한 건을 회수한다.
   * @summary 시스템 권한 회수
   * @param {CiaApiApiV1AdminSystemAssignmentsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminSystemAssignmentsDelete(
    requestParameters: CiaApiApiV1AdminSystemAssignmentsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 권한 목록 조회
   * @summary 시스템 권한 목록 조회
   * @param {CiaApiApiV1AdminSystemAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminSystemAssignmentsGet(
    requestParameters: CiaApiApiV1AdminSystemAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudSystemAssignmentList>;

  /**
   * system scope 권한(system_assignment) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다.
   * @summary 시스템 권한 일괄 부여
   * @param {CiaApiApiV1AdminSystemAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminSystemAssignmentsPost(
    requestParameters: CiaApiApiV1AdminSystemAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 전체 사용자 목록 조회
   * @summary 전체 사용자 목록 조회
   * @param {CiaApiApiV1AdminUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminUsersGet(
    requestParameters: CiaApiApiV1AdminUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUsers>;

  /**
   * 사용자 삭제
   * @summary 사용자 삭제
   * @param {CiaApiApiV1AdminUsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminUsersUserIdDelete(
    requestParameters: CiaApiApiV1AdminUsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 유저의 비밀번호 강제변경
   * @summary 유저의 비밀번호 강제변경
   * @param {CiaApiApiV1AdminUsersUserIdPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminUsersUserIdPasswordPost(
    requestParameters: CiaApiApiV1AdminUsersUserIdPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 유저 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 유저 정보 수정
   * @param {CiaApiApiV1AdminUsersUserIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminUsersUserIdPatch(
    requestParameters: CiaApiApiV1AdminUsersUserIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUser>;

  /**
   * 사용자에게 system 권한 제거
   * @summary 사용자에게 system 권한 제거
   * @param {CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminUsersUserIdRolesRoleIdDelete(
    requestParameters: CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자에게 system 권한 부여
   * @summary 사용자에게 system 권한 부여
   * @param {CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AdminUsersUserIdRolesRoleIdPut(
    requestParameters: CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;
}

/**
 * Request parameters for apiV11AdminDomainsDomainIdGet operation in CiaApi.
 */
export interface CiaApiApiV11AdminDomainsDomainIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1AdminApplicationCredentialsGet operation in CiaApi.
 */
export interface CiaApiApiV1AdminApplicationCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * credential search by credential id, maxLength&#x3D;32
   */
  readonly id?: string;

  /**
   * credential search by credential name, maxLength&#x3D;64
   */
  readonly name?: string;

  /**
   * credential search by user id, maxLength&#x3D;32
   */
  readonly userId?: string;

  /**
   * credential search by project id, maxLength&#x3D;32
   */
  readonly projectId?: string;
}

/**
 * Request parameters for apiV1AdminAssignmentsDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminAssignmentsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * assignment type
   */
  readonly type: ApiV1AdminAssignmentsDeleteTypeEnum;

  /**
   * project id 또는 domain id, maxLength&#x3D;32
   */
  readonly targetId: string;

  /**
   * user id 또는 group id, maxLength&#x3D;32
   */
  readonly actorId: string;

  /**
   * role id, maxLength&#x3D;32
   */
  readonly roleId: string;

  /**
   * 상속 부여를 지울지 여부. 미지정 시 일반 부여만 지운다
   */
  readonly inherited?: boolean;
}

/**
 * Request parameters for apiV1AdminAssignmentsGet operation in CiaApi.
 */
export interface CiaApiApiV1AdminAssignmentsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * user id, maxLength&#x3D;32
   */
  readonly userId?: string;

  /**
   * group id, maxLength&#x3D;32
   */
  readonly groupId?: string;

  /**
   * target id, maxLength&#x3D;32
   */
  readonly domainId?: string;

  /**
   * target id, maxLength&#x3D;32
   */
  readonly projectId?: string;

  /**
   * assignment search by domain name, maxLength&#x3D;64
   */
  readonly domainName?: string;

  /**
   * assignment search by role name, maxLength&#x3D;64
   */
  readonly roleName?: string;

  /**
   * assignment search on system_role scope only
   */
  readonly isSystemRole?: boolean;
}

/**
 * Request parameters for apiV1AdminAssignmentsPost operation in CiaApi.
 */
export interface CiaApiApiV1AdminAssignmentsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 부여할 assignment
   */
  readonly request: RequestAdminAssignmentCreateRequest;
}

/**
 * Request parameters for apiV1AdminCredentialsGet operation in CiaApi.
 */
export interface CiaApiApiV1AdminCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
   */
  readonly offset?: number;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * credential project id
   */
  readonly projectId?: string;

  /**
   * credential user id
   */
  readonly userId?: string;

  /**
   * credential id
   */
  readonly id?: string;
}

/**
 * Request parameters for apiV1AdminDomainsDomainIdForceAssignOwnerPost operation in CiaApi.
 */
export interface CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * to_user_id
   */
  readonly forceAssignOwnerRequest: RequestForceAssignOwnerRequest;
}

/**
 * Request parameters for apiV1AdminGroupsGroupIdRolesRoleIdDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly groupId: string;

  /**
   * Role ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly roleId: string;
}

/**
 * Request parameters for apiV1AdminGroupsGroupIdRolesRoleIdPut operation in CiaApi.
 */
export interface CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly groupId: string;

  /**
   * Role ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly roleId: string;
}

/**
 * Request parameters for apiV1AdminPermissionsPost operation in CiaApi.
 */
export interface CiaApiApiV1AdminPermissionsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission 생성
   */
  readonly request: RequestPermissionCreateWithoutRoleRequest;
}

/**
 * Request parameters for apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut operation in CiaApi.
 */
export interface CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, maxLength&#x3D;32
   */
  readonly projectId: string;

  /**
   * Group ID, maxLength&#x3D;32
   */
  readonly groupId: string;

  /**
   * role names
   */
  readonly assignRolesToGroupRequest: RequestAssignRolesToGroupRequest;
}

/**
 * Request parameters for apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, maxLength&#x3D;32
   */
  readonly projectId: string;

  /**
   * User ID, maxLength&#x3D;32
   */
  readonly groupId: string;

  /**
   * User ID, maxLength&#x3D;32
   */
  readonly roleName: string;
}

/**
 * Request parameters for apiV1AdminProjectsProjectIdUsersUserIdRolesPut operation in CiaApi.
 */
export interface CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, maxLength&#x3D;32
   */
  readonly projectId: string;

  /**
   * User ID, maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * role names
   */
  readonly assignRolesToUserRequest: RequestAssignRolesToUserRequest;
}

/**
 * Request parameters for apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, maxLength&#x3D;32
   */
  readonly projectId: string;

  /**
   * User ID, maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * User ID, maxLength&#x3D;32
   */
  readonly roleName: string;
}

/**
 * Request parameters for apiV1AdminSystemAssignmentsDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminSystemAssignmentsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * assignment type
   */
  readonly type: ApiV1AdminSystemAssignmentsDeleteTypeEnum;

  /**
   * user id 또는 group id, maxLength&#x3D;32
   */
  readonly actorId: string;

  /**
   * role id, maxLength&#x3D;32
   */
  readonly roleId: string;
}

/**
 * Request parameters for apiV1AdminSystemAssignmentsGet operation in CiaApi.
 */
export interface CiaApiApiV1AdminSystemAssignmentsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * user id, maxLength&#x3D;32
   */
  readonly userId?: string;

  /**
   * group id, maxLength&#x3D;32
   */
  readonly groupId?: string;

  /**
   * assignment search by role name, maxLength&#x3D;64
   */
  readonly roleName?: string;
}

/**
 * Request parameters for apiV1AdminSystemAssignmentsPost operation in CiaApi.
 */
export interface CiaApiApiV1AdminSystemAssignmentsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 부여할 시스템 권한
   */
  readonly request: RequestAdminSystemAssignmentCreateRequest;
}

/**
 * Request parameters for apiV1AdminUsersGet operation in CiaApi.
 */
export interface CiaApiApiV1AdminUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * user search by domain id, maxLength&#x3D;32
   */
  readonly domainId?: string;

  /**
   * user search by domain name, maxLength&#x3D;64
   */
  readonly domainName?: string;

  /**
   * user search by user id, maxLength&#x3D;32
   */
  readonly id?: string;

  /**
   * user search by user name, maxLength&#x3D;64
   */
  readonly name?: string;

  /**
   * user search by user type (All, User, Account, Agent) default&#x3D;All
   */
  readonly userType?: string;
}

/**
 * Request parameters for apiV1AdminUsersUserIdDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminUsersUserIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1AdminUsersUserIdPasswordPost operation in CiaApi.
 */
export interface CiaApiApiV1AdminUsersUserIdPasswordPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * 비밀번호 정보
   */
  readonly passwordInfo: RequestCloudUserOverwritePasswordRequest;
}

/**
 * Request parameters for apiV1AdminUsersUserIdPatch operation in CiaApi.
 */
export interface CiaApiApiV1AdminUsersUserIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, minLength&#x3D;32, maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * 사용자 정보 수정 내용(enabled 값이 없는 경우 default&#x3D;false)
   */
  readonly cloudUserUpdateAdminRequest: RequestCloudUserUpdateAdminRequest;
}

/**
 * Request parameters for apiV1AdminUsersUserIdRolesRoleIdDelete operation in CiaApi.
 */
export interface CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * Role ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly roleId: string;
}

/**
 * Request parameters for apiV1AdminUsersUserIdRolesRoleIdPut operation in CiaApi.
 */
export interface CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly userId: string;

  /**
   * Role ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly roleId: string;
}

/**
 * CiaApi - object-oriented interface
 */
export class CiaApi extends BaseAPI implements CiaApiInterface {
  /**
   * 지정한 domain 정보 상세 조회
   * @summary 지정한 domain 정보 상세 조회
   * @param {CiaApiApiV11AdminDomainsDomainIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11AdminDomainsDomainIdGet(
    requestParameters: CiaApiApiV11AdminDomainsDomainIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV11AdminDomainsDomainIdGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * application credential 목록 조회
   * @summary application credential 목록 조회
   * @param {CiaApiApiV1AdminApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminApplicationCredentialsGet(
    requestParameters: CiaApiApiV1AdminApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminApplicationCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.id,
        requestParameters.name,
        requestParameters.userId,
        requestParameters.projectId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * assignment(프로젝트/도메인 권한) 한 건을 회수한다. inherited 로 일반 부여(false)와 상속 부여(true) 중 어느 쪽을 지울지 지정한다.
   * @summary 권한 회수
   * @param {CiaApiApiV1AdminAssignmentsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminAssignmentsDelete(
    requestParameters: CiaApiApiV1AdminAssignmentsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminAssignmentsDelete(
        requestParameters.xAuthToken,
        requestParameters.type,
        requestParameters.targetId,
        requestParameters.actorId,
        requestParameters.roleId,
        requestParameters.inherited,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 권한 목록 조회
   * @summary 권한 목록 조회
   * @param {CiaApiApiV1AdminAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminAssignmentsGet(
    requestParameters: CiaApiApiV1AdminAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminAssignmentsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.userId,
        requestParameters.groupId,
        requestParameters.domainId,
        requestParameters.projectId,
        requestParameters.domainName,
        requestParameters.roleName,
        requestParameters.isSystemRole,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * assignment(프로젝트/도메인 권한) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다. inherited=true 는 UserDomain/GroupDomain 에서만 유효하다 - 도메인 하위 전체 프로젝트에 적용되는 상속 부여를 만든다.
   * @summary 권한 일괄 부여
   * @param {CiaApiApiV1AdminAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminAssignmentsPost(
    requestParameters: CiaApiApiV1AdminAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminAssignmentsPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * credential 목록 조회
   * @summary credential 목록 조회.
   * @param {CiaApiApiV1AdminCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminCredentialsGet(
    requestParameters: CiaApiApiV1AdminCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.id,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * WRITE_TARGET_FOR_ADMIN 권한 확인 후 대상 사용자를 도메인 소유자로 강제 변경한다. 대상 사용자는 해당 도메인 소속이어야 한다.
   * @summary 조직 소유자 강제 변경 (Admin)
   * @param {CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminDomainsDomainIdForceAssignOwnerPost(
    requestParameters: CiaApiApiV1AdminDomainsDomainIdForceAssignOwnerPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminDomainsDomainIdForceAssignOwnerPost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.forceAssignOwnerRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹에게 system 권한 제거
   * @summary 그룹에게 system 권한 제거
   * @param {CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminGroupsGroupIdRolesRoleIdDelete(
    requestParameters: CiaApiApiV1AdminGroupsGroupIdRolesRoleIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminGroupsGroupIdRolesRoleIdDelete(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.roleId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹에게 system 권한 부여
   * @summary 그룹에게 system 권한 부여
   * @param {CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminGroupsGroupIdRolesRoleIdPut(
    requestParameters: CiaApiApiV1AdminGroupsGroupIdRolesRoleIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminGroupsGroupIdRolesRoleIdPut(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.roleId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능. Default Role 생성을 원치않는 경우 사용 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러
   * @summary permission 생성
   * @param {CiaApiApiV1AdminPermissionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminPermissionsPost(
    requestParameters: CiaApiApiV1AdminPermissionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminPermissionsPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹에 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 그룹에 Project 의 role 부여
   * @param {CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminProjectsProjectIdGroupsGroupIdRolesPut(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.groupId,
        requestParameters.assignRolesToGroupRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자의 Project role 삭제
   * @param {CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminProjectsProjectIdGroupsGroupIdRolesRoleNameDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.groupId,
        requestParameters.roleName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 유지되며 신규 요청한 role 이 추가로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자에게 Project 의 role 부여
   * @param {CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminProjectsProjectIdUsersUserIdRolesPut(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.assignRolesToUserRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 Project role 삭제. 기존에 부여된 role 은 유지되며 신규 요청한 role 만 삭제된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자의 Project role 삭제
   * @param {CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
    requestParameters: CiaApiApiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminProjectsProjectIdUsersUserIdRolesRoleNameDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.roleName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * system scope 권한(system_assignment) 한 건을 회수한다.
   * @summary 시스템 권한 회수
   * @param {CiaApiApiV1AdminSystemAssignmentsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminSystemAssignmentsDelete(
    requestParameters: CiaApiApiV1AdminSystemAssignmentsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminSystemAssignmentsDelete(
        requestParameters.xAuthToken,
        requestParameters.type,
        requestParameters.actorId,
        requestParameters.roleId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 권한 목록 조회
   * @summary 시스템 권한 목록 조회
   * @param {CiaApiApiV1AdminSystemAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminSystemAssignmentsGet(
    requestParameters: CiaApiApiV1AdminSystemAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminSystemAssignmentsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.userId,
        requestParameters.groupId,
        requestParameters.roleName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * system scope 권한(system_assignment) 을 일괄 부여한다. actor_ids × role_ids 전 조합을 생성하며 이미 있는 조합은 무시한다.
   * @summary 시스템 권한 일괄 부여
   * @param {CiaApiApiV1AdminSystemAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminSystemAssignmentsPost(
    requestParameters: CiaApiApiV1AdminSystemAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminSystemAssignmentsPost(
        requestParameters.xAuthToken,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 전체 사용자 목록 조회
   * @summary 전체 사용자 목록 조회
   * @param {CiaApiApiV1AdminUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminUsersGet(
    requestParameters: CiaApiApiV1AdminUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminUsersGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.domainId,
        requestParameters.domainName,
        requestParameters.id,
        requestParameters.name,
        requestParameters.userType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 삭제
   * @summary 사용자 삭제
   * @param {CiaApiApiV1AdminUsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminUsersUserIdDelete(
    requestParameters: CiaApiApiV1AdminUsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminUsersUserIdDelete(requestParameters.xAuthToken, requestParameters.userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 유저의 비밀번호 강제변경
   * @summary 유저의 비밀번호 강제변경
   * @param {CiaApiApiV1AdminUsersUserIdPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminUsersUserIdPasswordPost(
    requestParameters: CiaApiApiV1AdminUsersUserIdPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminUsersUserIdPasswordPost(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.passwordInfo,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 유저 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 유저 정보 수정
   * @param {CiaApiApiV1AdminUsersUserIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminUsersUserIdPatch(
    requestParameters: CiaApiApiV1AdminUsersUserIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminUsersUserIdPatch(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.cloudUserUpdateAdminRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자에게 system 권한 제거
   * @summary 사용자에게 system 권한 제거
   * @param {CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminUsersUserIdRolesRoleIdDelete(
    requestParameters: CiaApiApiV1AdminUsersUserIdRolesRoleIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminUsersUserIdRolesRoleIdDelete(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.roleId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자에게 system 권한 부여
   * @summary 사용자에게 system 권한 부여
   * @param {CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AdminUsersUserIdRolesRoleIdPut(
    requestParameters: CiaApiApiV1AdminUsersUserIdRolesRoleIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CiaApiFp(this.configuration)
      .apiV1AdminUsersUserIdRolesRoleIdPut(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.roleId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV1AdminAssignmentsDeleteTypeEnum = {
  UserProject: 'UserProject',
  GroupProject: 'GroupProject',
  UserDomain: 'UserDomain',
  GroupDomain: 'GroupDomain',
} as const;
export type ApiV1AdminAssignmentsDeleteTypeEnum =
  (typeof ApiV1AdminAssignmentsDeleteTypeEnum)[keyof typeof ApiV1AdminAssignmentsDeleteTypeEnum];
export const ApiV1AdminSystemAssignmentsDeleteTypeEnum = {
  UserSystem: 'UserSystem',
  GroupSystem: 'GroupSystem',
} as const;
export type ApiV1AdminSystemAssignmentsDeleteTypeEnum =
  (typeof ApiV1AdminSystemAssignmentsDeleteTypeEnum)[keyof typeof ApiV1AdminSystemAssignmentsDeleteTypeEnum];

/**
 * CredentialsApi - axios parameter creator
 */
export const CredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * credential 정보 상세 조회
     * @summary credential 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, sha256 value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsCredentialIdGet: async (
      xAuthToken: string,
      credentialId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1CredentialsCredentialIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'credentialId' is not null or undefined
      assertParamExists('apiV1CredentialsCredentialIdGet', 'credentialId', credentialId);
      const localVarPath = `/api/v1/credentials/{credential_id}`.replace(
        '{credential_id}',
        encodeURIComponent(String(credentialId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * credential 수정
     * @summary credential 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, minLength&#x3D;64 maxLength&#x3D;64
     * @param {RequestCredentialUpdateRequest} credential credential 정보 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsCredentialIdPut: async (
      xAuthToken: string,
      credentialId: string,
      credential: RequestCredentialUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1CredentialsCredentialIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'credentialId' is not null or undefined
      assertParamExists('apiV1CredentialsCredentialIdPut', 'credentialId', credentialId);
      // verify required parameter 'credential' is not null or undefined
      assertParamExists('apiV1CredentialsCredentialIdPut', 'credential', credential);
      const localVarPath = `/api/v1/credentials/{credential_id}`.replace(
        '{credential_id}',
        encodeURIComponent(String(credentialId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        credential,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * credential 삭제
     * @summary credential 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} credentialIds Credential ID, sha256 values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsDelete: async (
      xAuthToken: string,
      credentialIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1CredentialsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'credentialIds' is not null or undefined
      assertParamExists('apiV1CredentialsDelete', 'credentialIds', credentialIds);
      const localVarPath = `/api/v1/credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (credentialIds) {
        localVarQueryParameter['credential_ids'] = credentialIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * credential 생성
     * @summary credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCredentialCreateRequest} credential user_id, project_id, name 필수
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsPost: async (
      xAuthToken: string,
      credential: RequestCredentialCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1CredentialsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'credential' is not null or undefined
      assertParamExists('apiV1CredentialsPost', 'credential', credential);
      const localVarPath = `/api/v1/credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        credential,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 에 존재하는 credential 목록 조회
     * @summary domain 에 존재하는 credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [id] credential id for search, sha256 value
     * @param {string} [projectName] project name for search, 영소문자+숫자+특수문자(-) 32자
     * @param {string} [userName] username for search, 이메일 사용가능 문자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdCredentialsGet: async (
      xAuthToken: string,
      domainId: string,
      offset?: number,
      size?: number,
      id?: string,
      projectName?: string,
      userName?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdCredentialsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdCredentialsGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/credentials`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (projectName !== undefined) {
        localVarQueryParameter['project_name'] = projectName;
      }

      if (userName !== undefined) {
        localVarQueryParameter['user_name'] = userName;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 credential 목록 조회 (blob 포함)
     * @summary 사용자 credential 목록 조회 (blob 포함)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId credential user id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdCredentialsExpGet: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdCredentialsExpGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdCredentialsExpGet', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}/credentials/exp`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 credential 목록 조회
     * @summary 사용자 credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId credential user id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [id] credential id for search, sha256 value
     * @param {string} [projectName] project name for search, 영대소문자+숫자+특수문자(-) 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdCredentialsGet: async (
      xAuthToken: string,
      userId: string,
      offset?: number,
      size?: number,
      id?: string,
      projectName?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdCredentialsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdCredentialsGet', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}/credentials`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (projectName !== undefined) {
        localVarQueryParameter['project_name'] = projectName;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CredentialsApi - functional programming interface
 */
export const CredentialsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CredentialsApiAxiosParamCreator(configuration);
  return {
    /**
     * credential 정보 상세 조회
     * @summary credential 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, sha256 value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1CredentialsCredentialIdGet(
      xAuthToken: string,
      credentialId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCredentialGetResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CredentialsCredentialIdGet(
        xAuthToken,
        credentialId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1CredentialsCredentialIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * credential 수정
     * @summary credential 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, minLength&#x3D;64 maxLength&#x3D;64
     * @param {RequestCredentialUpdateRequest} credential credential 정보 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1CredentialsCredentialIdPut(
      xAuthToken: string,
      credentialId: string,
      credential: RequestCredentialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CredentialsCredentialIdPut(
        xAuthToken,
        credentialId,
        credential,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1CredentialsCredentialIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * credential 삭제
     * @summary credential 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} credentialIds Credential ID, sha256 values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1CredentialsDelete(
      xAuthToken: string,
      credentialIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CredentialsDelete(
        xAuthToken,
        credentialIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1CredentialsDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * credential 생성
     * @summary credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCredentialCreateRequest} credential user_id, project_id, name 필수
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1CredentialsPost(
      xAuthToken: string,
      credential: RequestCredentialCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCredentialCreateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CredentialsPost(
        xAuthToken,
        credential,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1CredentialsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 에 존재하는 credential 목록 조회
     * @summary domain 에 존재하는 credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [id] credential id for search, sha256 value
     * @param {string} [projectName] project name for search, 영소문자+숫자+특수문자(-) 32자
     * @param {string} [userName] username for search, 이메일 사용가능 문자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdCredentialsGet(
      xAuthToken: string,
      domainId: string,
      offset?: number,
      size?: number,
      id?: string,
      projectName?: string,
      userName?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCredentialListByDomainResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdCredentialsGet(
        xAuthToken,
        domainId,
        offset,
        size,
        id,
        projectName,
        userName,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1DomainsDomainIdCredentialsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 credential 목록 조회 (blob 포함)
     * @summary 사용자 credential 목록 조회 (blob 포함)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId credential user id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdCredentialsExpGet(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCredentialListByUserWithBlobResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdCredentialsExpGet(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1UsersUserIdCredentialsExpGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 credential 목록 조회
     * @summary 사용자 credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId credential user id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {string} [id] credential id for search, sha256 value
     * @param {string} [projectName] project name for search, 영대소문자+숫자+특수문자(-) 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdCredentialsGet(
      xAuthToken: string,
      userId: string,
      offset?: number,
      size?: number,
      id?: string,
      projectName?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCredentialListByUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdCredentialsGet(
        xAuthToken,
        userId,
        offset,
        size,
        id,
        projectName,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CredentialsApi.apiV1UsersUserIdCredentialsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CredentialsApi - factory interface
 */
export const CredentialsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CredentialsApiFp(configuration);
  return {
    /**
     * credential 정보 상세 조회
     * @summary credential 정보 상세 조회
     * @param {CredentialsApiApiV1CredentialsCredentialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsCredentialIdGet(
      requestParameters: CredentialsApiApiV1CredentialsCredentialIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialGetResponse> {
      return localVarFp
        .apiV1CredentialsCredentialIdGet(
          requestParameters.xAuthToken,
          requestParameters.credentialId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * credential 수정
     * @summary credential 수정
     * @param {CredentialsApiApiV1CredentialsCredentialIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsCredentialIdPut(
      requestParameters: CredentialsApiApiV1CredentialsCredentialIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1CredentialsCredentialIdPut(
          requestParameters.xAuthToken,
          requestParameters.credentialId,
          requestParameters.credential,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * credential 삭제
     * @summary credential 삭제
     * @param {CredentialsApiApiV1CredentialsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsDelete(
      requestParameters: CredentialsApiApiV1CredentialsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1CredentialsDelete(
          requestParameters.xAuthToken,
          requestParameters.credentialIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * credential 생성
     * @summary credential 생성
     * @param {CredentialsApiApiV1CredentialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1CredentialsPost(
      requestParameters: CredentialsApiApiV1CredentialsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialCreateResponse> {
      return localVarFp
        .apiV1CredentialsPost(requestParameters.xAuthToken, requestParameters.credential, options)
        .then(request => request(axios, basePath));
    },
    /**
     * domain 에 존재하는 credential 목록 조회
     * @summary domain 에 존재하는 credential 목록 조회
     * @param {CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdCredentialsGet(
      requestParameters: CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialListByDomainResponse> {
      return localVarFp
        .apiV1DomainsDomainIdCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.id,
          requestParameters.projectName,
          requestParameters.userName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 credential 목록 조회 (blob 포함)
     * @summary 사용자 credential 목록 조회 (blob 포함)
     * @param {CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdCredentialsExpGet(
      requestParameters: CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialListByUserWithBlobResponse> {
      return localVarFp
        .apiV1UsersUserIdCredentialsExpGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 credential 목록 조회
     * @summary 사용자 credential 목록 조회
     * @param {CredentialsApiApiV1UsersUserIdCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdCredentialsGet(
      requestParameters: CredentialsApiApiV1UsersUserIdCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialListByUserResponse> {
      return localVarFp
        .apiV1UsersUserIdCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.id,
          requestParameters.projectName,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CredentialsApi - interface
 */
export interface CredentialsApiInterface {
  /**
   * credential 정보 상세 조회
   * @summary credential 정보 상세 조회
   * @param {CredentialsApiApiV1CredentialsCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1CredentialsCredentialIdGet(
    requestParameters: CredentialsApiApiV1CredentialsCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialGetResponse>;

  /**
   * credential 수정
   * @summary credential 수정
   * @param {CredentialsApiApiV1CredentialsCredentialIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1CredentialsCredentialIdPut(
    requestParameters: CredentialsApiApiV1CredentialsCredentialIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * credential 삭제
   * @summary credential 삭제
   * @param {CredentialsApiApiV1CredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1CredentialsDelete(
    requestParameters: CredentialsApiApiV1CredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * credential 생성
   * @summary credential 생성
   * @param {CredentialsApiApiV1CredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1CredentialsPost(
    requestParameters: CredentialsApiApiV1CredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialCreateResponse>;

  /**
   * domain 에 존재하는 credential 목록 조회
   * @summary domain 에 존재하는 credential 목록 조회
   * @param {CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdCredentialsGet(
    requestParameters: CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialListByDomainResponse>;

  /**
   * 사용자 credential 목록 조회 (blob 포함)
   * @summary 사용자 credential 목록 조회 (blob 포함)
   * @param {CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdCredentialsExpGet(
    requestParameters: CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialListByUserWithBlobResponse>;

  /**
   * 사용자 credential 목록 조회
   * @summary 사용자 credential 목록 조회
   * @param {CredentialsApiApiV1UsersUserIdCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdCredentialsGet(
    requestParameters: CredentialsApiApiV1UsersUserIdCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialListByUserResponse>;
}

/**
 * Request parameters for apiV1CredentialsCredentialIdGet operation in CredentialsApi.
 */
export interface CredentialsApiApiV1CredentialsCredentialIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * credential_id, sha256 value
   */
  readonly credentialId: string;
}

/**
 * Request parameters for apiV1CredentialsCredentialIdPut operation in CredentialsApi.
 */
export interface CredentialsApiApiV1CredentialsCredentialIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * credential_id, minLength&#x3D;64 maxLength&#x3D;64
   */
  readonly credentialId: string;

  /**
   * credential 정보 업데이트
   */
  readonly credential: RequestCredentialUpdateRequest;
}

/**
 * Request parameters for apiV1CredentialsDelete operation in CredentialsApi.
 */
export interface CredentialsApiApiV1CredentialsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Credential ID, sha256 values
   */
  readonly credentialIds: Array<string>;
}

/**
 * Request parameters for apiV1CredentialsPost operation in CredentialsApi.
 */
export interface CredentialsApiApiV1CredentialsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * user_id, project_id, name 필수
   */
  readonly credential: RequestCredentialCreateRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdCredentialsGet operation in CredentialsApi.
 */
export interface CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자
   */
  readonly domainId: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
   */
  readonly offset?: number;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * credential id for search, sha256 value
   */
  readonly id?: string;

  /**
   * project name for search, 영소문자+숫자+특수문자(-) 32자
   */
  readonly projectName?: string;

  /**
   * username for search, 이메일 사용가능 문자
   */
  readonly userName?: string;
}

/**
 * Request parameters for apiV1UsersUserIdCredentialsExpGet operation in CredentialsApi.
 */
export interface CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * credential user id, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1UsersUserIdCredentialsGet operation in CredentialsApi.
 */
export interface CredentialsApiApiV1UsersUserIdCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * credential user id, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size..., default&#x3D;0
   */
  readonly offset?: number;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * credential id for search, sha256 value
   */
  readonly id?: string;

  /**
   * project name for search, 영대소문자+숫자+특수문자(-) 32자
   */
  readonly projectName?: string;
}

/**
 * CredentialsApi - object-oriented interface
 */
export class CredentialsApi extends BaseAPI implements CredentialsApiInterface {
  /**
   * credential 정보 상세 조회
   * @summary credential 정보 상세 조회
   * @param {CredentialsApiApiV1CredentialsCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1CredentialsCredentialIdGet(
    requestParameters: CredentialsApiApiV1CredentialsCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1CredentialsCredentialIdGet(
        requestParameters.xAuthToken,
        requestParameters.credentialId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * credential 수정
   * @summary credential 수정
   * @param {CredentialsApiApiV1CredentialsCredentialIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1CredentialsCredentialIdPut(
    requestParameters: CredentialsApiApiV1CredentialsCredentialIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1CredentialsCredentialIdPut(
        requestParameters.xAuthToken,
        requestParameters.credentialId,
        requestParameters.credential,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * credential 삭제
   * @summary credential 삭제
   * @param {CredentialsApiApiV1CredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1CredentialsDelete(
    requestParameters: CredentialsApiApiV1CredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1CredentialsDelete(
        requestParameters.xAuthToken,
        requestParameters.credentialIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * credential 생성
   * @summary credential 생성
   * @param {CredentialsApiApiV1CredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1CredentialsPost(
    requestParameters: CredentialsApiApiV1CredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1CredentialsPost(requestParameters.xAuthToken, requestParameters.credential, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 에 존재하는 credential 목록 조회
   * @summary domain 에 존재하는 credential 목록 조회
   * @param {CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdCredentialsGet(
    requestParameters: CredentialsApiApiV1DomainsDomainIdCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1DomainsDomainIdCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.id,
        requestParameters.projectName,
        requestParameters.userName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 credential 목록 조회 (blob 포함)
   * @summary 사용자 credential 목록 조회 (blob 포함)
   * @param {CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdCredentialsExpGet(
    requestParameters: CredentialsApiApiV1UsersUserIdCredentialsExpGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1UsersUserIdCredentialsExpGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 credential 목록 조회
   * @summary 사용자 credential 목록 조회
   * @param {CredentialsApiApiV1UsersUserIdCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdCredentialsGet(
    requestParameters: CredentialsApiApiV1UsersUserIdCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CredentialsApiFp(this.configuration)
      .apiV1UsersUserIdCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.id,
        requestParameters.projectName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * DomainsApi - axios parameter creator
 */
export const DomainsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 도메인 이름이 이미 존재하는지 확인
     * @summary 도메인 이름이 이미 존재하는지 확인.
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {string} domainName domain name, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1DomainsNameDomainNameHead: async (
      authorization: string,
      domainName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('accountV1DomainsNameDomainNameHead', 'authorization', authorization);
      // verify required parameter 'domainName' is not null or undefined
      assertParamExists('accountV1DomainsNameDomainNameHead', 'domainName', domainName);
      const localVarPath = `/account/v1/domains/name/{domain_name}`.replace(
        '{domain_name}',
        encodeURIComponent(String(domainName)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 정보 상세 조회
     * @summary 지정한 domain 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdGet: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdGet', 'domainId', domainId);
      const localVarPath = `/api/v1_1/domains/{domain_id}`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain에 존재하는 모든 그룹 목록 조회
     * @summary 지정한 domain에 존재하는 모든 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {string} [id] group prefix search by id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 all
     * @param {ApiV11DomainsDomainIdGroupsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdGroupsGet: async (
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11DomainsDomainIdGroupsGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdGroupsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdGroupsGet', 'domainId', domainId);
      const localVarPath = `/api/v1_1/domains/{domain_id}/groups`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain에 존재하는 모든 project 목록 조회 user_count · group_count 는 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 직접 할당만 센다 — project scope 로 등록되지 않은 role 로만 할당된 사용자·그룹은 제외된다.
     * @summary 지정한 domain에 존재하는 모든 project 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {string} [id] search by project id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...,
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {ApiV11DomainsDomainIdProjectsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc), default&#x3D;asc
     * @param {string} [sortColumn] sort by (name), default&#x3D;name
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부, default&#x3D;false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdProjectsGet: async (
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11DomainsDomainIdProjectsGetSortOrderEnum,
      sortColumn?: string,
      includeDisabled?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdProjectsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdProjectsGet', 'domainId', domainId);
      const localVarPath = `/api/v1_1/domains/{domain_id}/projects`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain에 존재하는 모든 사용자 목록 조회 콘솔 노출 대상 role(kic_role_extra 에 domain scope 로 등록) 할당만 도메인 역할로 친다. 미등록 role 로만 할당된 사용자는 domain_role_count 가 0 이고 no_role=true 결과에 포함되며, role 필터로도 잡히지 않는다.
     * @summary 지정한 domain에 존재하는 모든 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32
     * @param {string} [id] User ID, maxLength&#x3D;32
     * @param {string} [name] user prefix search by name
     * @param {Array<string>} [role] user search by domain role id (UserDomain/GroupDomain, inherited&#x3D;0)
     * @param {boolean} [noRole] user search by not have domain role (inherited-only user is considered to have no domain role)
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {ApiV11DomainsDomainIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name, created_at), default&#x3D;name
     * @param {string} [userType] search by user_type (all, user, account, agent), 대소문자 구분x
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdUsersGet: async (
      xAuthToken: string,
      domainId: string,
      id?: string,
      name?: string,
      role?: Array<string>,
      noRole?: boolean,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11DomainsDomainIdUsersGetSortOrderEnum,
      sortColumn?: string,
      userType?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdUsersGet', 'domainId', domainId);
      const localVarPath = `/api/v1_1/domains/{domain_id}/users`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (role) {
        localVarQueryParameter['role'] = role;
      }

      if (noRole !== undefined) {
        localVarQueryParameter['no_role'] = noRole;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 에서 group 이 보유한 도메인 역할을 부여 경로와 함께 조회한다. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 false 다(유저 조회 응답과 모양을 맞춤). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 group 이 해당 domain 소속이 아니면 403 반환.
     * @summary 지정한 domain에서 group이 보유한 domain role 조회 - 부여 경로 포함
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12DomainsDomainIdGroupsGroupIdRolesGet: async (
      xAuthToken: string,
      domainId: string,
      groupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12DomainsDomainIdGroupsGroupIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV12DomainsDomainIdGroupsGroupIdRolesGet', 'domainId', domainId);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV12DomainsDomainIdGroupsGroupIdRolesGet', 'groupId', groupId);
      const localVarPath = `/api/v1_2/domains/{domain_id}/groups/{group_id}/roles`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 에서 사용자가 보유한 도메인 역할을 부여 경로와 함께 조회한다. 사용자 직접 부여(E)와 소속 그룹 경유(F)를 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 경유 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 사용자가 해당 domain 소속이 아니면 403 반환.
     * @summary 지정한 domain에서 사용자가 보유한 domain role 조회 - 할당 타입별
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. 필터는 role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12DomainsDomainIdUsersUserIdRolesGet: async (
      xAuthToken: string,
      domainId: string,
      userId: string,
      actorType?: ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12DomainsDomainIdUsersUserIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV12DomainsDomainIdUsersUserIdRolesGet', 'domainId', domainId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV12DomainsDomainIdUsersUserIdRolesGet', 'userId', userId);
      const localVarPath = `/api/v1_2/domains/{domain_id}/users/{user_id}/roles`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (actorType !== undefined) {
        localVarQueryParameter['actor_type'] = actorType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 조직 소유자 권한 이양. from_user 가 조직 소유자인 경우 to_user 에게 조직 소유자 권한을 이양
     * @summary 조직 소유자 권한 이양
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignOwnerRoleRequest} assignOwnerRoleRequest from user, to user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAssignDomainOwnerPost: async (
      xAuthToken: string,
      domainId: string,
      assignOwnerRoleRequest: RequestAssignOwnerRoleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAssignDomainOwnerPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdAssignDomainOwnerPost', 'domainId', domainId);
      // verify required parameter 'assignOwnerRoleRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdAssignDomainOwnerPost',
        'assignOwnerRoleRequest',
        assignOwnerRoleRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/assign-domain-owner`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignOwnerRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 삭제
     * @summary domain 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdDelete: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdDelete', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
     * @summary domain 활성/비활성화
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {boolean} enabled true: 활성화, false: 비활성화
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdEnabledPatch: async (
      xAuthToken: string,
      domainId: string,
      enabled: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdEnabledPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdEnabledPatch', 'domainId', domainId);
      // verify required parameter 'enabled' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdEnabledPatch', 'enabled', enabled);
      const localVarPath = `/api/v1/domains/{domain_id}/enabled`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (enabled !== undefined) {
        localVarQueryParameter['enabled'] = enabled;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 그룹에게 직접 부여된 role 목록 조회. 그룹에게 부여된 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 true 다(유저 조회 응답과 모양을 맞춤).
     * @summary 지정한 domain에서 그룹에게 직접 부여된 상속 역할 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet: async (
      xAuthToken: string,
      domainId: string,
      groupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet', 'domainId', domainId);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet', 'groupId', groupId);
      const localVarPath = `/api/v1/domains/{domain_id}/groups/{group_id}/inherited-roles`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/groups/{group_id}/roles 를 사용한다. 이 API 는 role 의 id/name 만 반환하고 부여 경로와 role 표시 정보(display_name 등)를 누락한다. 지정한 domain에 속한 group의 role 정보를 조회
     * @summary [Deprecated] 지정한 domain에 속한 group의 role 정보를 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsGroupIdRolesGet: async (
      xAuthToken: string,
      domainId: string,
      groupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsGroupIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsGroupIdRolesGet', 'domainId', domainId);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsGroupIdRolesGet', 'groupId', groupId);
      const localVarPath = `/api/v1/domains/{domain_id}/groups/{group_id}/roles`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 그룹의 일괄 접근 권한(inherited=1)을 그룹 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
     * @summary 지정한 domain 하위 그룹 일괄 접근 권한(상속 역할) 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} groupIds Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsInheritedRolesDelete: async (
      xAuthToken: string,
      domainId: string,
      groupIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsInheritedRolesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsInheritedRolesDelete', 'domainId', domainId);
      // verify required parameter 'groupIds' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsInheritedRolesDelete', 'groupIds', groupIds);
      const localVarPath = `/api/v1/domains/{domain_id}/groups/inherited-roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (groupIds) {
        localVarQueryParameter['group_ids'] = groupIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
     * @summary 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(상속 역할) 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignGroupsToDomainRequest} assignGroupsToDomainRequest group_ids, role_ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsInheritedRolesPut: async (
      xAuthToken: string,
      domainId: string,
      assignGroupsToDomainRequest: RequestAssignGroupsToDomainRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsInheritedRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsInheritedRolesPut', 'domainId', domainId);
      // verify required parameter 'assignGroupsToDomainRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdGroupsInheritedRolesPut',
        'assignGroupsToDomainRequest',
        assignGroupsToDomainRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/groups/inherited-roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignGroupsToDomainRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain에 그룹 생성 시 이름이 이미 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary domain에 그룹 생성 시 이름이 이미 존재하는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupName Group name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsNameGroupNameHead: async (
      xAuthToken: string,
      domainId: string,
      groupName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsNameGroupNameHead', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsNameGroupNameHead', 'domainId', domainId);
      // verify required parameter 'groupName' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsNameGroupNameHead', 'groupName', groupName);
      const localVarPath = `/api/v1/domains/{domain_id}/groups/name/{group_name}`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{group_name}', encodeURIComponent(String(groupName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Suggest groups of Domain
     * @summary Suggest groups of Domain
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} name group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum} [sortOrder] 이름 정렬 방향
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsNameSuggestGet: async (
      xAuthToken: string,
      domainId: string,
      name: string,
      size?: number,
      sortOrder?: ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsNameSuggestGet', 'domainId', domainId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsNameSuggestGet', 'name', name);
      const localVarPath = `/api/v1/domains/{domain_id}/groups/name/suggest`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} groupIds Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsRolesDelete: async (
      xAuthToken: string,
      domainId: string,
      groupIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsRolesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsRolesDelete', 'domainId', domainId);
      // verify required parameter 'groupIds' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsRolesDelete', 'groupIds', groupIds);
      const localVarPath = `/api/v1/domains/{domain_id}/groups/roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (groupIds) {
        localVarQueryParameter['group_ids'] = groupIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 조직에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignGroupsToDomainRequest} assignGroupsToDomainRequest group ids, role ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsRolesPut: async (
      xAuthToken: string,
      domainId: string,
      assignGroupsToDomainRequest: RequestAssignGroupsToDomainRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdGroupsRolesPut', 'domainId', domainId);
      // verify required parameter 'assignGroupsToDomainRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdGroupsRolesPut',
        'assignGroupsToDomainRequest',
        assignGroupsToDomainRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/groups/roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignGroupsToDomainRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 그룹을 이름 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 그룹은 제외된다.
     * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] group name prefix 검색
     * @param {string} [id] 특정 group id 필터, 영소문자+숫자 32자
     * @param {number} [offset] 페이징 offset
     * @param {number} [size] 페이징 size, 0이면 전체 반환
     * @param {ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum} [sortOrder] asc | desc
     * @param {string} [sortColumn] name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdInheritedRolesGroupsGet: async (
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdInheritedRolesGroupsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdInheritedRolesGroupsGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/inherited-roles/groups`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 사용자를 이름·이메일 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 사용자는 제외된다.
     * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] 이름·이메일 prefix 검색 (user name &#x3D; 이메일)
     * @param {string} [id] 특정 user id 필터, 영소문자+숫자 32자
     * @param {ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. user 는 직접 상속 권한, group 은 소속 그룹 경유 상속 권한을 가진 사용자만 반환한다.
     * @param {number} [offset] 페이징 offset
     * @param {number} [size] 페이징 size, 0이면 전체 반환
     * @param {ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum} [sortOrder] asc | desc
     * @param {string} [sortColumn] name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdInheritedRolesUsersGet: async (
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      actorType?: ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdInheritedRolesUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdInheritedRolesUsersGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/inherited-roles/users`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (actorType !== undefined) {
        localVarQueryParameter['actor_type'] = actorType;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain IP 접근제어(ip_access_check_enabled) 설정 수정
     * @summary domain IP 접근제어 설정 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateIpAccessCheckRequest} domain domain IP 접근제어 설정 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdIpAccessCheckPatch: async (
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateIpAccessCheckRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdIpAccessCheckPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdIpAccessCheckPatch', 'domainId', domainId);
      // verify required parameter 'domain' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdIpAccessCheckPatch', 'domain', domain);
      const localVarPath = `/api/v1/domains/{domain_id}/ip-access-check`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        domain,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 로그인 2차 인증 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
     * @summary domain 로그인 2차 인증 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateLoginInfoRequest} domain domain 로그인 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdLoginInfoPatch: async (
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateLoginInfoRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdLoginInfoPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdLoginInfoPatch', 'domainId', domainId);
      // verify required parameter 'domain' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdLoginInfoPatch', 'domain', domain);
      const localVarPath = `/api/v1/domains/{domain_id}/login-info`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        domain,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
     * @summary domain 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestCloudDomainUpdateRequest} domain domain 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdPatch: async (
      xAuthToken: string,
      domainId: string,
      domain: RequestCloudDomainUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdPatch', 'domainId', domainId);
      // verify required parameter 'domain' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdPatch', 'domain', domain);
      const localVarPath = `/api/v1/domains/{domain_id}`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        domain,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * get Projects Suggestions of Domain
     * @summary Suggest Projects of Domain
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} name project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [includeDisabled] project prefix search by name
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdProjectsNameSuggestGet: async (
      xAuthToken: string,
      domainId: string,
      name: string,
      includeDisabled?: boolean,
      size?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdProjectsNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdProjectsNameSuggestGet', 'domainId', domainId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdProjectsNameSuggestGet', 'name', name);
      const localVarPath = `/api/v1/domains/{domain_id}/projects/name/suggest`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 내에 project nickname 이 이미 존재하는 확인
     * @summary domain 내에 project nickname 이 이미 존재하는 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} nickname Project nickname, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdProjectsNicknameNicknameHead: async (
      xAuthToken: string,
      domainId: string,
      nickname: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdProjectsNicknameNicknameHead',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdProjectsNicknameNicknameHead', 'domainId', domainId);
      // verify required parameter 'nickname' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdProjectsNicknameNicknameHead', 'nickname', nickname);
      const localVarPath = `/api/v1/domains/{domain_id}/projects/nickname/{nickname}`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{nickname}', encodeURIComponent(String(nickname)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
     * @summary 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} roleIds Role IDs, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdRolesUsersGet: async (
      xAuthToken: string,
      domainId: string,
      roleIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdRolesUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdRolesUsersGet', 'domainId', domainId);
      // verify required parameter 'roleIds' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdRolesUsersGet', 'roleIds', roleIds);
      const localVarPath = `/api/v1/domains/{domain_id}/roles/users`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (roleIds) {
        localVarQueryParameter['role_ids'] = roleIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 보안 설정 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary domain 보안 설정 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateSecurityInfoRequest} domain domain 보안 설정 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSecurityInfoPatch: async (
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateSecurityInfoRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSecurityInfoPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSecurityInfoPatch', 'domainId', domainId);
      // verify required parameter 'domain' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSecurityInfoPatch', 'domain', domain);
      const localVarPath = `/api/v1/domains/{domain_id}/security-info`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        domain,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 출발지 기반 접근제어 mode 수정 payload 내 모든 항목이 필수
     * @summary domain 출발지 기반 접근제어 mode 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateSrcAcModeRequest} domain domain src ac mode 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcModePatch: async (
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateSrcAcModeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcModePatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcModePatch', 'domainId', domainId);
      // verify required parameter 'domain' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcModePatch', 'domain', domain);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/mode`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        domain,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 Domain 의 통계 정보 조회
     * @summary 지정한 Domain 의 통계 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdStatisticsGet: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdStatisticsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdStatisticsGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/statistics`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 사용자의 일괄 접근 권한(inherited=1)을 유저 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
     * @summary 지정한 domain 하위 사용자 일괄 접근 권한(상속 역할) 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} userIds User ID,영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersInheritedRolesDelete: async (
      xAuthToken: string,
      domainId: string,
      userIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersInheritedRolesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersInheritedRolesDelete', 'domainId', domainId);
      // verify required parameter 'userIds' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersInheritedRolesDelete', 'userIds', userIds);
      const localVarPath = `/api/v1/domains/{domain_id}/users/inherited-roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userIds) {
        localVarQueryParameter['user_ids'] = userIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
     * @summary 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(상속 역할) 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignToUsersOnDomainRequest} assignToUsersOnDomainRequest user_ids, role_ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersInheritedRolesPut: async (
      xAuthToken: string,
      domainId: string,
      assignToUsersOnDomainRequest: RequestAssignToUsersOnDomainRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersInheritedRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersInheritedRolesPut', 'domainId', domainId);
      // verify required parameter 'assignToUsersOnDomainRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdUsersInheritedRolesPut',
        'assignToUsersOnDomainRequest',
        assignToUsersOnDomainRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/users/inherited-roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignToUsersOnDomainRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
     * @summary 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} names user name
     * @param {string} userType user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersNameMatchGet: async (
      xAuthToken: string,
      domainId: string,
      names: Array<string>,
      userType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameMatchGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameMatchGet', 'domainId', domainId);
      // verify required parameter 'names' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameMatchGet', 'names', names);
      // verify required parameter 'userType' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameMatchGet', 'userType', userType);
      const localVarPath = `/api/v1/domains/{domain_id}/users/name/match`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (names) {
        localVarQueryParameter['names'] = names;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * get Users Suggestions of Domain
     * @summary Suggest Users of Domain
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} name user prefix search by name, 이메일 사용 가능 문자
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {string} [userType] user search by user type (all, user, account, agent) 대소문자 구분x
     * @param {ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum} [sortOrder] 이름 정렬 방향
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersNameSuggestGet: async (
      xAuthToken: string,
      domainId: string,
      name: string,
      size?: number,
      userType?: string,
      sortOrder?: ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameSuggestGet', 'domainId', domainId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameSuggestGet', 'name', name);
      const localVarPath = `/api/v1/domains/{domain_id}/users/name/suggest`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain에 소속된 사용자의 모든 domain role 삭제
     * @summary 지정한 domain에 소속된 사용자의 모든 domain role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} userIds User ID,영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersRolesDelete: async (
      xAuthToken: string,
      domainId: string,
      userIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersRolesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersRolesDelete', 'domainId', domainId);
      // verify required parameter 'userIds' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersRolesDelete', 'userIds', userIds);
      const localVarPath = `/api/v1/domains/{domain_id}/users/roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userIds) {
        localVarQueryParameter['user_ids'] = userIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain에 소속된 사용자 조직/빌링 역할 변경 (신규 역할 추가, 기존 역할 제거) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 domain에 소속된 사용자 조직 역할 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignToUsersOnDomainRequest} assignToUsersOnDomainRequest user_id, role_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersRolesPut: async (
      xAuthToken: string,
      domainId: string,
      assignToUsersOnDomainRequest: RequestAssignToUsersOnDomainRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersRolesPut', 'domainId', domainId);
      // verify required parameter 'assignToUsersOnDomainRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdUsersRolesPut',
        'assignToUsersOnDomainRequest',
        assignToUsersOnDomainRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/users/roles`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignToUsersOnDomainRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 도메인 스코프 토큰 발급 시 token.roles 에 담기는 role 목록(직접 부여 + 그룹 경유 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 토큰 role 캐시를 재사용하므로 도메인 스코프 토큰의 role 과 일치한다. 도메인 자체 권한만 대상이다 — 상속 부여(inherited=1)는 하위 프로젝트에만 적용되므로 포함되지 않는다. 콘솔 노출 대상 role 만 반환하며(kic_role_extra 미등록 role 제외), role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 도메인에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet: async (
      xAuthToken: string,
      domainId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet',
        'domainId',
        domainId,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet',
        'userId',
        userId,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/users/{user_id}/effective-roles/display`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 사용자 직접 및 소속 그룹을 통해 부여된 role과 부여 경로 조회. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 상속 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 지정한 domain에서 사용자가 보유한 상속 역할 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. 필터는 role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersUserIdInheritedRolesGet: async (
      xAuthToken: string,
      domainId: string,
      userId: string,
      actorType?: ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdUsersUserIdInheritedRolesGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersUserIdInheritedRolesGet', 'domainId', domainId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersUserIdInheritedRolesGet', 'userId', userId);
      const localVarPath = `/api/v1/domains/{domain_id}/users/{user_id}/inherited-roles`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (actorType !== undefined) {
        localVarQueryParameter['actor_type'] = actorType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 이 API 는 사용자에게 직접 부여된 role 만 반환하고 소속 그룹을 통해 얻은 role 은 누락한다. 지정한 domain에 소속된 사용자에 할당된 domain role 목록 조회
     * @summary [Deprecated] 지정한 domain에 소속된 사용자에 할당된 domain role 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersUserIdRolesGet: async (
      xAuthToken: string,
      domainId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersUserIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersUserIdRolesGet', 'domainId', domainId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersUserIdRolesGet', 'userId', userId);
      const localVarPath = `/api/v1/domains/{domain_id}/users/{user_id}/roles`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 모든 domain 목록 조회. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공)
     * @summary 모든 domain 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [id] domain search by id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] domain search by name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [nameLike] true 인 경우 name 검색 시 like 검색. false 인 경우 name equal 검색
     * @param {boolean} [includeDisabled] 비활성화 domain 포함 여부
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      id?: string,
      name?: string,
      nameLike?: boolean,
      includeDisabled?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/domains`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name_like'] = nameLike;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 생성 및 domain 관리자(Owner)도 같이 생성한다. UseType 의 경우 다음 6가지 값으로 입력 (Default=외부 고객사).  1.KC system  2.외부 고객사  3.대외교육 및 홍보  4.KEP 서비스 개발  5.KC 서비스 검증  6.KC 서비스 운영 projectDefaultEndpointGroup은 {interface}-{region} 으로 입력. 존재하지 않는 endpoint group 은 설정 안됨 ex) public, public-kr-central-2
     * @summary domain 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudDomainCreateRequest} domainCreateRequest name, owner 정보 필수. bool 타입 필드는 생략하면 false로 설정.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsPost: async (
      xAuthToken: string,
      domainCreateRequest: RequestCloudDomainCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainCreateRequest' is not null or undefined
      assertParamExists('apiV1DomainsPost', 'domainCreateRequest', domainCreateRequest);
      const localVarPath = `/api/v1/domains`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        domainCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DomainsApi - functional programming interface
 */
export const DomainsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DomainsApiAxiosParamCreator(configuration);
  return {
    /**
     * 도메인 이름이 이미 존재하는지 확인
     * @summary 도메인 이름이 이미 존재하는지 확인.
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {string} domainName domain name, maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1DomainsNameDomainNameHead(
      authorization: string,
      domainName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1DomainsNameDomainNameHead(
        authorization,
        domainName,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.accountV1DomainsNameDomainNameHead']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 정보 상세 조회
     * @summary 지정한 domain 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11DomainsDomainIdGet(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseDomainGetResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11DomainsDomainIdGet(
        xAuthToken,
        domainId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV11DomainsDomainIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain에 존재하는 모든 그룹 목록 조회
     * @summary 지정한 domain에 존재하는 모든 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {string} [id] group prefix search by id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 all
     * @param {ApiV11DomainsDomainIdGroupsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11DomainsDomainIdGroupsGet(
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11DomainsDomainIdGroupsGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseGetGroupListByDomainResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11DomainsDomainIdGroupsGet(
        xAuthToken,
        domainId,
        name,
        id,
        offset,
        size,
        sortOrder,
        sortColumn,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV11DomainsDomainIdGroupsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain에 존재하는 모든 project 목록 조회 user_count · group_count 는 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 직접 할당만 센다 — project scope 로 등록되지 않은 role 로만 할당된 사용자·그룹은 제외된다.
     * @summary 지정한 domain에 존재하는 모든 project 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {string} [id] search by project id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...,
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {ApiV11DomainsDomainIdProjectsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc), default&#x3D;asc
     * @param {string} [sortColumn] sort by (name), default&#x3D;name
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부, default&#x3D;false
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11DomainsDomainIdProjectsGet(
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11DomainsDomainIdProjectsGetSortOrderEnum,
      sortColumn?: string,
      includeDisabled?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseProjectListByDomainResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11DomainsDomainIdProjectsGet(
        xAuthToken,
        domainId,
        name,
        id,
        offset,
        size,
        sortOrder,
        sortColumn,
        includeDisabled,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV11DomainsDomainIdProjectsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain에 존재하는 모든 사용자 목록 조회 콘솔 노출 대상 role(kic_role_extra 에 domain scope 로 등록) 할당만 도메인 역할로 친다. 미등록 role 로만 할당된 사용자는 domain_role_count 가 0 이고 no_role=true 결과에 포함되며, role 필터로도 잡히지 않는다.
     * @summary 지정한 domain에 존재하는 모든 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, maxLength&#x3D;32
     * @param {string} [id] User ID, maxLength&#x3D;32
     * @param {string} [name] user prefix search by name
     * @param {Array<string>} [role] user search by domain role id (UserDomain/GroupDomain, inherited&#x3D;0)
     * @param {boolean} [noRole] user search by not have domain role (inherited-only user is considered to have no domain role)
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, default&#x3D;0(all)
     * @param {ApiV11DomainsDomainIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name, created_at), default&#x3D;name
     * @param {string} [userType] search by user_type (all, user, account, agent), 대소문자 구분x
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11DomainsDomainIdUsersGet(
      xAuthToken: string,
      domainId: string,
      id?: string,
      name?: string,
      role?: Array<string>,
      noRole?: boolean,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11DomainsDomainIdUsersGetSortOrderEnum,
      sortColumn?: string,
      userType?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListByDomainResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11DomainsDomainIdUsersGet(
        xAuthToken,
        domainId,
        id,
        name,
        role,
        noRole,
        offset,
        size,
        sortOrder,
        sortColumn,
        userType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV11DomainsDomainIdUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 에서 group 이 보유한 도메인 역할을 부여 경로와 함께 조회한다. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 false 다(유저 조회 응답과 모양을 맞춤). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 group 이 해당 domain 소속이 아니면 403 반환.
     * @summary 지정한 domain에서 group이 보유한 domain role 조회 - 부여 경로 포함
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12DomainsDomainIdGroupsGroupIdRolesGet(
      xAuthToken: string,
      domainId: string,
      groupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssignedRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12DomainsDomainIdGroupsGroupIdRolesGet(
          xAuthToken,
          domainId,
          groupId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV12DomainsDomainIdGroupsGroupIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 에서 사용자가 보유한 도메인 역할을 부여 경로와 함께 조회한다. 사용자 직접 부여(E)와 소속 그룹 경유(F)를 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 경유 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 사용자가 해당 domain 소속이 아니면 403 반환.
     * @summary 지정한 domain에서 사용자가 보유한 domain role 조회 - 할당 타입별
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. 필터는 role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12DomainsDomainIdUsersUserIdRolesGet(
      xAuthToken: string,
      domainId: string,
      userId: string,
      actorType?: ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssignedRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12DomainsDomainIdUsersUserIdRolesGet(
          xAuthToken,
          domainId,
          userId,
          actorType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV12DomainsDomainIdUsersUserIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 조직 소유자 권한 이양. from_user 가 조직 소유자인 경우 to_user 에게 조직 소유자 권한을 이양
     * @summary 조직 소유자 권한 이양
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignOwnerRoleRequest} assignOwnerRoleRequest from user, to user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdAssignDomainOwnerPost(
      xAuthToken: string,
      domainId: string,
      assignOwnerRoleRequest: RequestAssignOwnerRoleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdAssignDomainOwnerPost(
          xAuthToken,
          domainId,
          assignOwnerRoleRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdAssignDomainOwnerPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 삭제
     * @summary domain 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdDelete(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdDelete(
        xAuthToken,
        domainId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
     * @summary domain 활성/비활성화
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {boolean} enabled true: 활성화, false: 비활성화
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdEnabledPatch(
      xAuthToken: string,
      domainId: string,
      enabled: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdEnabledPatch(
        xAuthToken,
        domainId,
        enabled,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdEnabledPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 그룹에게 직접 부여된 role 목록 조회. 그룹에게 부여된 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 true 다(유저 조회 응답과 모양을 맞춤).
     * @summary 지정한 domain에서 그룹에게 직접 부여된 상속 역할 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
      xAuthToken: string,
      domainId: string,
      groupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssignedRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
          xAuthToken,
          domainId,
          groupId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/groups/{group_id}/roles 를 사용한다. 이 API 는 role 의 id/name 만 반환하고 부여 경로와 role 표시 정보(display_name 등)를 누락한다. 지정한 domain에 속한 group의 role 정보를 조회
     * @summary [Deprecated] 지정한 domain에 속한 group의 role 정보를 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsGroupIdRolesGet(
      xAuthToken: string,
      domainId: string,
      groupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsGroupIdRolesGet(
          xAuthToken,
          domainId,
          groupId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsGroupIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 그룹의 일괄 접근 권한(inherited=1)을 그룹 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
     * @summary 지정한 domain 하위 그룹 일괄 접근 권한(상속 역할) 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} groupIds Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsInheritedRolesDelete(
      xAuthToken: string,
      domainId: string,
      groupIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsInheritedRolesDelete(
          xAuthToken,
          domainId,
          groupIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsInheritedRolesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
     * @summary 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(상속 역할) 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignGroupsToDomainRequest} assignGroupsToDomainRequest group_ids, role_ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsInheritedRolesPut(
      xAuthToken: string,
      domainId: string,
      assignGroupsToDomainRequest: RequestAssignGroupsToDomainRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsInheritedRolesPut(
          xAuthToken,
          domainId,
          assignGroupsToDomainRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsInheritedRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain에 그룹 생성 시 이름이 이미 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary domain에 그룹 생성 시 이름이 이미 존재하는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} groupName Group name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsNameGroupNameHead(
      xAuthToken: string,
      domainId: string,
      groupName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsNameGroupNameHead(
          xAuthToken,
          domainId,
          groupName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsNameGroupNameHead']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Suggest groups of Domain
     * @summary Suggest groups of Domain
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} name group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum} [sortOrder] 이름 정렬 방향
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsNameSuggestGet(
      xAuthToken: string,
      domainId: string,
      name: string,
      size?: number,
      sortOrder?: ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuggestedGroups>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsNameSuggestGet(
          xAuthToken,
          domainId,
          name,
          size,
          sortOrder,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsNameSuggestGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} groupIds Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsRolesDelete(
      xAuthToken: string,
      domainId: string,
      groupIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsRolesDelete(
          xAuthToken,
          domainId,
          groupIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsRolesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 조직에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignGroupsToDomainRequest} assignGroupsToDomainRequest group ids, role ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdGroupsRolesPut(
      xAuthToken: string,
      domainId: string,
      assignGroupsToDomainRequest: RequestAssignGroupsToDomainRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdGroupsRolesPut(
        xAuthToken,
        domainId,
        assignGroupsToDomainRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdGroupsRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 그룹을 이름 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 그룹은 제외된다.
     * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] group name prefix 검색
     * @param {string} [id] 특정 group id 필터, 영소문자+숫자 32자
     * @param {number} [offset] 페이징 offset
     * @param {number} [size] 페이징 size, 0이면 전체 반환
     * @param {ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum} [sortOrder] asc | desc
     * @param {string} [sortColumn] name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdInheritedRolesGroupsGet(
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListInheritedRoleGroupsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdInheritedRolesGroupsGet(
          xAuthToken,
          domainId,
          name,
          id,
          offset,
          size,
          sortOrder,
          sortColumn,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdInheritedRolesGroupsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 사용자를 이름·이메일 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 사용자는 제외된다.
     * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] 이름·이메일 prefix 검색 (user name &#x3D; 이메일)
     * @param {string} [id] 특정 user id 필터, 영소문자+숫자 32자
     * @param {ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. user 는 직접 상속 권한, group 은 소속 그룹 경유 상속 권한을 가진 사용자만 반환한다.
     * @param {number} [offset] 페이징 offset
     * @param {number} [size] 페이징 size, 0이면 전체 반환
     * @param {ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum} [sortOrder] asc | desc
     * @param {string} [sortColumn] name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdInheritedRolesUsersGet(
      xAuthToken: string,
      domainId: string,
      name?: string,
      id?: string,
      actorType?: ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListInheritedRoleUsersResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdInheritedRolesUsersGet(
          xAuthToken,
          domainId,
          name,
          id,
          actorType,
          offset,
          size,
          sortOrder,
          sortColumn,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdInheritedRolesUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain IP 접근제어(ip_access_check_enabled) 설정 수정
     * @summary domain IP 접근제어 설정 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateIpAccessCheckRequest} domain domain IP 접근제어 설정 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdIpAccessCheckPatch(
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateIpAccessCheckRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdIpAccessCheckPatch(
          xAuthToken,
          domainId,
          domain,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdIpAccessCheckPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 로그인 2차 인증 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
     * @summary domain 로그인 2차 인증 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateLoginInfoRequest} domain domain 로그인 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdLoginInfoPatch(
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateLoginInfoRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdLoginInfoPatch(
        xAuthToken,
        domainId,
        domain,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdLoginInfoPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
     * @summary domain 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestCloudDomainUpdateRequest} domain domain 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdPatch(
      xAuthToken: string,
      domainId: string,
      domain: RequestCloudDomainUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseDomainUpdateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdPatch(
        xAuthToken,
        domainId,
        domain,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdPatch']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * get Projects Suggestions of Domain
     * @summary Suggest Projects of Domain
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} name project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [includeDisabled] project prefix search by name
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdProjectsNameSuggestGet(
      xAuthToken: string,
      domainId: string,
      name: string,
      includeDisabled?: boolean,
      size?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectSuggestResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdProjectsNameSuggestGet(
          xAuthToken,
          domainId,
          name,
          includeDisabled,
          size,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdProjectsNameSuggestGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 내에 project nickname 이 이미 존재하는 확인
     * @summary domain 내에 project nickname 이 이미 존재하는 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} nickname Project nickname, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdProjectsNicknameNicknameHead(
      xAuthToken: string,
      domainId: string,
      nickname: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdProjectsNicknameNicknameHead(
          xAuthToken,
          domainId,
          nickname,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdProjectsNicknameNicknameHead']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
     * @summary 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} roleIds Role IDs, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdRolesUsersGet(
      xAuthToken: string,
      domainId: string,
      roleIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListUserAssignmentsByDomainResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdRolesUsersGet(
        xAuthToken,
        domainId,
        roleIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdRolesUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 보안 설정 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary domain 보안 설정 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateSecurityInfoRequest} domain domain 보안 설정 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSecurityInfoPatch(
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateSecurityInfoRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSecurityInfoPatch(
          xAuthToken,
          domainId,
          domain,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdSecurityInfoPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 출발지 기반 접근제어 mode 수정 payload 내 모든 항목이 필수
     * @summary domain 출발지 기반 접근제어 mode 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestUpdateSrcAcModeRequest} domain domain src ac mode 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcModePatch(
      xAuthToken: string,
      domainId: string,
      domain: RequestUpdateSrcAcModeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcModePatch(
        xAuthToken,
        domainId,
        domain,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdSrcAcModePatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 Domain 의 통계 정보 조회
     * @summary 지정한 Domain 의 통계 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdStatisticsGet(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetDomainStatistics>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdStatisticsGet(
        xAuthToken,
        domainId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdStatisticsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 사용자의 일괄 접근 권한(inherited=1)을 유저 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
     * @summary 지정한 domain 하위 사용자 일괄 접근 권한(상속 역할) 회수
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} userIds User ID,영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersInheritedRolesDelete(
      xAuthToken: string,
      domainId: string,
      userIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersInheritedRolesDelete(
          xAuthToken,
          domainId,
          userIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersInheritedRolesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
     * @summary 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(상속 역할) 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignToUsersOnDomainRequest} assignToUsersOnDomainRequest user_ids, role_ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersInheritedRolesPut(
      xAuthToken: string,
      domainId: string,
      assignToUsersOnDomainRequest: RequestAssignToUsersOnDomainRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersInheritedRolesPut(
          xAuthToken,
          domainId,
          assignToUsersOnDomainRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersInheritedRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
     * @summary 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} names user name
     * @param {string} userType user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersNameMatchGet(
      xAuthToken: string,
      domainId: string,
      names: Array<string>,
      userType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUserIdMap>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersNameMatchGet(
          xAuthToken,
          domainId,
          names,
          userType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersNameMatchGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * get Users Suggestions of Domain
     * @summary Suggest Users of Domain
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} name user prefix search by name, 이메일 사용 가능 문자
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {string} [userType] user search by user type (all, user, account, agent) 대소문자 구분x
     * @param {ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum} [sortOrder] 이름 정렬 방향
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersNameSuggestGet(
      xAuthToken: string,
      domainId: string,
      name: string,
      size?: number,
      userType?: string,
      sortOrder?: ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuggestedUsers>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersNameSuggestGet(
          xAuthToken,
          domainId,
          name,
          size,
          userType,
          sortOrder,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersNameSuggestGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain에 소속된 사용자의 모든 domain role 삭제
     * @summary 지정한 domain에 소속된 사용자의 모든 domain role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} userIds User ID,영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersRolesDelete(
      xAuthToken: string,
      domainId: string,
      userIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersRolesDelete(
          xAuthToken,
          domainId,
          userIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersRolesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain에 소속된 사용자 조직/빌링 역할 변경 (신규 역할 추가, 기존 역할 제거) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 domain에 소속된 사용자 조직 역할 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestAssignToUsersOnDomainRequest} assignToUsersOnDomainRequest user_id, role_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersRolesPut(
      xAuthToken: string,
      domainId: string,
      assignToUsersOnDomainRequest: RequestAssignToUsersOnDomainRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersRolesPut(
        xAuthToken,
        domainId,
        assignToUsersOnDomainRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 도메인 스코프 토큰 발급 시 token.roles 에 담기는 role 목록(직접 부여 + 그룹 경유 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 토큰 role 캐시를 재사용하므로 도메인 스코프 토큰의 role 과 일치한다. 도메인 자체 권한만 대상이다 — 상속 부여(inherited=1)는 하위 프로젝트에만 적용되므로 포함되지 않는다. 콘솔 노출 대상 role 만 반환하며(kic_role_extra 미등록 role 제외), role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 도메인에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
      xAuthToken: string,
      domainId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEffectiveRolesDisplay>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
          xAuthToken,
          domainId,
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 사용자 직접 및 소속 그룹을 통해 부여된 role과 부여 경로 조회. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 상속 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 지정한 domain에서 사용자가 보유한 상속 역할 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. 필터는 role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
      xAuthToken: string,
      domainId: string,
      userId: string,
      actorType?: ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssignedRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
          xAuthToken,
          domainId,
          userId,
          actorType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersUserIdInheritedRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 이 API 는 사용자에게 직접 부여된 role 만 반환하고 소속 그룹을 통해 얻은 role 은 누락한다. 지정한 domain에 소속된 사용자에 할당된 domain role 목록 조회
     * @summary [Deprecated] 지정한 domain에 소속된 사용자에 할당된 domain role 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersUserIdRolesGet(
      xAuthToken: string,
      domainId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersUserIdRolesGet(
          xAuthToken,
          domainId,
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsDomainIdUsersUserIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 모든 domain 목록 조회. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공)
     * @summary 모든 domain 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [id] domain search by id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [name] domain search by name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [nameLike] true 인 경우 name 검색 시 like 검색. false 인 경우 name equal 검색
     * @param {boolean} [includeDisabled] 비활성화 domain 포함 여부
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      id?: string,
      name?: string,
      nameLike?: boolean,
      includeDisabled?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseDomainListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsGet(
        xAuthToken,
        size,
        offset,
        id,
        name,
        nameLike,
        includeDisabled,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 생성 및 domain 관리자(Owner)도 같이 생성한다. UseType 의 경우 다음 6가지 값으로 입력 (Default=외부 고객사).  1.KC system  2.외부 고객사  3.대외교육 및 홍보  4.KEP 서비스 개발  5.KC 서비스 검증  6.KC 서비스 운영 projectDefaultEndpointGroup은 {interface}-{region} 으로 입력. 존재하지 않는 endpoint group 은 설정 안됨 ex) public, public-kr-central-2
     * @summary domain 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudDomainCreateRequest} domainCreateRequest name, owner 정보 필수. bool 타입 필드는 생략하면 false로 설정.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsPost(
      xAuthToken: string,
      domainCreateRequest: RequestCloudDomainCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudDomain>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1DomainsPost(
        xAuthToken,
        domainCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DomainsApi.apiV1DomainsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DomainsApi - factory interface
 */
export const DomainsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DomainsApiFp(configuration);
  return {
    /**
     * 도메인 이름이 이미 존재하는지 확인
     * @summary 도메인 이름이 이미 존재하는지 확인.
     * @param {DomainsApiAccountV1DomainsNameDomainNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1DomainsNameDomainNameHead(
      requestParameters: DomainsApiAccountV1DomainsNameDomainNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .accountV1DomainsNameDomainNameHead(
          requestParameters.authorization,
          requestParameters.domainName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 정보 상세 조회
     * @summary 지정한 domain 정보 상세 조회
     * @param {DomainsApiApiV11DomainsDomainIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdGet(
      requestParameters: DomainsApiApiV11DomainsDomainIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseDomainGetResponse> {
      return localVarFp
        .apiV11DomainsDomainIdGet(requestParameters.xAuthToken, requestParameters.domainId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain에 존재하는 모든 그룹 목록 조회
     * @summary 지정한 domain에 존재하는 모든 그룹 목록 조회
     * @param {DomainsApiApiV11DomainsDomainIdGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdGroupsGet(
      requestParameters: DomainsApiApiV11DomainsDomainIdGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGetGroupListByDomainResponse> {
      return localVarFp
        .apiV11DomainsDomainIdGroupsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.id,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain에 존재하는 모든 project 목록 조회 user_count · group_count 는 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 직접 할당만 센다 — project scope 로 등록되지 않은 role 로만 할당된 사용자·그룹은 제외된다.
     * @summary 지정한 domain에 존재하는 모든 project 목록 조회
     * @param {DomainsApiApiV11DomainsDomainIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdProjectsGet(
      requestParameters: DomainsApiApiV11DomainsDomainIdProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectListByDomainResponse> {
      return localVarFp
        .apiV11DomainsDomainIdProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.id,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          requestParameters.includeDisabled,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain에 존재하는 모든 사용자 목록 조회 콘솔 노출 대상 role(kic_role_extra 에 domain scope 로 등록) 할당만 도메인 역할로 친다. 미등록 role 로만 할당된 사용자는 domain_role_count 가 0 이고 no_role=true 결과에 포함되며, role 필터로도 잡히지 않는다.
     * @summary 지정한 domain에 존재하는 모든 사용자 목록 조회
     * @param {DomainsApiApiV11DomainsDomainIdUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdUsersGet(
      requestParameters: DomainsApiApiV11DomainsDomainIdUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListByDomainResponse> {
      return localVarFp
        .apiV11DomainsDomainIdUsersGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.id,
          requestParameters.name,
          requestParameters.role,
          requestParameters.noRole,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          requestParameters.userType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 에서 group 이 보유한 도메인 역할을 부여 경로와 함께 조회한다. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 false 다(유저 조회 응답과 모양을 맞춤). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 group 이 해당 domain 소속이 아니면 403 반환.
     * @summary 지정한 domain에서 group이 보유한 domain role 조회 - 부여 경로 포함
     * @param {DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12DomainsDomainIdGroupsGroupIdRolesGet(
      requestParameters: DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAssignedRoles> {
      return localVarFp
        .apiV12DomainsDomainIdGroupsGroupIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.groupId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 에서 사용자가 보유한 도메인 역할을 부여 경로와 함께 조회한다. 사용자 직접 부여(E)와 소속 그룹 경유(F)를 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 경유 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 사용자가 해당 domain 소속이 아니면 403 반환.
     * @summary 지정한 domain에서 사용자가 보유한 domain role 조회 - 할당 타입별
     * @param {DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12DomainsDomainIdUsersUserIdRolesGet(
      requestParameters: DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAssignedRoles> {
      return localVarFp
        .apiV12DomainsDomainIdUsersUserIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userId,
          requestParameters.actorType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 조직 소유자 권한 이양. from_user 가 조직 소유자인 경우 to_user 에게 조직 소유자 권한을 이양
     * @summary 조직 소유자 권한 이양
     * @param {DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdAssignDomainOwnerPost(
      requestParameters: DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdAssignDomainOwnerPost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.assignOwnerRoleRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 삭제
     * @summary domain 삭제
     * @param {DomainsApiApiV1DomainsDomainIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdDelete(
      requestParameters: DomainsApiApiV1DomainsDomainIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
     * @summary domain 활성/비활성화
     * @param {DomainsApiApiV1DomainsDomainIdEnabledPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdEnabledPatch(
      requestParameters: DomainsApiApiV1DomainsDomainIdEnabledPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdEnabledPatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.enabled,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 그룹에게 직접 부여된 role 목록 조회. 그룹에게 부여된 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 true 다(유저 조회 응답과 모양을 맞춤).
     * @summary 지정한 domain에서 그룹에게 직접 부여된 상속 역할 조회
     * @param {DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAssignedRoles> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.groupId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/groups/{group_id}/roles 를 사용한다. 이 API 는 role 의 id/name 만 반환하고 부여 경로와 role 표시 정보(display_name 등)를 누락한다. 지정한 domain에 속한 group의 role 정보를 조회
     * @summary [Deprecated] 지정한 domain에 속한 group의 role 정보를 조회
     * @param {DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsGroupIdRolesGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoles> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsGroupIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.groupId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 그룹의 일괄 접근 권한(inherited=1)을 그룹 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
     * @summary 지정한 domain 하위 그룹 일괄 접근 권한(상속 역할) 회수
     * @param {DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsInheritedRolesDelete(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsInheritedRolesDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.groupIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
     * @summary 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(상속 역할) 변경
     * @param {DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsInheritedRolesPut(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsInheritedRolesPut(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.assignGroupsToDomainRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain에 그룹 생성 시 이름이 이미 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary domain에 그룹 생성 시 이름이 이미 존재하는지 확인.
     * @param {DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsNameGroupNameHead(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsNameGroupNameHead(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.groupName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Suggest groups of Domain
     * @summary Suggest groups of Domain
     * @param {DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsNameSuggestGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSuggestedGroups> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.size,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @param {DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsRolesDelete(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsRolesDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.groupIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 조직에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
     * @param {DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdGroupsRolesPut(
      requestParameters: DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdGroupsRolesPut(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.assignGroupsToDomainRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 그룹을 이름 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 그룹은 제외된다.
     * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 그룹 목록 조회
     * @param {DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdInheritedRolesGroupsGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListInheritedRoleGroupsResponse> {
      return localVarFp
        .apiV1DomainsDomainIdInheritedRolesGroupsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.id,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 사용자를 이름·이메일 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 사용자는 제외된다.
     * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 사용자 목록 조회
     * @param {DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdInheritedRolesUsersGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListInheritedRoleUsersResponse> {
      return localVarFp
        .apiV1DomainsDomainIdInheritedRolesUsersGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.id,
          requestParameters.actorType,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain IP 접근제어(ip_access_check_enabled) 설정 수정
     * @summary domain IP 접근제어 설정 수정
     * @param {DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdIpAccessCheckPatch(
      requestParameters: DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdIpAccessCheckPatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.domain,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 로그인 2차 인증 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
     * @summary domain 로그인 2차 인증 정보 수정
     * @param {DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdLoginInfoPatch(
      requestParameters: DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdLoginInfoPatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.domain,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
     * @summary domain 정보 수정
     * @param {DomainsApiApiV1DomainsDomainIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdPatch(
      requestParameters: DomainsApiApiV1DomainsDomainIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseDomainUpdateResponse> {
      return localVarFp
        .apiV1DomainsDomainIdPatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.domain,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * get Projects Suggestions of Domain
     * @summary Suggest Projects of Domain
     * @param {DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdProjectsNameSuggestGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectSuggestResponse> {
      return localVarFp
        .apiV1DomainsDomainIdProjectsNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.includeDisabled,
          requestParameters.size,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 내에 project nickname 이 이미 존재하는 확인
     * @summary domain 내에 project nickname 이 이미 존재하는 확인
     * @param {DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdProjectsNicknameNicknameHead(
      requestParameters: DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdProjectsNicknameNicknameHead(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.nickname,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
     * @summary 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
     * @param {DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdRolesUsersGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListUserAssignmentsByDomainResponse> {
      return localVarFp
        .apiV1DomainsDomainIdRolesUsersGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.roleIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 보안 설정 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary domain 보안 설정 정보 수정
     * @param {DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSecurityInfoPatch(
      requestParameters: DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdSecurityInfoPatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.domain,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 출발지 기반 접근제어 mode 수정 payload 내 모든 항목이 필수
     * @summary domain 출발지 기반 접근제어 mode 수정
     * @param {DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcModePatch(
      requestParameters: DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcModePatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.domain,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 Domain 의 통계 정보 조회
     * @summary 지정한 Domain 의 통계 정보 조회
     * @param {DomainsApiApiV1DomainsDomainIdStatisticsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdStatisticsGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdStatisticsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGetDomainStatistics> {
      return localVarFp
        .apiV1DomainsDomainIdStatisticsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 사용자의 일괄 접근 권한(inherited=1)을 유저 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
     * @summary 지정한 domain 하위 사용자 일괄 접근 권한(상속 역할) 회수
     * @param {DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersInheritedRolesDelete(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdUsersInheritedRolesDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
     * @summary 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(상속 역할) 변경
     * @param {DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersInheritedRolesPut(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdUsersInheritedRolesPut(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.assignToUsersOnDomainRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
     * @summary 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인
     * @param {DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersNameMatchGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUserIdMap> {
      return localVarFp
        .apiV1DomainsDomainIdUsersNameMatchGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.names,
          requestParameters.userType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * get Users Suggestions of Domain
     * @summary Suggest Users of Domain
     * @param {DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersNameSuggestGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSuggestedUsers> {
      return localVarFp
        .apiV1DomainsDomainIdUsersNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.name,
          requestParameters.size,
          requestParameters.userType,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain에 소속된 사용자의 모든 domain role 삭제
     * @summary 지정한 domain에 소속된 사용자의 모든 domain role 삭제
     * @param {DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersRolesDelete(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdUsersRolesDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain에 소속된 사용자 조직/빌링 역할 변경 (신규 역할 추가, 기존 역할 제거) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 domain에 소속된 사용자 조직 역할 변경
     * @param {DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersRolesPut(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdUsersRolesPut(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.assignToUsersOnDomainRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 도메인 스코프 토큰 발급 시 token.roles 에 담기는 role 목록(직접 부여 + 그룹 경유 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 토큰 role 캐시를 재사용하므로 도메인 스코프 토큰의 role 과 일치한다. 도메인 자체 권한만 대상이다 — 상속 부여(inherited=1)는 하위 프로젝트에만 적용되므로 포함되지 않는다. 콘솔 노출 대상 role 만 반환하며(kic_role_extra 미등록 role 제외), role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 도메인에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
     * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEffectiveRolesDisplay> {
      return localVarFp
        .apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 사용자 직접 및 소속 그룹을 통해 부여된 role과 부여 경로 조회. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 상속 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 지정한 domain에서 사용자가 보유한 상속 역할 조회
     * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAssignedRoles> {
      return localVarFp
        .apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userId,
          requestParameters.actorType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 이 API 는 사용자에게 직접 부여된 role 만 반환하고 소속 그룹을 통해 얻은 role 은 누락한다. 지정한 domain에 소속된 사용자에 할당된 domain role 목록 조회
     * @summary [Deprecated] 지정한 domain에 소속된 사용자에 할당된 domain role 조회
     * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersUserIdRolesGet(
      requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoles> {
      return localVarFp
        .apiV1DomainsDomainIdUsersUserIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 모든 domain 목록 조회. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공)
     * @summary 모든 domain 목록 조회
     * @param {DomainsApiApiV1DomainsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsGet(
      requestParameters: DomainsApiApiV1DomainsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseDomainListResponse> {
      return localVarFp
        .apiV1DomainsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.id,
          requestParameters.name,
          requestParameters.nameLike,
          requestParameters.includeDisabled,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 생성 및 domain 관리자(Owner)도 같이 생성한다. UseType 의 경우 다음 6가지 값으로 입력 (Default=외부 고객사).  1.KC system  2.외부 고객사  3.대외교육 및 홍보  4.KEP 서비스 개발  5.KC 서비스 검증  6.KC 서비스 운영 projectDefaultEndpointGroup은 {interface}-{region} 으로 입력. 존재하지 않는 endpoint group 은 설정 안됨 ex) public, public-kr-central-2
     * @summary domain 생성
     * @param {DomainsApiApiV1DomainsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsPost(
      requestParameters: DomainsApiApiV1DomainsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudDomain> {
      return localVarFp
        .apiV1DomainsPost(
          requestParameters.xAuthToken,
          requestParameters.domainCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * DomainsApi - interface
 */
export interface DomainsApiInterface {
  /**
   * 도메인 이름이 이미 존재하는지 확인
   * @summary 도메인 이름이 이미 존재하는지 확인.
   * @param {DomainsApiAccountV1DomainsNameDomainNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1DomainsNameDomainNameHead(
    requestParameters: DomainsApiAccountV1DomainsNameDomainNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 domain 정보 상세 조회
   * @summary 지정한 domain 정보 상세 조회
   * @param {DomainsApiApiV11DomainsDomainIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11DomainsDomainIdGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseDomainGetResponse>;

  /**
   * 지정한 domain에 존재하는 모든 그룹 목록 조회
   * @summary 지정한 domain에 존재하는 모든 그룹 목록 조회
   * @param {DomainsApiApiV11DomainsDomainIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11DomainsDomainIdGroupsGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGetGroupListByDomainResponse>;

  /**
   * 지정한 domain에 존재하는 모든 project 목록 조회 user_count · group_count 는 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 직접 할당만 센다 — project scope 로 등록되지 않은 role 로만 할당된 사용자·그룹은 제외된다.
   * @summary 지정한 domain에 존재하는 모든 project 목록 조회
   * @param {DomainsApiApiV11DomainsDomainIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11DomainsDomainIdProjectsGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectListByDomainResponse>;

  /**
   * 지정한 domain에 존재하는 모든 사용자 목록 조회 콘솔 노출 대상 role(kic_role_extra 에 domain scope 로 등록) 할당만 도메인 역할로 친다. 미등록 role 로만 할당된 사용자는 domain_role_count 가 0 이고 no_role=true 결과에 포함되며, role 필터로도 잡히지 않는다.
   * @summary 지정한 domain에 존재하는 모든 사용자 목록 조회
   * @param {DomainsApiApiV11DomainsDomainIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11DomainsDomainIdUsersGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListByDomainResponse>;

  /**
   * 지정한 domain 에서 group 이 보유한 도메인 역할을 부여 경로와 함께 조회한다. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 false 다(유저 조회 응답과 모양을 맞춤). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 group 이 해당 domain 소속이 아니면 403 반환.
   * @summary 지정한 domain에서 group이 보유한 domain role 조회 - 부여 경로 포함
   * @param {DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12DomainsDomainIdGroupsGroupIdRolesGet(
    requestParameters: DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAssignedRoles>;

  /**
   * 지정한 domain 에서 사용자가 보유한 도메인 역할을 부여 경로와 함께 조회한다. 사용자 직접 부여(E)와 소속 그룹 경유(F)를 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 경유 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 사용자가 해당 domain 소속이 아니면 403 반환.
   * @summary 지정한 domain에서 사용자가 보유한 domain role 조회 - 할당 타입별
   * @param {DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12DomainsDomainIdUsersUserIdRolesGet(
    requestParameters: DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAssignedRoles>;

  /**
   * 조직 소유자 권한 이양. from_user 가 조직 소유자인 경우 to_user 에게 조직 소유자 권한을 이양
   * @summary 조직 소유자 권한 이양
   * @param {DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdAssignDomainOwnerPost(
    requestParameters: DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 삭제
   * @summary domain 삭제
   * @param {DomainsApiApiV1DomainsDomainIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
   * @summary domain 활성/비활성화
   * @param {DomainsApiApiV1DomainsDomainIdEnabledPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdEnabledPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdEnabledPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 그룹에게 직접 부여된 role 목록 조회. 그룹에게 부여된 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 true 다(유저 조회 응답과 모양을 맞춤).
   * @summary 지정한 domain에서 그룹에게 직접 부여된 상속 역할 조회
   * @param {DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAssignedRoles>;

  /**
   * Deprecated: GET /api/v1_2/domains/{domain_id}/groups/{group_id}/roles 를 사용한다. 이 API 는 role 의 id/name 만 반환하고 부여 경로와 role 표시 정보(display_name 등)를 누락한다. 지정한 domain에 속한 group의 role 정보를 조회
   * @summary [Deprecated] 지정한 domain에 속한 group의 role 정보를 조회
   * @param {DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsGroupIdRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoles>;

  /**
   * 지정한 domain 하위 그룹의 일괄 접근 권한(inherited=1)을 그룹 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
   * @summary 지정한 domain 하위 그룹 일괄 접근 권한(상속 역할) 회수
   * @param {DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsInheritedRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
   * @summary 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(상속 역할) 변경
   * @param {DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsInheritedRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain에 그룹 생성 시 이름이 이미 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
   * @summary domain에 그룹 생성 시 이름이 이미 존재하는지 확인.
   * @param {DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsNameGroupNameHead(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Suggest groups of Domain
   * @summary Suggest groups of Domain
   * @param {DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsNameSuggestGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSuggestedGroups>;

  /**
   * 지정한 조직에 지정한 그룹들에 대한 권한 설정
   * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
   * @param {DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 조직에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
   * @param {DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdGroupsRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 그룹을 이름 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 그룹은 제외된다.
   * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 그룹 목록 조회
   * @param {DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdInheritedRolesGroupsGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListInheritedRoleGroupsResponse>;

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 사용자를 이름·이메일 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 사용자는 제외된다.
   * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 사용자 목록 조회
   * @param {DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdInheritedRolesUsersGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListInheritedRoleUsersResponse>;

  /**
   * domain IP 접근제어(ip_access_check_enabled) 설정 수정
   * @summary domain IP 접근제어 설정 수정
   * @param {DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdIpAccessCheckPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 로그인 2차 인증 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
   * @summary domain 로그인 2차 인증 정보 수정
   * @param {DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdLoginInfoPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
   * @summary domain 정보 수정
   * @param {DomainsApiApiV1DomainsDomainIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseDomainUpdateResponse>;

  /**
   * get Projects Suggestions of Domain
   * @summary Suggest Projects of Domain
   * @param {DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdProjectsNameSuggestGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectSuggestResponse>;

  /**
   * domain 내에 project nickname 이 이미 존재하는 확인
   * @summary domain 내에 project nickname 이 이미 존재하는 확인
   * @param {DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdProjectsNicknameNicknameHead(
    requestParameters: DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
   * @summary 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
   * @param {DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdRolesUsersGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListUserAssignmentsByDomainResponse>;

  /**
   * domain 보안 설정 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary domain 보안 설정 정보 수정
   * @param {DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSecurityInfoPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 출발지 기반 접근제어 mode 수정 payload 내 모든 항목이 필수
   * @summary domain 출발지 기반 접근제어 mode 수정
   * @param {DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcModePatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 Domain 의 통계 정보 조회
   * @summary 지정한 Domain 의 통계 정보 조회
   * @param {DomainsApiApiV1DomainsDomainIdStatisticsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdStatisticsGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdStatisticsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGetDomainStatistics>;

  /**
   * 지정한 domain 하위 사용자의 일괄 접근 권한(inherited=1)을 유저 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
   * @summary 지정한 domain 하위 사용자 일괄 접근 권한(상속 역할) 회수
   * @param {DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersInheritedRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
   * @summary 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(상속 역할) 변경
   * @param {DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersInheritedRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
   * @summary 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인
   * @param {DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersNameMatchGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUserIdMap>;

  /**
   * get Users Suggestions of Domain
   * @summary Suggest Users of Domain
   * @param {DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersNameSuggestGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSuggestedUsers>;

  /**
   * 지정한 domain에 소속된 사용자의 모든 domain role 삭제
   * @summary 지정한 domain에 소속된 사용자의 모든 domain role 삭제
   * @param {DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 domain에 소속된 사용자 조직/빌링 역할 변경 (신규 역할 추가, 기존 역할 제거) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 domain에 소속된 사용자 조직 역할 변경
   * @param {DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 도메인 스코프 토큰 발급 시 token.roles 에 담기는 role 목록(직접 부여 + 그룹 경유 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 토큰 role 캐시를 재사용하므로 도메인 스코프 토큰의 role 과 일치한다. 도메인 자체 권한만 대상이다 — 상속 부여(inherited=1)는 하위 프로젝트에만 적용되므로 포함되지 않는다. 콘솔 노출 대상 role 만 반환하며(kic_role_extra 미등록 role 제외), role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
   * @summary 도메인에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
   * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEffectiveRolesDisplay>;

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 사용자 직접 및 소속 그룹을 통해 부여된 role과 부여 경로 조회. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 상속 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
   * @summary 지정한 domain에서 사용자가 보유한 상속 역할 조회
   * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAssignedRoles>;

  /**
   * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 이 API 는 사용자에게 직접 부여된 role 만 반환하고 소속 그룹을 통해 얻은 role 은 누락한다. 지정한 domain에 소속된 사용자에 할당된 domain role 목록 조회
   * @summary [Deprecated] 지정한 domain에 소속된 사용자에 할당된 domain role 조회
   * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersUserIdRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoles>;

  /**
   * 모든 domain 목록 조회. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공)
   * @summary 모든 domain 목록 조회
   * @param {DomainsApiApiV1DomainsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsGet(
    requestParameters: DomainsApiApiV1DomainsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseDomainListResponse>;

  /**
   * domain 생성 및 domain 관리자(Owner)도 같이 생성한다. UseType 의 경우 다음 6가지 값으로 입력 (Default=외부 고객사).  1.KC system  2.외부 고객사  3.대외교육 및 홍보  4.KEP 서비스 개발  5.KC 서비스 검증  6.KC 서비스 운영 projectDefaultEndpointGroup은 {interface}-{region} 으로 입력. 존재하지 않는 endpoint group 은 설정 안됨 ex) public, public-kr-central-2
   * @summary domain 생성
   * @param {DomainsApiApiV1DomainsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsPost(
    requestParameters: DomainsApiApiV1DomainsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudDomain>;
}

/**
 * Request parameters for accountV1DomainsNameDomainNameHead operation in DomainsApi.
 */
export interface DomainsApiAccountV1DomainsNameDomainNameHeadRequest {
  /**
   * Authorization: Basic base64(client id:Client Secret)
   */
  readonly authorization: string;

  /**
   * domain name, maxLength&#x3D;32
   */
  readonly domainName: string;
}

/**
 * Request parameters for apiV11DomainsDomainIdGet operation in DomainsApi.
 */
export interface DomainsApiApiV11DomainsDomainIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV11DomainsDomainIdGroupsGet operation in DomainsApi.
 */
export interface DomainsApiApiV11DomainsDomainIdGroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * group prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * group prefix search by id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0일 경우 all
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV11DomainsDomainIdGroupsGetSortOrderEnum;

  /**
   * sort by (name)
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV11DomainsDomainIdProjectsGet operation in DomainsApi.
 */
export interface DomainsApiApiV11DomainsDomainIdProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * project prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * search by project id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...,
   */
  readonly offset?: number;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc), default&#x3D;asc
   */
  readonly sortOrder?: ApiV11DomainsDomainIdProjectsGetSortOrderEnum;

  /**
   * sort by (name), default&#x3D;name
   */
  readonly sortColumn?: string;

  /**
   * 비활성화 project 포함 여부, default&#x3D;false
   */
  readonly includeDisabled?: boolean;
}

/**
 * Request parameters for apiV11DomainsDomainIdUsersGet operation in DomainsApi.
 */
export interface DomainsApiApiV11DomainsDomainIdUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, maxLength&#x3D;32
   */
  readonly domainId: string;

  /**
   * User ID, maxLength&#x3D;32
   */
  readonly id?: string;

  /**
   * user prefix search by name
   */
  readonly name?: string;

  /**
   * user search by domain role id (UserDomain/GroupDomain, inherited&#x3D;0)
   */
  readonly role?: Array<string>;

  /**
   * user search by not have domain role (inherited-only user is considered to have no domain role)
   */
  readonly noRole?: boolean;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, default&#x3D;0(all)
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV11DomainsDomainIdUsersGetSortOrderEnum;

  /**
   * sort by (name, created_at), default&#x3D;name
   */
  readonly sortColumn?: string;

  /**
   * search by user_type (all, user, account, agent), 대소문자 구분x
   */
  readonly userType?: string;
}

/**
 * Request parameters for apiV12DomainsDomainIdGroupsGroupIdRolesGet operation in DomainsApi.
 */
export interface DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;
}

/**
 * Request parameters for apiV12DomainsDomainIdUsersUserIdRolesGet operation in DomainsApi.
 */
export interface DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * assignment 주체로 필터링 (user or group), 미지정 시 전체. 필터는 role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다.
   */
  readonly actorType?: ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum;
}

/**
 * Request parameters for apiV1DomainsDomainIdAssignDomainOwnerPost operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * from user, to user
   */
  readonly assignOwnerRoleRequest: RequestAssignOwnerRoleRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdDelete operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdEnabledPatch operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdEnabledPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * true: 활성화, false: 비활성화
   */
  readonly enabled: boolean;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsGroupIdRolesGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsInheritedRolesDelete operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupIds: Array<string>;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsInheritedRolesPut operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * group_ids, role_ids
   */
  readonly assignGroupsToDomainRequest: RequestAssignGroupsToDomainRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsNameGroupNameHead operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Group name, 영대소문자+숫자+특수문자(-)
   */
  readonly groupName: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsNameSuggestGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * group prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name: string;

  /**
   * list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;

  /**
   * 이름 정렬 방향
   */
  readonly sortOrder?: ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsRolesDelete operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
   */
  readonly groupIds: Array<string>;
}

/**
 * Request parameters for apiV1DomainsDomainIdGroupsRolesPut operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * group ids, role ids
   */
  readonly assignGroupsToDomainRequest: RequestAssignGroupsToDomainRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdInheritedRolesGroupsGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * group name prefix 검색
   */
  readonly name?: string;

  /**
   * 특정 group id 필터, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * 페이징 offset
   */
  readonly offset?: number;

  /**
   * 페이징 size, 0이면 전체 반환
   */
  readonly size?: number;

  /**
   * asc | desc
   */
  readonly sortOrder?: ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum;

  /**
   * name
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdInheritedRolesUsersGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * 이름·이메일 prefix 검색 (user name &#x3D; 이메일)
   */
  readonly name?: string;

  /**
   * 특정 user id 필터, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * assignment 주체로 필터링 (user or group), 미지정 시 전체. user 는 직접 상속 권한, group 은 소속 그룹 경유 상속 권한을 가진 사용자만 반환한다.
   */
  readonly actorType?: ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum;

  /**
   * 페이징 offset
   */
  readonly offset?: number;

  /**
   * 페이징 size, 0이면 전체 반환
   */
  readonly size?: number;

  /**
   * asc | desc
   */
  readonly sortOrder?: ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum;

  /**
   * name
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdIpAccessCheckPatch operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * domain IP 접근제어 설정 업데이트
   */
  readonly domain: RequestUpdateIpAccessCheckRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdLoginInfoPatch operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * domain 로그인 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
   */
  readonly domain: RequestUpdateLoginInfoRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdPatch operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * domain 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
   */
  readonly domain: RequestCloudDomainUpdateRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdProjectsNameSuggestGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * project prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name: string;

  /**
   * project prefix search by name
   */
  readonly includeDisabled?: boolean;

  /**
   * list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;
}

/**
 * Request parameters for apiV1DomainsDomainIdProjectsNicknameNicknameHead operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Project nickname, 영대소문자+숫자+특수문자(-)
   */
  readonly nickname: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdRolesUsersGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * Role IDs, maxLength&#x3D;100, 영소문자+숫자 32자
   */
  readonly roleIds: Array<string>;
}

/**
 * Request parameters for apiV1DomainsDomainIdSecurityInfoPatch operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * domain 보안 설정 정보 업데이트. 값이 입력되지 않을 경우 무조건 default 값으로 수정
   */
  readonly domain: RequestUpdateSecurityInfoRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcModePatch operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * domain src ac mode 업데이트
   */
  readonly domain: RequestUpdateSrcAcModeRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdStatisticsGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdStatisticsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersInheritedRolesDelete operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * User ID,영소문자+숫자 32자
   */
  readonly userIds: Array<string>;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersInheritedRolesPut operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * user_ids, role_ids
   */
  readonly assignToUsersOnDomainRequest: RequestAssignToUsersOnDomainRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersNameMatchGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * user name
   */
  readonly names: Array<string>;

  /**
   * user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
   */
  readonly userType: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersNameSuggestGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * user prefix search by name, 이메일 사용 가능 문자
   */
  readonly name: string;

  /**
   * list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;

  /**
   * user search by user type (all, user, account, agent) 대소문자 구분x
   */
  readonly userType?: string;

  /**
   * 이름 정렬 방향
   */
  readonly sortOrder?: ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersRolesDelete operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * User ID,영소문자+숫자 32자
   */
  readonly userIds: Array<string>;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersRolesPut operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * user_id, role_id
   */
  readonly assignToUsersOnDomainRequest: RequestAssignToUsersOnDomainRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersUserIdInheritedRolesGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * assignment 주체로 필터링 (user or group), 미지정 시 전체. 필터는 role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다.
   */
  readonly actorType?: ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersUserIdRolesGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1DomainsGet operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * domain search by id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly id?: string;

  /**
   * domain search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * true 인 경우 name 검색 시 like 검색. false 인 경우 name equal 검색
   */
  readonly nameLike?: boolean;

  /**
   * 비활성화 domain 포함 여부
   */
  readonly includeDisabled?: boolean;
}

/**
 * Request parameters for apiV1DomainsPost operation in DomainsApi.
 */
export interface DomainsApiApiV1DomainsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * name, owner 정보 필수. bool 타입 필드는 생략하면 false로 설정.
   */
  readonly domainCreateRequest: RequestCloudDomainCreateRequest;
}

/**
 * DomainsApi - object-oriented interface
 */
export class DomainsApi extends BaseAPI implements DomainsApiInterface {
  /**
   * 도메인 이름이 이미 존재하는지 확인
   * @summary 도메인 이름이 이미 존재하는지 확인.
   * @param {DomainsApiAccountV1DomainsNameDomainNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1DomainsNameDomainNameHead(
    requestParameters: DomainsApiAccountV1DomainsNameDomainNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .accountV1DomainsNameDomainNameHead(
        requestParameters.authorization,
        requestParameters.domainName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 정보 상세 조회
   * @summary 지정한 domain 정보 상세 조회
   * @param {DomainsApiApiV11DomainsDomainIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11DomainsDomainIdGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV11DomainsDomainIdGet(requestParameters.xAuthToken, requestParameters.domainId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain에 존재하는 모든 그룹 목록 조회
   * @summary 지정한 domain에 존재하는 모든 그룹 목록 조회
   * @param {DomainsApiApiV11DomainsDomainIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11DomainsDomainIdGroupsGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV11DomainsDomainIdGroupsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.id,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain에 존재하는 모든 project 목록 조회 user_count · group_count 는 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 직접 할당만 센다 — project scope 로 등록되지 않은 role 로만 할당된 사용자·그룹은 제외된다.
   * @summary 지정한 domain에 존재하는 모든 project 목록 조회
   * @param {DomainsApiApiV11DomainsDomainIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11DomainsDomainIdProjectsGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV11DomainsDomainIdProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.id,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        requestParameters.includeDisabled,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain에 존재하는 모든 사용자 목록 조회 콘솔 노출 대상 role(kic_role_extra 에 domain scope 로 등록) 할당만 도메인 역할로 친다. 미등록 role 로만 할당된 사용자는 domain_role_count 가 0 이고 no_role=true 결과에 포함되며, role 필터로도 잡히지 않는다.
   * @summary 지정한 domain에 존재하는 모든 사용자 목록 조회
   * @param {DomainsApiApiV11DomainsDomainIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11DomainsDomainIdUsersGet(
    requestParameters: DomainsApiApiV11DomainsDomainIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV11DomainsDomainIdUsersGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.id,
        requestParameters.name,
        requestParameters.role,
        requestParameters.noRole,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        requestParameters.userType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 에서 group 이 보유한 도메인 역할을 부여 경로와 함께 조회한다. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 false 다(유저 조회 응답과 모양을 맞춤). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 group 이 해당 domain 소속이 아니면 403 반환.
   * @summary 지정한 domain에서 group이 보유한 domain role 조회 - 부여 경로 포함
   * @param {DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12DomainsDomainIdGroupsGroupIdRolesGet(
    requestParameters: DomainsApiApiV12DomainsDomainIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV12DomainsDomainIdGroupsGroupIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.groupId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 에서 사용자가 보유한 도메인 역할을 부여 경로와 함께 조회한다. 사용자 직접 부여(E)와 소속 그룹 경유(F)를 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 경유 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 하위 프로젝트 일괄 접근 권한(상속, inherited=1)은 포함하지 않는다 — 그것은 inherited-roles API 가 담당한다. 조회 대상 사용자가 해당 domain 소속이 아니면 403 반환.
   * @summary 지정한 domain에서 사용자가 보유한 domain role 조회 - 할당 타입별
   * @param {DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12DomainsDomainIdUsersUserIdRolesGet(
    requestParameters: DomainsApiApiV12DomainsDomainIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV12DomainsDomainIdUsersUserIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userId,
        requestParameters.actorType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 조직 소유자 권한 이양. from_user 가 조직 소유자인 경우 to_user 에게 조직 소유자 권한을 이양
   * @summary 조직 소유자 권한 이양
   * @param {DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdAssignDomainOwnerPost(
    requestParameters: DomainsApiApiV1DomainsDomainIdAssignDomainOwnerPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdAssignDomainOwnerPost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.assignOwnerRoleRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 삭제
   * @summary domain 삭제
   * @param {DomainsApiApiV1DomainsDomainIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdDelete(requestParameters.xAuthToken, requestParameters.domainId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
   * @summary domain 활성/비활성화
   * @param {DomainsApiApiV1DomainsDomainIdEnabledPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdEnabledPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdEnabledPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdEnabledPatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.enabled,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 그룹에게 직접 부여된 role 목록 조회. 그룹에게 부여된 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환. role 은 display_order 순으로 정렬되며, 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 그룹은 nested group 을 지원하지 않아 부여 경로가 하나뿐이다 — 이 엔드포인트에서 grant_types 는 항상 1개이고, actor_type 은 항상 Group, group 은 항상 조회 대상 그룹(URL 의 group_id), inherited 는 항상 true 다(유저 조회 응답과 모양을 맞춤).
   * @summary 지정한 domain에서 그룹에게 직접 부여된 상속 역할 조회
   * @param {DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsGroupIdInheritedRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsGroupIdInheritedRolesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.groupId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Deprecated: GET /api/v1_2/domains/{domain_id}/groups/{group_id}/roles 를 사용한다. 이 API 는 role 의 id/name 만 반환하고 부여 경로와 role 표시 정보(display_name 등)를 누락한다. 지정한 domain에 속한 group의 role 정보를 조회
   * @summary [Deprecated] 지정한 domain에 속한 group의 role 정보를 조회
   * @param {DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsGroupIdRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsGroupIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.groupId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 그룹의 일괄 접근 권한(inherited=1)을 그룹 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
   * @summary 지정한 domain 하위 그룹 일괄 접근 권한(상속 역할) 회수
   * @param {DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsInheritedRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsInheritedRolesDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.groupIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
   * @summary 지정한 domain 하위 전체 프로젝트에 대한 그룹 일괄 접근 권한(상속 역할) 변경
   * @param {DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsInheritedRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsInheritedRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsInheritedRolesPut(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.assignGroupsToDomainRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain에 그룹 생성 시 이름이 이미 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
   * @summary domain에 그룹 생성 시 이름이 이미 존재하는지 확인.
   * @param {DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsNameGroupNameHead(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsNameGroupNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsNameGroupNameHead(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.groupName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Suggest groups of Domain
   * @summary Suggest groups of Domain
   * @param {DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsNameSuggestGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.size,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 조직에 지정한 그룹들에 대한 권한 설정
   * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
   * @param {DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsRolesDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.groupIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 조직에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 조직에 지정한 그룹들에 대한 권한 설정
   * @param {DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdGroupsRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdGroupsRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdGroupsRolesPut(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.assignGroupsToDomainRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 그룹을 이름 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 그룹은 제외된다.
   * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 그룹 목록 조회
   * @param {DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdInheritedRolesGroupsGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdInheritedRolesGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdInheritedRolesGroupsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.id,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 보유 사용자를 이름·이메일 prefix 검색 + 페이징으로 조회 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 상속만 보유로 친다 — 미등록 role 로만 상속받은 사용자는 제외된다.
   * @summary 지정한 domain에서 일괄 접근 권한(상속 역할) 보유 사용자 목록 조회
   * @param {DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdInheritedRolesUsersGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdInheritedRolesUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdInheritedRolesUsersGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.id,
        requestParameters.actorType,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain IP 접근제어(ip_access_check_enabled) 설정 수정
   * @summary domain IP 접근제어 설정 수정
   * @param {DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdIpAccessCheckPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdIpAccessCheckPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdIpAccessCheckPatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.domain,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 로그인 2차 인증 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
   * @summary domain 로그인 2차 인증 정보 수정
   * @param {DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdLoginInfoPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdLoginInfoPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdLoginInfoPatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.domain,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) console 로그인 2단계 인증이 필수인 경우 mfa_enabled = true 로 고정, 수정불가
   * @summary domain 정보 수정
   * @param {DomainsApiApiV1DomainsDomainIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdPatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.domain,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * get Projects Suggestions of Domain
   * @summary Suggest Projects of Domain
   * @param {DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdProjectsNameSuggestGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdProjectsNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdProjectsNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.includeDisabled,
        requestParameters.size,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 내에 project nickname 이 이미 존재하는 확인
   * @summary domain 내에 project nickname 이 이미 존재하는 확인
   * @param {DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdProjectsNicknameNicknameHead(
    requestParameters: DomainsApiApiV1DomainsDomainIdProjectsNicknameNicknameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdProjectsNicknameNicknameHead(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.nickname,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
   * @summary 지정한 조직 내 지정한 조직 권한을 가진 user 목록 조회
   * @param {DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdRolesUsersGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdRolesUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdRolesUsersGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.roleIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 보안 설정 정보 수정. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary domain 보안 설정 정보 수정
   * @param {DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSecurityInfoPatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdSecurityInfoPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdSecurityInfoPatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.domain,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 출발지 기반 접근제어 mode 수정 payload 내 모든 항목이 필수
   * @summary domain 출발지 기반 접근제어 mode 수정
   * @param {DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcModePatch(
    requestParameters: DomainsApiApiV1DomainsDomainIdSrcAcModePatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcModePatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.domain,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 Domain 의 통계 정보 조회
   * @summary 지정한 Domain 의 통계 정보 조회
   * @param {DomainsApiApiV1DomainsDomainIdStatisticsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdStatisticsGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdStatisticsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdStatisticsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 사용자의 일괄 접근 권한(inherited=1)을 유저 단위로 전부 제거. 일반 도메인 역할(inherited=0)은 건드리지 않는다.
   * @summary 지정한 domain 하위 사용자 일괄 접근 권한(상속 역할) 회수
   * @param {DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersInheritedRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersInheritedRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersInheritedRolesDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(inherited=1) 변경 (요청 role 집합으로 스냅샷 교체) 일반 도메인 역할(inherited=0)은 변경하지 않는다. payload 내 모든 항목이 필수.
   * @summary 지정한 domain 하위 전체 프로젝트에 대한 사용자 일괄 접근 권한(상속 역할) 변경
   * @param {DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersInheritedRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersInheritedRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersInheritedRolesPut(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.assignToUsersOnDomainRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
   * @summary 사용하려는 다수의 이름을 domain내에 존재하는 이름인지 확인
   * @param {DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersNameMatchGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersNameMatchGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersNameMatchGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.names,
        requestParameters.userType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * get Users Suggestions of Domain
   * @summary Suggest Users of Domain
   * @param {DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersNameSuggestGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.name,
        requestParameters.size,
        requestParameters.userType,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain에 소속된 사용자의 모든 domain role 삭제
   * @summary 지정한 domain에 소속된 사용자의 모든 domain role 삭제
   * @param {DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersRolesDelete(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersRolesDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain에 소속된 사용자 조직/빌링 역할 변경 (신규 역할 추가, 기존 역할 제거) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 domain에 소속된 사용자 조직 역할 변경
   * @param {DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersRolesPut(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersRolesPut(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.assignToUsersOnDomainRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 도메인 스코프 토큰 발급 시 token.roles 에 담기는 role 목록(직접 부여 + 그룹 경유 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 토큰 role 캐시를 재사용하므로 도메인 스코프 토큰의 role 과 일치한다. 도메인 자체 권한만 대상이다 — 상속 부여(inherited=1)는 하위 프로젝트에만 적용되므로 포함되지 않는다. 콘솔 노출 대상 role 만 반환하며(kic_role_extra 미등록 role 제외), role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
   * @summary 도메인에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
   * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersUserIdEffectiveRolesDisplayGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 domain 하위 전체 프로젝트에 대한 일괄 접근 권한(inherited=1) 중 사용자 직접 및 소속 그룹을 통해 부여된 role과 부여 경로 조회. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. role 은 display_order 순, grant_types 는 유저 상속 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 상속 역할이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
   * @summary 지정한 domain에서 사용자가 보유한 상속 역할 조회
   * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdInheritedRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersUserIdInheritedRolesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userId,
        requestParameters.actorType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 이 API 는 사용자에게 직접 부여된 role 만 반환하고 소속 그룹을 통해 얻은 role 은 누락한다. 지정한 domain에 소속된 사용자에 할당된 domain role 목록 조회
   * @summary [Deprecated] 지정한 domain에 소속된 사용자에 할당된 domain role 조회
   * @param {DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersUserIdRolesGet(
    requestParameters: DomainsApiApiV1DomainsDomainIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersUserIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 모든 domain 목록 조회. federated_domain 필드의 value는 내려가지 않음.(/api/v1/domains/{domain_id}에서만 제공)
   * @summary 모든 domain 목록 조회
   * @param {DomainsApiApiV1DomainsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsGet(
    requestParameters: DomainsApiApiV1DomainsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.id,
        requestParameters.name,
        requestParameters.nameLike,
        requestParameters.includeDisabled,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 생성 및 domain 관리자(Owner)도 같이 생성한다. UseType 의 경우 다음 6가지 값으로 입력 (Default=외부 고객사).  1.KC system  2.외부 고객사  3.대외교육 및 홍보  4.KEP 서비스 개발  5.KC 서비스 검증  6.KC 서비스 운영 projectDefaultEndpointGroup은 {interface}-{region} 으로 입력. 존재하지 않는 endpoint group 은 설정 안됨 ex) public, public-kr-central-2
   * @summary domain 생성
   * @param {DomainsApiApiV1DomainsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsPost(
    requestParameters: DomainsApiApiV1DomainsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DomainsApiFp(this.configuration)
      .apiV1DomainsPost(
        requestParameters.xAuthToken,
        requestParameters.domainCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV11DomainsDomainIdGroupsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV11DomainsDomainIdGroupsGetSortOrderEnum =
  (typeof ApiV11DomainsDomainIdGroupsGetSortOrderEnum)[keyof typeof ApiV11DomainsDomainIdGroupsGetSortOrderEnum];
export const ApiV11DomainsDomainIdProjectsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV11DomainsDomainIdProjectsGetSortOrderEnum =
  (typeof ApiV11DomainsDomainIdProjectsGetSortOrderEnum)[keyof typeof ApiV11DomainsDomainIdProjectsGetSortOrderEnum];
export const ApiV11DomainsDomainIdUsersGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV11DomainsDomainIdUsersGetSortOrderEnum =
  (typeof ApiV11DomainsDomainIdUsersGetSortOrderEnum)[keyof typeof ApiV11DomainsDomainIdUsersGetSortOrderEnum];
export const ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum = {
  User: 'user',
  Group: 'group',
} as const;
export type ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum =
  (typeof ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum)[keyof typeof ApiV12DomainsDomainIdUsersUserIdRolesGetActorTypeEnum];
export const ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdGroupsNameSuggestGetSortOrderEnum];
export const ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdInheritedRolesGroupsGetSortOrderEnum];
export const ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum = {
  User: 'user',
  Group: 'group',
} as const;
export type ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum =
  (typeof ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum)[keyof typeof ApiV1DomainsDomainIdInheritedRolesUsersGetActorTypeEnum];
export const ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdInheritedRolesUsersGetSortOrderEnum];
export const ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdUsersNameSuggestGetSortOrderEnum];
export const ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum = {
  User: 'user',
  Group: 'group',
} as const;
export type ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum =
  (typeof ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum)[keyof typeof ApiV1DomainsDomainIdUsersUserIdInheritedRolesGetActorTypeEnum];

/**
 * EndpointApi - axios parameter creator
 */
export const EndpointApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Endpoint 삭제
     * @summary Endpoint 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointId endpoint id,영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsEndpointIdDelete: async (
      xAuthToken: string,
      endpointId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointsEndpointIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'endpointId' is not null or undefined
      assertParamExists('apiV1EndpointsEndpointIdDelete', 'endpointId', endpointId);
      const localVarPath = `/api/v1/endpoints/{endpoint_id}`.replace(
        '{endpoint_id}',
        encodeURIComponent(String(endpointId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Endpoint 조회
     * @summary Endpoint 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointId endpoint id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsEndpointIdGet: async (
      xAuthToken: string,
      endpointId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointsEndpointIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'endpointId' is not null or undefined
      assertParamExists('apiV1EndpointsEndpointIdGet', 'endpointId', endpointId);
      const localVarPath = `/api/v1/endpoints/{endpoint_id}`.replace(
        '{endpoint_id}',
        encodeURIComponent(String(endpointId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Endpoint 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Endpoint 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointId endpoint id,영소문자+숫자 32자
     * @param {RequestEndpointUpdateRequest} endpointUpdateRequest 모든 값 필수
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsEndpointIdPut: async (
      xAuthToken: string,
      endpointId: string,
      endpointUpdateRequest: RequestEndpointUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointsEndpointIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'endpointId' is not null or undefined
      assertParamExists('apiV1EndpointsEndpointIdPut', 'endpointId', endpointId);
      // verify required parameter 'endpointUpdateRequest' is not null or undefined
      assertParamExists(
        'apiV1EndpointsEndpointIdPut',
        'endpointUpdateRequest',
        endpointUpdateRequest,
      );
      const localVarPath = `/api/v1/endpoints/{endpoint_id}`.replace(
        '{endpoint_id}',
        encodeURIComponent(String(endpointId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endpointUpdateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Endpoint 목록 조회
     * @summary Endpoint 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [serviceId] service id
     * @param {string} [_interface] interface
     * @param {string} [regionId] region id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsGet: async (
      xAuthToken: string,
      serviceId?: string,
      _interface?: string,
      regionId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/endpoints`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (serviceId !== undefined) {
        localVarQueryParameter['service_id'] = serviceId;
      }

      if (_interface !== undefined) {
        localVarQueryParameter['interface'] = _interface;
      }

      if (regionId !== undefined) {
        localVarQueryParameter['region_id'] = regionId;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Endpoint 생성
     * @summary Endpoint 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestEndpointCreateRequest} endpointCreateRequest 모든 값 필수
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsPost: async (
      xAuthToken: string,
      endpointCreateRequest: RequestEndpointCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'endpointCreateRequest' is not null or undefined
      assertParamExists('apiV1EndpointsPost', 'endpointCreateRequest', endpointCreateRequest);
      const localVarPath = `/api/v1/endpoints`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endpointCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndpointApi - functional programming interface
 */
export const EndpointApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EndpointApiAxiosParamCreator(configuration);
  return {
    /**
     * Endpoint 삭제
     * @summary Endpoint 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointId endpoint id,영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointsEndpointIdDelete(
      xAuthToken: string,
      endpointId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointsEndpointIdDelete(
        xAuthToken,
        endpointId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointApi.apiV1EndpointsEndpointIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Endpoint 조회
     * @summary Endpoint 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointId endpoint id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointsEndpointIdGet(
      xAuthToken: string,
      endpointId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointsEndpointIdGet(
        xAuthToken,
        endpointId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointApi.apiV1EndpointsEndpointIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Endpoint 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Endpoint 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointId endpoint id,영소문자+숫자 32자
     * @param {RequestEndpointUpdateRequest} endpointUpdateRequest 모든 값 필수
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointsEndpointIdPut(
      xAuthToken: string,
      endpointId: string,
      endpointUpdateRequest: RequestEndpointUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointsEndpointIdPut(
        xAuthToken,
        endpointId,
        endpointUpdateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointApi.apiV1EndpointsEndpointIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Endpoint 목록 조회
     * @summary Endpoint 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [serviceId] service id
     * @param {string} [_interface] interface
     * @param {string} [regionId] region id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointsGet(
      xAuthToken: string,
      serviceId?: string,
      _interface?: string,
      regionId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointsGet(
        xAuthToken,
        serviceId,
        _interface,
        regionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointApi.apiV1EndpointsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Endpoint 생성
     * @summary Endpoint 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestEndpointCreateRequest} endpointCreateRequest 모든 값 필수
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointsPost(
      xAuthToken: string,
      endpointCreateRequest: RequestEndpointCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointsPost(
        xAuthToken,
        endpointCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointApi.apiV1EndpointsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EndpointApi - factory interface
 */
export const EndpointApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndpointApiFp(configuration);
  return {
    /**
     * Endpoint 삭제
     * @summary Endpoint 삭제
     * @param {EndpointApiApiV1EndpointsEndpointIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsEndpointIdDelete(
      requestParameters: EndpointApiApiV1EndpointsEndpointIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1EndpointsEndpointIdDelete(
          requestParameters.xAuthToken,
          requestParameters.endpointId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Endpoint 조회
     * @summary Endpoint 조회
     * @param {EndpointApiApiV1EndpointsEndpointIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsEndpointIdGet(
      requestParameters: EndpointApiApiV1EndpointsEndpointIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointResponse> {
      return localVarFp
        .apiV1EndpointsEndpointIdGet(
          requestParameters.xAuthToken,
          requestParameters.endpointId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Endpoint 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Endpoint 수정
     * @param {EndpointApiApiV1EndpointsEndpointIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsEndpointIdPut(
      requestParameters: EndpointApiApiV1EndpointsEndpointIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointResponse> {
      return localVarFp
        .apiV1EndpointsEndpointIdPut(
          requestParameters.xAuthToken,
          requestParameters.endpointId,
          requestParameters.endpointUpdateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Endpoint 목록 조회
     * @summary Endpoint 목록 조회
     * @param {EndpointApiApiV1EndpointsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsGet(
      requestParameters: EndpointApiApiV1EndpointsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointListResponse> {
      return localVarFp
        .apiV1EndpointsGet(
          requestParameters.xAuthToken,
          requestParameters.serviceId,
          requestParameters._interface,
          requestParameters.regionId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Endpoint 생성
     * @summary Endpoint 생성
     * @param {EndpointApiApiV1EndpointsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointsPost(
      requestParameters: EndpointApiApiV1EndpointsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointResponse> {
      return localVarFp
        .apiV1EndpointsPost(
          requestParameters.xAuthToken,
          requestParameters.endpointCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * EndpointApi - interface
 */
export interface EndpointApiInterface {
  /**
   * Endpoint 삭제
   * @summary Endpoint 삭제
   * @param {EndpointApiApiV1EndpointsEndpointIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointsEndpointIdDelete(
    requestParameters: EndpointApiApiV1EndpointsEndpointIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Endpoint 조회
   * @summary Endpoint 조회
   * @param {EndpointApiApiV1EndpointsEndpointIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointsEndpointIdGet(
    requestParameters: EndpointApiApiV1EndpointsEndpointIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointResponse>;

  /**
   * Endpoint 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Endpoint 수정
   * @param {EndpointApiApiV1EndpointsEndpointIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointsEndpointIdPut(
    requestParameters: EndpointApiApiV1EndpointsEndpointIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointResponse>;

  /**
   * Endpoint 목록 조회
   * @summary Endpoint 목록 조회
   * @param {EndpointApiApiV1EndpointsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointsGet(
    requestParameters: EndpointApiApiV1EndpointsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointListResponse>;

  /**
   * Endpoint 생성
   * @summary Endpoint 생성
   * @param {EndpointApiApiV1EndpointsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointsPost(
    requestParameters: EndpointApiApiV1EndpointsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointResponse>;
}

/**
 * Request parameters for apiV1EndpointsEndpointIdDelete operation in EndpointApi.
 */
export interface EndpointApiApiV1EndpointsEndpointIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * endpoint id,영소문자+숫자 32자
   */
  readonly endpointId: string;
}

/**
 * Request parameters for apiV1EndpointsEndpointIdGet operation in EndpointApi.
 */
export interface EndpointApiApiV1EndpointsEndpointIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * endpoint id
   */
  readonly endpointId: string;
}

/**
 * Request parameters for apiV1EndpointsEndpointIdPut operation in EndpointApi.
 */
export interface EndpointApiApiV1EndpointsEndpointIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * endpoint id,영소문자+숫자 32자
   */
  readonly endpointId: string;

  /**
   * 모든 값 필수
   */
  readonly endpointUpdateRequest: RequestEndpointUpdateRequest;
}

/**
 * Request parameters for apiV1EndpointsGet operation in EndpointApi.
 */
export interface EndpointApiApiV1EndpointsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service id
   */
  readonly serviceId?: string;

  /**
   * interface
   */
  readonly _interface?: string;

  /**
   * region id
   */
  readonly regionId?: string;
}

/**
 * Request parameters for apiV1EndpointsPost operation in EndpointApi.
 */
export interface EndpointApiApiV1EndpointsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 모든 값 필수
   */
  readonly endpointCreateRequest: RequestEndpointCreateRequest;
}

/**
 * EndpointApi - object-oriented interface
 */
export class EndpointApi extends BaseAPI implements EndpointApiInterface {
  /**
   * Endpoint 삭제
   * @summary Endpoint 삭제
   * @param {EndpointApiApiV1EndpointsEndpointIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointsEndpointIdDelete(
    requestParameters: EndpointApiApiV1EndpointsEndpointIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointApiFp(this.configuration)
      .apiV1EndpointsEndpointIdDelete(
        requestParameters.xAuthToken,
        requestParameters.endpointId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Endpoint 조회
   * @summary Endpoint 조회
   * @param {EndpointApiApiV1EndpointsEndpointIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointsEndpointIdGet(
    requestParameters: EndpointApiApiV1EndpointsEndpointIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointApiFp(this.configuration)
      .apiV1EndpointsEndpointIdGet(
        requestParameters.xAuthToken,
        requestParameters.endpointId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Endpoint 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Endpoint 수정
   * @param {EndpointApiApiV1EndpointsEndpointIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointsEndpointIdPut(
    requestParameters: EndpointApiApiV1EndpointsEndpointIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointApiFp(this.configuration)
      .apiV1EndpointsEndpointIdPut(
        requestParameters.xAuthToken,
        requestParameters.endpointId,
        requestParameters.endpointUpdateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Endpoint 목록 조회
   * @summary Endpoint 목록 조회
   * @param {EndpointApiApiV1EndpointsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointsGet(
    requestParameters: EndpointApiApiV1EndpointsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointApiFp(this.configuration)
      .apiV1EndpointsGet(
        requestParameters.xAuthToken,
        requestParameters.serviceId,
        requestParameters._interface,
        requestParameters.regionId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Endpoint 생성
   * @summary Endpoint 생성
   * @param {EndpointApiApiV1EndpointsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointsPost(
    requestParameters: EndpointApiApiV1EndpointsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointApiFp(this.configuration)
      .apiV1EndpointsPost(
        requestParameters.xAuthToken,
        requestParameters.endpointCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * EndpointGroupsApi - axios parameter creator
 */
export const EndpointGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * EndpointGroup 삭제 (endpoint_group, iam_endpoint_group 테이블에서 삭제)
     * @summary EndpointGroup 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointGroupId endpoint_group_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsEndpointGroupIdDelete: async (
      xAuthToken: string,
      endpointGroupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointGroupsEndpointGroupIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'endpointGroupId' is not null or undefined
      assertParamExists(
        'apiV1EndpointGroupsEndpointGroupIdDelete',
        'endpointGroupId',
        endpointGroupId,
      );
      const localVarPath = `/api/v1/endpoint_groups/{endpoint_group_id}`.replace(
        '{endpoint_group_id}',
        encodeURIComponent(String(endpointGroupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * EndpointGroup 상세 조회
     * @summary EndpointGroup 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointGroupId endpoint_group_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsEndpointGroupIdGet: async (
      xAuthToken: string,
      endpointGroupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointGroupsEndpointGroupIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'endpointGroupId' is not null or undefined
      assertParamExists(
        'apiV1EndpointGroupsEndpointGroupIdGet',
        'endpointGroupId',
        endpointGroupId,
      );
      const localVarPath = `/api/v1/endpoint_groups/{endpoint_group_id}`.replace(
        '{endpoint_group_id}',
        encodeURIComponent(String(endpointGroupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * EndpointGroup 목록 조회 (id, name)
     * @summary EndpointGroup 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointGroupsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/endpoint_groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * EndpointGroup 생성 (endpoint_group, iam_endpoint_group 테이블에 저장)
     * @summary EndpointGroup 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestEndpointGroupCreateRequest} request endpoint group 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsPost: async (
      xAuthToken: string,
      request: RequestEndpointGroupCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1EndpointGroupsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1EndpointGroupsPost', 'request', request);
      const localVarPath = `/api/v1/endpoint_groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에 걸린 endpoint group 필터를 모두 제거한다.  교체 API(`PUT`)는 빈 배열을 400 으로 막으므로 전체 해제는 이 API 가 담당한다. 필터가 없는 프로젝트는 **전 리전 endpoint 가 노출**되는 상태이므로 해제 전에 의도를 확인해야 한다. 이미 필터가 없으면 아무것도 바꾸지 않고 성공한다(멱등).
     * @summary Project 의 EndpointGroup 필터 전체 해제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdEndpointGroupsDelete: async (
      xAuthToken: string,
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEndpointGroupsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEndpointGroupsDelete', 'projectId', projectId);
      const localVarPath = `/api/v1/projects/{project_id}/endpoint-groups`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에 걸린 endpoint group 필터를 요청 내용으로 통째로 교체한다.  **주의 — 증분이 아니라 스냅샷 교체다. 요청에 포함되지 않은 endpoint group 은 모두 삭제된다.** 현재 목록을 먼저 조회하지 않고 일부만 담아 호출하면 나머지 필터가 사라진다.  `endpoint_group_ids` 가 빈 배열이거나 누락되면 400 이다. 필터가 통째로 사라지는 것을 실수로 만들지 않기 위해 막아두었다. 전체 해제가 필요하면 DELETE /api/v1/projects/{project_id}/endpoint-groups 를 쓴다.  추가만 / 삭제만 / 교체를 이 API 하나로 처리한다. endpoint group id 가 하나라도 존재하지 않으면 아무것도 반영하지 않고 404 로 종료한다.
     * @summary Project 의 EndpointGroup 필터 교체
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project_id, 영소문자+숫자 32자
     * @param {RequestReplaceProjectEndpointGroupsRequest} body 교체할 endpoint group id 목록. 1개 이상 필수이며 빈 배열은 400
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdEndpointGroupsPut: async (
      xAuthToken: string,
      projectId: string,
      body: RequestReplaceProjectEndpointGroupsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEndpointGroupsPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEndpointGroupsPut', 'projectId', projectId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEndpointGroupsPut', 'body', body);
      const localVarPath = `/api/v1/projects/{project_id}/endpoint-groups`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndpointGroupsApi - functional programming interface
 */
export const EndpointGroupsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EndpointGroupsApiAxiosParamCreator(configuration);
  return {
    /**
     * EndpointGroup 삭제 (endpoint_group, iam_endpoint_group 테이블에서 삭제)
     * @summary EndpointGroup 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointGroupId endpoint_group_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointGroupsEndpointGroupIdDelete(
      xAuthToken: string,
      endpointGroupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1EndpointGroupsEndpointGroupIdDelete(
          xAuthToken,
          endpointGroupId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointGroupsApi.apiV1EndpointGroupsEndpointGroupIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * EndpointGroup 상세 조회
     * @summary EndpointGroup 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} endpointGroupId endpoint_group_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointGroupsEndpointGroupIdGet(
      xAuthToken: string,
      endpointGroupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointGroupGetResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1EndpointGroupsEndpointGroupIdGet(
          xAuthToken,
          endpointGroupId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointGroupsApi.apiV1EndpointGroupsEndpointGroupIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * EndpointGroup 목록 조회 (id, name)
     * @summary EndpointGroup 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointGroupsGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointGroupListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointGroupsGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointGroupsApi.apiV1EndpointGroupsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * EndpointGroup 생성 (endpoint_group, iam_endpoint_group 테이블에 저장)
     * @summary EndpointGroup 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestEndpointGroupCreateRequest} request endpoint group 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1EndpointGroupsPost(
      xAuthToken: string,
      request: RequestEndpointGroupCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEndpointGroupGetResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EndpointGroupsPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointGroupsApi.apiV1EndpointGroupsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에 걸린 endpoint group 필터를 모두 제거한다.  교체 API(`PUT`)는 빈 배열을 400 으로 막으므로 전체 해제는 이 API 가 담당한다. 필터가 없는 프로젝트는 **전 리전 endpoint 가 노출**되는 상태이므로 해제 전에 의도를 확인해야 한다. 이미 필터가 없으면 아무것도 바꾸지 않고 성공한다(멱등).
     * @summary Project 의 EndpointGroup 필터 전체 해제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdEndpointGroupsDelete(
      xAuthToken: string,
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdEndpointGroupsDelete(
          xAuthToken,
          projectId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointGroupsApi.apiV1ProjectsProjectIdEndpointGroupsDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에 걸린 endpoint group 필터를 요청 내용으로 통째로 교체한다.  **주의 — 증분이 아니라 스냅샷 교체다. 요청에 포함되지 않은 endpoint group 은 모두 삭제된다.** 현재 목록을 먼저 조회하지 않고 일부만 담아 호출하면 나머지 필터가 사라진다.  `endpoint_group_ids` 가 빈 배열이거나 누락되면 400 이다. 필터가 통째로 사라지는 것을 실수로 만들지 않기 위해 막아두었다. 전체 해제가 필요하면 DELETE /api/v1/projects/{project_id}/endpoint-groups 를 쓴다.  추가만 / 삭제만 / 교체를 이 API 하나로 처리한다. endpoint group id 가 하나라도 존재하지 않으면 아무것도 반영하지 않고 404 로 종료한다.
     * @summary Project 의 EndpointGroup 필터 교체
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project_id, 영소문자+숫자 32자
     * @param {RequestReplaceProjectEndpointGroupsRequest} body 교체할 endpoint group id 목록. 1개 이상 필수이며 빈 배열은 400
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdEndpointGroupsPut(
      xAuthToken: string,
      projectId: string,
      body: RequestReplaceProjectEndpointGroupsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseProjectEndpointGroupsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdEndpointGroupsPut(
          xAuthToken,
          projectId,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EndpointGroupsApi.apiV1ProjectsProjectIdEndpointGroupsPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EndpointGroupsApi - factory interface
 */
export const EndpointGroupsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndpointGroupsApiFp(configuration);
  return {
    /**
     * EndpointGroup 삭제 (endpoint_group, iam_endpoint_group 테이블에서 삭제)
     * @summary EndpointGroup 삭제
     * @param {EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsEndpointGroupIdDelete(
      requestParameters: EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1EndpointGroupsEndpointGroupIdDelete(
          requestParameters.xAuthToken,
          requestParameters.endpointGroupId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * EndpointGroup 상세 조회
     * @summary EndpointGroup 상세 조회
     * @param {EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsEndpointGroupIdGet(
      requestParameters: EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointGroupGetResponse> {
      return localVarFp
        .apiV1EndpointGroupsEndpointGroupIdGet(
          requestParameters.xAuthToken,
          requestParameters.endpointGroupId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * EndpointGroup 목록 조회 (id, name)
     * @summary EndpointGroup 목록 조회
     * @param {EndpointGroupsApiApiV1EndpointGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsGet(
      requestParameters: EndpointGroupsApiApiV1EndpointGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointGroupListResponse> {
      return localVarFp
        .apiV1EndpointGroupsGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * EndpointGroup 생성 (endpoint_group, iam_endpoint_group 테이블에 저장)
     * @summary EndpointGroup 생성
     * @param {EndpointGroupsApiApiV1EndpointGroupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1EndpointGroupsPost(
      requestParameters: EndpointGroupsApiApiV1EndpointGroupsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEndpointGroupGetResponse> {
      return localVarFp
        .apiV1EndpointGroupsPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에 걸린 endpoint group 필터를 모두 제거한다.  교체 API(`PUT`)는 빈 배열을 400 으로 막으므로 전체 해제는 이 API 가 담당한다. 필터가 없는 프로젝트는 **전 리전 endpoint 가 노출**되는 상태이므로 해제 전에 의도를 확인해야 한다. 이미 필터가 없으면 아무것도 바꾸지 않고 성공한다(멱등).
     * @summary Project 의 EndpointGroup 필터 전체 해제
     * @param {EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdEndpointGroupsDelete(
      requestParameters: EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdEndpointGroupsDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에 걸린 endpoint group 필터를 요청 내용으로 통째로 교체한다.  **주의 — 증분이 아니라 스냅샷 교체다. 요청에 포함되지 않은 endpoint group 은 모두 삭제된다.** 현재 목록을 먼저 조회하지 않고 일부만 담아 호출하면 나머지 필터가 사라진다.  `endpoint_group_ids` 가 빈 배열이거나 누락되면 400 이다. 필터가 통째로 사라지는 것을 실수로 만들지 않기 위해 막아두었다. 전체 해제가 필요하면 DELETE /api/v1/projects/{project_id}/endpoint-groups 를 쓴다.  추가만 / 삭제만 / 교체를 이 API 하나로 처리한다. endpoint group id 가 하나라도 존재하지 않으면 아무것도 반영하지 않고 404 로 종료한다.
     * @summary Project 의 EndpointGroup 필터 교체
     * @param {EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdEndpointGroupsPut(
      requestParameters: EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectEndpointGroupsResponse> {
      return localVarFp
        .apiV1ProjectsProjectIdEndpointGroupsPut(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.body,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * EndpointGroupsApi - interface
 */
export interface EndpointGroupsApiInterface {
  /**
   * EndpointGroup 삭제 (endpoint_group, iam_endpoint_group 테이블에서 삭제)
   * @summary EndpointGroup 삭제
   * @param {EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointGroupsEndpointGroupIdDelete(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * EndpointGroup 상세 조회
   * @summary EndpointGroup 상세 조회
   * @param {EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointGroupsEndpointGroupIdGet(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointGroupGetResponse>;

  /**
   * EndpointGroup 목록 조회 (id, name)
   * @summary EndpointGroup 목록 조회
   * @param {EndpointGroupsApiApiV1EndpointGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointGroupsGet(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointGroupListResponse>;

  /**
   * EndpointGroup 생성 (endpoint_group, iam_endpoint_group 테이블에 저장)
   * @summary EndpointGroup 생성
   * @param {EndpointGroupsApiApiV1EndpointGroupsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1EndpointGroupsPost(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEndpointGroupGetResponse>;

  /**
   * 프로젝트에 걸린 endpoint group 필터를 모두 제거한다.  교체 API(`PUT`)는 빈 배열을 400 으로 막으므로 전체 해제는 이 API 가 담당한다. 필터가 없는 프로젝트는 **전 리전 endpoint 가 노출**되는 상태이므로 해제 전에 의도를 확인해야 한다. 이미 필터가 없으면 아무것도 바꾸지 않고 성공한다(멱등).
   * @summary Project 의 EndpointGroup 필터 전체 해제
   * @param {EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdEndpointGroupsDelete(
    requestParameters: EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 프로젝트에 걸린 endpoint group 필터를 요청 내용으로 통째로 교체한다.  **주의 — 증분이 아니라 스냅샷 교체다. 요청에 포함되지 않은 endpoint group 은 모두 삭제된다.** 현재 목록을 먼저 조회하지 않고 일부만 담아 호출하면 나머지 필터가 사라진다.  `endpoint_group_ids` 가 빈 배열이거나 누락되면 400 이다. 필터가 통째로 사라지는 것을 실수로 만들지 않기 위해 막아두었다. 전체 해제가 필요하면 DELETE /api/v1/projects/{project_id}/endpoint-groups 를 쓴다.  추가만 / 삭제만 / 교체를 이 API 하나로 처리한다. endpoint group id 가 하나라도 존재하지 않으면 아무것도 반영하지 않고 404 로 종료한다.
   * @summary Project 의 EndpointGroup 필터 교체
   * @param {EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdEndpointGroupsPut(
    requestParameters: EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectEndpointGroupsResponse>;
}

/**
 * Request parameters for apiV1EndpointGroupsEndpointGroupIdDelete operation in EndpointGroupsApi.
 */
export interface EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * endpoint_group_id
   */
  readonly endpointGroupId: string;
}

/**
 * Request parameters for apiV1EndpointGroupsEndpointGroupIdGet operation in EndpointGroupsApi.
 */
export interface EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * endpoint_group_id
   */
  readonly endpointGroupId: string;
}

/**
 * Request parameters for apiV1EndpointGroupsGet operation in EndpointGroupsApi.
 */
export interface EndpointGroupsApiApiV1EndpointGroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1EndpointGroupsPost operation in EndpointGroupsApi.
 */
export interface EndpointGroupsApiApiV1EndpointGroupsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * endpoint group 생성 정보
   */
  readonly request: RequestEndpointGroupCreateRequest;
}

/**
 * Request parameters for apiV1ProjectsProjectIdEndpointGroupsDelete operation in EndpointGroupsApi.
 */
export interface EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project_id, 영소문자+숫자 32자
   */
  readonly projectId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdEndpointGroupsPut operation in EndpointGroupsApi.
 */
export interface EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project_id, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * 교체할 endpoint group id 목록. 1개 이상 필수이며 빈 배열은 400
   */
  readonly body: RequestReplaceProjectEndpointGroupsRequest;
}

/**
 * EndpointGroupsApi - object-oriented interface
 */
export class EndpointGroupsApi extends BaseAPI implements EndpointGroupsApiInterface {
  /**
   * EndpointGroup 삭제 (endpoint_group, iam_endpoint_group 테이블에서 삭제)
   * @summary EndpointGroup 삭제
   * @param {EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointGroupsEndpointGroupIdDelete(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointGroupsApiFp(this.configuration)
      .apiV1EndpointGroupsEndpointGroupIdDelete(
        requestParameters.xAuthToken,
        requestParameters.endpointGroupId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * EndpointGroup 상세 조회
   * @summary EndpointGroup 상세 조회
   * @param {EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointGroupsEndpointGroupIdGet(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsEndpointGroupIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointGroupsApiFp(this.configuration)
      .apiV1EndpointGroupsEndpointGroupIdGet(
        requestParameters.xAuthToken,
        requestParameters.endpointGroupId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * EndpointGroup 목록 조회 (id, name)
   * @summary EndpointGroup 목록 조회
   * @param {EndpointGroupsApiApiV1EndpointGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointGroupsGet(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointGroupsApiFp(this.configuration)
      .apiV1EndpointGroupsGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * EndpointGroup 생성 (endpoint_group, iam_endpoint_group 테이블에 저장)
   * @summary EndpointGroup 생성
   * @param {EndpointGroupsApiApiV1EndpointGroupsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1EndpointGroupsPost(
    requestParameters: EndpointGroupsApiApiV1EndpointGroupsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointGroupsApiFp(this.configuration)
      .apiV1EndpointGroupsPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에 걸린 endpoint group 필터를 모두 제거한다.  교체 API(`PUT`)는 빈 배열을 400 으로 막으므로 전체 해제는 이 API 가 담당한다. 필터가 없는 프로젝트는 **전 리전 endpoint 가 노출**되는 상태이므로 해제 전에 의도를 확인해야 한다. 이미 필터가 없으면 아무것도 바꾸지 않고 성공한다(멱등).
   * @summary Project 의 EndpointGroup 필터 전체 해제
   * @param {EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdEndpointGroupsDelete(
    requestParameters: EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointGroupsApiFp(this.configuration)
      .apiV1ProjectsProjectIdEndpointGroupsDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에 걸린 endpoint group 필터를 요청 내용으로 통째로 교체한다.  **주의 — 증분이 아니라 스냅샷 교체다. 요청에 포함되지 않은 endpoint group 은 모두 삭제된다.** 현재 목록을 먼저 조회하지 않고 일부만 담아 호출하면 나머지 필터가 사라진다.  `endpoint_group_ids` 가 빈 배열이거나 누락되면 400 이다. 필터가 통째로 사라지는 것을 실수로 만들지 않기 위해 막아두었다. 전체 해제가 필요하면 DELETE /api/v1/projects/{project_id}/endpoint-groups 를 쓴다.  추가만 / 삭제만 / 교체를 이 API 하나로 처리한다. endpoint group id 가 하나라도 존재하지 않으면 아무것도 반영하지 않고 404 로 종료한다.
   * @summary Project 의 EndpointGroup 필터 교체
   * @param {EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdEndpointGroupsPut(
    requestParameters: EndpointGroupsApiApiV1ProjectsProjectIdEndpointGroupsPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EndpointGroupsApiFp(this.configuration)
      .apiV1ProjectsProjectIdEndpointGroupsPut(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.body,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * FederatedDomainsApi - axios parameter creator
 */
export const FederatedDomainsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * domain의 연동정보 조회
     * @summary domain의 연동정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdFederatedDomainsGet: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdFederatedDomainsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV11DomainsDomainIdFederatedDomainsGet', 'domainId', domainId);
      const localVarPath = `/api/v1_1/domains/{domain_id}/federated-domains`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 연동 정보 삭제
     * @summary domain 연동 정보 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdFederatedDomainsDelete: async (
      xAuthToken: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdFederatedDomainsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdFederatedDomainsDelete', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/federated-domains`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 연동 정보 생성
     * @summary domain OIDC 연동 정보 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestFederatedDomainCreateRequest} federatedDomainCreateRequest 생성할 연동 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdFederatedDomainsOidcPost: async (
      xAuthToken: string,
      domainId: string,
      federatedDomainCreateRequest: RequestFederatedDomainCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdFederatedDomainsOidcPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdFederatedDomainsOidcPost', 'domainId', domainId);
      // verify required parameter 'federatedDomainCreateRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdFederatedDomainsOidcPost',
        'federatedDomainCreateRequest',
        federatedDomainCreateRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/federated-domains/oidc`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        federatedDomainCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain 연동 정보 생성
     * @summary domain SAML 연동 정보 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestFederatedDomainCreateSamlRequest} federatedDomainCreateSamlRequest 생성할 연동 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdFederatedDomainsSamlPost: async (
      xAuthToken: string,
      domainId: string,
      federatedDomainCreateSamlRequest: RequestFederatedDomainCreateSamlRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdFederatedDomainsSamlPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdFederatedDomainsSamlPost', 'domainId', domainId);
      // verify required parameter 'federatedDomainCreateSamlRequest' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdFederatedDomainsSamlPost',
        'federatedDomainCreateSamlRequest',
        federatedDomainCreateSamlRequest,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/federated-domains/saml`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        federatedDomainCreateSamlRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FederatedDomainsApi - functional programming interface
 */
export const FederatedDomainsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FederatedDomainsApiAxiosParamCreator(configuration);
  return {
    /**
     * domain의 연동정보 조회
     * @summary domain의 연동정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11DomainsDomainIdFederatedDomainsGet(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseFederatedDomainResponseWithIdp>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV11DomainsDomainIdFederatedDomainsGet(
          xAuthToken,
          domainId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FederatedDomainsApi.apiV11DomainsDomainIdFederatedDomainsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 연동 정보 삭제
     * @summary domain 연동 정보 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdFederatedDomainsDelete(
      xAuthToken: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdFederatedDomainsDelete(
          xAuthToken,
          domainId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FederatedDomainsApi.apiV1DomainsDomainIdFederatedDomainsDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 연동 정보 생성
     * @summary domain OIDC 연동 정보 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestFederatedDomainCreateRequest} federatedDomainCreateRequest 생성할 연동 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdFederatedDomainsOidcPost(
      xAuthToken: string,
      domainId: string,
      federatedDomainCreateRequest: RequestFederatedDomainCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFederatedDomainResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdFederatedDomainsOidcPost(
          xAuthToken,
          domainId,
          federatedDomainCreateRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FederatedDomainsApi.apiV1DomainsDomainIdFederatedDomainsOidcPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain 연동 정보 생성
     * @summary domain SAML 연동 정보 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {RequestFederatedDomainCreateSamlRequest} federatedDomainCreateSamlRequest 생성할 연동 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdFederatedDomainsSamlPost(
      xAuthToken: string,
      domainId: string,
      federatedDomainCreateSamlRequest: RequestFederatedDomainCreateSamlRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFederatedDomainResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdFederatedDomainsSamlPost(
          xAuthToken,
          domainId,
          federatedDomainCreateSamlRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FederatedDomainsApi.apiV1DomainsDomainIdFederatedDomainsSamlPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * FederatedDomainsApi - factory interface
 */
export const FederatedDomainsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FederatedDomainsApiFp(configuration);
  return {
    /**
     * domain의 연동정보 조회
     * @summary domain의 연동정보 조회
     * @param {FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11DomainsDomainIdFederatedDomainsGet(
      requestParameters: FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseFederatedDomainResponseWithIdp> {
      return localVarFp
        .apiV11DomainsDomainIdFederatedDomainsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 연동 정보 삭제
     * @summary domain 연동 정보 삭제
     * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdFederatedDomainsDelete(
      requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdFederatedDomainsDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 연동 정보 생성
     * @summary domain OIDC 연동 정보 생성
     * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdFederatedDomainsOidcPost(
      requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseFederatedDomainResponse> {
      return localVarFp
        .apiV1DomainsDomainIdFederatedDomainsOidcPost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.federatedDomainCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain 연동 정보 생성
     * @summary domain SAML 연동 정보 생성
     * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdFederatedDomainsSamlPost(
      requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseFederatedDomainResponse> {
      return localVarFp
        .apiV1DomainsDomainIdFederatedDomainsSamlPost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.federatedDomainCreateSamlRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * FederatedDomainsApi - interface
 */
export interface FederatedDomainsApiInterface {
  /**
   * domain의 연동정보 조회
   * @summary domain의 연동정보 조회
   * @param {FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11DomainsDomainIdFederatedDomainsGet(
    requestParameters: FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseFederatedDomainResponseWithIdp>;

  /**
   * domain 연동 정보 삭제
   * @summary domain 연동 정보 삭제
   * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdFederatedDomainsDelete(
    requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain 연동 정보 생성
   * @summary domain OIDC 연동 정보 생성
   * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdFederatedDomainsOidcPost(
    requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseFederatedDomainResponse>;

  /**
   * domain 연동 정보 생성
   * @summary domain SAML 연동 정보 생성
   * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdFederatedDomainsSamlPost(
    requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseFederatedDomainResponse>;
}

/**
 * Request parameters for apiV11DomainsDomainIdFederatedDomainsGet operation in FederatedDomainsApi.
 */
export interface FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdFederatedDomainsDelete operation in FederatedDomainsApi.
 */
export interface FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdFederatedDomainsOidcPost operation in FederatedDomainsApi.
 */
export interface FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * 생성할 연동 정보
   */
  readonly federatedDomainCreateRequest: RequestFederatedDomainCreateRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdFederatedDomainsSamlPost operation in FederatedDomainsApi.
 */
export interface FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * 생성할 연동 정보
   */
  readonly federatedDomainCreateSamlRequest: RequestFederatedDomainCreateSamlRequest;
}

/**
 * FederatedDomainsApi - object-oriented interface
 */
export class FederatedDomainsApi extends BaseAPI implements FederatedDomainsApiInterface {
  /**
   * domain의 연동정보 조회
   * @summary domain의 연동정보 조회
   * @param {FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11DomainsDomainIdFederatedDomainsGet(
    requestParameters: FederatedDomainsApiApiV11DomainsDomainIdFederatedDomainsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FederatedDomainsApiFp(this.configuration)
      .apiV11DomainsDomainIdFederatedDomainsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 연동 정보 삭제
   * @summary domain 연동 정보 삭제
   * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdFederatedDomainsDelete(
    requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FederatedDomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdFederatedDomainsDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 연동 정보 생성
   * @summary domain OIDC 연동 정보 생성
   * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdFederatedDomainsOidcPost(
    requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsOidcPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FederatedDomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdFederatedDomainsOidcPost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.federatedDomainCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain 연동 정보 생성
   * @summary domain SAML 연동 정보 생성
   * @param {FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdFederatedDomainsSamlPost(
    requestParameters: FederatedDomainsApiApiV1DomainsDomainIdFederatedDomainsSamlPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FederatedDomainsApiFp(this.configuration)
      .apiV1DomainsDomainIdFederatedDomainsSamlPost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.federatedDomainCreateSamlRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * GroupsApi - axios parameter creator
 */
export const GroupsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 지정한 그룹 일괄 삭제
     * @summary 지정한 그룹 일괄 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} groupIds Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11GroupsDelete: async (
      xAuthToken: string,
      groupIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11GroupsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupIds' is not null or undefined
      assertParamExists('apiV11GroupsDelete', 'groupIds', groupIds);
      const localVarPath = `/api/v1_1/groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (groupIds) {
        localVarQueryParameter['group_ids'] = groupIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 그룹에 소속된 사용자 목록 조회
     * @summary 지정한 그룹에 소속된 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {string} [id] user id, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용가능 문자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 전체 목록 반환
     * @param {ApiV11GroupsGroupIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11GroupsGroupIdUsersGet: async (
      xAuthToken: string,
      groupId: string,
      id?: string,
      name?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11GroupsGroupIdUsersGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11GroupsGroupIdUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV11GroupsGroupIdUsersGet', 'groupId', groupId);
      const localVarPath = `/api/v1_1/groups/{group_id}/users`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹의 실효 프로젝트 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
     * @summary 그룹의 실효 프로젝트 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 프로젝트 포함 여부
     * @param {string} [id] Project ID, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12GroupsGroupIdProjectsGet: async (
      xAuthToken: string,
      groupId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      id?: string,
      name?: string,
      inherited?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12GroupsGroupIdProjectsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV12GroupsGroupIdProjectsGet', 'groupId', groupId);
      const localVarPath = `/api/v1_2/groups/{group_id}/projects`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 모든 그룹 목록 조회
     * @summary 모든 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [domainId] group search by domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [domainName] group search by domain name, 영소문자+숫자+특수문자(-)
     * @param {string} [id] group search by group id, 영소문자+숫자 32자
     * @param {string} [name] group search by group name, 영소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      domainId?: string,
      domainName?: string,
      id?: string,
      name?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (domainName !== undefined) {
        localVarQueryParameter['domain_name'] = domainName;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 그룹 삭제
     * @summary 지정한 그룹 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdDelete: async (
      xAuthToken: string,
      groupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdDelete', 'groupId', groupId);
      const localVarPath = `/api/v1/groups/{group_id}`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹 정보 상세 조회
     * @summary 그룹 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdGet: async (
      xAuthToken: string,
      groupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdGet', 'groupId', groupId);
      const localVarPath = `/api/v1/groups/{group_id}`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 그룹이 권한을 가진 프로젝트 목록을 조회 Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/groups/{group_id}/projects 로 대체되었다.
     * @summary 지정한 그룹이 권한을 가진 프로젝트 목록을 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 프로젝트 포함 여부
     * @param {string} [id] Project ID, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdProjectsGet: async (
      xAuthToken: string,
      groupId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      id?: string,
      name?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdProjectsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdProjectsGet', 'groupId', groupId);
      const localVarPath = `/api/v1/groups/{group_id}/projects`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 그룹 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {RequestGroupUpdateRequest} groupUpdateRequest 그룹 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdPut: async (
      xAuthToken: string,
      groupId: string,
      groupUpdateRequest: RequestGroupUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdPut', 'groupId', groupId);
      // verify required parameter 'groupUpdateRequest' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdPut', 'groupUpdateRequest', groupUpdateRequest);
      const localVarPath = `/api/v1/groups/{group_id}`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        groupUpdateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 그룹에서 여러 사용자 제거
     * @summary 지정한 그룹에서 여러 사용자 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {Array<string>} userIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersDelete: async (
      xAuthToken: string,
      groupId: string,
      userIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersDelete', 'groupId', groupId);
      // verify required parameter 'userIds' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersDelete', 'userIds', userIds);
      const localVarPath = `/api/v1/groups/{group_id}/users`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userIds) {
        localVarQueryParameter['user_ids'] = userIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
     * @summary 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {Array<string>} names user name
     * @param {string} userType user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersNameMatchGet: async (
      xAuthToken: string,
      groupId: string,
      names: Array<string>,
      userType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameMatchGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameMatchGet', 'groupId', groupId);
      // verify required parameter 'names' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameMatchGet', 'names', names);
      // verify required parameter 'userType' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameMatchGet', 'userType', userType);
      const localVarPath = `/api/v1/groups/{group_id}/users/name/match`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (names) {
        localVarQueryParameter['names'] = names;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * get Users Suggestions of Group
     * @summary Suggest Users of Group
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {string} name user prefix search by name, 이메일 사용 가능 문자
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum} [sortOrder] 이름 정렬 방향
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersNameSuggestGet: async (
      xAuthToken: string,
      groupId: string,
      name: string,
      size?: number,
      sortOrder?: ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameSuggestGet', 'groupId', groupId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersNameSuggestGet', 'name', name);
      const localVarPath = `/api/v1/groups/{group_id}/users/name/suggest`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 그룹에 사용자 추가 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 그룹에 사용자 추가
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {RequestCloudGroupUsersRequest} userIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersPut: async (
      xAuthToken: string,
      groupId: string,
      userIds: RequestCloudGroupUsersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersPut', 'groupId', groupId);
      // verify required parameter 'userIds' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersPut', 'userIds', userIds);
      const localVarPath = `/api/v1/groups/{group_id}/users`.replace(
        '{group_id}',
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userIds,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 그룹에 user id가 존재 하는지 확인. 그룹에 user id가 존재하는 경우 http status 204, 존재하지 않는 경우 http status 404
     * @summary 지정한 그룹에 user id가 존재 하는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {string} userId user_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersUserIdHead: async (
      xAuthToken: string,
      groupId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersUserIdHead', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersUserIdHead', 'groupId', groupId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1GroupsGroupIdUsersUserIdHead', 'userId', userId);
      const localVarPath = `/api/v1/groups/{group_id}/users/{user_id}`
        .replace('{group_id}', encodeURIComponent(String(groupId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 그룹 생성
     * @summary 그룹 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestGroupCreateRequest} groupCreateRequest 그룹 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsPost: async (
      xAuthToken: string,
      groupCreateRequest: RequestGroupCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1GroupsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'groupCreateRequest' is not null or undefined
      assertParamExists('apiV1GroupsPost', 'groupCreateRequest', groupCreateRequest);
      const localVarPath = `/api/v1/groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        groupCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GroupsApi - functional programming interface
 */
export const GroupsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GroupsApiAxiosParamCreator(configuration);
  return {
    /**
     * 지정한 그룹 일괄 삭제
     * @summary 지정한 그룹 일괄 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} groupIds Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11GroupsDelete(
      xAuthToken: string,
      groupIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGroupBulkDeleteResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11GroupsDelete(
        xAuthToken,
        groupIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV11GroupsDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 그룹에 소속된 사용자 목록 조회
     * @summary 지정한 그룹에 소속된 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {string} [id] user id, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용가능 문자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 전체 목록 반환
     * @param {ApiV11GroupsGroupIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11GroupsGroupIdUsersGet(
      xAuthToken: string,
      groupId: string,
      id?: string,
      name?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11GroupsGroupIdUsersGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListUserByGroupResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11GroupsGroupIdUsersGet(
        xAuthToken,
        groupId,
        id,
        name,
        offset,
        size,
        sortOrder,
        sortColumn,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV11GroupsGroupIdUsersGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹의 실효 프로젝트 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
     * @summary 그룹의 실효 프로젝트 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 프로젝트 포함 여부
     * @param {string} [id] Project ID, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12GroupsGroupIdProjectsGet(
      xAuthToken: string,
      groupId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      id?: string,
      name?: string,
      inherited?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectListByGroupResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV12GroupsGroupIdProjectsGet(
        xAuthToken,
        groupId,
        size,
        offset,
        includeDisabled,
        id,
        name,
        inherited,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV12GroupsGroupIdProjectsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 모든 그룹 목록 조회
     * @summary 모든 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [domainId] group search by domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} [domainName] group search by domain name, 영소문자+숫자+특수문자(-)
     * @param {string} [id] group search by group id, 영소문자+숫자 32자
     * @param {string} [name] group search by group name, 영소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      domainId?: string,
      domainName?: string,
      id?: string,
      name?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGroupListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGet(
        xAuthToken,
        size,
        offset,
        domainId,
        domainName,
        id,
        name,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 그룹 삭제
     * @summary 지정한 그룹 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdDelete(
      xAuthToken: string,
      groupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdDelete(
        xAuthToken,
        groupId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹 정보 상세 조회
     * @summary 그룹 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdGet(
      xAuthToken: string,
      groupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGroupDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdGet(
        xAuthToken,
        groupId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 그룹이 권한을 가진 프로젝트 목록을 조회 Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/groups/{group_id}/projects 로 대체되었다.
     * @summary 지정한 그룹이 권한을 가진 프로젝트 목록을 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 프로젝트 포함 여부
     * @param {string} [id] Project ID, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdProjectsGet(
      xAuthToken: string,
      groupId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      id?: string,
      name?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectListByGroupResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdProjectsGet(
        xAuthToken,
        groupId,
        size,
        offset,
        includeDisabled,
        id,
        name,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdProjectsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 그룹 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {RequestGroupUpdateRequest} groupUpdateRequest 그룹 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdPut(
      xAuthToken: string,
      groupId: string,
      groupUpdateRequest: RequestGroupUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGroupDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdPut(
        xAuthToken,
        groupId,
        groupUpdateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 그룹에서 여러 사용자 제거
     * @summary 지정한 그룹에서 여러 사용자 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {Array<string>} userIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdUsersDelete(
      xAuthToken: string,
      groupId: string,
      userIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdUsersDelete(
        xAuthToken,
        groupId,
        userIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdUsersDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
     * @summary 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {Array<string>} names user name
     * @param {string} userType user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdUsersNameMatchGet(
      xAuthToken: string,
      groupId: string,
      names: Array<string>,
      userType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUserIdMap>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdUsersNameMatchGet(
        xAuthToken,
        groupId,
        names,
        userType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdUsersNameMatchGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * get Users Suggestions of Group
     * @summary Suggest Users of Group
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {string} name user prefix search by name, 이메일 사용 가능 문자
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum} [sortOrder] 이름 정렬 방향
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdUsersNameSuggestGet(
      xAuthToken: string,
      groupId: string,
      name: string,
      size?: number,
      sortOrder?: ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuggestedUsers>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1GroupsGroupIdUsersNameSuggestGet(
          xAuthToken,
          groupId,
          name,
          size,
          sortOrder,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdUsersNameSuggestGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 그룹에 사용자 추가 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 그룹에 사용자 추가
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {RequestCloudGroupUsersRequest} userIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdUsersPut(
      xAuthToken: string,
      groupId: string,
      userIds: RequestCloudGroupUsersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdUsersPut(
        xAuthToken,
        groupId,
        userIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdUsersPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 그룹에 user id가 존재 하는지 확인. 그룹에 user id가 존재하는 경우 http status 204, 존재하지 않는 경우 http status 404
     * @summary 지정한 그룹에 user id가 존재 하는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} groupId group_id, 영소문자+숫자 32자
     * @param {string} userId user_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsGroupIdUsersUserIdHead(
      xAuthToken: string,
      groupId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsGroupIdUsersUserIdHead(
        xAuthToken,
        groupId,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsGroupIdUsersUserIdHead']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 그룹 생성
     * @summary 그룹 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestGroupCreateRequest} groupCreateRequest 그룹 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1GroupsPost(
      xAuthToken: string,
      groupCreateRequest: RequestGroupCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGroupDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1GroupsPost(
        xAuthToken,
        groupCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.apiV1GroupsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * GroupsApi - factory interface
 */
export const GroupsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GroupsApiFp(configuration);
  return {
    /**
     * 지정한 그룹 일괄 삭제
     * @summary 지정한 그룹 일괄 삭제
     * @param {GroupsApiApiV11GroupsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11GroupsDelete(
      requestParameters: GroupsApiApiV11GroupsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGroupBulkDeleteResponse> {
      return localVarFp
        .apiV11GroupsDelete(requestParameters.xAuthToken, requestParameters.groupIds, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 그룹에 소속된 사용자 목록 조회
     * @summary 지정한 그룹에 소속된 사용자 목록 조회
     * @param {GroupsApiApiV11GroupsGroupIdUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11GroupsGroupIdUsersGet(
      requestParameters: GroupsApiApiV11GroupsGroupIdUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListUserByGroupResponse> {
      return localVarFp
        .apiV11GroupsGroupIdUsersGet(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.id,
          requestParameters.name,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹의 실효 프로젝트 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
     * @summary 그룹의 실효 프로젝트 목록 조회
     * @param {GroupsApiApiV12GroupsGroupIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12GroupsGroupIdProjectsGet(
      requestParameters: GroupsApiApiV12GroupsGroupIdProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectListByGroupResponse> {
      return localVarFp
        .apiV12GroupsGroupIdProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.includeDisabled,
          requestParameters.id,
          requestParameters.name,
          requestParameters.inherited,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 모든 그룹 목록 조회
     * @summary 모든 그룹 목록 조회
     * @param {GroupsApiApiV1GroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGet(
      requestParameters: GroupsApiApiV1GroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGroupListResponse> {
      return localVarFp
        .apiV1GroupsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.domainId,
          requestParameters.domainName,
          requestParameters.id,
          requestParameters.name,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 그룹 삭제
     * @summary 지정한 그룹 삭제
     * @param {GroupsApiApiV1GroupsGroupIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdDelete(
      requestParameters: GroupsApiApiV1GroupsGroupIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1GroupsGroupIdDelete(requestParameters.xAuthToken, requestParameters.groupId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹 정보 상세 조회
     * @summary 그룹 정보 상세 조회
     * @param {GroupsApiApiV1GroupsGroupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdGet(
      requestParameters: GroupsApiApiV1GroupsGroupIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGroupDto> {
      return localVarFp
        .apiV1GroupsGroupIdGet(requestParameters.xAuthToken, requestParameters.groupId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 그룹이 권한을 가진 프로젝트 목록을 조회 Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/groups/{group_id}/projects 로 대체되었다.
     * @summary 지정한 그룹이 권한을 가진 프로젝트 목록을 조회
     * @param {GroupsApiApiV1GroupsGroupIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdProjectsGet(
      requestParameters: GroupsApiApiV1GroupsGroupIdProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectListByGroupResponse> {
      return localVarFp
        .apiV1GroupsGroupIdProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.includeDisabled,
          requestParameters.id,
          requestParameters.name,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 그룹 정보 수정
     * @param {GroupsApiApiV1GroupsGroupIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdPut(
      requestParameters: GroupsApiApiV1GroupsGroupIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGroupDto> {
      return localVarFp
        .apiV1GroupsGroupIdPut(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.groupUpdateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 그룹에서 여러 사용자 제거
     * @summary 지정한 그룹에서 여러 사용자 제거
     * @param {GroupsApiApiV1GroupsGroupIdUsersDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersDelete(
      requestParameters: GroupsApiApiV1GroupsGroupIdUsersDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1GroupsGroupIdUsersDelete(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.userIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
     * @summary 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인
     * @param {GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersNameMatchGet(
      requestParameters: GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUserIdMap> {
      return localVarFp
        .apiV1GroupsGroupIdUsersNameMatchGet(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.names,
          requestParameters.userType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * get Users Suggestions of Group
     * @summary Suggest Users of Group
     * @param {GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersNameSuggestGet(
      requestParameters: GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSuggestedUsers> {
      return localVarFp
        .apiV1GroupsGroupIdUsersNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.name,
          requestParameters.size,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 그룹에 사용자 추가 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 그룹에 사용자 추가
     * @param {GroupsApiApiV1GroupsGroupIdUsersPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersPut(
      requestParameters: GroupsApiApiV1GroupsGroupIdUsersPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1GroupsGroupIdUsersPut(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.userIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 그룹에 user id가 존재 하는지 확인. 그룹에 user id가 존재하는 경우 http status 204, 존재하지 않는 경우 http status 404
     * @summary 지정한 그룹에 user id가 존재 하는지 확인.
     * @param {GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsGroupIdUsersUserIdHead(
      requestParameters: GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1GroupsGroupIdUsersUserIdHead(
          requestParameters.xAuthToken,
          requestParameters.groupId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 그룹 생성
     * @summary 그룹 생성
     * @param {GroupsApiApiV1GroupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1GroupsPost(
      requestParameters: GroupsApiApiV1GroupsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGroupDto> {
      return localVarFp
        .apiV1GroupsPost(
          requestParameters.xAuthToken,
          requestParameters.groupCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * GroupsApi - interface
 */
export interface GroupsApiInterface {
  /**
   * 지정한 그룹 일괄 삭제
   * @summary 지정한 그룹 일괄 삭제
   * @param {GroupsApiApiV11GroupsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11GroupsDelete(
    requestParameters: GroupsApiApiV11GroupsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGroupBulkDeleteResponse>;

  /**
   * 지정한 그룹에 소속된 사용자 목록 조회
   * @summary 지정한 그룹에 소속된 사용자 목록 조회
   * @param {GroupsApiApiV11GroupsGroupIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11GroupsGroupIdUsersGet(
    requestParameters: GroupsApiApiV11GroupsGroupIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListUserByGroupResponse>;

  /**
   * 그룹의 실효 프로젝트 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
   * @summary 그룹의 실효 프로젝트 목록 조회
   * @param {GroupsApiApiV12GroupsGroupIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12GroupsGroupIdProjectsGet(
    requestParameters: GroupsApiApiV12GroupsGroupIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectListByGroupResponse>;

  /**
   * 모든 그룹 목록 조회
   * @summary 모든 그룹 목록 조회
   * @param {GroupsApiApiV1GroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGet(
    requestParameters: GroupsApiApiV1GroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGroupListResponse>;

  /**
   * 지정한 그룹 삭제
   * @summary 지정한 그룹 삭제
   * @param {GroupsApiApiV1GroupsGroupIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdDelete(
    requestParameters: GroupsApiApiV1GroupsGroupIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 그룹 정보 상세 조회
   * @summary 그룹 정보 상세 조회
   * @param {GroupsApiApiV1GroupsGroupIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGroupDto>;

  /**
   * 지정한 그룹이 권한을 가진 프로젝트 목록을 조회 Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/groups/{group_id}/projects 로 대체되었다.
   * @summary 지정한 그룹이 권한을 가진 프로젝트 목록을 조회
   * @param {GroupsApiApiV1GroupsGroupIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdProjectsGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectListByGroupResponse>;

  /**
   * 그룹 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 그룹 정보 수정
   * @param {GroupsApiApiV1GroupsGroupIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdPut(
    requestParameters: GroupsApiApiV1GroupsGroupIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGroupDto>;

  /**
   * 지정한 그룹에서 여러 사용자 제거
   * @summary 지정한 그룹에서 여러 사용자 제거
   * @param {GroupsApiApiV1GroupsGroupIdUsersDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdUsersDelete(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
   * @summary 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인
   * @param {GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdUsersNameMatchGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUserIdMap>;

  /**
   * get Users Suggestions of Group
   * @summary Suggest Users of Group
   * @param {GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdUsersNameSuggestGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSuggestedUsers>;

  /**
   * 지정한 그룹에 사용자 추가 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 그룹에 사용자 추가
   * @param {GroupsApiApiV1GroupsGroupIdUsersPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdUsersPut(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 그룹에 user id가 존재 하는지 확인. 그룹에 user id가 존재하는 경우 http status 204, 존재하지 않는 경우 http status 404
   * @summary 지정한 그룹에 user id가 존재 하는지 확인.
   * @param {GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsGroupIdUsersUserIdHead(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 그룹 생성
   * @summary 그룹 생성
   * @param {GroupsApiApiV1GroupsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1GroupsPost(
    requestParameters: GroupsApiApiV1GroupsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGroupDto>;
}

/**
 * Request parameters for apiV11GroupsDelete operation in GroupsApi.
 */
export interface GroupsApiApiV11GroupsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupIds: Array<string>;
}

/**
 * Request parameters for apiV11GroupsGroupIdUsersGet operation in GroupsApi.
 */
export interface GroupsApiApiV11GroupsGroupIdUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * group_id, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * user id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * user prefix search by name, 이메일 사용가능 문자
   */
  readonly name?: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0일 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV11GroupsGroupIdUsersGetSortOrderEnum;

  /**
   * sort by (name)
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV12GroupsGroupIdProjectsGet operation in GroupsApi.
 */
export interface GroupsApiApiV12GroupsGroupIdProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * 비활성화 프로젝트 포함 여부
   */
  readonly includeDisabled?: boolean;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * project prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
   */
  readonly inherited?: boolean;
}

/**
 * Request parameters for apiV1GroupsGet operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * group search by domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId?: string;

  /**
   * group search by domain name, 영소문자+숫자+특수문자(-)
   */
  readonly domainName?: string;

  /**
   * group search by group id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * group search by group name, 영소문자+숫자+특수문자(-)
   */
  readonly name?: string;
}

/**
 * Request parameters for apiV1GroupsGroupIdDelete operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * group_id, 영소문자+숫자 32자
   */
  readonly groupId: string;
}

/**
 * Request parameters for apiV1GroupsGroupIdGet operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * group_id, 영소문자+숫자 32자
   */
  readonly groupId: string;
}

/**
 * Request parameters for apiV1GroupsGroupIdProjectsGet operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * 비활성화 프로젝트 포함 여부
   */
  readonly includeDisabled?: boolean;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * project prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;
}

/**
 * Request parameters for apiV1GroupsGroupIdPut operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * group_id, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * 그룹 수정 정보
   */
  readonly groupUpdateRequest: RequestGroupUpdateRequest;
}

/**
 * Request parameters for apiV1GroupsGroupIdUsersDelete operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdUsersDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userIds: Array<string>;
}

/**
 * Request parameters for apiV1GroupsGroupIdUsersNameMatchGet operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * user name
   */
  readonly names: Array<string>;

  /**
   * user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
   */
  readonly userType: string;
}

/**
 * Request parameters for apiV1GroupsGroupIdUsersNameSuggestGet operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * user prefix search by name, 이메일 사용 가능 문자
   */
  readonly name: string;

  /**
   * list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;

  /**
   * 이름 정렬 방향
   */
  readonly sortOrder?: ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum;
}

/**
 * Request parameters for apiV1GroupsGroupIdUsersPut operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdUsersPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userIds: RequestCloudGroupUsersRequest;
}

/**
 * Request parameters for apiV1GroupsGroupIdUsersUserIdHead operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * group_id, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * user_id, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1GroupsPost operation in GroupsApi.
 */
export interface GroupsApiApiV1GroupsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 그룹 생성 정보
   */
  readonly groupCreateRequest: RequestGroupCreateRequest;
}

/**
 * GroupsApi - object-oriented interface
 */
export class GroupsApi extends BaseAPI implements GroupsApiInterface {
  /**
   * 지정한 그룹 일괄 삭제
   * @summary 지정한 그룹 일괄 삭제
   * @param {GroupsApiApiV11GroupsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11GroupsDelete(
    requestParameters: GroupsApiApiV11GroupsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV11GroupsDelete(requestParameters.xAuthToken, requestParameters.groupIds, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 그룹에 소속된 사용자 목록 조회
   * @summary 지정한 그룹에 소속된 사용자 목록 조회
   * @param {GroupsApiApiV11GroupsGroupIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11GroupsGroupIdUsersGet(
    requestParameters: GroupsApiApiV11GroupsGroupIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV11GroupsGroupIdUsersGet(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.id,
        requestParameters.name,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹의 실효 프로젝트 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
   * @summary 그룹의 실효 프로젝트 목록 조회
   * @param {GroupsApiApiV12GroupsGroupIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12GroupsGroupIdProjectsGet(
    requestParameters: GroupsApiApiV12GroupsGroupIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV12GroupsGroupIdProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.includeDisabled,
        requestParameters.id,
        requestParameters.name,
        requestParameters.inherited,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 모든 그룹 목록 조회
   * @summary 모든 그룹 목록 조회
   * @param {GroupsApiApiV1GroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGet(
    requestParameters: GroupsApiApiV1GroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.domainId,
        requestParameters.domainName,
        requestParameters.id,
        requestParameters.name,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 그룹 삭제
   * @summary 지정한 그룹 삭제
   * @param {GroupsApiApiV1GroupsGroupIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdDelete(
    requestParameters: GroupsApiApiV1GroupsGroupIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdDelete(requestParameters.xAuthToken, requestParameters.groupId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹 정보 상세 조회
   * @summary 그룹 정보 상세 조회
   * @param {GroupsApiApiV1GroupsGroupIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdGet(requestParameters.xAuthToken, requestParameters.groupId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 그룹이 권한을 가진 프로젝트 목록을 조회 Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/groups/{group_id}/projects 로 대체되었다.
   * @summary 지정한 그룹이 권한을 가진 프로젝트 목록을 조회
   * @param {GroupsApiApiV1GroupsGroupIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdProjectsGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.includeDisabled,
        requestParameters.id,
        requestParameters.name,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 그룹 정보 수정
   * @param {GroupsApiApiV1GroupsGroupIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdPut(
    requestParameters: GroupsApiApiV1GroupsGroupIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdPut(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.groupUpdateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 그룹에서 여러 사용자 제거
   * @summary 지정한 그룹에서 여러 사용자 제거
   * @param {GroupsApiApiV1GroupsGroupIdUsersDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdUsersDelete(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdUsersDelete(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.userIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음.
   * @summary 사용하려는 다수의 이름을 group 내에 존재하는 이름인지 확인
   * @param {GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdUsersNameMatchGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersNameMatchGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdUsersNameMatchGet(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.names,
        requestParameters.userType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * get Users Suggestions of Group
   * @summary Suggest Users of Group
   * @param {GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdUsersNameSuggestGet(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdUsersNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.name,
        requestParameters.size,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 그룹에 사용자 추가 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 그룹에 사용자 추가
   * @param {GroupsApiApiV1GroupsGroupIdUsersPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdUsersPut(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdUsersPut(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.userIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 그룹에 user id가 존재 하는지 확인. 그룹에 user id가 존재하는 경우 http status 204, 존재하지 않는 경우 http status 404
   * @summary 지정한 그룹에 user id가 존재 하는지 확인.
   * @param {GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsGroupIdUsersUserIdHead(
    requestParameters: GroupsApiApiV1GroupsGroupIdUsersUserIdHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsGroupIdUsersUserIdHead(
        requestParameters.xAuthToken,
        requestParameters.groupId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 그룹 생성
   * @summary 그룹 생성
   * @param {GroupsApiApiV1GroupsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1GroupsPost(
    requestParameters: GroupsApiApiV1GroupsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return GroupsApiFp(this.configuration)
      .apiV1GroupsPost(requestParameters.xAuthToken, requestParameters.groupCreateRequest, options)
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV11GroupsGroupIdUsersGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV11GroupsGroupIdUsersGetSortOrderEnum =
  (typeof ApiV11GroupsGroupIdUsersGetSortOrderEnum)[keyof typeof ApiV11GroupsGroupIdUsersGetSortOrderEnum];
export const ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum =
  (typeof ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum)[keyof typeof ApiV1GroupsGroupIdUsersNameSuggestGetSortOrderEnum];

/**
 * HistoryApi - axios parameter creator
 */
export const HistoryApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 삭제된 Project 목록 조회. (시스템 scope 인증 token만 가능)
     * @summary 삭제된 Project 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId] domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} [projectIds] project search by project id, 영소문자+숫자 32자
     * @param {Array<string>} [names] project search by project name, 영대소문자+숫자+특수문자(-)
     * @param {string} [startAt] project search by UTC 기준 삭제 시작 일자. example : 2021-03-30T06:00:00Z
     * @param {string} [endAt] user search by UTC 기준 삭제 종료 일자. example : 2021-03-30T07:00:00Z
     * @param {number} [offset] offset
     * @param {number} [size] list size 0일 경우 전체 반환
     * @param {ApiV1HistoryDeletedProjectsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HistoryDeletedProjectsGet: async (
      xAuthToken: string,
      domainId?: string,
      projectIds?: Array<string>,
      names?: Array<string>,
      startAt?: string,
      endAt?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1HistoryDeletedProjectsGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1HistoryDeletedProjectsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/history/deleted-projects`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (projectIds) {
        localVarQueryParameter['project_ids'] = projectIds;
      }

      if (names) {
        localVarQueryParameter['names'] = names;
      }

      if (startAt !== undefined) {
        localVarQueryParameter['start_at'] = startAt;
      }

      if (endAt !== undefined) {
        localVarQueryParameter['end_at'] = endAt;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 삭제된 사용자 목록 조회. (시스템 scope 인증 token만 가능)
     * @summary 삭제된 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId] domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} [userIds] user search by user id, 영소문자+숫자 32자
     * @param {Array<string>} [names] user search by user name, 이메일 사용 가능 문자
     * @param {string} [startAt] user search by UTC 기준 삭제 시작 일자. example : 2021-03-30T06:00:00Z
     * @param {string} [endAt] user search by UTC 기준 삭제 종료 일자. example : 2021-03-30T07:00:00Z
     * @param {number} [offset] offset
     * @param {number} [size] list size, 0일 경우 전체 반환
     * @param {ApiV1HistoryDeletedUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HistoryDeletedUsersGet: async (
      xAuthToken: string,
      domainId?: string,
      userIds?: Array<string>,
      names?: Array<string>,
      startAt?: string,
      endAt?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1HistoryDeletedUsersGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1HistoryDeletedUsersGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/history/deleted-users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (userIds) {
        localVarQueryParameter['user_ids'] = userIds;
      }

      if (names) {
        localVarQueryParameter['names'] = names;
      }

      if (startAt !== undefined) {
        localVarQueryParameter['start_at'] = startAt;
      }

      if (endAt !== undefined) {
        localVarQueryParameter['end_at'] = endAt;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HistoryApi - functional programming interface
 */
export const HistoryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HistoryApiAxiosParamCreator(configuration);
  return {
    /**
     * 삭제된 Project 목록 조회. (시스템 scope 인증 token만 가능)
     * @summary 삭제된 Project 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId] domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} [projectIds] project search by project id, 영소문자+숫자 32자
     * @param {Array<string>} [names] project search by project name, 영대소문자+숫자+특수문자(-)
     * @param {string} [startAt] project search by UTC 기준 삭제 시작 일자. example : 2021-03-30T06:00:00Z
     * @param {string} [endAt] user search by UTC 기준 삭제 종료 일자. example : 2021-03-30T07:00:00Z
     * @param {number} [offset] offset
     * @param {number} [size] list size 0일 경우 전체 반환
     * @param {ApiV1HistoryDeletedProjectsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1HistoryDeletedProjectsGet(
      xAuthToken: string,
      domainId?: string,
      projectIds?: Array<string>,
      names?: Array<string>,
      startAt?: string,
      endAt?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1HistoryDeletedProjectsGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRemProjects>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HistoryDeletedProjectsGet(
        xAuthToken,
        domainId,
        projectIds,
        names,
        startAt,
        endAt,
        offset,
        size,
        sortOrder,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HistoryApi.apiV1HistoryDeletedProjectsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 삭제된 사용자 목록 조회. (시스템 scope 인증 token만 가능)
     * @summary 삭제된 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId] domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {Array<string>} [userIds] user search by user id, 영소문자+숫자 32자
     * @param {Array<string>} [names] user search by user name, 이메일 사용 가능 문자
     * @param {string} [startAt] user search by UTC 기준 삭제 시작 일자. example : 2021-03-30T06:00:00Z
     * @param {string} [endAt] user search by UTC 기준 삭제 종료 일자. example : 2021-03-30T07:00:00Z
     * @param {number} [offset] offset
     * @param {number} [size] list size, 0일 경우 전체 반환
     * @param {ApiV1HistoryDeletedUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1HistoryDeletedUsersGet(
      xAuthToken: string,
      domainId?: string,
      userIds?: Array<string>,
      names?: Array<string>,
      startAt?: string,
      endAt?: string,
      offset?: number,
      size?: number,
      sortOrder?: ApiV1HistoryDeletedUsersGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudDeletedUsers>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HistoryDeletedUsersGet(
        xAuthToken,
        domainId,
        userIds,
        names,
        startAt,
        endAt,
        offset,
        size,
        sortOrder,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HistoryApi.apiV1HistoryDeletedUsersGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * HistoryApi - factory interface
 */
export const HistoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HistoryApiFp(configuration);
  return {
    /**
     * 삭제된 Project 목록 조회. (시스템 scope 인증 token만 가능)
     * @summary 삭제된 Project 목록 조회
     * @param {HistoryApiApiV1HistoryDeletedProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HistoryDeletedProjectsGet(
      requestParameters: HistoryApiApiV1HistoryDeletedProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseRemProjects> {
      return localVarFp
        .apiV1HistoryDeletedProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.projectIds,
          requestParameters.names,
          requestParameters.startAt,
          requestParameters.endAt,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 삭제된 사용자 목록 조회. (시스템 scope 인증 token만 가능)
     * @summary 삭제된 사용자 목록 조회
     * @param {HistoryApiApiV1HistoryDeletedUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HistoryDeletedUsersGet(
      requestParameters: HistoryApiApiV1HistoryDeletedUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudDeletedUsers> {
      return localVarFp
        .apiV1HistoryDeletedUsersGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userIds,
          requestParameters.names,
          requestParameters.startAt,
          requestParameters.endAt,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * HistoryApi - interface
 */
export interface HistoryApiInterface {
  /**
   * 삭제된 Project 목록 조회. (시스템 scope 인증 token만 가능)
   * @summary 삭제된 Project 목록 조회
   * @param {HistoryApiApiV1HistoryDeletedProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1HistoryDeletedProjectsGet(
    requestParameters: HistoryApiApiV1HistoryDeletedProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseRemProjects>;

  /**
   * 삭제된 사용자 목록 조회. (시스템 scope 인증 token만 가능)
   * @summary 삭제된 사용자 목록 조회
   * @param {HistoryApiApiV1HistoryDeletedUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1HistoryDeletedUsersGet(
    requestParameters: HistoryApiApiV1HistoryDeletedUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudDeletedUsers>;
}

/**
 * Request parameters for apiV1HistoryDeletedProjectsGet operation in HistoryApi.
 */
export interface HistoryApiApiV1HistoryDeletedProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId?: string;

  /**
   * project search by project id, 영소문자+숫자 32자
   */
  readonly projectIds?: Array<string>;

  /**
   * project search by project name, 영대소문자+숫자+특수문자(-)
   */
  readonly names?: Array<string>;

  /**
   * project search by UTC 기준 삭제 시작 일자. example : 2021-03-30T06:00:00Z
   */
  readonly startAt?: string;

  /**
   * user search by UTC 기준 삭제 종료 일자. example : 2021-03-30T07:00:00Z
   */
  readonly endAt?: string;

  /**
   * offset
   */
  readonly offset?: number;

  /**
   * list size 0일 경우 전체 반환
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV1HistoryDeletedProjectsGetSortOrderEnum;
}

/**
 * Request parameters for apiV1HistoryDeletedUsersGet operation in HistoryApi.
 */
export interface HistoryApiApiV1HistoryDeletedUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId?: string;

  /**
   * user search by user id, 영소문자+숫자 32자
   */
  readonly userIds?: Array<string>;

  /**
   * user search by user name, 이메일 사용 가능 문자
   */
  readonly names?: Array<string>;

  /**
   * user search by UTC 기준 삭제 시작 일자. example : 2021-03-30T06:00:00Z
   */
  readonly startAt?: string;

  /**
   * user search by UTC 기준 삭제 종료 일자. example : 2021-03-30T07:00:00Z
   */
  readonly endAt?: string;

  /**
   * offset
   */
  readonly offset?: number;

  /**
   * list size, 0일 경우 전체 반환
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV1HistoryDeletedUsersGetSortOrderEnum;
}

/**
 * HistoryApi - object-oriented interface
 */
export class HistoryApi extends BaseAPI implements HistoryApiInterface {
  /**
   * 삭제된 Project 목록 조회. (시스템 scope 인증 token만 가능)
   * @summary 삭제된 Project 목록 조회
   * @param {HistoryApiApiV1HistoryDeletedProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1HistoryDeletedProjectsGet(
    requestParameters: HistoryApiApiV1HistoryDeletedProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HistoryApiFp(this.configuration)
      .apiV1HistoryDeletedProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.projectIds,
        requestParameters.names,
        requestParameters.startAt,
        requestParameters.endAt,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 삭제된 사용자 목록 조회. (시스템 scope 인증 token만 가능)
   * @summary 삭제된 사용자 목록 조회
   * @param {HistoryApiApiV1HistoryDeletedUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1HistoryDeletedUsersGet(
    requestParameters: HistoryApiApiV1HistoryDeletedUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HistoryApiFp(this.configuration)
      .apiV1HistoryDeletedUsersGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userIds,
        requestParameters.names,
        requestParameters.startAt,
        requestParameters.endAt,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV1HistoryDeletedProjectsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1HistoryDeletedProjectsGetSortOrderEnum =
  (typeof ApiV1HistoryDeletedProjectsGetSortOrderEnum)[keyof typeof ApiV1HistoryDeletedProjectsGetSortOrderEnum];
export const ApiV1HistoryDeletedUsersGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1HistoryDeletedUsersGetSortOrderEnum =
  (typeof ApiV1HistoryDeletedUsersGetSortOrderEnum)[keyof typeof ApiV1HistoryDeletedUsersGetSortOrderEnum];

/**
 * HttpBasicAuthApi - axios parameter creator
 */
export const HttpBasicAuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Http Auth Client 정보 삭제
     * @summary Http Auth Client 정보 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthClientIdDelete: async (
      xAuthToken: string,
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthClientIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthClientIdDelete', 'clientId', clientId);
      const localVarPath = `/api/v1/http-basic/auth/{client_id}`.replace(
        '{client_id}',
        encodeURIComponent(String(clientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Http Auth Client  정보 조회
     * @summary Http Auth Client 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthClientIdGet: async (
      xAuthToken: string,
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthClientIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthClientIdGet', 'clientId', clientId);
      const localVarPath = `/api/v1/http-basic/auth/{client_id}`.replace(
        '{client_id}',
        encodeURIComponent(String(clientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Http Auth Client 목록
     * @summary Http Auth Client 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/http-basic/auth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Http Auth Client 정보 생성
     * @summary Http Auth Client 정보 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudBasicAuthClientRequest} createRequest 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthPost: async (
      xAuthToken: string,
      createRequest: RequestCloudBasicAuthClientRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'createRequest' is not null or undefined
      assertParamExists('apiV1HttpBasicAuthPost', 'createRequest', createRequest);
      const localVarPath = `/api/v1/http-basic/auth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HttpBasicAuthApi - functional programming interface
 */
export const HttpBasicAuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HttpBasicAuthApiAxiosParamCreator(configuration);
  return {
    /**
     * Http Auth Client 정보 삭제
     * @summary Http Auth Client 정보 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1HttpBasicAuthClientIdDelete(
      xAuthToken: string,
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HttpBasicAuthClientIdDelete(
        xAuthToken,
        clientId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HttpBasicAuthApi.apiV1HttpBasicAuthClientIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Http Auth Client  정보 조회
     * @summary Http Auth Client 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID, minLength&#x3D;32 maxLength&#x3D;32
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1HttpBasicAuthClientIdGet(
      xAuthToken: string,
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HttpBasicAuthClientIdGet(
        xAuthToken,
        clientId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HttpBasicAuthApi.apiV1HttpBasicAuthClientIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Http Auth Client 목록
     * @summary Http Auth Client 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1HttpBasicAuthGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HttpBasicAuthGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HttpBasicAuthApi.apiV1HttpBasicAuthGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Http Auth Client 정보 생성
     * @summary Http Auth Client 정보 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudBasicAuthClientRequest} createRequest 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1HttpBasicAuthPost(
      xAuthToken: string,
      createRequest: RequestCloudBasicAuthClientRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudBasicAuthClient>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1HttpBasicAuthPost(
        xAuthToken,
        createRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HttpBasicAuthApi.apiV1HttpBasicAuthPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * HttpBasicAuthApi - factory interface
 */
export const HttpBasicAuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HttpBasicAuthApiFp(configuration);
  return {
    /**
     * Http Auth Client 정보 삭제
     * @summary Http Auth Client 정보 삭제
     * @param {HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthClientIdDelete(
      requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1HttpBasicAuthClientIdDelete(
          requestParameters.xAuthToken,
          requestParameters.clientId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Http Auth Client  정보 조회
     * @summary Http Auth Client 정보 조회
     * @param {HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthClientIdGet(
      requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1HttpBasicAuthClientIdGet(
          requestParameters.xAuthToken,
          requestParameters.clientId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Http Auth Client 목록
     * @summary Http Auth Client 목록
     * @param {HttpBasicAuthApiApiV1HttpBasicAuthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthGet(
      requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1HttpBasicAuthGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Http Auth Client 정보 생성
     * @summary Http Auth Client 정보 생성
     * @param {HttpBasicAuthApiApiV1HttpBasicAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1HttpBasicAuthPost(
      requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudBasicAuthClient> {
      return localVarFp
        .apiV1HttpBasicAuthPost(
          requestParameters.xAuthToken,
          requestParameters.createRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * HttpBasicAuthApi - interface
 */
export interface HttpBasicAuthApiInterface {
  /**
   * Http Auth Client 정보 삭제
   * @summary Http Auth Client 정보 삭제
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1HttpBasicAuthClientIdDelete(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Http Auth Client  정보 조회
   * @summary Http Auth Client 정보 조회
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1HttpBasicAuthClientIdGet(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Http Auth Client 목록
   * @summary Http Auth Client 목록
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1HttpBasicAuthGet(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Http Auth Client 정보 생성
   * @summary Http Auth Client 정보 생성
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1HttpBasicAuthPost(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudBasicAuthClient>;
}

/**
 * Request parameters for apiV1HttpBasicAuthClientIdDelete operation in HttpBasicAuthApi.
 */
export interface HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Client ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly clientId: string;
}

/**
 * Request parameters for apiV1HttpBasicAuthClientIdGet operation in HttpBasicAuthApi.
 */
export interface HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Client ID, minLength&#x3D;32 maxLength&#x3D;32
   */
  readonly clientId: string;
}

/**
 * Request parameters for apiV1HttpBasicAuthGet operation in HttpBasicAuthApi.
 */
export interface HttpBasicAuthApiApiV1HttpBasicAuthGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1HttpBasicAuthPost operation in HttpBasicAuthApi.
 */
export interface HttpBasicAuthApiApiV1HttpBasicAuthPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 생성 정보
   */
  readonly createRequest: RequestCloudBasicAuthClientRequest;
}

/**
 * HttpBasicAuthApi - object-oriented interface
 */
export class HttpBasicAuthApi extends BaseAPI implements HttpBasicAuthApiInterface {
  /**
   * Http Auth Client 정보 삭제
   * @summary Http Auth Client 정보 삭제
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1HttpBasicAuthClientIdDelete(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthClientIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HttpBasicAuthApiFp(this.configuration)
      .apiV1HttpBasicAuthClientIdDelete(
        requestParameters.xAuthToken,
        requestParameters.clientId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Http Auth Client  정보 조회
   * @summary Http Auth Client 정보 조회
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1HttpBasicAuthClientIdGet(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthClientIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HttpBasicAuthApiFp(this.configuration)
      .apiV1HttpBasicAuthClientIdGet(
        requestParameters.xAuthToken,
        requestParameters.clientId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Http Auth Client 목록
   * @summary Http Auth Client 목록
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1HttpBasicAuthGet(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HttpBasicAuthApiFp(this.configuration)
      .apiV1HttpBasicAuthGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Http Auth Client 정보 생성
   * @summary Http Auth Client 정보 생성
   * @param {HttpBasicAuthApiApiV1HttpBasicAuthPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1HttpBasicAuthPost(
    requestParameters: HttpBasicAuthApiApiV1HttpBasicAuthPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return HttpBasicAuthApiFp(this.configuration)
      .apiV1HttpBasicAuthPost(
        requestParameters.xAuthToken,
        requestParameters.createRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * IdentityApi - axios parameter creator
 */
export const IdentityApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * identity version 정보 조회
     * @summary identity version 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/identity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 토큰 회수(revoke)
     * @summary 토큰 회수(revoke)
     * @param {string} xAuthToken authentication token
     * @param {string} xSubjectToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3AuthTokensDelete: async (
      xAuthToken: string,
      xSubjectToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('identityV3AuthTokensDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'xSubjectToken' is not null or undefined
      assertParamExists('identityV3AuthTokensDelete', 'xSubjectToken', xSubjectToken);
      const localVarPath = `/identity/v3/auth/tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      if (xSubjectToken != null) {
        localVarHeaderParameter['X-Subject-Token'] = String(xSubjectToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 토큰 유효성 검증 및 정보 확인
     * @summary 토큰 유효성 검증 및 정보 확인
     * @param {string} xAuthToken authentication token
     * @param {string} xSubjectToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3AuthTokensGet: async (
      xAuthToken: string,
      xSubjectToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('identityV3AuthTokensGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'xSubjectToken' is not null or undefined
      assertParamExists('identityV3AuthTokensGet', 'xSubjectToken', xSubjectToken);
      const localVarPath = `/identity/v3/auth/tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      if (xSubjectToken != null) {
        localVarHeaderParameter['X-Subject-Token'] = String(xSubjectToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 인증 및 토큰 발급 API. ID&PW Token 발급 기준으로 Request Body 샘픔 제공. 기타 나머지 발급에 대한 샘플은 token 발급 가이드 Wiki 참고: https://wiki.daumkakao.com/pages/viewpage.action?pageId=821939211 1. ID&PW 인증 ( Project Scope 기준. 기타 scope는 token 발급 가이드 참고. ) 2. Token 인증 ( token 발급 가이드 참고 ) 3. Application credential 인증 ( token 발급 가이드 참고 ) 4. Trust 인증 ( token 발급 가이드 참고 )
     * @summary 인증 토큰 발급 API
     * @param {RouterSwaggerIdPwdRequest} [iDPW] ID&amp;PW 인증. Project Scope 기준
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3AuthTokensPost: async (
      iDPW?: RouterSwaggerIdPwdRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/identity/v3/auth/tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDPW,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * identity version 정보 조회
     * @summary identity version 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3Get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/identity/v3`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * credential 기반 인증 및 토큰 발급 API (s3) 발급 성공 시 token body 만 응답, token string 은 응답하지 않음
     * @summary credential 기반 인증 토큰 발급 API (s3)
     * @param {RouterSwaggerS3Request} iDPW credential 기반 token 발급
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3S3tokensPost: async (
      iDPW: RouterSwaggerS3Request,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'iDPW' is not null or undefined
      assertParamExists('identityV3S3tokensPost', 'iDPW', iDPW);
      const localVarPath = `/identity/v3/s3tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDPW,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * IdentityApi - functional programming interface
 */
export const IdentityApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IdentityApiAxiosParamCreator(configuration);
  return {
    /**
     * identity version 정보 조회
     * @summary identity version 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async identityGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.identityGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityApi.identityGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 토큰 회수(revoke)
     * @summary 토큰 회수(revoke)
     * @param {string} xAuthToken authentication token
     * @param {string} xSubjectToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async identityV3AuthTokensDelete(
      xAuthToken: string,
      xSubjectToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.identityV3AuthTokensDelete(
        xAuthToken,
        xSubjectToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityApi.identityV3AuthTokensDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 토큰 유효성 검증 및 정보 확인
     * @summary 토큰 유효성 검증 및 정보 확인
     * @param {string} xAuthToken authentication token
     * @param {string} xSubjectToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async identityV3AuthTokensGet(
      xAuthToken: string,
      xSubjectToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTokenResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.identityV3AuthTokensGet(
        xAuthToken,
        xSubjectToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityApi.identityV3AuthTokensGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 인증 및 토큰 발급 API. ID&PW Token 발급 기준으로 Request Body 샘픔 제공. 기타 나머지 발급에 대한 샘플은 token 발급 가이드 Wiki 참고: https://wiki.daumkakao.com/pages/viewpage.action?pageId=821939211 1. ID&PW 인증 ( Project Scope 기준. 기타 scope는 token 발급 가이드 참고. ) 2. Token 인증 ( token 발급 가이드 참고 ) 3. Application credential 인증 ( token 발급 가이드 참고 ) 4. Trust 인증 ( token 발급 가이드 참고 )
     * @summary 인증 토큰 발급 API
     * @param {RouterSwaggerIdPwdRequest} [iDPW] ID&amp;PW 인증. Project Scope 기준
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async identityV3AuthTokensPost(
      iDPW?: RouterSwaggerIdPwdRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTokenResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.identityV3AuthTokensPost(
        iDPW,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityApi.identityV3AuthTokensPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * identity version 정보 조회
     * @summary identity version 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async identityV3Get(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.identityV3Get(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityApi.identityV3Get']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * credential 기반 인증 및 토큰 발급 API (s3) 발급 성공 시 token body 만 응답, token string 은 응답하지 않음
     * @summary credential 기반 인증 토큰 발급 API (s3)
     * @param {RouterSwaggerS3Request} iDPW credential 기반 token 발급
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async identityV3S3tokensPost(
      iDPW: RouterSwaggerS3Request,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTokenResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.identityV3S3tokensPost(
        iDPW,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityApi.identityV3S3tokensPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * IdentityApi - factory interface
 */
export const IdentityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = IdentityApiFp(configuration);
  return {
    /**
     * identity version 정보 조회
     * @summary identity version 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.identityGet(options).then(request => request(axios, basePath));
    },
    /**
     * 토큰 회수(revoke)
     * @summary 토큰 회수(revoke)
     * @param {IdentityApiIdentityV3AuthTokensDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3AuthTokensDelete(
      requestParameters: IdentityApiIdentityV3AuthTokensDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .identityV3AuthTokensDelete(
          requestParameters.xAuthToken,
          requestParameters.xSubjectToken,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 토큰 유효성 검증 및 정보 확인
     * @summary 토큰 유효성 검증 및 정보 확인
     * @param {IdentityApiIdentityV3AuthTokensGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3AuthTokensGet(
      requestParameters: IdentityApiIdentityV3AuthTokensGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTokenResponse> {
      return localVarFp
        .identityV3AuthTokensGet(
          requestParameters.xAuthToken,
          requestParameters.xSubjectToken,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 인증 및 토큰 발급 API. ID&PW Token 발급 기준으로 Request Body 샘픔 제공. 기타 나머지 발급에 대한 샘플은 token 발급 가이드 Wiki 참고: https://wiki.daumkakao.com/pages/viewpage.action?pageId=821939211 1. ID&PW 인증 ( Project Scope 기준. 기타 scope는 token 발급 가이드 참고. ) 2. Token 인증 ( token 발급 가이드 참고 ) 3. Application credential 인증 ( token 발급 가이드 참고 ) 4. Trust 인증 ( token 발급 가이드 참고 )
     * @summary 인증 토큰 발급 API
     * @param {IdentityApiIdentityV3AuthTokensPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3AuthTokensPost(
      requestParameters: IdentityApiIdentityV3AuthTokensPostRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTokenResponse> {
      return localVarFp
        .identityV3AuthTokensPost(requestParameters.iDPW, options)
        .then(request => request(axios, basePath));
    },
    /**
     * identity version 정보 조회
     * @summary identity version 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3Get(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.identityV3Get(options).then(request => request(axios, basePath));
    },
    /**
     * credential 기반 인증 및 토큰 발급 API (s3) 발급 성공 시 token body 만 응답, token string 은 응답하지 않음
     * @summary credential 기반 인증 토큰 발급 API (s3)
     * @param {IdentityApiIdentityV3S3tokensPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    identityV3S3tokensPost(
      requestParameters: IdentityApiIdentityV3S3tokensPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTokenResponse> {
      return localVarFp
        .identityV3S3tokensPost(requestParameters.iDPW, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * IdentityApi - interface
 */
export interface IdentityApiInterface {
  /**
   * identity version 정보 조회
   * @summary identity version 정보 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  identityGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

  /**
   * 토큰 회수(revoke)
   * @summary 토큰 회수(revoke)
   * @param {IdentityApiIdentityV3AuthTokensDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  identityV3AuthTokensDelete(
    requestParameters: IdentityApiIdentityV3AuthTokensDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 토큰 유효성 검증 및 정보 확인
   * @summary 토큰 유효성 검증 및 정보 확인
   * @param {IdentityApiIdentityV3AuthTokensGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  identityV3AuthTokensGet(
    requestParameters: IdentityApiIdentityV3AuthTokensGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTokenResponse>;

  /**
   * 인증 및 토큰 발급 API. ID&PW Token 발급 기준으로 Request Body 샘픔 제공. 기타 나머지 발급에 대한 샘플은 token 발급 가이드 Wiki 참고: https://wiki.daumkakao.com/pages/viewpage.action?pageId=821939211 1. ID&PW 인증 ( Project Scope 기준. 기타 scope는 token 발급 가이드 참고. ) 2. Token 인증 ( token 발급 가이드 참고 ) 3. Application credential 인증 ( token 발급 가이드 참고 ) 4. Trust 인증 ( token 발급 가이드 참고 )
   * @summary 인증 토큰 발급 API
   * @param {IdentityApiIdentityV3AuthTokensPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  identityV3AuthTokensPost(
    requestParameters?: IdentityApiIdentityV3AuthTokensPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTokenResponse>;

  /**
   * identity version 정보 조회
   * @summary identity version 정보 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  identityV3Get(options?: RawAxiosRequestConfig): AxiosPromise<void>;

  /**
   * credential 기반 인증 및 토큰 발급 API (s3) 발급 성공 시 token body 만 응답, token string 은 응답하지 않음
   * @summary credential 기반 인증 토큰 발급 API (s3)
   * @param {IdentityApiIdentityV3S3tokensPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  identityV3S3tokensPost(
    requestParameters: IdentityApiIdentityV3S3tokensPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTokenResponse>;
}

/**
 * Request parameters for identityV3AuthTokensDelete operation in IdentityApi.
 */
export interface IdentityApiIdentityV3AuthTokensDeleteRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;

  /**
   * authentication token
   */
  readonly xSubjectToken: string;
}

/**
 * Request parameters for identityV3AuthTokensGet operation in IdentityApi.
 */
export interface IdentityApiIdentityV3AuthTokensGetRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;

  /**
   * authentication token
   */
  readonly xSubjectToken: string;
}

/**
 * Request parameters for identityV3AuthTokensPost operation in IdentityApi.
 */
export interface IdentityApiIdentityV3AuthTokensPostRequest {
  /**
   * ID&amp;PW 인증. Project Scope 기준
   */
  readonly iDPW?: RouterSwaggerIdPwdRequest;
}

/**
 * Request parameters for identityV3S3tokensPost operation in IdentityApi.
 */
export interface IdentityApiIdentityV3S3tokensPostRequest {
  /**
   * credential 기반 token 발급
   */
  readonly iDPW: RouterSwaggerS3Request;
}

/**
 * IdentityApi - object-oriented interface
 */
export class IdentityApi extends BaseAPI implements IdentityApiInterface {
  /**
   * identity version 정보 조회
   * @summary identity version 정보 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public identityGet(options?: RawAxiosRequestConfig) {
    return IdentityApiFp(this.configuration)
      .identityGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 토큰 회수(revoke)
   * @summary 토큰 회수(revoke)
   * @param {IdentityApiIdentityV3AuthTokensDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public identityV3AuthTokensDelete(
    requestParameters: IdentityApiIdentityV3AuthTokensDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentityApiFp(this.configuration)
      .identityV3AuthTokensDelete(
        requestParameters.xAuthToken,
        requestParameters.xSubjectToken,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 토큰 유효성 검증 및 정보 확인
   * @summary 토큰 유효성 검증 및 정보 확인
   * @param {IdentityApiIdentityV3AuthTokensGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public identityV3AuthTokensGet(
    requestParameters: IdentityApiIdentityV3AuthTokensGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentityApiFp(this.configuration)
      .identityV3AuthTokensGet(
        requestParameters.xAuthToken,
        requestParameters.xSubjectToken,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 인증 및 토큰 발급 API. ID&PW Token 발급 기준으로 Request Body 샘픔 제공. 기타 나머지 발급에 대한 샘플은 token 발급 가이드 Wiki 참고: https://wiki.daumkakao.com/pages/viewpage.action?pageId=821939211 1. ID&PW 인증 ( Project Scope 기준. 기타 scope는 token 발급 가이드 참고. ) 2. Token 인증 ( token 발급 가이드 참고 ) 3. Application credential 인증 ( token 발급 가이드 참고 ) 4. Trust 인증 ( token 발급 가이드 참고 )
   * @summary 인증 토큰 발급 API
   * @param {IdentityApiIdentityV3AuthTokensPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public identityV3AuthTokensPost(
    requestParameters: IdentityApiIdentityV3AuthTokensPostRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return IdentityApiFp(this.configuration)
      .identityV3AuthTokensPost(requestParameters.iDPW, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * identity version 정보 조회
   * @summary identity version 정보 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public identityV3Get(options?: RawAxiosRequestConfig) {
    return IdentityApiFp(this.configuration)
      .identityV3Get(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * credential 기반 인증 및 토큰 발급 API (s3) 발급 성공 시 token body 만 응답, token string 은 응답하지 않음
   * @summary credential 기반 인증 토큰 발급 API (s3)
   * @param {IdentityApiIdentityV3S3tokensPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public identityV3S3tokensPost(
    requestParameters: IdentityApiIdentityV3S3tokensPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentityApiFp(this.configuration)
      .identityV3S3tokensPost(requestParameters.iDPW, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * IdentityProvidersApi - axios parameter creator
 */
export const IdentityProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 연동 가능한 IDP 목록
     * @summary 연동 가능한 IDP 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [protocol] 연동 프로토콜 ex) openid, saml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1IdentityProvidersGet: async (
      xAuthToken: string,
      protocol?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1IdentityProvidersGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/identity-providers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (protocol !== undefined) {
        localVarQueryParameter['protocol'] = protocol;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * IdentityProvidersApi - functional programming interface
 */
export const IdentityProvidersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IdentityProvidersApiAxiosParamCreator(configuration);
  return {
    /**
     * 연동 가능한 IDP 목록
     * @summary 연동 가능한 IDP 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [protocol] 연동 프로토콜 ex) openid, saml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1IdentityProvidersGet(
      xAuthToken: string,
      protocol?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseIdentityProviders>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1IdentityProvidersGet(
        xAuthToken,
        protocol,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['IdentityProvidersApi.apiV1IdentityProvidersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * IdentityProvidersApi - factory interface
 */
export const IdentityProvidersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = IdentityProvidersApiFp(configuration);
  return {
    /**
     * 연동 가능한 IDP 목록
     * @summary 연동 가능한 IDP 목록
     * @param {IdentityProvidersApiApiV1IdentityProvidersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1IdentityProvidersGet(
      requestParameters: IdentityProvidersApiApiV1IdentityProvidersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseIdentityProviders> {
      return localVarFp
        .apiV1IdentityProvidersGet(
          requestParameters.xAuthToken,
          requestParameters.protocol,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * IdentityProvidersApi - interface
 */
export interface IdentityProvidersApiInterface {
  /**
   * 연동 가능한 IDP 목록
   * @summary 연동 가능한 IDP 목록
   * @param {IdentityProvidersApiApiV1IdentityProvidersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1IdentityProvidersGet(
    requestParameters: IdentityProvidersApiApiV1IdentityProvidersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseIdentityProviders>;
}

/**
 * Request parameters for apiV1IdentityProvidersGet operation in IdentityProvidersApi.
 */
export interface IdentityProvidersApiApiV1IdentityProvidersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 연동 프로토콜 ex) openid, saml
   */
  readonly protocol?: string;
}

/**
 * IdentityProvidersApi - object-oriented interface
 */
export class IdentityProvidersApi extends BaseAPI implements IdentityProvidersApiInterface {
  /**
   * 연동 가능한 IDP 목록
   * @summary 연동 가능한 IDP 목록
   * @param {IdentityProvidersApiApiV1IdentityProvidersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1IdentityProvidersGet(
    requestParameters: IdentityProvidersApiApiV1IdentityProvidersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentityProvidersApiFp(this.configuration)
      .apiV1IdentityProvidersGet(requestParameters.xAuthToken, requestParameters.protocol, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * LoginApi - axios parameter creator
 */
export const LoginApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 클라우드 로그인 API
     * @summary 클라우드 로그인 API
     * @param {string} domainName domain name
     * @param {string} userName user name
     * @param {string} password user password
     * @param {string} redirectUri redirect uri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginCloudPost: async (
      domainName: string,
      userName: string,
      password: string,
      redirectUri: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'domainName' is not null or undefined
      assertParamExists('accountV1LoginCloudPost', 'domainName', domainName);
      // verify required parameter 'userName' is not null or undefined
      assertParamExists('accountV1LoginCloudPost', 'userName', userName);
      // verify required parameter 'password' is not null or undefined
      assertParamExists('accountV1LoginCloudPost', 'password', password);
      // verify required parameter 'redirectUri' is not null or undefined
      assertParamExists('accountV1LoginCloudPost', 'redirectUri', redirectUri);
      const localVarPath = `/account/v1/login/cloud`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (domainName !== undefined) {
        localVarFormParams.append('domain_name', domainName as any);
      }

      if (userName !== undefined) {
        localVarFormParams.append('user_name', userName as any);
      }

      if (password !== undefined) {
        localVarFormParams.append('password', password as any);
      }

      if (redirectUri !== undefined) {
        localVarFormParams.append('redirect_uri', redirectUri as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
     * @summary 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {string} domainName domain name
     * @param {string} [redirectUri] 로그인 후 보내질 주소
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginDomainsDomainNameGet: async (
      authorization: string,
      domainName: string,
      redirectUri?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('accountV1LoginDomainsDomainNameGet', 'authorization', authorization);
      // verify required parameter 'domainName' is not null or undefined
      assertParamExists('accountV1LoginDomainsDomainNameGet', 'domainName', domainName);
      const localVarPath = `/account/v1/login/domains/{domain_name}`.replace(
        '{domain_name}',
        encodeURIComponent(String(domainName)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (redirectUri !== undefined) {
        localVarQueryParameter['redirect_uri'] = redirectUri;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 세션 사용자의 2차 인증 수단 정보 조회 mfa_type: user_name(로그인ID) | email(연락처 이메일) | phone(휴대폰) | otp value: email: email주소(user@mail.com) | phone: 휴대전화 번호(ex. 821012345678) | otp: 활성화 여부(ex. \"true\")
     * @summary 세션 사용자의 2차 인증 수단 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginMfaInfoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/account/v1/login/mfa-info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 이메일로 2차 인증 번호 발송 mfa_type: user_name(로그인ID) | email(연락처 이메일)
     * @summary 사용자의 이메일로 2차 인증 번호 발송
     * @param {RequestSendLoginAuthEmailRequest} sendMfaEmailRequest SendMfaEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginSendEmailPost: async (
      sendMfaEmailRequest: RequestSendLoginAuthEmailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sendMfaEmailRequest' is not null or undefined
      assertParamExists('accountV1LoginSendEmailPost', 'sendMfaEmailRequest', sendMfaEmailRequest);
      const localVarPath = `/account/v1/login/send-email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendMfaEmailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 휴대전화로 2차 인증 번호 발송
     * @summary 사용자의 휴대전화로 2차 인증 번호 발송
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginSendSmsPost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/account/v1/login/send-sms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 인증번호 확인 및 로그인 mfa_type: user_name(로그인ID) | email(연락처 이메일)
     * @summary 인증번호 확인 및 로그인
     * @param {RequestValidateLoginEmailRequest} validateLoginEmailRequest ValidateLoginEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginValidateEmailPost: async (
      validateLoginEmailRequest: RequestValidateLoginEmailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'validateLoginEmailRequest' is not null or undefined
      assertParamExists(
        'accountV1LoginValidateEmailPost',
        'validateLoginEmailRequest',
        validateLoginEmailRequest,
      );
      const localVarPath = `/account/v1/login/validate-email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        validateLoginEmailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OTP 인증번호 확인 및 로그인
     * @summary OTP 인증번호 확인 및 로그인
     * @param {RequestValidateOtpRequest} validateOtpRequest ValidateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginValidateOtpPost: async (
      validateOtpRequest: RequestValidateOtpRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'validateOtpRequest' is not null or undefined
      assertParamExists('accountV1LoginValidateOtpPost', 'validateOtpRequest', validateOtpRequest);
      const localVarPath = `/account/v1/login/validate-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        validateOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 인증번호 확인 및 로그인
     * @summary 인증번호 확인 및 로그인
     * @param {RequestValidateLoginPhoneRequest} validateLoginPhoneRequest ValidateLoginPhoneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginValidateSmsPost: async (
      validateLoginPhoneRequest: RequestValidateLoginPhoneRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'validateLoginPhoneRequest' is not null or undefined
      assertParamExists(
        'accountV1LoginValidateSmsPost',
        'validateLoginPhoneRequest',
        validateLoginPhoneRequest,
      );
      const localVarPath = `/account/v1/login/validate-sms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        validateLoginPhoneRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @param {string} xAuthToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthReplaceSessionPost: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AuthReplaceSessionPost', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/auth/replace-session`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @param {string} xAuthToken authentication token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1AuthReplaceTokenPost: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1AuthReplaceTokenPost', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/auth/replace-token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 유저의 마지막 로그인 정보 조회
     * @summary 유저의 마지막 로그인 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersLatestLoginGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersLatestLoginGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/users/latest-login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LoginApi - functional programming interface
 */
export const LoginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration);
  return {
    /**
     * 클라우드 로그인 API
     * @summary 클라우드 로그인 API
     * @param {string} domainName domain name
     * @param {string} userName user name
     * @param {string} password user password
     * @param {string} redirectUri redirect uri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginCloudPost(
      domainName: string,
      userName: string,
      password: string,
      redirectUri: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginCloudPost(
        domainName,
        userName,
        password,
        redirectUri,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginCloudPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
     * @summary 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {string} domainName domain name
     * @param {string} [redirectUri] 로그인 후 보내질 주소
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginDomainsDomainNameGet(
      authorization: string,
      domainName: string,
      redirectUri?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseDomainGetAuthTypeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginDomainsDomainNameGet(
        authorization,
        domainName,
        redirectUri,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginDomainsDomainNameGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 세션 사용자의 2차 인증 수단 정보 조회 mfa_type: user_name(로그인ID) | email(연락처 이메일) | phone(휴대폰) | otp value: email: email주소(user@mail.com) | phone: 휴대전화 번호(ex. 821012345678) | otp: 활성화 여부(ex. \"true\")
     * @summary 세션 사용자의 2차 인증 수단 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginMfaInfoGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMfaInfoList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginMfaInfoGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginMfaInfoGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 이메일로 2차 인증 번호 발송 mfa_type: user_name(로그인ID) | email(연락처 이메일)
     * @summary 사용자의 이메일로 2차 인증 번호 발송
     * @param {RequestSendLoginAuthEmailRequest} sendMfaEmailRequest SendMfaEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginSendEmailPost(
      sendMfaEmailRequest: RequestSendLoginAuthEmailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginSendEmailPost(
        sendMfaEmailRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginSendEmailPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 휴대전화로 2차 인증 번호 발송
     * @summary 사용자의 휴대전화로 2차 인증 번호 발송
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginSendSmsPost(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginSendSmsPost(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginSendSmsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 인증번호 확인 및 로그인 mfa_type: user_name(로그인ID) | email(연락처 이메일)
     * @summary 인증번호 확인 및 로그인
     * @param {RequestValidateLoginEmailRequest} validateLoginEmailRequest ValidateLoginEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginValidateEmailPost(
      validateLoginEmailRequest: RequestValidateLoginEmailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseValidateLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginValidateEmailPost(
        validateLoginEmailRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginValidateEmailPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OTP 인증번호 확인 및 로그인
     * @summary OTP 인증번호 확인 및 로그인
     * @param {RequestValidateOtpRequest} validateOtpRequest ValidateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginValidateOtpPost(
      validateOtpRequest: RequestValidateOtpRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseValidateLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginValidateOtpPost(
        validateOtpRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginValidateOtpPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 인증번호 확인 및 로그인
     * @summary 인증번호 확인 및 로그인
     * @param {RequestValidateLoginPhoneRequest} validateLoginPhoneRequest ValidateLoginPhoneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1LoginValidateSmsPost(
      validateLoginPhoneRequest: RequestValidateLoginPhoneRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseValidateLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1LoginValidateSmsPost(
        validateLoginPhoneRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.accountV1LoginValidateSmsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @param {string} xAuthToken authentication token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1AuthReplaceSessionPost(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseReplaceSessionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthReplaceSessionPost(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.apiV1AuthReplaceSessionPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @param {string} xAuthToken authentication token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1AuthReplaceTokenPost(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseReplaceSessionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AuthReplaceTokenPost(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.apiV1AuthReplaceTokenPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 유저의 마지막 로그인 정보 조회
     * @summary 유저의 마지막 로그인 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersLatestLoginGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseLoginLog>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersLatestLoginGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LoginApi.apiV1UsersLatestLoginGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * LoginApi - factory interface
 */
export const LoginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LoginApiFp(configuration);
  return {
    /**
     * 클라우드 로그인 API
     * @summary 클라우드 로그인 API
     * @param {LoginApiAccountV1LoginCloudPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginCloudPost(
      requestParameters: LoginApiAccountV1LoginCloudPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudAuthResponse> {
      return localVarFp
        .accountV1LoginCloudPost(
          requestParameters.domainName,
          requestParameters.userName,
          requestParameters.password,
          requestParameters.redirectUri,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
     * @summary 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
     * @param {LoginApiAccountV1LoginDomainsDomainNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginDomainsDomainNameGet(
      requestParameters: LoginApiAccountV1LoginDomainsDomainNameGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseDomainGetAuthTypeResponse> {
      return localVarFp
        .accountV1LoginDomainsDomainNameGet(
          requestParameters.authorization,
          requestParameters.domainName,
          requestParameters.redirectUri,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 세션 사용자의 2차 인증 수단 정보 조회 mfa_type: user_name(로그인ID) | email(연락처 이메일) | phone(휴대폰) | otp value: email: email주소(user@mail.com) | phone: 휴대전화 번호(ex. 821012345678) | otp: 활성화 여부(ex. \"true\")
     * @summary 세션 사용자의 2차 인증 수단 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginMfaInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<ResponseMfaInfoList> {
      return localVarFp.accountV1LoginMfaInfoGet(options).then(request => request(axios, basePath));
    },
    /**
     * 사용자의 이메일로 2차 인증 번호 발송 mfa_type: user_name(로그인ID) | email(연락처 이메일)
     * @summary 사용자의 이메일로 2차 인증 번호 발송
     * @param {LoginApiAccountV1LoginSendEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginSendEmailPost(
      requestParameters: LoginApiAccountV1LoginSendEmailPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .accountV1LoginSendEmailPost(requestParameters.sendMfaEmailRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 휴대전화로 2차 인증 번호 발송
     * @summary 사용자의 휴대전화로 2차 인증 번호 발송
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginSendSmsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .accountV1LoginSendSmsPost(options)
        .then(request => request(axios, basePath));
    },
    /**
     * 인증번호 확인 및 로그인 mfa_type: user_name(로그인ID) | email(연락처 이메일)
     * @summary 인증번호 확인 및 로그인
     * @param {LoginApiAccountV1LoginValidateEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginValidateEmailPost(
      requestParameters: LoginApiAccountV1LoginValidateEmailPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseValidateLoginResponse> {
      return localVarFp
        .accountV1LoginValidateEmailPost(requestParameters.validateLoginEmailRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * OTP 인증번호 확인 및 로그인
     * @summary OTP 인증번호 확인 및 로그인
     * @param {LoginApiAccountV1LoginValidateOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginValidateOtpPost(
      requestParameters: LoginApiAccountV1LoginValidateOtpPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseValidateLoginResponse> {
      return localVarFp
        .accountV1LoginValidateOtpPost(requestParameters.validateOtpRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 인증번호 확인 및 로그인
     * @summary 인증번호 확인 및 로그인
     * @param {LoginApiAccountV1LoginValidateSmsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1LoginValidateSmsPost(
      requestParameters: LoginApiAccountV1LoginValidateSmsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseValidateLoginResponse> {
      return localVarFp
        .accountV1LoginValidateSmsPost(requestParameters.validateLoginPhoneRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @param {LoginApiApiV1AuthReplaceSessionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1AuthReplaceSessionPost(
      requestParameters: LoginApiApiV1AuthReplaceSessionPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseReplaceSessionResponse> {
      return localVarFp
        .apiV1AuthReplaceSessionPost(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
     * @param {LoginApiApiV1AuthReplaceTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1AuthReplaceTokenPost(
      requestParameters: LoginApiApiV1AuthReplaceTokenPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseReplaceSessionResponse> {
      return localVarFp
        .apiV1AuthReplaceTokenPost(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 유저의 마지막 로그인 정보 조회
     * @summary 유저의 마지막 로그인 정보 조회
     * @param {LoginApiApiV1UsersLatestLoginGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersLatestLoginGet(
      requestParameters: LoginApiApiV1UsersLatestLoginGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseLoginLog> {
      return localVarFp
        .apiV1UsersLatestLoginGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * LoginApi - interface
 */
export interface LoginApiInterface {
  /**
   * 클라우드 로그인 API
   * @summary 클라우드 로그인 API
   * @param {LoginApiAccountV1LoginCloudPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginCloudPost(
    requestParameters: LoginApiAccountV1LoginCloudPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudAuthResponse>;

  /**
   * 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
   * @summary 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
   * @param {LoginApiAccountV1LoginDomainsDomainNameGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginDomainsDomainNameGet(
    requestParameters: LoginApiAccountV1LoginDomainsDomainNameGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseDomainGetAuthTypeResponse>;

  /**
   * 세션 사용자의 2차 인증 수단 정보 조회 mfa_type: user_name(로그인ID) | email(연락처 이메일) | phone(휴대폰) | otp value: email: email주소(user@mail.com) | phone: 휴대전화 번호(ex. 821012345678) | otp: 활성화 여부(ex. \"true\")
   * @summary 세션 사용자의 2차 인증 수단 정보 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginMfaInfoGet(options?: RawAxiosRequestConfig): AxiosPromise<ResponseMfaInfoList>;

  /**
   * 사용자의 이메일로 2차 인증 번호 발송 mfa_type: user_name(로그인ID) | email(연락처 이메일)
   * @summary 사용자의 이메일로 2차 인증 번호 발송
   * @param {LoginApiAccountV1LoginSendEmailPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginSendEmailPost(
    requestParameters: LoginApiAccountV1LoginSendEmailPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 휴대전화로 2차 인증 번호 발송
   * @summary 사용자의 휴대전화로 2차 인증 번호 발송
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginSendSmsPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

  /**
   * 인증번호 확인 및 로그인 mfa_type: user_name(로그인ID) | email(연락처 이메일)
   * @summary 인증번호 확인 및 로그인
   * @param {LoginApiAccountV1LoginValidateEmailPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginValidateEmailPost(
    requestParameters: LoginApiAccountV1LoginValidateEmailPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseValidateLoginResponse>;

  /**
   * OTP 인증번호 확인 및 로그인
   * @summary OTP 인증번호 확인 및 로그인
   * @param {LoginApiAccountV1LoginValidateOtpPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginValidateOtpPost(
    requestParameters: LoginApiAccountV1LoginValidateOtpPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseValidateLoginResponse>;

  /**
   * 인증번호 확인 및 로그인
   * @summary 인증번호 확인 및 로그인
   * @param {LoginApiAccountV1LoginValidateSmsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1LoginValidateSmsPost(
    requestParameters: LoginApiAccountV1LoginValidateSmsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseValidateLoginResponse>;

  /**
   * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @param {LoginApiApiV1AuthReplaceSessionPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1AuthReplaceSessionPost(
    requestParameters: LoginApiApiV1AuthReplaceSessionPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseReplaceSessionResponse>;

  /**
   * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @param {LoginApiApiV1AuthReplaceTokenPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1AuthReplaceTokenPost(
    requestParameters: LoginApiApiV1AuthReplaceTokenPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseReplaceSessionResponse>;

  /**
   * 유저의 마지막 로그인 정보 조회
   * @summary 유저의 마지막 로그인 정보 조회
   * @param {LoginApiApiV1UsersLatestLoginGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersLatestLoginGet(
    requestParameters: LoginApiApiV1UsersLatestLoginGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseLoginLog>;
}

/**
 * Request parameters for accountV1LoginCloudPost operation in LoginApi.
 */
export interface LoginApiAccountV1LoginCloudPostRequest {
  /**
   * domain name
   */
  readonly domainName: string;

  /**
   * user name
   */
  readonly userName: string;

  /**
   * user password
   */
  readonly password: string;

  /**
   * redirect uri
   */
  readonly redirectUri: string;
}

/**
 * Request parameters for accountV1LoginDomainsDomainNameGet operation in LoginApi.
 */
export interface LoginApiAccountV1LoginDomainsDomainNameGetRequest {
  /**
   * Authorization: Basic base64(client id:Client Secret)
   */
  readonly authorization: string;

  /**
   * domain name
   */
  readonly domainName: string;

  /**
   * 로그인 후 보내질 주소
   */
  readonly redirectUri?: string;
}

/**
 * Request parameters for accountV1LoginSendEmailPost operation in LoginApi.
 */
export interface LoginApiAccountV1LoginSendEmailPostRequest {
  /**
   * SendMfaEmailRequest
   */
  readonly sendMfaEmailRequest: RequestSendLoginAuthEmailRequest;
}

/**
 * Request parameters for accountV1LoginValidateEmailPost operation in LoginApi.
 */
export interface LoginApiAccountV1LoginValidateEmailPostRequest {
  /**
   * ValidateLoginEmailRequest
   */
  readonly validateLoginEmailRequest: RequestValidateLoginEmailRequest;
}

/**
 * Request parameters for accountV1LoginValidateOtpPost operation in LoginApi.
 */
export interface LoginApiAccountV1LoginValidateOtpPostRequest {
  /**
   * ValidateOtpRequest
   */
  readonly validateOtpRequest: RequestValidateOtpRequest;
}

/**
 * Request parameters for accountV1LoginValidateSmsPost operation in LoginApi.
 */
export interface LoginApiAccountV1LoginValidateSmsPostRequest {
  /**
   * ValidateLoginPhoneRequest
   */
  readonly validateLoginPhoneRequest: RequestValidateLoginPhoneRequest;
}

/**
 * Request parameters for apiV1AuthReplaceSessionPost operation in LoginApi.
 */
export interface LoginApiApiV1AuthReplaceSessionPostRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1AuthReplaceTokenPost operation in LoginApi.
 */
export interface LoginApiApiV1AuthReplaceTokenPostRequest {
  /**
   * authentication token
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1UsersLatestLoginGet operation in LoginApi.
 */
export interface LoginApiApiV1UsersLatestLoginGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * LoginApi - object-oriented interface
 */
export class LoginApi extends BaseAPI implements LoginApiInterface {
  /**
   * 클라우드 로그인 API
   * @summary 클라우드 로그인 API
   * @param {LoginApiAccountV1LoginCloudPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginCloudPost(
    requestParameters: LoginApiAccountV1LoginCloudPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .accountV1LoginCloudPost(
        requestParameters.domainName,
        requestParameters.userName,
        requestParameters.password,
        requestParameters.redirectUri,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
   * @summary 요청한 domain이 존재하는 경우, 가능한 로그인 방식 정보 전달
   * @param {LoginApiAccountV1LoginDomainsDomainNameGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginDomainsDomainNameGet(
    requestParameters: LoginApiAccountV1LoginDomainsDomainNameGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .accountV1LoginDomainsDomainNameGet(
        requestParameters.authorization,
        requestParameters.domainName,
        requestParameters.redirectUri,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 세션 사용자의 2차 인증 수단 정보 조회 mfa_type: user_name(로그인ID) | email(연락처 이메일) | phone(휴대폰) | otp value: email: email주소(user@mail.com) | phone: 휴대전화 번호(ex. 821012345678) | otp: 활성화 여부(ex. \"true\")
   * @summary 세션 사용자의 2차 인증 수단 정보 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginMfaInfoGet(options?: RawAxiosRequestConfig) {
    return LoginApiFp(this.configuration)
      .accountV1LoginMfaInfoGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 이메일로 2차 인증 번호 발송 mfa_type: user_name(로그인ID) | email(연락처 이메일)
   * @summary 사용자의 이메일로 2차 인증 번호 발송
   * @param {LoginApiAccountV1LoginSendEmailPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginSendEmailPost(
    requestParameters: LoginApiAccountV1LoginSendEmailPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .accountV1LoginSendEmailPost(requestParameters.sendMfaEmailRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 휴대전화로 2차 인증 번호 발송
   * @summary 사용자의 휴대전화로 2차 인증 번호 발송
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginSendSmsPost(options?: RawAxiosRequestConfig) {
    return LoginApiFp(this.configuration)
      .accountV1LoginSendSmsPost(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 인증번호 확인 및 로그인 mfa_type: user_name(로그인ID) | email(연락처 이메일)
   * @summary 인증번호 확인 및 로그인
   * @param {LoginApiAccountV1LoginValidateEmailPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginValidateEmailPost(
    requestParameters: LoginApiAccountV1LoginValidateEmailPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .accountV1LoginValidateEmailPost(requestParameters.validateLoginEmailRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OTP 인증번호 확인 및 로그인
   * @summary OTP 인증번호 확인 및 로그인
   * @param {LoginApiAccountV1LoginValidateOtpPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginValidateOtpPost(
    requestParameters: LoginApiAccountV1LoginValidateOtpPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .accountV1LoginValidateOtpPost(requestParameters.validateOtpRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 인증번호 확인 및 로그인
   * @summary 인증번호 확인 및 로그인
   * @param {LoginApiAccountV1LoginValidateSmsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1LoginValidateSmsPost(
    requestParameters: LoginApiAccountV1LoginValidateSmsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .accountV1LoginValidateSmsPost(requestParameters.validateLoginPhoneRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @param {LoginApiApiV1AuthReplaceSessionPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1AuthReplaceSessionPost(
    requestParameters: LoginApiApiV1AuthReplaceSessionPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .apiV1AuthReplaceSessionPost(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @summary 이미 발급된 사용자의 모든 토큰을 만료시키고, 입력받은 토큰을 쿠키에 저장
   * @param {LoginApiApiV1AuthReplaceTokenPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1AuthReplaceTokenPost(
    requestParameters: LoginApiApiV1AuthReplaceTokenPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .apiV1AuthReplaceTokenPost(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 유저의 마지막 로그인 정보 조회
   * @summary 유저의 마지막 로그인 정보 조회
   * @param {LoginApiApiV1UsersLatestLoginGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersLatestLoginGet(
    requestParameters: LoginApiApiV1UsersLatestLoginGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginApiFp(this.configuration)
      .apiV1UsersLatestLoginGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * NoticesApi - axios parameter creator
 */
export const NoticesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 최근 등록된 공지 사항 조회(1건만 조회)
     * @summary 최근 등록된 공지 사항 조회(1건만 조회)
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1NoticesLatelyGet: async (
      authorization: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('accountV1NoticesLatelyGet', 'authorization', authorization);
      const localVarPath = `/account/v1/notices/lately`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 전체 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1NoticesGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/notices`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} noticeSeq 공지 seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesNoticeSeqDelete: async (
      xAuthToken: string,
      noticeSeq: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'noticeSeq' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqDelete', 'noticeSeq', noticeSeq);
      const localVarPath = `/api/v1/notices/{notice_seq}`.replace(
        '{notice_seq}',
        encodeURIComponent(String(noticeSeq)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} noticeSeq 공지 seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesNoticeSeqGet: async (
      xAuthToken: string,
      noticeSeq: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'noticeSeq' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqGet', 'noticeSeq', noticeSeq);
      const localVarPath = `/api/v1/notices/{notice_seq}`.replace(
        '{notice_seq}',
        encodeURIComponent(String(noticeSeq)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 공지사항 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} noticeSeq 공지 seq
     * @param {RequestCloudNoticeUpdateRequest} updateRequest 공지사항 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesNoticeSeqPut: async (
      xAuthToken: string,
      noticeSeq: number,
      updateRequest: RequestCloudNoticeUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'noticeSeq' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqPut', 'noticeSeq', noticeSeq);
      // verify required parameter 'updateRequest' is not null or undefined
      assertParamExists('apiV1NoticesNoticeSeqPut', 'updateRequest', updateRequest);
      const localVarPath = `/api/v1/notices/{notice_seq}`.replace(
        '{notice_seq}',
        encodeURIComponent(String(noticeSeq)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 등록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudNoticeCreateRequest} createRequest 공지사항 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesPost: async (
      xAuthToken: string,
      createRequest: RequestCloudNoticeCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1NoticesPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'createRequest' is not null or undefined
      assertParamExists('apiV1NoticesPost', 'createRequest', createRequest);
      const localVarPath = `/api/v1/notices`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NoticesApi - functional programming interface
 */
export const NoticesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NoticesApiAxiosParamCreator(configuration);
  return {
    /**
     * 최근 등록된 공지 사항 조회(1건만 조회)
     * @summary 최근 등록된 공지 사항 조회(1건만 조회)
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1NoticesLatelyGet(
      authorization: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudNotice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1NoticesLatelyGet(
        authorization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NoticesApi.accountV1NoticesLatelyGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 전체 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1NoticesGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudNotice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NoticesGet(
        xAuthToken,
        size,
        offset,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NoticesApi.apiV1NoticesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} noticeSeq 공지 seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1NoticesNoticeSeqDelete(
      xAuthToken: string,
      noticeSeq: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NoticesNoticeSeqDelete(
        xAuthToken,
        noticeSeq,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NoticesApi.apiV1NoticesNoticeSeqDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} noticeSeq 공지 seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1NoticesNoticeSeqGet(
      xAuthToken: string,
      noticeSeq: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudNotice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NoticesNoticeSeqGet(
        xAuthToken,
        noticeSeq,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NoticesApi.apiV1NoticesNoticeSeqGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 공지사항 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} noticeSeq 공지 seq
     * @param {RequestCloudNoticeUpdateRequest} updateRequest 공지사항 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1NoticesNoticeSeqPut(
      xAuthToken: string,
      noticeSeq: number,
      updateRequest: RequestCloudNoticeUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudNotice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NoticesNoticeSeqPut(
        xAuthToken,
        noticeSeq,
        updateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NoticesApi.apiV1NoticesNoticeSeqPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 등록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudNoticeCreateRequest} createRequest 공지사항 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1NoticesPost(
      xAuthToken: string,
      createRequest: RequestCloudNoticeCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudNotice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1NoticesPost(
        xAuthToken,
        createRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NoticesApi.apiV1NoticesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * NoticesApi - factory interface
 */
export const NoticesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = NoticesApiFp(configuration);
  return {
    /**
     * 최근 등록된 공지 사항 조회(1건만 조회)
     * @summary 최근 등록된 공지 사항 조회(1건만 조회)
     * @param {NoticesApiAccountV1NoticesLatelyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1NoticesLatelyGet(
      requestParameters: NoticesApiAccountV1NoticesLatelyGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudNotice> {
      return localVarFp
        .accountV1NoticesLatelyGet(requestParameters.authorization, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 전체 조회
     * @param {NoticesApiApiV1NoticesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesGet(
      requestParameters: NoticesApiApiV1NoticesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudNotice> {
      return localVarFp
        .apiV1NoticesGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 삭제
     * @param {NoticesApiApiV1NoticesNoticeSeqDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesNoticeSeqDelete(
      requestParameters: NoticesApiApiV1NoticesNoticeSeqDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1NoticesNoticeSeqDelete(
          requestParameters.xAuthToken,
          requestParameters.noticeSeq,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 조회
     * @param {NoticesApiApiV1NoticesNoticeSeqGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesNoticeSeqGet(
      requestParameters: NoticesApiApiV1NoticesNoticeSeqGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudNotice> {
      return localVarFp
        .apiV1NoticesNoticeSeqGet(
          requestParameters.xAuthToken,
          requestParameters.noticeSeq,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 공지사항 수정
     * @param {NoticesApiApiV1NoticesNoticeSeqPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesNoticeSeqPut(
      requestParameters: NoticesApiApiV1NoticesNoticeSeqPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudNotice> {
      return localVarFp
        .apiV1NoticesNoticeSeqPut(
          requestParameters.xAuthToken,
          requestParameters.noticeSeq,
          requestParameters.updateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능
     * @summary 공지사항 등록
     * @param {NoticesApiApiV1NoticesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1NoticesPost(
      requestParameters: NoticesApiApiV1NoticesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudNotice> {
      return localVarFp
        .apiV1NoticesPost(requestParameters.xAuthToken, requestParameters.createRequest, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * NoticesApi - interface
 */
export interface NoticesApiInterface {
  /**
   * 최근 등록된 공지 사항 조회(1건만 조회)
   * @summary 최근 등록된 공지 사항 조회(1건만 조회)
   * @param {NoticesApiAccountV1NoticesLatelyGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1NoticesLatelyGet(
    requestParameters: NoticesApiAccountV1NoticesLatelyGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudNotice>;

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 전체 조회
   * @param {NoticesApiApiV1NoticesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1NoticesGet(
    requestParameters: NoticesApiApiV1NoticesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudNotice>;

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 삭제
   * @param {NoticesApiApiV1NoticesNoticeSeqDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1NoticesNoticeSeqDelete(
    requestParameters: NoticesApiApiV1NoticesNoticeSeqDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 조회
   * @param {NoticesApiApiV1NoticesNoticeSeqGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1NoticesNoticeSeqGet(
    requestParameters: NoticesApiApiV1NoticesNoticeSeqGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudNotice>;

  /**
   * 시스템 관리자만 가능 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 공지사항 수정
   * @param {NoticesApiApiV1NoticesNoticeSeqPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1NoticesNoticeSeqPut(
    requestParameters: NoticesApiApiV1NoticesNoticeSeqPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudNotice>;

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 등록
   * @param {NoticesApiApiV1NoticesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1NoticesPost(
    requestParameters: NoticesApiApiV1NoticesPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudNotice>;
}

/**
 * Request parameters for accountV1NoticesLatelyGet operation in NoticesApi.
 */
export interface NoticesApiAccountV1NoticesLatelyGetRequest {
  /**
   * Authorization: Basic base64(client id:Client Secret)
   */
  readonly authorization: string;
}

/**
 * Request parameters for apiV1NoticesGet operation in NoticesApi.
 */
export interface NoticesApiApiV1NoticesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;
}

/**
 * Request parameters for apiV1NoticesNoticeSeqDelete operation in NoticesApi.
 */
export interface NoticesApiApiV1NoticesNoticeSeqDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 공지 seq
   */
  readonly noticeSeq: number;
}

/**
 * Request parameters for apiV1NoticesNoticeSeqGet operation in NoticesApi.
 */
export interface NoticesApiApiV1NoticesNoticeSeqGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 공지 seq
   */
  readonly noticeSeq: number;
}

/**
 * Request parameters for apiV1NoticesNoticeSeqPut operation in NoticesApi.
 */
export interface NoticesApiApiV1NoticesNoticeSeqPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 공지 seq
   */
  readonly noticeSeq: number;

  /**
   * 공지사항 수정 정보
   */
  readonly updateRequest: RequestCloudNoticeUpdateRequest;
}

/**
 * Request parameters for apiV1NoticesPost operation in NoticesApi.
 */
export interface NoticesApiApiV1NoticesPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 공지사항 생성 정보
   */
  readonly createRequest: RequestCloudNoticeCreateRequest;
}

/**
 * NoticesApi - object-oriented interface
 */
export class NoticesApi extends BaseAPI implements NoticesApiInterface {
  /**
   * 최근 등록된 공지 사항 조회(1건만 조회)
   * @summary 최근 등록된 공지 사항 조회(1건만 조회)
   * @param {NoticesApiAccountV1NoticesLatelyGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1NoticesLatelyGet(
    requestParameters: NoticesApiAccountV1NoticesLatelyGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoticesApiFp(this.configuration)
      .accountV1NoticesLatelyGet(requestParameters.authorization, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 전체 조회
   * @param {NoticesApiApiV1NoticesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1NoticesGet(
    requestParameters: NoticesApiApiV1NoticesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoticesApiFp(this.configuration)
      .apiV1NoticesGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 삭제
   * @param {NoticesApiApiV1NoticesNoticeSeqDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1NoticesNoticeSeqDelete(
    requestParameters: NoticesApiApiV1NoticesNoticeSeqDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoticesApiFp(this.configuration)
      .apiV1NoticesNoticeSeqDelete(
        requestParameters.xAuthToken,
        requestParameters.noticeSeq,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 조회
   * @param {NoticesApiApiV1NoticesNoticeSeqGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1NoticesNoticeSeqGet(
    requestParameters: NoticesApiApiV1NoticesNoticeSeqGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoticesApiFp(this.configuration)
      .apiV1NoticesNoticeSeqGet(requestParameters.xAuthToken, requestParameters.noticeSeq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 공지사항 수정
   * @param {NoticesApiApiV1NoticesNoticeSeqPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1NoticesNoticeSeqPut(
    requestParameters: NoticesApiApiV1NoticesNoticeSeqPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoticesApiFp(this.configuration)
      .apiV1NoticesNoticeSeqPut(
        requestParameters.xAuthToken,
        requestParameters.noticeSeq,
        requestParameters.updateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능
   * @summary 공지사항 등록
   * @param {NoticesApiApiV1NoticesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1NoticesPost(
    requestParameters: NoticesApiApiV1NoticesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoticesApiFp(this.configuration)
      .apiV1NoticesPost(requestParameters.xAuthToken, requestParameters.createRequest, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * OauthApi - axios parameter creator
 */
export const OauthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * access token 폐기 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary access token 폐기 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1TokenDelete: async (
      authorization: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('oauthApiV1TokenDelete', 'authorization', authorization);
      const localVarPath = `/oauth/api/v1/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * access token 정보 조회 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary access token 정보 조회 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1TokenGet: async (
      authorization: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('oauthApiV1TokenGet', 'authorization', authorization);
      const localVarPath = `/oauth/api/v1/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Refresh Token을 가지고 Access Token 발급 요청 API id_token은 기존 Access Token의 scope 혹은 새로 요청한 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
     * @summary Refresh Token을 가지고 Access Token 발급 요청 API
     * @param {string} grantType grant type. ex)refresh_token
     * @param {string} refreshToken refresh token
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {string} [scope] scope
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthReissueTokenPost: async (
      grantType: string,
      refreshToken: string,
      clientId: string,
      clientSecret: string,
      scope?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'grantType' is not null or undefined
      assertParamExists('oauthReissueTokenPost', 'grantType', grantType);
      // verify required parameter 'refreshToken' is not null or undefined
      assertParamExists('oauthReissueTokenPost', 'refreshToken', refreshToken);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('oauthReissueTokenPost', 'clientId', clientId);
      // verify required parameter 'clientSecret' is not null or undefined
      assertParamExists('oauthReissueTokenPost', 'clientSecret', clientSecret);
      const localVarPath = `/oauth/reissue-token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (grantType !== undefined) {
        localVarFormParams.append('grant_type', grantType as any);
      }

      if (refreshToken !== undefined) {
        localVarFormParams.append('refresh_token', refreshToken as any);
      }

      if (scope !== undefined) {
        localVarFormParams.append('scope', scope as any);
      }

      if (clientId !== undefined) {
        localVarFormParams.append('client_id', clientId as any);
      }

      if (clientSecret !== undefined) {
        localVarFormParams.append('client_secret', clientSecret as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Authorization_Code를 이용한 Access Token 발급 요청 API id_token은 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
     * @summary Authorization Code를 이용한 Access Token 발급 요청 API
     * @param {string} grantType grant type. ex)authorization_code
     * @param {string} code Authorization code
     * @param {string} redirectUri redirect uri
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthTokenPost: async (
      grantType: string,
      code: string,
      redirectUri: string,
      clientId: string,
      clientSecret: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'grantType' is not null or undefined
      assertParamExists('oauthTokenPost', 'grantType', grantType);
      // verify required parameter 'code' is not null or undefined
      assertParamExists('oauthTokenPost', 'code', code);
      // verify required parameter 'redirectUri' is not null or undefined
      assertParamExists('oauthTokenPost', 'redirectUri', redirectUri);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('oauthTokenPost', 'clientId', clientId);
      // verify required parameter 'clientSecret' is not null or undefined
      assertParamExists('oauthTokenPost', 'clientSecret', clientSecret);
      const localVarPath = `/oauth/token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (grantType !== undefined) {
        localVarFormParams.append('grant_type', grantType as any);
      }

      if (code !== undefined) {
        localVarFormParams.append('code', code as any);
      }

      if (redirectUri !== undefined) {
        localVarFormParams.append('redirect_uri', redirectUri as any);
      }

      if (clientId !== undefined) {
        localVarFormParams.append('client_id', clientId as any);
      }

      if (clientSecret !== undefined) {
        localVarFormParams.append('client_secret', clientSecret as any);
      }
      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * oauth .well-known 정보
     * @summary oauth .well-known 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthWellKnownOauthAuthorizationServerGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/oauth/.well-known/oauth-authorization-server`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * openid .well-known 정보
     * @summary openid .well-known 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthWellKnownOpenidConfigurationGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/oauth/.well-known/openid-configuration`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OauthApi - functional programming interface
 */
export const OauthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OauthApiAxiosParamCreator(configuration);
  return {
    /**
     * access token 폐기 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary access token 폐기 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthApiV1TokenDelete(
      authorization: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthApiV1TokenDelete(
        authorization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthApi.oauthApiV1TokenDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * access token 정보 조회 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary access token 정보 조회 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthApiV1TokenGet(
      authorization: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAccessTokenInfoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthApiV1TokenGet(
        authorization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthApi.oauthApiV1TokenGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Refresh Token을 가지고 Access Token 발급 요청 API id_token은 기존 Access Token의 scope 혹은 새로 요청한 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
     * @summary Refresh Token을 가지고 Access Token 발급 요청 API
     * @param {string} grantType grant type. ex)refresh_token
     * @param {string} refreshToken refresh token
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {string} [scope] scope
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthReissueTokenPost(
      grantType: string,
      refreshToken: string,
      clientId: string,
      clientSecret: string,
      scope?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAccessTokenResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthReissueTokenPost(
        grantType,
        refreshToken,
        clientId,
        clientSecret,
        scope,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthApi.oauthReissueTokenPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Authorization_Code를 이용한 Access Token 발급 요청 API id_token은 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
     * @summary Authorization Code를 이용한 Access Token 발급 요청 API
     * @param {string} grantType grant type. ex)authorization_code
     * @param {string} code Authorization code
     * @param {string} redirectUri redirect uri
     * @param {string} clientId client id
     * @param {string} clientSecret client secret
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthTokenPost(
      grantType: string,
      code: string,
      redirectUri: string,
      clientId: string,
      clientSecret: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAccessTokenResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthTokenPost(
        grantType,
        code,
        redirectUri,
        clientId,
        clientSecret,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthApi.oauthTokenPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * oauth .well-known 정보
     * @summary oauth .well-known 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthWellKnownOauthAuthorizationServerGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseConfiguration>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.oauthWellKnownOauthAuthorizationServerGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthApi.oauthWellKnownOauthAuthorizationServerGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * openid .well-known 정보
     * @summary openid .well-known 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthWellKnownOpenidConfigurationGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseConfiguration>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.oauthWellKnownOpenidConfigurationGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthApi.oauthWellKnownOpenidConfigurationGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OauthApi - factory interface
 */
export const OauthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OauthApiFp(configuration);
  return {
    /**
     * access token 폐기 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary access token 폐기 API
     * @param {OauthApiOauthApiV1TokenDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1TokenDelete(
      requestParameters: OauthApiOauthApiV1TokenDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .oauthApiV1TokenDelete(requestParameters.authorization, options)
        .then(request => request(axios, basePath));
    },
    /**
     * access token 정보 조회 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary access token 정보 조회 API
     * @param {OauthApiOauthApiV1TokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1TokenGet(
      requestParameters: OauthApiOauthApiV1TokenGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAccessTokenInfoResponse> {
      return localVarFp
        .oauthApiV1TokenGet(requestParameters.authorization, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Refresh Token을 가지고 Access Token 발급 요청 API id_token은 기존 Access Token의 scope 혹은 새로 요청한 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
     * @summary Refresh Token을 가지고 Access Token 발급 요청 API
     * @param {OauthApiOauthReissueTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthReissueTokenPost(
      requestParameters: OauthApiOauthReissueTokenPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAccessTokenResponse> {
      return localVarFp
        .oauthReissueTokenPost(
          requestParameters.grantType,
          requestParameters.refreshToken,
          requestParameters.clientId,
          requestParameters.clientSecret,
          requestParameters.scope,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Authorization_Code를 이용한 Access Token 발급 요청 API id_token은 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
     * @summary Authorization Code를 이용한 Access Token 발급 요청 API
     * @param {OauthApiOauthTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthTokenPost(
      requestParameters: OauthApiOauthTokenPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAccessTokenResponse> {
      return localVarFp
        .oauthTokenPost(
          requestParameters.grantType,
          requestParameters.code,
          requestParameters.redirectUri,
          requestParameters.clientId,
          requestParameters.clientSecret,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * oauth .well-known 정보
     * @summary oauth .well-known 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthWellKnownOauthAuthorizationServerGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseConfiguration> {
      return localVarFp
        .oauthWellKnownOauthAuthorizationServerGet(options)
        .then(request => request(axios, basePath));
    },
    /**
     * openid .well-known 정보
     * @summary openid .well-known 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthWellKnownOpenidConfigurationGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseConfiguration> {
      return localVarFp
        .oauthWellKnownOpenidConfigurationGet(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * OauthApi - interface
 */
export interface OauthApiInterface {
  /**
   * access token 폐기 API http status != 200 인 경우 error, error_description 필드 참고.
   * @summary access token 폐기 API
   * @param {OauthApiOauthApiV1TokenDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthApiV1TokenDelete(
    requestParameters: OauthApiOauthApiV1TokenDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * access token 정보 조회 API http status != 200 인 경우 error, error_description 필드 참고.
   * @summary access token 정보 조회 API
   * @param {OauthApiOauthApiV1TokenGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthApiV1TokenGet(
    requestParameters: OauthApiOauthApiV1TokenGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAccessTokenInfoResponse>;

  /**
   * Refresh Token을 가지고 Access Token 발급 요청 API id_token은 기존 Access Token의 scope 혹은 새로 요청한 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
   * @summary Refresh Token을 가지고 Access Token 발급 요청 API
   * @param {OauthApiOauthReissueTokenPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthReissueTokenPost(
    requestParameters: OauthApiOauthReissueTokenPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAccessTokenResponse>;

  /**
   * Authorization_Code를 이용한 Access Token 발급 요청 API id_token은 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
   * @summary Authorization Code를 이용한 Access Token 발급 요청 API
   * @param {OauthApiOauthTokenPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthTokenPost(
    requestParameters: OauthApiOauthTokenPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAccessTokenResponse>;

  /**
   * oauth .well-known 정보
   * @summary oauth .well-known 정보
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthWellKnownOauthAuthorizationServerGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseConfiguration>;

  /**
   * openid .well-known 정보
   * @summary openid .well-known 정보
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthWellKnownOpenidConfigurationGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseConfiguration>;
}

/**
 * Request parameters for oauthApiV1TokenDelete operation in OauthApi.
 */
export interface OauthApiOauthApiV1TokenDeleteRequest {
  /**
   * Bearer ${access_token}
   */
  readonly authorization: string;
}

/**
 * Request parameters for oauthApiV1TokenGet operation in OauthApi.
 */
export interface OauthApiOauthApiV1TokenGetRequest {
  /**
   * Bearer ${access_token}
   */
  readonly authorization: string;
}

/**
 * Request parameters for oauthReissueTokenPost operation in OauthApi.
 */
export interface OauthApiOauthReissueTokenPostRequest {
  /**
   * grant type. ex)refresh_token
   */
  readonly grantType: string;

  /**
   * refresh token
   */
  readonly refreshToken: string;

  /**
   * client id
   */
  readonly clientId: string;

  /**
   * client secret
   */
  readonly clientSecret: string;

  /**
   * scope
   */
  readonly scope?: string;
}

/**
 * Request parameters for oauthTokenPost operation in OauthApi.
 */
export interface OauthApiOauthTokenPostRequest {
  /**
   * grant type. ex)authorization_code
   */
  readonly grantType: string;

  /**
   * Authorization code
   */
  readonly code: string;

  /**
   * redirect uri
   */
  readonly redirectUri: string;

  /**
   * client id
   */
  readonly clientId: string;

  /**
   * client secret
   */
  readonly clientSecret: string;
}

/**
 * OauthApi - object-oriented interface
 */
export class OauthApi extends BaseAPI implements OauthApiInterface {
  /**
   * access token 폐기 API http status != 200 인 경우 error, error_description 필드 참고.
   * @summary access token 폐기 API
   * @param {OauthApiOauthApiV1TokenDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthApiV1TokenDelete(
    requestParameters: OauthApiOauthApiV1TokenDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthApiFp(this.configuration)
      .oauthApiV1TokenDelete(requestParameters.authorization, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * access token 정보 조회 API http status != 200 인 경우 error, error_description 필드 참고.
   * @summary access token 정보 조회 API
   * @param {OauthApiOauthApiV1TokenGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthApiV1TokenGet(
    requestParameters: OauthApiOauthApiV1TokenGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthApiFp(this.configuration)
      .oauthApiV1TokenGet(requestParameters.authorization, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Refresh Token을 가지고 Access Token 발급 요청 API id_token은 기존 Access Token의 scope 혹은 새로 요청한 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
   * @summary Refresh Token을 가지고 Access Token 발급 요청 API
   * @param {OauthApiOauthReissueTokenPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthReissueTokenPost(
    requestParameters: OauthApiOauthReissueTokenPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthApiFp(this.configuration)
      .oauthReissueTokenPost(
        requestParameters.grantType,
        requestParameters.refreshToken,
        requestParameters.clientId,
        requestParameters.clientSecret,
        requestParameters.scope,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Authorization_Code를 이용한 Access Token 발급 요청 API id_token은 scope에 openid가 있는 경우에만 전달. http status = 400 인 경우 error, error_description 필드 참고.
   * @summary Authorization Code를 이용한 Access Token 발급 요청 API
   * @param {OauthApiOauthTokenPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthTokenPost(
    requestParameters: OauthApiOauthTokenPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthApiFp(this.configuration)
      .oauthTokenPost(
        requestParameters.grantType,
        requestParameters.code,
        requestParameters.redirectUri,
        requestParameters.clientId,
        requestParameters.clientSecret,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * oauth .well-known 정보
   * @summary oauth .well-known 정보
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthWellKnownOauthAuthorizationServerGet(options?: RawAxiosRequestConfig) {
    return OauthApiFp(this.configuration)
      .oauthWellKnownOauthAuthorizationServerGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * openid .well-known 정보
   * @summary openid .well-known 정보
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthWellKnownOpenidConfigurationGet(options?: RawAxiosRequestConfig) {
    return OauthApiFp(this.configuration)
      .oauthWellKnownOpenidConfigurationGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * OauthClientApi - axios parameter creator
 */
export const OauthClientApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * OAuth Client 정보 삭제 API
     * @summary OAuth Client 정보 삭제 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsClientIdDelete: async (
      xAuthToken: string,
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdDelete', 'clientId', clientId);
      const localVarPath = `/api/v1/oauth/clients/{client_id}`.replace(
        '{client_id}',
        encodeURIComponent(String(clientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth Client 조회 API
     * @summary OAuth Client 조회 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsClientIdGet: async (
      xAuthToken: string,
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdGet', 'clientId', clientId);
      const localVarPath = `/api/v1/oauth/clients/{client_id}`.replace(
        '{client_id}',
        encodeURIComponent(String(clientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth Client 정보 수정 API payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary OAuth Client 정보 수정 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID
     * @param {RequestOAuthClientUpdateRequest} userCreateRequest OAuth Client 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsClientIdPut: async (
      xAuthToken: string,
      clientId: string,
      userCreateRequest: RequestOAuthClientUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdPut', 'clientId', clientId);
      // verify required parameter 'userCreateRequest' is not null or undefined
      assertParamExists('apiV1OauthClientsClientIdPut', 'userCreateRequest', userCreateRequest);
      const localVarPath = `/api/v1/oauth/clients/{client_id}`.replace(
        '{client_id}',
        encodeURIComponent(String(clientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth Client 조회 API
     * @summary OAuth Client 조회 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthClientsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/oauth/clients`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth Client 생성 API
     * @summary OAuth Client 생성 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestOAuthClientCreateRequest} userCreateRequest OAuth Client 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsPost: async (
      xAuthToken: string,
      userCreateRequest: RequestOAuthClientCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthClientsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userCreateRequest' is not null or undefined
      assertParamExists('apiV1OauthClientsPost', 'userCreateRequest', userCreateRequest);
      const localVarPath = `/api/v1/oauth/clients`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OauthClientApi - functional programming interface
 */
export const OauthClientApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OauthClientApiAxiosParamCreator(configuration);
  return {
    /**
     * OAuth Client 정보 삭제 API
     * @summary OAuth Client 정보 삭제 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthClientsClientIdDelete(
      xAuthToken: string,
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthClientsClientIdDelete(
        xAuthToken,
        clientId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthClientApi.apiV1OauthClientsClientIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OAuth Client 조회 API
     * @summary OAuth Client 조회 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthClientsClientIdGet(
      xAuthToken: string,
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseOAuthClientDetail>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthClientsClientIdGet(
        xAuthToken,
        clientId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthClientApi.apiV1OauthClientsClientIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OAuth Client 정보 수정 API payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary OAuth Client 정보 수정 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} clientId Client ID
     * @param {RequestOAuthClientUpdateRequest} userCreateRequest OAuth Client 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthClientsClientIdPut(
      xAuthToken: string,
      clientId: string,
      userCreateRequest: RequestOAuthClientUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseOAuthClientDetail>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthClientsClientIdPut(
        xAuthToken,
        clientId,
        userCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthClientApi.apiV1OauthClientsClientIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OAuth Client 조회 API
     * @summary OAuth Client 조회 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthClientsGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseOAuthClientList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthClientsGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthClientApi.apiV1OauthClientsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OAuth Client 생성 API
     * @summary OAuth Client 생성 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestOAuthClientCreateRequest} userCreateRequest OAuth Client 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthClientsPost(
      xAuthToken: string,
      userCreateRequest: RequestOAuthClientCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseOAuthClientDetail>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthClientsPost(
        xAuthToken,
        userCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthClientApi.apiV1OauthClientsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OauthClientApi - factory interface
 */
export const OauthClientApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OauthClientApiFp(configuration);
  return {
    /**
     * OAuth Client 정보 삭제 API
     * @summary OAuth Client 정보 삭제 API
     * @param {OauthClientApiApiV1OauthClientsClientIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsClientIdDelete(
      requestParameters: OauthClientApiApiV1OauthClientsClientIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1OauthClientsClientIdDelete(
          requestParameters.xAuthToken,
          requestParameters.clientId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * OAuth Client 조회 API
     * @summary OAuth Client 조회 API
     * @param {OauthClientApiApiV1OauthClientsClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsClientIdGet(
      requestParameters: OauthClientApiApiV1OauthClientsClientIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseOAuthClientDetail> {
      return localVarFp
        .apiV1OauthClientsClientIdGet(
          requestParameters.xAuthToken,
          requestParameters.clientId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * OAuth Client 정보 수정 API payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary OAuth Client 정보 수정 API
     * @param {OauthClientApiApiV1OauthClientsClientIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsClientIdPut(
      requestParameters: OauthClientApiApiV1OauthClientsClientIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseOAuthClientDetail> {
      return localVarFp
        .apiV1OauthClientsClientIdPut(
          requestParameters.xAuthToken,
          requestParameters.clientId,
          requestParameters.userCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * OAuth Client 조회 API
     * @summary OAuth Client 조회 API
     * @param {OauthClientApiApiV1OauthClientsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsGet(
      requestParameters: OauthClientApiApiV1OauthClientsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseOAuthClientList> {
      return localVarFp
        .apiV1OauthClientsGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * OAuth Client 생성 API
     * @summary OAuth Client 생성 API
     * @param {OauthClientApiApiV1OauthClientsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthClientsPost(
      requestParameters: OauthClientApiApiV1OauthClientsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseOAuthClientDetail> {
      return localVarFp
        .apiV1OauthClientsPost(
          requestParameters.xAuthToken,
          requestParameters.userCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * OauthClientApi - interface
 */
export interface OauthClientApiInterface {
  /**
   * OAuth Client 정보 삭제 API
   * @summary OAuth Client 정보 삭제 API
   * @param {OauthClientApiApiV1OauthClientsClientIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthClientsClientIdDelete(
    requestParameters: OauthClientApiApiV1OauthClientsClientIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * OAuth Client 조회 API
   * @summary OAuth Client 조회 API
   * @param {OauthClientApiApiV1OauthClientsClientIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthClientsClientIdGet(
    requestParameters: OauthClientApiApiV1OauthClientsClientIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseOAuthClientDetail>;

  /**
   * OAuth Client 정보 수정 API payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary OAuth Client 정보 수정 API
   * @param {OauthClientApiApiV1OauthClientsClientIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthClientsClientIdPut(
    requestParameters: OauthClientApiApiV1OauthClientsClientIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseOAuthClientDetail>;

  /**
   * OAuth Client 조회 API
   * @summary OAuth Client 조회 API
   * @param {OauthClientApiApiV1OauthClientsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthClientsGet(
    requestParameters: OauthClientApiApiV1OauthClientsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseOAuthClientList>;

  /**
   * OAuth Client 생성 API
   * @summary OAuth Client 생성 API
   * @param {OauthClientApiApiV1OauthClientsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthClientsPost(
    requestParameters: OauthClientApiApiV1OauthClientsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseOAuthClientDetail>;
}

/**
 * Request parameters for apiV1OauthClientsClientIdDelete operation in OauthClientApi.
 */
export interface OauthClientApiApiV1OauthClientsClientIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Client ID
   */
  readonly clientId: string;
}

/**
 * Request parameters for apiV1OauthClientsClientIdGet operation in OauthClientApi.
 */
export interface OauthClientApiApiV1OauthClientsClientIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Client ID
   */
  readonly clientId: string;
}

/**
 * Request parameters for apiV1OauthClientsClientIdPut operation in OauthClientApi.
 */
export interface OauthClientApiApiV1OauthClientsClientIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Client ID
   */
  readonly clientId: string;

  /**
   * OAuth Client 수정 정보
   */
  readonly userCreateRequest: RequestOAuthClientUpdateRequest;
}

/**
 * Request parameters for apiV1OauthClientsGet operation in OauthClientApi.
 */
export interface OauthClientApiApiV1OauthClientsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1OauthClientsPost operation in OauthClientApi.
 */
export interface OauthClientApiApiV1OauthClientsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * OAuth Client 생성 정보
   */
  readonly userCreateRequest: RequestOAuthClientCreateRequest;
}

/**
 * OauthClientApi - object-oriented interface
 */
export class OauthClientApi extends BaseAPI implements OauthClientApiInterface {
  /**
   * OAuth Client 정보 삭제 API
   * @summary OAuth Client 정보 삭제 API
   * @param {OauthClientApiApiV1OauthClientsClientIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthClientsClientIdDelete(
    requestParameters: OauthClientApiApiV1OauthClientsClientIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthClientApiFp(this.configuration)
      .apiV1OauthClientsClientIdDelete(
        requestParameters.xAuthToken,
        requestParameters.clientId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OAuth Client 조회 API
   * @summary OAuth Client 조회 API
   * @param {OauthClientApiApiV1OauthClientsClientIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthClientsClientIdGet(
    requestParameters: OauthClientApiApiV1OauthClientsClientIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthClientApiFp(this.configuration)
      .apiV1OauthClientsClientIdGet(
        requestParameters.xAuthToken,
        requestParameters.clientId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OAuth Client 정보 수정 API payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary OAuth Client 정보 수정 API
   * @param {OauthClientApiApiV1OauthClientsClientIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthClientsClientIdPut(
    requestParameters: OauthClientApiApiV1OauthClientsClientIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthClientApiFp(this.configuration)
      .apiV1OauthClientsClientIdPut(
        requestParameters.xAuthToken,
        requestParameters.clientId,
        requestParameters.userCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OAuth Client 조회 API
   * @summary OAuth Client 조회 API
   * @param {OauthClientApiApiV1OauthClientsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthClientsGet(
    requestParameters: OauthClientApiApiV1OauthClientsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthClientApiFp(this.configuration)
      .apiV1OauthClientsGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OAuth Client 생성 API
   * @summary OAuth Client 생성 API
   * @param {OauthClientApiApiV1OauthClientsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthClientsPost(
    requestParameters: OauthClientApiApiV1OauthClientsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthClientApiFp(this.configuration)
      .apiV1OauthClientsPost(
        requestParameters.xAuthToken,
        requestParameters.userCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * OauthUserApi - axios parameter creator
 */
export const OauthUserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 사용자가 OAuth 연결한 Application 연결끊기 API
     * @summary 사용자가 OAuth 연결한 Application 연결끊기 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID,영소문자+숫자 32자
     * @param {RequestUserConsentRequest} userConsentRequest Client 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthUsersUserIdConsentDelete: async (
      xAuthToken: string,
      userId: string,
      userConsentRequest: RequestUserConsentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthUsersUserIdConsentDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1OauthUsersUserIdConsentDelete', 'userId', userId);
      // verify required parameter 'userConsentRequest' is not null or undefined
      assertParamExists(
        'apiV1OauthUsersUserIdConsentDelete',
        'userConsentRequest',
        userConsentRequest,
      );
      const localVarPath = `/api/v1/oauth/users/{user_id}/consent`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userConsentRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자가 OAuth 연결한 Application 목록 API
     * @summary 사용자가 OAuth 연결한 Application 목록 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthUsersUserIdConsentGet: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1OauthUsersUserIdConsentGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1OauthUsersUserIdConsentGet', 'userId', userId);
      const localVarPath = `/api/v1/oauth/users/{user_id}/consent`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * AccessToken 으로 OAuth User가 속한 project 목록 조회 API
     * @summary OAuth User가 속한 project 목록 조회
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV11UsersProjectsGet: async (
      authorization: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('oauthApiV11UsersProjectsGet', 'authorization', authorization);
      const localVarPath = `/oauth/api/v1_1/users/projects`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth 정보 제공 동의 취소 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary OAuth 정보 제공 동의 취소 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1ConsentDelete: async (
      authorization: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('oauthApiV1ConsentDelete', 'authorization', authorization);
      const localVarPath = `/oauth/api/v1/consent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth API 동의 추가 API http status != 200 인 경우 error, error_description 필드 참고. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary OAuth API 동의 추가 API
     * @param {string} authorization Bearer ${access_token}
     * @param {RequestAddConsentRequest} addConsent 추가 동의할 api id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1ConsentPatch: async (
      authorization: string,
      addConsent: RequestAddConsentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('oauthApiV1ConsentPatch', 'authorization', authorization);
      // verify required parameter 'addConsent' is not null or undefined
      assertParamExists('oauthApiV1ConsentPatch', 'addConsent', addConsent);
      const localVarPath = `/oauth/api/v1/consent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addConsent,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * AccessToken 으로 사용자 정보 조회 API
     * @summary 사용자 정보 조회 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1UsersProfilesGet: async (
      authorization: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('oauthApiV1UsersProfilesGet', 'authorization', authorization);
      const localVarPath = `/oauth/api/v1/users/profiles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OauthUserApi - functional programming interface
 */
export const OauthUserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OauthUserApiAxiosParamCreator(configuration);
  return {
    /**
     * 사용자가 OAuth 연결한 Application 연결끊기 API
     * @summary 사용자가 OAuth 연결한 Application 연결끊기 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID,영소문자+숫자 32자
     * @param {RequestUserConsentRequest} userConsentRequest Client 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthUsersUserIdConsentDelete(
      xAuthToken: string,
      userId: string,
      userConsentRequest: RequestUserConsentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthUsersUserIdConsentDelete(
        xAuthToken,
        userId,
        userConsentRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthUserApi.apiV1OauthUsersUserIdConsentDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자가 OAuth 연결한 Application 목록 API
     * @summary 사용자가 OAuth 연결한 Application 목록 API
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1OauthUsersUserIdConsentGet(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserConsentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1OauthUsersUserIdConsentGet(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthUserApi.apiV1OauthUsersUserIdConsentGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * AccessToken 으로 OAuth User가 속한 project 목록 조회 API
     * @summary OAuth User가 속한 project 목록 조회
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthApiV11UsersProjectsGet(
      authorization: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectListByUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthApiV11UsersProjectsGet(
        authorization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthUserApi.oauthApiV11UsersProjectsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OAuth 정보 제공 동의 취소 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary OAuth 정보 제공 동의 취소 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthApiV1ConsentDelete(
      authorization: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthApiV1ConsentDelete(
        authorization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthUserApi.oauthApiV1ConsentDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * OAuth API 동의 추가 API http status != 200 인 경우 error, error_description 필드 참고. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary OAuth API 동의 추가 API
     * @param {string} authorization Bearer ${access_token}
     * @param {RequestAddConsentRequest} addConsent 추가 동의할 api id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthApiV1ConsentPatch(
      authorization: string,
      addConsent: RequestAddConsentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthApiV1ConsentPatch(
        authorization,
        addConsent,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthUserApi.oauthApiV1ConsentPatch']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * AccessToken 으로 사용자 정보 조회 API
     * @summary 사용자 정보 조회 API
     * @param {string} authorization Bearer ${access_token}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async oauthApiV1UsersProfilesGet(
      authorization: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserInfoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.oauthApiV1UsersProfilesGet(
        authorization,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OauthUserApi.oauthApiV1UsersProfilesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OauthUserApi - factory interface
 */
export const OauthUserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OauthUserApiFp(configuration);
  return {
    /**
     * 사용자가 OAuth 연결한 Application 연결끊기 API
     * @summary 사용자가 OAuth 연결한 Application 연결끊기 API
     * @param {OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthUsersUserIdConsentDelete(
      requestParameters: OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1OauthUsersUserIdConsentDelete(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.userConsentRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자가 OAuth 연결한 Application 목록 API
     * @summary 사용자가 OAuth 연결한 Application 목록 API
     * @param {OauthUserApiApiV1OauthUsersUserIdConsentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1OauthUsersUserIdConsentGet(
      requestParameters: OauthUserApiApiV1OauthUsersUserIdConsentGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseUserConsentResponse> {
      return localVarFp
        .apiV1OauthUsersUserIdConsentGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * AccessToken 으로 OAuth User가 속한 project 목록 조회 API
     * @summary OAuth User가 속한 project 목록 조회
     * @param {OauthUserApiOauthApiV11UsersProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV11UsersProjectsGet(
      requestParameters: OauthUserApiOauthApiV11UsersProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectListByUserResponse> {
      return localVarFp
        .oauthApiV11UsersProjectsGet(requestParameters.authorization, options)
        .then(request => request(axios, basePath));
    },
    /**
     * OAuth 정보 제공 동의 취소 API http status != 200 인 경우 error, error_description 필드 참고.
     * @summary OAuth 정보 제공 동의 취소 API
     * @param {OauthUserApiOauthApiV1ConsentDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1ConsentDelete(
      requestParameters: OauthUserApiOauthApiV1ConsentDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .oauthApiV1ConsentDelete(requestParameters.authorization, options)
        .then(request => request(axios, basePath));
    },
    /**
     * OAuth API 동의 추가 API http status != 200 인 경우 error, error_description 필드 참고. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary OAuth API 동의 추가 API
     * @param {OauthUserApiOauthApiV1ConsentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1ConsentPatch(
      requestParameters: OauthUserApiOauthApiV1ConsentPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .oauthApiV1ConsentPatch(
          requestParameters.authorization,
          requestParameters.addConsent,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * AccessToken 으로 사용자 정보 조회 API
     * @summary 사용자 정보 조회 API
     * @param {OauthUserApiOauthApiV1UsersProfilesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauthApiV1UsersProfilesGet(
      requestParameters: OauthUserApiOauthApiV1UsersProfilesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseUserInfoResponse> {
      return localVarFp
        .oauthApiV1UsersProfilesGet(requestParameters.authorization, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * OauthUserApi - interface
 */
export interface OauthUserApiInterface {
  /**
   * 사용자가 OAuth 연결한 Application 연결끊기 API
   * @summary 사용자가 OAuth 연결한 Application 연결끊기 API
   * @param {OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthUsersUserIdConsentDelete(
    requestParameters: OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자가 OAuth 연결한 Application 목록 API
   * @summary 사용자가 OAuth 연결한 Application 목록 API
   * @param {OauthUserApiApiV1OauthUsersUserIdConsentGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1OauthUsersUserIdConsentGet(
    requestParameters: OauthUserApiApiV1OauthUsersUserIdConsentGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseUserConsentResponse>;

  /**
   * AccessToken 으로 OAuth User가 속한 project 목록 조회 API
   * @summary OAuth User가 속한 project 목록 조회
   * @param {OauthUserApiOauthApiV11UsersProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthApiV11UsersProjectsGet(
    requestParameters: OauthUserApiOauthApiV11UsersProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectListByUserResponse>;

  /**
   * OAuth 정보 제공 동의 취소 API http status != 200 인 경우 error, error_description 필드 참고.
   * @summary OAuth 정보 제공 동의 취소 API
   * @param {OauthUserApiOauthApiV1ConsentDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthApiV1ConsentDelete(
    requestParameters: OauthUserApiOauthApiV1ConsentDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * OAuth API 동의 추가 API http status != 200 인 경우 error, error_description 필드 참고. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary OAuth API 동의 추가 API
   * @param {OauthUserApiOauthApiV1ConsentPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthApiV1ConsentPatch(
    requestParameters: OauthUserApiOauthApiV1ConsentPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * AccessToken 으로 사용자 정보 조회 API
   * @summary 사용자 정보 조회 API
   * @param {OauthUserApiOauthApiV1UsersProfilesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  oauthApiV1UsersProfilesGet(
    requestParameters: OauthUserApiOauthApiV1UsersProfilesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseUserInfoResponse>;
}

/**
 * Request parameters for apiV1OauthUsersUserIdConsentDelete operation in OauthUserApi.
 */
export interface OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID,영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * Client 정보
   */
  readonly userConsentRequest: RequestUserConsentRequest;
}

/**
 * Request parameters for apiV1OauthUsersUserIdConsentGet operation in OauthUserApi.
 */
export interface OauthUserApiApiV1OauthUsersUserIdConsentGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for oauthApiV11UsersProjectsGet operation in OauthUserApi.
 */
export interface OauthUserApiOauthApiV11UsersProjectsGetRequest {
  /**
   * Bearer ${access_token}
   */
  readonly authorization: string;
}

/**
 * Request parameters for oauthApiV1ConsentDelete operation in OauthUserApi.
 */
export interface OauthUserApiOauthApiV1ConsentDeleteRequest {
  /**
   * Bearer ${access_token}
   */
  readonly authorization: string;
}

/**
 * Request parameters for oauthApiV1ConsentPatch operation in OauthUserApi.
 */
export interface OauthUserApiOauthApiV1ConsentPatchRequest {
  /**
   * Bearer ${access_token}
   */
  readonly authorization: string;

  /**
   * 추가 동의할 api id
   */
  readonly addConsent: RequestAddConsentRequest;
}

/**
 * Request parameters for oauthApiV1UsersProfilesGet operation in OauthUserApi.
 */
export interface OauthUserApiOauthApiV1UsersProfilesGetRequest {
  /**
   * Bearer ${access_token}
   */
  readonly authorization: string;
}

/**
 * OauthUserApi - object-oriented interface
 */
export class OauthUserApi extends BaseAPI implements OauthUserApiInterface {
  /**
   * 사용자가 OAuth 연결한 Application 연결끊기 API
   * @summary 사용자가 OAuth 연결한 Application 연결끊기 API
   * @param {OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthUsersUserIdConsentDelete(
    requestParameters: OauthUserApiApiV1OauthUsersUserIdConsentDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthUserApiFp(this.configuration)
      .apiV1OauthUsersUserIdConsentDelete(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.userConsentRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자가 OAuth 연결한 Application 목록 API
   * @summary 사용자가 OAuth 연결한 Application 목록 API
   * @param {OauthUserApiApiV1OauthUsersUserIdConsentGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1OauthUsersUserIdConsentGet(
    requestParameters: OauthUserApiApiV1OauthUsersUserIdConsentGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthUserApiFp(this.configuration)
      .apiV1OauthUsersUserIdConsentGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * AccessToken 으로 OAuth User가 속한 project 목록 조회 API
   * @summary OAuth User가 속한 project 목록 조회
   * @param {OauthUserApiOauthApiV11UsersProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthApiV11UsersProjectsGet(
    requestParameters: OauthUserApiOauthApiV11UsersProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthUserApiFp(this.configuration)
      .oauthApiV11UsersProjectsGet(requestParameters.authorization, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OAuth 정보 제공 동의 취소 API http status != 200 인 경우 error, error_description 필드 참고.
   * @summary OAuth 정보 제공 동의 취소 API
   * @param {OauthUserApiOauthApiV1ConsentDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthApiV1ConsentDelete(
    requestParameters: OauthUserApiOauthApiV1ConsentDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthUserApiFp(this.configuration)
      .oauthApiV1ConsentDelete(requestParameters.authorization, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * OAuth API 동의 추가 API http status != 200 인 경우 error, error_description 필드 참고. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary OAuth API 동의 추가 API
   * @param {OauthUserApiOauthApiV1ConsentPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthApiV1ConsentPatch(
    requestParameters: OauthUserApiOauthApiV1ConsentPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthUserApiFp(this.configuration)
      .oauthApiV1ConsentPatch(
        requestParameters.authorization,
        requestParameters.addConsent,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * AccessToken 으로 사용자 정보 조회 API
   * @summary 사용자 정보 조회 API
   * @param {OauthUserApiOauthApiV1UsersProfilesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public oauthApiV1UsersProfilesGet(
    requestParameters: OauthUserApiOauthApiV1UsersProfilesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OauthUserApiFp(this.configuration)
      .oauthApiV1UsersProfilesGet(requestParameters.authorization, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PasswordsApi - axios parameter creator
 */
export const PasswordsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 공공클라우드 초대한 조직 소유자 초기 비밀번호를 등록한다.
     * @summary 공공클라우드 초대한 조직 소유자 초기 비밀번호 등록
     * @param {RequestCloudGOVUserPasswordSetRequest} user 등록 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersInitialGovRegistPost: async (
      user: RequestCloudGOVUserPasswordSetRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'user' is not null or undefined
      assertParamExists('accountV1PasswordsUsersInitialGovRegistPost', 'user', user);
      const localVarPath = `/account/v1/passwords/users/initial-gov-regist`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        user,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 초대한 사용자 초기 비밀번호를 등록한다.
     * @summary 초대한 사용자 초기 비밀번호 등록
     * @param {RequestCloudUserPasswordSetRequest} user 등록 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersInitialRegistPost: async (
      user: RequestCloudUserPasswordSetRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'user' is not null or undefined
      assertParamExists('accountV1PasswordsUsersInitialRegistPost', 'user', user);
      const localVarPath = `/account/v1/passwords/users/initial-regist`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        user,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 비밀번호 재설정 한다.
     * @summary 사용자 비밀번호 재설정
     * @param {RequestCloudUserPasswordSetRequest} user 등록 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersResetPost: async (
      user: RequestCloudUserPasswordSetRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'user' is not null or undefined
      assertParamExists('accountV1PasswordsUsersResetPost', 'user', user);
      const localVarPath = `/account/v1/passwords/users/reset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        user,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 비밀번호 재설정 이메일 발송 요청
     * @summary 사용자 비밀번호 재설정 이메일 발송 요청
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {RequestCloudUserPasswordResetEmailRequest} user 발송 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersSendResetPost: async (
      authorization: string,
      user: RequestCloudUserPasswordResetEmailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authorization' is not null or undefined
      assertParamExists('accountV1PasswordsUsersSendResetPost', 'authorization', authorization);
      // verify required parameter 'user' is not null or undefined
      assertParamExists('accountV1PasswordsUsersSendResetPost', 'user', user);
      const localVarPath = `/account/v1/passwords/users/send-reset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (authorization != null) {
        localVarHeaderParameter['Authorization'] = String(authorization);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        user,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 초대한 사용자 Req ID가 유효한지 검증
     * @summary 초대한 사용자 Req ID 검증
     * @param {string} reqId Request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersValidateInviteGet: async (
      reqId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'reqId' is not null or undefined
      assertParamExists('accountV1PasswordsUsersValidateInviteGet', 'reqId', reqId);
      const localVarPath = `/account/v1/passwords/users/validate-invite`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (reqId !== undefined) {
        localVarQueryParameter['req_id'] = reqId;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 비밀번호 재설정  Req ID가 유효한지 검증
     * @summary 사용자 비밀번호 재설정 Req ID 검증
     * @param {string} reqId Request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersValidateResetGet: async (
      reqId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'reqId' is not null or undefined
      assertParamExists('accountV1PasswordsUsersValidateResetGet', 'reqId', reqId);
      const localVarPath = `/account/v1/passwords/users/validate-reset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (reqId !== undefined) {
        localVarQueryParameter['req_id'] = reqId;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 비빌번호 변경
     * @summary 사용자 비빌번호 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestCloudUserUpdatePasswordRequest} passwordInfo 비밀번호 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdPasswordPost: async (
      xAuthToken: string,
      userId: string,
      passwordInfo: RequestCloudUserUpdatePasswordRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdPasswordPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdPasswordPost', 'userId', userId);
      // verify required parameter 'passwordInfo' is not null or undefined
      assertParamExists('apiV1UsersUserIdPasswordPost', 'passwordInfo', passwordInfo);
      const localVarPath = `/api/v1/users/{user_id}/password`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        passwordInfo,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PasswordsApi - functional programming interface
 */
export const PasswordsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PasswordsApiAxiosParamCreator(configuration);
  return {
    /**
     * 공공클라우드 초대한 조직 소유자 초기 비밀번호를 등록한다.
     * @summary 공공클라우드 초대한 조직 소유자 초기 비밀번호 등록
     * @param {RequestCloudGOVUserPasswordSetRequest} user 등록 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1PasswordsUsersInitialGovRegistPost(
      user: RequestCloudGOVUserPasswordSetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountV1PasswordsUsersInitialGovRegistPost(user, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.accountV1PasswordsUsersInitialGovRegistPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 초대한 사용자 초기 비밀번호를 등록한다.
     * @summary 초대한 사용자 초기 비밀번호 등록
     * @param {RequestCloudUserPasswordSetRequest} user 등록 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1PasswordsUsersInitialRegistPost(
      user: RequestCloudUserPasswordSetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountV1PasswordsUsersInitialRegistPost(user, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.accountV1PasswordsUsersInitialRegistPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 비밀번호 재설정 한다.
     * @summary 사용자 비밀번호 재설정
     * @param {RequestCloudUserPasswordSetRequest} user 등록 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1PasswordsUsersResetPost(
      user: RequestCloudUserPasswordSetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accountV1PasswordsUsersResetPost(
        user,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.accountV1PasswordsUsersResetPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 비밀번호 재설정 이메일 발송 요청
     * @summary 사용자 비밀번호 재설정 이메일 발송 요청
     * @param {string} authorization Authorization: Basic base64(client id:Client Secret)
     * @param {RequestCloudUserPasswordResetEmailRequest} user 발송 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1PasswordsUsersSendResetPost(
      authorization: string,
      user: RequestCloudUserPasswordResetEmailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountV1PasswordsUsersSendResetPost(
          authorization,
          user,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.accountV1PasswordsUsersSendResetPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 초대한 사용자 Req ID가 유효한지 검증
     * @summary 초대한 사용자 Req ID 검증
     * @param {string} reqId Request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1PasswordsUsersValidateInviteGet(
      reqId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRequestIdInfo>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountV1PasswordsUsersValidateInviteGet(reqId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.accountV1PasswordsUsersValidateInviteGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 비밀번호 재설정  Req ID가 유효한지 검증
     * @summary 사용자 비밀번호 재설정 Req ID 검증
     * @param {string} reqId Request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1PasswordsUsersValidateResetGet(
      reqId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRequestIdInfo>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountV1PasswordsUsersValidateResetGet(reqId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.accountV1PasswordsUsersValidateResetGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 비빌번호 변경
     * @summary 사용자 비빌번호 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestCloudUserUpdatePasswordRequest} passwordInfo 비밀번호 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdPasswordPost(
      xAuthToken: string,
      userId: string,
      passwordInfo: RequestCloudUserUpdatePasswordRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdPasswordPost(
        xAuthToken,
        userId,
        passwordInfo,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PasswordsApi.apiV1UsersUserIdPasswordPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PasswordsApi - factory interface
 */
export const PasswordsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PasswordsApiFp(configuration);
  return {
    /**
     * 공공클라우드 초대한 조직 소유자 초기 비밀번호를 등록한다.
     * @summary 공공클라우드 초대한 조직 소유자 초기 비밀번호 등록
     * @param {PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersInitialGovRegistPost(
      requestParameters: PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .accountV1PasswordsUsersInitialGovRegistPost(requestParameters.user, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 초대한 사용자 초기 비밀번호를 등록한다.
     * @summary 초대한 사용자 초기 비밀번호 등록
     * @param {PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersInitialRegistPost(
      requestParameters: PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .accountV1PasswordsUsersInitialRegistPost(requestParameters.user, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 비밀번호 재설정 한다.
     * @summary 사용자 비밀번호 재설정
     * @param {PasswordsApiAccountV1PasswordsUsersResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersResetPost(
      requestParameters: PasswordsApiAccountV1PasswordsUsersResetPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .accountV1PasswordsUsersResetPost(requestParameters.user, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 비밀번호 재설정 이메일 발송 요청
     * @summary 사용자 비밀번호 재설정 이메일 발송 요청
     * @param {PasswordsApiAccountV1PasswordsUsersSendResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersSendResetPost(
      requestParameters: PasswordsApiAccountV1PasswordsUsersSendResetPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .accountV1PasswordsUsersSendResetPost(
          requestParameters.authorization,
          requestParameters.user,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 초대한 사용자 Req ID가 유효한지 검증
     * @summary 초대한 사용자 Req ID 검증
     * @param {PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersValidateInviteGet(
      requestParameters: PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRequestIdInfo> {
      return localVarFp
        .accountV1PasswordsUsersValidateInviteGet(requestParameters.reqId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 비밀번호 재설정  Req ID가 유효한지 검증
     * @summary 사용자 비밀번호 재설정 Req ID 검증
     * @param {PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1PasswordsUsersValidateResetGet(
      requestParameters: PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRequestIdInfo> {
      return localVarFp
        .accountV1PasswordsUsersValidateResetGet(requestParameters.reqId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 비빌번호 변경
     * @summary 사용자 비빌번호 변경
     * @param {PasswordsApiApiV1UsersUserIdPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdPasswordPost(
      requestParameters: PasswordsApiApiV1UsersUserIdPasswordPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdPasswordPost(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.passwordInfo,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PasswordsApi - interface
 */
export interface PasswordsApiInterface {
  /**
   * 공공클라우드 초대한 조직 소유자 초기 비밀번호를 등록한다.
   * @summary 공공클라우드 초대한 조직 소유자 초기 비밀번호 등록
   * @param {PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1PasswordsUsersInitialGovRegistPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 초대한 사용자 초기 비밀번호를 등록한다.
   * @summary 초대한 사용자 초기 비밀번호 등록
   * @param {PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1PasswordsUsersInitialRegistPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자 비밀번호 재설정 한다.
   * @summary 사용자 비밀번호 재설정
   * @param {PasswordsApiAccountV1PasswordsUsersResetPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1PasswordsUsersResetPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersResetPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자 비밀번호 재설정 이메일 발송 요청
   * @summary 사용자 비밀번호 재설정 이메일 발송 요청
   * @param {PasswordsApiAccountV1PasswordsUsersSendResetPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1PasswordsUsersSendResetPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersSendResetPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 초대한 사용자 Req ID가 유효한지 검증
   * @summary 초대한 사용자 Req ID 검증
   * @param {PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1PasswordsUsersValidateInviteGet(
    requestParameters: PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRequestIdInfo>;

  /**
   * 사용자 비밀번호 재설정  Req ID가 유효한지 검증
   * @summary 사용자 비밀번호 재설정 Req ID 검증
   * @param {PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1PasswordsUsersValidateResetGet(
    requestParameters: PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRequestIdInfo>;

  /**
   * 사용자 비빌번호 변경
   * @summary 사용자 비빌번호 변경
   * @param {PasswordsApiApiV1UsersUserIdPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdPasswordPost(
    requestParameters: PasswordsApiApiV1UsersUserIdPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;
}

/**
 * Request parameters for accountV1PasswordsUsersInitialGovRegistPost operation in PasswordsApi.
 */
export interface PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest {
  /**
   * 등록 정보
   */
  readonly user: RequestCloudGOVUserPasswordSetRequest;
}

/**
 * Request parameters for accountV1PasswordsUsersInitialRegistPost operation in PasswordsApi.
 */
export interface PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest {
  /**
   * 등록 정보
   */
  readonly user: RequestCloudUserPasswordSetRequest;
}

/**
 * Request parameters for accountV1PasswordsUsersResetPost operation in PasswordsApi.
 */
export interface PasswordsApiAccountV1PasswordsUsersResetPostRequest {
  /**
   * 등록 정보
   */
  readonly user: RequestCloudUserPasswordSetRequest;
}

/**
 * Request parameters for accountV1PasswordsUsersSendResetPost operation in PasswordsApi.
 */
export interface PasswordsApiAccountV1PasswordsUsersSendResetPostRequest {
  /**
   * Authorization: Basic base64(client id:Client Secret)
   */
  readonly authorization: string;

  /**
   * 발송 정보
   */
  readonly user: RequestCloudUserPasswordResetEmailRequest;
}

/**
 * Request parameters for accountV1PasswordsUsersValidateInviteGet operation in PasswordsApi.
 */
export interface PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest {
  /**
   * Request ID
   */
  readonly reqId: string;
}

/**
 * Request parameters for accountV1PasswordsUsersValidateResetGet operation in PasswordsApi.
 */
export interface PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest {
  /**
   * Request ID
   */
  readonly reqId: string;
}

/**
 * Request parameters for apiV1UsersUserIdPasswordPost operation in PasswordsApi.
 */
export interface PasswordsApiApiV1UsersUserIdPasswordPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * 비밀번호 정보
   */
  readonly passwordInfo: RequestCloudUserUpdatePasswordRequest;
}

/**
 * PasswordsApi - object-oriented interface
 */
export class PasswordsApi extends BaseAPI implements PasswordsApiInterface {
  /**
   * 공공클라우드 초대한 조직 소유자 초기 비밀번호를 등록한다.
   * @summary 공공클라우드 초대한 조직 소유자 초기 비밀번호 등록
   * @param {PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1PasswordsUsersInitialGovRegistPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersInitialGovRegistPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .accountV1PasswordsUsersInitialGovRegistPost(requestParameters.user, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 초대한 사용자 초기 비밀번호를 등록한다.
   * @summary 초대한 사용자 초기 비밀번호 등록
   * @param {PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1PasswordsUsersInitialRegistPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersInitialRegistPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .accountV1PasswordsUsersInitialRegistPost(requestParameters.user, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 비밀번호 재설정 한다.
   * @summary 사용자 비밀번호 재설정
   * @param {PasswordsApiAccountV1PasswordsUsersResetPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1PasswordsUsersResetPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersResetPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .accountV1PasswordsUsersResetPost(requestParameters.user, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 비밀번호 재설정 이메일 발송 요청
   * @summary 사용자 비밀번호 재설정 이메일 발송 요청
   * @param {PasswordsApiAccountV1PasswordsUsersSendResetPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1PasswordsUsersSendResetPost(
    requestParameters: PasswordsApiAccountV1PasswordsUsersSendResetPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .accountV1PasswordsUsersSendResetPost(
        requestParameters.authorization,
        requestParameters.user,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 초대한 사용자 Req ID가 유효한지 검증
   * @summary 초대한 사용자 Req ID 검증
   * @param {PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1PasswordsUsersValidateInviteGet(
    requestParameters: PasswordsApiAccountV1PasswordsUsersValidateInviteGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .accountV1PasswordsUsersValidateInviteGet(requestParameters.reqId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 비밀번호 재설정  Req ID가 유효한지 검증
   * @summary 사용자 비밀번호 재설정 Req ID 검증
   * @param {PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1PasswordsUsersValidateResetGet(
    requestParameters: PasswordsApiAccountV1PasswordsUsersValidateResetGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .accountV1PasswordsUsersValidateResetGet(requestParameters.reqId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 비빌번호 변경
   * @summary 사용자 비빌번호 변경
   * @param {PasswordsApiApiV1UsersUserIdPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdPasswordPost(
    requestParameters: PasswordsApiApiV1UsersUserIdPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PasswordsApiFp(this.configuration)
      .apiV1UsersUserIdPasswordPost(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.passwordInfo,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PermissionsApi - axios parameter creator
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 시스템 관리자만 가능 permission list 조회. service type을 이용하여 필터링 가능
     * @summary permission list 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} [serviceType] service type
     * @param {Array<string>} [displayServiceName] display service name
     * @param {string} [permissionId] Permission ID
     * @param {boolean} [targetUserCheckEnabled] 권한 체크 시 token scope 에 관계 없이 token_user_id 와 target_user_id 가 같은지 검사하는 로직 활성화 여부 (기존 unscoped permisison role)
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11PermissionsGet: async (
      xAuthToken: string,
      serviceType?: Array<string>,
      displayServiceName?: Array<string>,
      permissionId?: string,
      targetUserCheckEnabled?: boolean,
      size?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11PermissionsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1_1/permissions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (serviceType) {
        localVarQueryParameter['service_type'] = serviceType;
      }

      if (displayServiceName) {
        localVarQueryParameter['display_service_name'] = displayServiceName;
      }

      if (permissionId !== undefined) {
        localVarQueryParameter['permission_id'] = permissionId;
      }

      if (targetUserCheckEnabled !== undefined) {
        localVarQueryParameter['target_user_check_enabled'] = targetUserCheckEnabled;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission apis 조회
     * @summary Permission apis 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [httpMethod]
     * @param {number} [offset]
     * @param {string} [path]
     * @param {string} [permissionId]
     * @param {string} [serviceType]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsApisGet: async (
      xAuthToken: string,
      httpMethod?: string,
      offset?: number,
      path?: string,
      permissionId?: string,
      serviceType?: string,
      size?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsApisGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/permissions/apis`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (httpMethod !== undefined) {
        localVarQueryParameter['http_method'] = httpMethod;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (path !== undefined) {
        localVarQueryParameter['path'] = path;
      }

      if (permissionId !== undefined) {
        localVarQueryParameter['permission_id'] = permissionId;
      }

      if (serviceType !== undefined) {
        localVarQueryParameter['service_type'] = serviceType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission apis 생성 (추가)
     * @summary Permission apis 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCreatePermissionApisRequest} createPermissionApisRequest create permission apis
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsApisPost: async (
      xAuthToken: string,
      createPermissionApisRequest: RequestCreatePermissionApisRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsApisPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'createPermissionApisRequest' is not null or undefined
      assertParamExists(
        'apiV1PermissionsApisPost',
        'createPermissionApisRequest',
        createPermissionApisRequest,
      );
      const localVarPath = `/api/v1/permissions/apis`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPermissionApisRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission apis 수정 (replace)
     * @summary Permission apis 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestUpdatePermissionApisRequest} updatePermissionApisRequest update permission apis
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsApisPut: async (
      xAuthToken: string,
      updatePermissionApisRequest: RequestUpdatePermissionApisRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsApisPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'updatePermissionApisRequest' is not null or undefined
      assertParamExists(
        'apiV1PermissionsApisPut',
        'updatePermissionApisRequest',
        updatePermissionApisRequest,
      );
      const localVarPath = `/api/v1/permissions/apis`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePermissionApisRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission 삭제
     * @summary Permission 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdDelete: async (
      xAuthToken: string,
      permissionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'permissionId' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdDelete', 'permissionId', permissionId);
      const localVarPath = `/api/v1/permissions/{permission_id}`.replace(
        '{permission_id}',
        encodeURIComponent(String(permissionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 id를 기준으로 permission 조회
     * @summary permission id를 기준으로 permission 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdGet: async (
      xAuthToken: string,
      permissionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'permissionId' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdGet', 'permissionId', permissionId);
      const localVarPath = `/api/v1/permissions/{permission_id}`.replace(
        '{permission_id}',
        encodeURIComponent(String(permissionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission 수정
     * @summary Permission 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {RequestPermissionUpdateRequest} permissionUpdateRequest permission update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdPut: async (
      xAuthToken: string,
      permissionId: string,
      permissionUpdateRequest: RequestPermissionUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'permissionId' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdPut', 'permissionId', permissionId);
      // verify required parameter 'permissionUpdateRequest' is not null or undefined
      assertParamExists(
        'apiV1PermissionsPermissionIdPut',
        'permissionUpdateRequest',
        permissionUpdateRequest,
      );
      const localVarPath = `/api/v1/permissions/{permission_id}`.replace(
        '{permission_id}',
        encodeURIComponent(String(permissionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        permissionUpdateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission 역할 삭제
     * @summary Permission 역할 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {string} roleId role id, (role 이 any 인 경우 any 사용)
     * @param {string} scope scope
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete: async (
      xAuthToken: string,
      permissionId: string,
      roleId: string,
      scope: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'permissionId' is not null or undefined
      assertParamExists(
        'apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete',
        'permissionId',
        permissionId,
      );
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists(
        'apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete',
        'roleId',
        roleId,
      );
      // verify required parameter 'scope' is not null or undefined
      assertParamExists('apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete', 'scope', scope);
      const localVarPath = `/api/v1/permissions/{permission_id}/roles/{role_id}/scopes/{scope}`
        .replace('{permission_id}', encodeURIComponent(String(permissionId)))
        .replace('{role_id}', encodeURIComponent(String(roleId)))
        .replace('{scope}', encodeURIComponent(String(scope)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"default_role_name\" - permission에 필요한 최소 권한 생성. \'admin\', \'member\' 와 같이 하나의 역할만 입력 가능. 3. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러 4. \"default_role_scope\" - default_role_name 의 scope 설정. 하나의 scope 만 입력 가능 (ex. domain, project, system..)
     * @summary permission 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestPermissionBulkCreateRequest} request permission 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPost: async (
      xAuthToken: string,
      request: RequestPermissionBulkCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1PermissionsPost', 'request', request);
      const localVarPath = `/api/v1/permissions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission 역할 list 조회. service type을 이용하여 필터링 가능
     * @summary permission 역할 list 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} [serviceType] service type
     * @param {Array<string>} [displayServiceName] display service name
     * @param {string} [permissionId] Permission ID
     * @param {string} [roleName] role name
     * @param {string} [scope] scope
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsRolesGet: async (
      xAuthToken: string,
      serviceType?: Array<string>,
      displayServiceName?: Array<string>,
      permissionId?: string,
      roleName?: string,
      scope?: string,
      size?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsRolesGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/permissions/roles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (serviceType) {
        localVarQueryParameter['service_type'] = serviceType;
      }

      if (displayServiceName) {
        localVarQueryParameter['display_service_name'] = displayServiceName;
      }

      if (permissionId !== undefined) {
        localVarQueryParameter['permission_id'] = permissionId;
      }

      if (roleName !== undefined) {
        localVarQueryParameter['role_name'] = roleName;
      }

      if (scope !== undefined) {
        localVarQueryParameter['scope'] = scope;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 permission 생성
     * @summary permission의 role 정보 등록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestPermissionRoleBulkCreateRequest} request permission 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsRolesPost: async (
      xAuthToken: string,
      request: RequestPermissionRoleBulkCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsRolesPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1PermissionsRolesPost', 'request', request);
      const localVarPath = `/api/v1/permissions/roles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 시스템 관리자만 가능 Service Type에 해당 하는 모든 Permission 삭제
     * @summary Service Type에 해당 하는 모든 Permission 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsServicesServiceTypeDelete: async (
      xAuthToken: string,
      serviceType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1PermissionsServicesServiceTypeDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'serviceType' is not null or undefined
      assertParamExists('apiV1PermissionsServicesServiceTypeDelete', 'serviceType', serviceType);
      const localVarPath = `/api/v1/permissions/services/{service_type}`.replace(
        '{service_type}',
        encodeURIComponent(String(serviceType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PermissionsApi - functional programming interface
 */
export const PermissionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration);
  return {
    /**
     * 시스템 관리자만 가능 permission list 조회. service type을 이용하여 필터링 가능
     * @summary permission list 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} [serviceType] service type
     * @param {Array<string>} [displayServiceName] display service name
     * @param {string} [permissionId] Permission ID
     * @param {boolean} [targetUserCheckEnabled] 권한 체크 시 token scope 에 관계 없이 token_user_id 와 target_user_id 가 같은지 검사하는 로직 활성화 여부 (기존 unscoped permisison role)
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11PermissionsGet(
      xAuthToken: string,
      serviceType?: Array<string>,
      displayServiceName?: Array<string>,
      permissionId?: string,
      targetUserCheckEnabled?: boolean,
      size?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListPermissionsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11PermissionsGet(
        xAuthToken,
        serviceType,
        displayServiceName,
        permissionId,
        targetUserCheckEnabled,
        size,
        offset,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV11PermissionsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission apis 조회
     * @summary Permission apis 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [httpMethod]
     * @param {number} [offset]
     * @param {string} [path]
     * @param {string} [permissionId]
     * @param {string} [serviceType]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsApisGet(
      xAuthToken: string,
      httpMethod?: string,
      offset?: number,
      path?: string,
      permissionId?: string,
      serviceType?: string,
      size?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsApisGet(
        xAuthToken,
        httpMethod,
        offset,
        path,
        permissionId,
        serviceType,
        size,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsApisGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission apis 생성 (추가)
     * @summary Permission apis 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCreatePermissionApisRequest} createPermissionApisRequest create permission apis
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsApisPost(
      xAuthToken: string,
      createPermissionApisRequest: RequestCreatePermissionApisRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsApisPost(
        xAuthToken,
        createPermissionApisRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsApisPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission apis 수정 (replace)
     * @summary Permission apis 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestUpdatePermissionApisRequest} updatePermissionApisRequest update permission apis
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsApisPut(
      xAuthToken: string,
      updatePermissionApisRequest: RequestUpdatePermissionApisRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsApisPut(
        xAuthToken,
        updatePermissionApisRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsApisPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission 삭제
     * @summary Permission 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsPermissionIdDelete(
      xAuthToken: string,
      permissionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsPermissionIdDelete(
        xAuthToken,
        permissionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsPermissionIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 id를 기준으로 permission 조회
     * @summary permission id를 기준으로 permission 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsPermissionIdGet(
      xAuthToken: string,
      permissionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudPermissionDetailDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsPermissionIdGet(
        xAuthToken,
        permissionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsPermissionIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission 수정
     * @summary Permission 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {RequestPermissionUpdateRequest} permissionUpdateRequest permission update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsPermissionIdPut(
      xAuthToken: string,
      permissionId: string,
      permissionUpdateRequest: RequestPermissionUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsPermissionIdPut(
        xAuthToken,
        permissionId,
        permissionUpdateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsPermissionIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission 역할 삭제
     * @summary Permission 역할 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} permissionId permission id
     * @param {string} roleId role id, (role 이 any 인 경우 any 사용)
     * @param {string} scope scope
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
      xAuthToken: string,
      permissionId: string,
      roleId: string,
      scope: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
          xAuthToken,
          permissionId,
          roleId,
          scope,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'PermissionsApi.apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"default_role_name\" - permission에 필요한 최소 권한 생성. \'admin\', \'member\' 와 같이 하나의 역할만 입력 가능. 3. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러 4. \"default_role_scope\" - default_role_name 의 scope 설정. 하나의 scope 만 입력 가능 (ex. domain, project, system..)
     * @summary permission 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestPermissionBulkCreateRequest} request permission 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsPost(
      xAuthToken: string,
      request: RequestPermissionBulkCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudPermissionDtos>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission 역할 list 조회. service type을 이용하여 필터링 가능
     * @summary permission 역할 list 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} [serviceType] service type
     * @param {Array<string>} [displayServiceName] display service name
     * @param {string} [permissionId] Permission ID
     * @param {string} [roleName] role name
     * @param {string} [scope] scope
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsRolesGet(
      xAuthToken: string,
      serviceType?: Array<string>,
      displayServiceName?: Array<string>,
      permissionId?: string,
      roleName?: string,
      scope?: string,
      size?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudPermissionRolesList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsRolesGet(
        xAuthToken,
        serviceType,
        displayServiceName,
        permissionId,
        roleName,
        scope,
        size,
        offset,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 permission 생성
     * @summary permission의 role 정보 등록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestPermissionRoleBulkCreateRequest} request permission 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsRolesPost(
      xAuthToken: string,
      request: RequestPermissionRoleBulkCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudPermissionRoleDtos>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PermissionsRolesPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsRolesPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 시스템 관리자만 가능 Service Type에 해당 하는 모든 Permission 삭제
     * @summary Service Type에 해당 하는 모든 Permission 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1PermissionsServicesServiceTypeDelete(
      xAuthToken: string,
      serviceType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1PermissionsServicesServiceTypeDelete(
          xAuthToken,
          serviceType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.apiV1PermissionsServicesServiceTypeDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PermissionsApi - factory interface
 */
export const PermissionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PermissionsApiFp(configuration);
  return {
    /**
     * 시스템 관리자만 가능 permission list 조회. service type을 이용하여 필터링 가능
     * @summary permission list 조회
     * @param {PermissionsApiApiV11PermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11PermissionsGet(
      requestParameters: PermissionsApiApiV11PermissionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListPermissionsResponse> {
      return localVarFp
        .apiV11PermissionsGet(
          requestParameters.xAuthToken,
          requestParameters.serviceType,
          requestParameters.displayServiceName,
          requestParameters.permissionId,
          requestParameters.targetUserCheckEnabled,
          requestParameters.size,
          requestParameters.offset,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission apis 조회
     * @summary Permission apis 조회
     * @param {PermissionsApiApiV1PermissionsApisGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsApisGet(
      requestParameters: PermissionsApiApiV1PermissionsApisGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsApisGet(
          requestParameters.xAuthToken,
          requestParameters.httpMethod,
          requestParameters.offset,
          requestParameters.path,
          requestParameters.permissionId,
          requestParameters.serviceType,
          requestParameters.size,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission apis 생성 (추가)
     * @summary Permission apis 생성
     * @param {PermissionsApiApiV1PermissionsApisPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsApisPost(
      requestParameters: PermissionsApiApiV1PermissionsApisPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsApisPost(
          requestParameters.xAuthToken,
          requestParameters.createPermissionApisRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission apis 수정 (replace)
     * @summary Permission apis 수정
     * @param {PermissionsApiApiV1PermissionsApisPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsApisPut(
      requestParameters: PermissionsApiApiV1PermissionsApisPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsApisPut(
          requestParameters.xAuthToken,
          requestParameters.updatePermissionApisRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission 삭제
     * @summary Permission 삭제
     * @param {PermissionsApiApiV1PermissionsPermissionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdDelete(
      requestParameters: PermissionsApiApiV1PermissionsPermissionIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsPermissionIdDelete(
          requestParameters.xAuthToken,
          requestParameters.permissionId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 id를 기준으로 permission 조회
     * @summary permission id를 기준으로 permission 조회
     * @param {PermissionsApiApiV1PermissionsPermissionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdGet(
      requestParameters: PermissionsApiApiV1PermissionsPermissionIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudPermissionDetailDto> {
      return localVarFp
        .apiV1PermissionsPermissionIdGet(
          requestParameters.xAuthToken,
          requestParameters.permissionId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission 수정
     * @summary Permission 수정
     * @param {PermissionsApiApiV1PermissionsPermissionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdPut(
      requestParameters: PermissionsApiApiV1PermissionsPermissionIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsPermissionIdPut(
          requestParameters.xAuthToken,
          requestParameters.permissionId,
          requestParameters.permissionUpdateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission 역할 삭제
     * @summary Permission 역할 삭제
     * @param {PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
      requestParameters: PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
          requestParameters.xAuthToken,
          requestParameters.permissionId,
          requestParameters.roleId,
          requestParameters.scope,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"default_role_name\" - permission에 필요한 최소 권한 생성. \'admin\', \'member\' 와 같이 하나의 역할만 입력 가능. 3. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러 4. \"default_role_scope\" - default_role_name 의 scope 설정. 하나의 scope 만 입력 가능 (ex. domain, project, system..)
     * @summary permission 생성
     * @param {PermissionsApiApiV1PermissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsPost(
      requestParameters: PermissionsApiApiV1PermissionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudPermissionDtos> {
      return localVarFp
        .apiV1PermissionsPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission 역할 list 조회. service type을 이용하여 필터링 가능
     * @summary permission 역할 list 조회
     * @param {PermissionsApiApiV1PermissionsRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsRolesGet(
      requestParameters: PermissionsApiApiV1PermissionsRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudPermissionRolesList> {
      return localVarFp
        .apiV1PermissionsRolesGet(
          requestParameters.xAuthToken,
          requestParameters.serviceType,
          requestParameters.displayServiceName,
          requestParameters.permissionId,
          requestParameters.roleName,
          requestParameters.scope,
          requestParameters.size,
          requestParameters.offset,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 permission 생성
     * @summary permission의 role 정보 등록
     * @param {PermissionsApiApiV1PermissionsRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsRolesPost(
      requestParameters: PermissionsApiApiV1PermissionsRolesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudPermissionRoleDtos> {
      return localVarFp
        .apiV1PermissionsRolesPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 시스템 관리자만 가능 Service Type에 해당 하는 모든 Permission 삭제
     * @summary Service Type에 해당 하는 모든 Permission 삭제
     * @param {PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1PermissionsServicesServiceTypeDelete(
      requestParameters: PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1PermissionsServicesServiceTypeDelete(
          requestParameters.xAuthToken,
          requestParameters.serviceType,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PermissionsApi - interface
 */
export interface PermissionsApiInterface {
  /**
   * 시스템 관리자만 가능 permission list 조회. service type을 이용하여 필터링 가능
   * @summary permission list 조회
   * @param {PermissionsApiApiV11PermissionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11PermissionsGet(
    requestParameters: PermissionsApiApiV11PermissionsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListPermissionsResponse>;

  /**
   * 시스템 관리자만 가능 permission apis 조회
   * @summary Permission apis 조회
   * @param {PermissionsApiApiV1PermissionsApisGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsApisGet(
    requestParameters: PermissionsApiApiV1PermissionsApisGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능 permission apis 생성 (추가)
   * @summary Permission apis 생성
   * @param {PermissionsApiApiV1PermissionsApisPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsApisPost(
    requestParameters: PermissionsApiApiV1PermissionsApisPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능 permission apis 수정 (replace)
   * @summary Permission apis 수정
   * @param {PermissionsApiApiV1PermissionsApisPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsApisPut(
    requestParameters: PermissionsApiApiV1PermissionsApisPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능 permission 삭제
   * @summary Permission 삭제
   * @param {PermissionsApiApiV1PermissionsPermissionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsPermissionIdDelete(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능 id를 기준으로 permission 조회
   * @summary permission id를 기준으로 permission 조회
   * @param {PermissionsApiApiV1PermissionsPermissionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsPermissionIdGet(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudPermissionDetailDto>;

  /**
   * 시스템 관리자만 가능 permission 수정
   * @summary Permission 수정
   * @param {PermissionsApiApiV1PermissionsPermissionIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsPermissionIdPut(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능 permission 역할 삭제
   * @summary Permission 역할 삭제
   * @param {PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 시스템 관리자만 가능 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"default_role_name\" - permission에 필요한 최소 권한 생성. \'admin\', \'member\' 와 같이 하나의 역할만 입력 가능. 3. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러 4. \"default_role_scope\" - default_role_name 의 scope 설정. 하나의 scope 만 입력 가능 (ex. domain, project, system..)
   * @summary permission 생성
   * @param {PermissionsApiApiV1PermissionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsPost(
    requestParameters: PermissionsApiApiV1PermissionsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudPermissionDtos>;

  /**
   * 시스템 관리자만 가능 permission 역할 list 조회. service type을 이용하여 필터링 가능
   * @summary permission 역할 list 조회
   * @param {PermissionsApiApiV1PermissionsRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsRolesGet(
    requestParameters: PermissionsApiApiV1PermissionsRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudPermissionRolesList>;

  /**
   * 시스템 관리자만 가능 permission 생성
   * @summary permission의 role 정보 등록
   * @param {PermissionsApiApiV1PermissionsRolesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsRolesPost(
    requestParameters: PermissionsApiApiV1PermissionsRolesPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudPermissionRoleDtos>;

  /**
   * 시스템 관리자만 가능 Service Type에 해당 하는 모든 Permission 삭제
   * @summary Service Type에 해당 하는 모든 Permission 삭제
   * @param {PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1PermissionsServicesServiceTypeDelete(
    requestParameters: PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;
}

/**
 * Request parameters for apiV11PermissionsGet operation in PermissionsApi.
 */
export interface PermissionsApiApiV11PermissionsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service type
   */
  readonly serviceType?: Array<string>;

  /**
   * display service name
   */
  readonly displayServiceName?: Array<string>;

  /**
   * Permission ID
   */
  readonly permissionId?: string;

  /**
   * 권한 체크 시 token scope 에 관계 없이 token_user_id 와 target_user_id 가 같은지 검사하는 로직 활성화 여부 (기존 unscoped permisison role)
   */
  readonly targetUserCheckEnabled?: boolean;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;
}

/**
 * Request parameters for apiV1PermissionsApisGet operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsApisGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  readonly httpMethod?: string;

  readonly offset?: number;

  readonly path?: string;

  readonly permissionId?: string;

  readonly serviceType?: string;

  readonly size?: number;
}

/**
 * Request parameters for apiV1PermissionsApisPost operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsApisPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * create permission apis
   */
  readonly createPermissionApisRequest: RequestCreatePermissionApisRequest;
}

/**
 * Request parameters for apiV1PermissionsApisPut operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsApisPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * update permission apis
   */
  readonly updatePermissionApisRequest: RequestUpdatePermissionApisRequest;
}

/**
 * Request parameters for apiV1PermissionsPermissionIdDelete operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsPermissionIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission id
   */
  readonly permissionId: string;
}

/**
 * Request parameters for apiV1PermissionsPermissionIdGet operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsPermissionIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission id
   */
  readonly permissionId: string;
}

/**
 * Request parameters for apiV1PermissionsPermissionIdPut operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsPermissionIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission id
   */
  readonly permissionId: string;

  /**
   * permission update
   */
  readonly permissionUpdateRequest: RequestPermissionUpdateRequest;
}

/**
 * Request parameters for apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission id
   */
  readonly permissionId: string;

  /**
   * role id, (role 이 any 인 경우 any 사용)
   */
  readonly roleId: string;

  /**
   * scope
   */
  readonly scope: string;
}

/**
 * Request parameters for apiV1PermissionsPost operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission 생성
   */
  readonly request: RequestPermissionBulkCreateRequest;
}

/**
 * Request parameters for apiV1PermissionsRolesGet operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service type
   */
  readonly serviceType?: Array<string>;

  /**
   * display service name
   */
  readonly displayServiceName?: Array<string>;

  /**
   * Permission ID
   */
  readonly permissionId?: string;

  /**
   * role name
   */
  readonly roleName?: string;

  /**
   * scope
   */
  readonly scope?: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;
}

/**
 * Request parameters for apiV1PermissionsRolesPost operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsRolesPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * permission 생성
   */
  readonly request: RequestPermissionRoleBulkCreateRequest;
}

/**
 * Request parameters for apiV1PermissionsServicesServiceTypeDelete operation in PermissionsApi.
 */
export interface PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service type
   */
  readonly serviceType: string;
}

/**
 * PermissionsApi - object-oriented interface
 */
export class PermissionsApi extends BaseAPI implements PermissionsApiInterface {
  /**
   * 시스템 관리자만 가능 permission list 조회. service type을 이용하여 필터링 가능
   * @summary permission list 조회
   * @param {PermissionsApiApiV11PermissionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11PermissionsGet(
    requestParameters: PermissionsApiApiV11PermissionsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV11PermissionsGet(
        requestParameters.xAuthToken,
        requestParameters.serviceType,
        requestParameters.displayServiceName,
        requestParameters.permissionId,
        requestParameters.targetUserCheckEnabled,
        requestParameters.size,
        requestParameters.offset,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission apis 조회
   * @summary Permission apis 조회
   * @param {PermissionsApiApiV1PermissionsApisGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsApisGet(
    requestParameters: PermissionsApiApiV1PermissionsApisGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsApisGet(
        requestParameters.xAuthToken,
        requestParameters.httpMethod,
        requestParameters.offset,
        requestParameters.path,
        requestParameters.permissionId,
        requestParameters.serviceType,
        requestParameters.size,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission apis 생성 (추가)
   * @summary Permission apis 생성
   * @param {PermissionsApiApiV1PermissionsApisPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsApisPost(
    requestParameters: PermissionsApiApiV1PermissionsApisPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsApisPost(
        requestParameters.xAuthToken,
        requestParameters.createPermissionApisRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission apis 수정 (replace)
   * @summary Permission apis 수정
   * @param {PermissionsApiApiV1PermissionsApisPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsApisPut(
    requestParameters: PermissionsApiApiV1PermissionsApisPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsApisPut(
        requestParameters.xAuthToken,
        requestParameters.updatePermissionApisRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission 삭제
   * @summary Permission 삭제
   * @param {PermissionsApiApiV1PermissionsPermissionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsPermissionIdDelete(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsPermissionIdDelete(
        requestParameters.xAuthToken,
        requestParameters.permissionId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 id를 기준으로 permission 조회
   * @summary permission id를 기준으로 permission 조회
   * @param {PermissionsApiApiV1PermissionsPermissionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsPermissionIdGet(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsPermissionIdGet(
        requestParameters.xAuthToken,
        requestParameters.permissionId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission 수정
   * @summary Permission 수정
   * @param {PermissionsApiApiV1PermissionsPermissionIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsPermissionIdPut(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsPermissionIdPut(
        requestParameters.xAuthToken,
        requestParameters.permissionId,
        requestParameters.permissionUpdateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission 역할 삭제
   * @summary Permission 역할 삭제
   * @param {PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
    requestParameters: PermissionsApiApiV1PermissionsPermissionIdRolesRoleIdScopesScopeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsPermissionIdRolesRoleIdScopesScopeDelete(
        requestParameters.xAuthToken,
        requestParameters.permissionId,
        requestParameters.roleId,
        requestParameters.scope,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission 생성 1. \"id\" - \"{service_type}:{원하는이름}\" 의 형식 권장 - \'.\', \':\' 을 제외한 특수 문자는 사용 불가 2. \"default_role_name\" - permission에 필요한 최소 권한 생성. \'admin\', \'member\' 와 같이 하나의 역할만 입력 가능. 3. \"path\" - id와 같은 uri parameter가 존재하는 경우, \'{}\'를 이용. {[a-zA-Z0-9-_.~]+} (ex. /api/users/{userid123} ). - proxy path가 포함되는 경우, \'{proxy+}\'와 같이 입력. {proxy\\+} (ex. /api/proxy_api/{proxy+} ) - 특수문자, 공백이 들어가는 경우 에러 4. \"default_role_scope\" - default_role_name 의 scope 설정. 하나의 scope 만 입력 가능 (ex. domain, project, system..)
   * @summary permission 생성
   * @param {PermissionsApiApiV1PermissionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsPost(
    requestParameters: PermissionsApiApiV1PermissionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission 역할 list 조회. service type을 이용하여 필터링 가능
   * @summary permission 역할 list 조회
   * @param {PermissionsApiApiV1PermissionsRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsRolesGet(
    requestParameters: PermissionsApiApiV1PermissionsRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsRolesGet(
        requestParameters.xAuthToken,
        requestParameters.serviceType,
        requestParameters.displayServiceName,
        requestParameters.permissionId,
        requestParameters.roleName,
        requestParameters.scope,
        requestParameters.size,
        requestParameters.offset,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 permission 생성
   * @summary permission의 role 정보 등록
   * @param {PermissionsApiApiV1PermissionsRolesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsRolesPost(
    requestParameters: PermissionsApiApiV1PermissionsRolesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsRolesPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 시스템 관리자만 가능 Service Type에 해당 하는 모든 Permission 삭제
   * @summary Service Type에 해당 하는 모든 Permission 삭제
   * @param {PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1PermissionsServicesServiceTypeDelete(
    requestParameters: PermissionsApiApiV1PermissionsServicesServiceTypeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PermissionsApiFp(this.configuration)
      .apiV1PermissionsServicesServiceTypeDelete(
        requestParameters.xAuthToken,
        requestParameters.serviceType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ProjectsApi - axios parameter creator
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 프로젝트에 권한이 있는 사용자 목록 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자는 제외) Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} [id] User ID, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type(user, service, all, account, agent), 대소문자 구분x
     * @param {Array<string>} [role] user search by role id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0인 경우 전체 반환
     * @param {ApiV11ProjectsProjectIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV11ProjectsProjectIdUsersGet: async (
      xAuthToken: string,
      projectId: string,
      id?: string,
      name?: string,
      userType?: string,
      role?: Array<string>,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11ProjectsProjectIdUsersGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11ProjectsProjectIdUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV11ProjectsProjectIdUsersGet', 'projectId', projectId);
      const localVarPath = `/api/v1_1/projects/{project_id}/users`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      if (role) {
        localVarQueryParameter['role'] = role;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트의 실효 그룹 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 그룹 판정에 반영한다 — 미등록 role 로만 할당된 그룹은 제외된다.
     * @summary 프로젝트의 실효 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 전체 반환
     * @param {string} [id] search by group id, 영소문자+숫자 32자
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {ApiV12ProjectsProjectIdGroupsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdGroupsGet: async (
      xAuthToken: string,
      projectId: string,
      offset?: number,
      size?: number,
      id?: string,
      name?: string,
      sortOrder?: ApiV12ProjectsProjectIdGroupsGetSortOrderEnum,
      sortColumn?: string,
      inherited?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdGroupsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdGroupsGet', 'projectId', projectId);
      const localVarPath = `/api/v1_2/projects/{project_id}/groups`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트-그룹 역할 조회. 직접 할당 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 도메인 상속(inherited=true, 해당 도메인 하위 전체 프로젝트에 적용)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. actor_type 은 항상 Group 이고 group 은 항상 조회 대상 그룹(URL 의 group_id)을 가리킨다(유저 조회 응답과 모양을 맞춤). role 은 display_order 순, grant_types 는 그룹 직접 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#9 위 groupRoles API 대체)
     * @summary 프로젝트-그룹 역할 조회 (할당 타입별)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체. role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdGroupsGroupIdRolesGet: async (
      xAuthToken: string,
      projectId: string,
      groupId: string,
      inherited?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdGroupsGroupIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdGroupsGroupIdRolesGet', 'projectId', projectId);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdGroupsGroupIdRolesGet', 'groupId', groupId);
      const localVarPath = `/api/v1_2/projects/{project_id}/groups/{group_id}/roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트 실효 멤버 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 프로젝트 실효 멤버 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} [id] User ID, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type(user, service, all, account, agent), 대소문자 구분x
     * @param {Array<string>} [role] user search by role id, 영소문자+숫자 32자
     * @param {string} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0인 경우 전체 반환
     * @param {ApiV12ProjectsProjectIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdUsersGet: async (
      xAuthToken: string,
      projectId: string,
      id?: string,
      name?: string,
      userType?: string,
      role?: Array<string>,
      actorType?: string,
      inherited?: boolean,
      offset?: number,
      size?: number,
      sortOrder?: ApiV12ProjectsProjectIdUsersGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersGet', 'projectId', projectId);
      const localVarPath = `/api/v1_2/projects/{project_id}/users`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      if (role) {
        localVarQueryParameter['role'] = role;
      }

      if (actorType !== undefined) {
        localVarQueryParameter['actor_type'] = actorType;
      }

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트 실효 멤버(직접 할당 + 그룹 경유 + 도메인 상속 포함) 대상 이름 자동완성. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 프로젝트 실효 멤버 이름 자동완성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} name user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type( ex. user, account, agent, all), 대소문자 구분x
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdUsersNameSuggestGet: async (
      xAuthToken: string,
      projectId: string,
      name: string,
      userType?: string,
      size?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersNameSuggestGet', 'projectId', projectId);
      // verify required parameter 'name' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersNameSuggestGet', 'name', name);
      const localVarPath = `/api/v1_2/projects/{project_id}/users/name/suggest`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트-유저 역할 조회. 직접 할당 + 그룹 경유 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 직접(actor_type=User, group=null)인지 어느 그룹을 경유했는지(actor_type=Group, group 채워짐), 도메인 상속(inherited=true)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 직접 → 유저 상속 → 그룹 상속 순(동일 순위 내 그룹명 순)으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#1 GET /api/v1/users/{user_id}/projects/{project_id}/roles, #2 위 roles API 대체)
     * @summary 프로젝트-유저 역할 조회 (할당 타입별)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체. actor_type 과 마찬가지로 부여 경로에 걸린다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdUsersUserIdRolesGet: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      actorType?: string,
      inherited?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersUserIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersUserIdRolesGet', 'projectId', projectId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV12ProjectsProjectIdUsersUserIdRolesGet', 'userId', userId);
      const localVarPath = `/api/v1_2/projects/{project_id}/users/{user_id}/roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (actorType !== undefined) {
        localVarQueryParameter['actor_type'] = actorType;
      }

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트 전체 목록 조회.(인증 token 의 domain 기준)
     * @summary 프로젝트 전체 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [domainId] project search by domain id, 영소문자+숫자 32자
     * @param {string} [domainName] project search by domain name, 영대소문자+숫자+특수문자(-)
     * @param {string} [id] project search by project id, 영소문자+숫자 32자
     * @param {string} [name] project search by project name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [nameLike] true 인 경우 name 검색 시 like 검색. false 인 경우 name equal 검색
     * @param {string} [nickname] project search by project nickname, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [nicknameLike] true 인 경우 nickname 검색 시 like 검색. false 인 경우 nickname equal 검색
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      domainId?: string,
      domainName?: string,
      id?: string,
      name?: string,
      nameLike?: boolean,
      nickname?: string,
      nicknameLike?: boolean,
      includeDisabled?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/projects`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (domainName !== undefined) {
        localVarQueryParameter['domain_name'] = domainName;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name_like'] = nameLike;
      }

      if (nickname !== undefined) {
        localVarQueryParameter['nickname'] = nickname;
      }

      if (nicknameLike !== undefined) {
        localVarQueryParameter['nickname_like'] = nicknameLike;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용하려는 Project Name 가 이미 존재하는지 확인. 이미 존재하는 경우 http status 204, 존재하지 않는 경우 404
     * @summary 사용하려는 Project Name 이 이미 존재하는지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectName Project name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsNameProjectNameHead: async (
      xAuthToken: string,
      projectName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsNameProjectNameHead', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectName' is not null or undefined
      assertParamExists('apiV1ProjectsNameProjectNameHead', 'projectName', projectName);
      const localVarPath = `/api/v1/projects/name/{project_name}`.replace(
        '{project_name}',
        encodeURIComponent(String(projectName)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Project 생성
     * @summary Project 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudProjectCreateRequest} project Project 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsPost: async (
      xAuthToken: string,
      project: RequestCloudProjectCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'project' is not null or undefined
      assertParamExists('apiV1ProjectsPost', 'project', project);
      const localVarPath = `/api/v1/projects`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        project,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Project 정보 삭제 (DB 상에서 삭제)
     * @summary Project 정보 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdDelete: async (
      xAuthToken: string,
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdDelete', 'projectId', projectId);
      const localVarPath = `/api/v1/projects/{project_id}`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Project 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
     * @summary Project 활성/비활성화
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {boolean} enabled true: 활성화, false: 비활성화
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdEnabledPatch: async (
      xAuthToken: string,
      projectId: string,
      enabled: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEnabledPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEnabledPatch', 'projectId', projectId);
      // verify required parameter 'enabled' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdEnabledPatch', 'enabled', enabled);
      const localVarPath = `/api/v1/projects/{project_id}/enabled`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (enabled !== undefined) {
        localVarQueryParameter['enabled'] = enabled;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 Project 정보 상세 조회
     * @summary 지정한 Project 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGet: async (
      xAuthToken: string,
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGet', 'projectId', projectId);
      const localVarPath = `/api/v1/projects/{project_id}`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에 권한이 있는 그룹 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 그룹 목록 조회.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 전체 반환
     * @param {string} [id] search by group id, 영소문자+숫자 32자
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {ApiV1ProjectsProjectIdGroupsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsGet: async (
      xAuthToken: string,
      projectId: string,
      offset?: number,
      size?: number,
      id?: string,
      name?: string,
      sortOrder?: ApiV1ProjectsProjectIdGroupsGetSortOrderEnum,
      sortColumn?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsGet', 'projectId', projectId);
      const localVarPath = `/api/v1/projects/{project_id}/groups`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에 권한이 있는 그룹의 role 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups/{group_id}/roles 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 그룹의 role 목록 조회.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsGroupIdRolesGet: async (
      xAuthToken: string,
      projectId: string,
      groupId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsGroupIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsGroupIdRolesGet', 'projectId', projectId);
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsGroupIdRolesGet', 'groupId', groupId);
      const localVarPath = `/api/v1/projects/{project_id}/groups/{group_id}/roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{group_id}', encodeURIComponent(String(groupId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
     * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} groupIds Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsRolesDelete: async (
      xAuthToken: string,
      projectId: string,
      groupIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsRolesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsRolesDelete', 'projectId', projectId);
      // verify required parameter 'groupIds' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsRolesDelete', 'groupIds', groupIds);
      const localVarPath = `/api/v1/projects/{project_id}/groups/roles`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (groupIds) {
        localVarQueryParameter['group_ids'] = groupIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {RequestAssignGroupsToProjectRequest} cloudGroupRoleRequest group ids, role ids, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsRolesPut: async (
      xAuthToken: string,
      projectId: string,
      cloudGroupRoleRequest: RequestAssignGroupsToProjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdGroupsRolesPut', 'projectId', projectId);
      // verify required parameter 'cloudGroupRoleRequest' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdGroupsRolesPut',
        'cloudGroupRoleRequest',
        cloudGroupRoleRequest,
      );
      const localVarPath = `/api/v1/projects/{project_id}/groups/roles`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cloudGroupRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Project 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Project 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {RequestCloudProjectUpdateRequest} project Project 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdPatch: async (
      xAuthToken: string,
      projectId: string,
      project: RequestCloudProjectUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdPatch', 'projectId', projectId);
      // verify required parameter 'project' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdPatch', 'project', project);
      const localVarPath = `/api/v1/projects/{project_id}`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        project,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 Project 에서 role_ids 로 주어진 role 을 **실효적으로 보유한(= 그 role 로 프로젝트 스코프 토큰 발급이 가능한) 활성 user** 를 중복 없이(distinct) 조회한다. 장애/점검 시 admin·member 등 특정 권한 보유자에게 일괄 연락(메일/SMS)하기 위한 대상자 산출 용도.  **포함(반환) 조건 — 아래 3가지를 모두 만족하는 user:** 1. (도달 경로) 다음 4경로 중 하나 이상으로 project 에 role 이 도달한다. ① User→Project 직접 부여, ② Group→Project 부여 + 해당 group 소속, ③ User→Domain 부여(상속, inherited=1), ④ Group→Domain 부여(상속) + 해당 group 소속. — 즉 프로젝트 스코프 토큰 발급 시 token.roles 에 실리는 경로와 동일하다. 2. (implied 전개) 부여된 role 의 상속 관계(admin ⊇ member ⊇ reader)를 전개한 실효 role 이 role_ids 와 겹친다. 예) admin 보유자는 role_ids=member 조회에도 포함된다. 3. (활성) user.enabled = true. 비활성 계정은 토큰 발급이 불가하므로 제외된다.  **제외되는 경우:** 일반 domain 할당(비상속, inherited=0)은 project 로 내려오지 않아 제외 · 순수 system 스코프 role(system-admin 등)만 보유한 경우 제외(프로젝트 토큰 role 에 안 섞임) · 비활성 user 제외.  **응답:** 각 user 는 1건만 반환되며(distinct), user 의 전체 정보(id/name/email/telephone/enabled/status 등)와 함께 `role_ids`(해당 user 의 실효 role 중 요청한 role_ids 에 해당하는 것)를 포함한다. role_ids 를 여러 개 주면 그 합집합으로 조회한다. 연락처(email/telephone)는 개인정보 암호화가 켜진 환경(공공)에서만 복호화되어 내려간다.
     * @summary 지정한 Project 내 지정한 role 을 가진 user 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} roleIds 조회할 Role ID 목록(최소 1개, 최대 100개). 각 32자. 여러 개 지정 시 합집합. 반환 user 는 이 role 들을 implied 전개 기준으로 실효 보유한 활성 user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdRolesUsersGet: async (
      xAuthToken: string,
      projectId: string,
      roleIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdRolesUsersGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdRolesUsersGet', 'projectId', projectId);
      // verify required parameter 'roleIds' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdRolesUsersGet', 'roleIds', roleIds);
      const localVarPath = `/api/v1/projects/{project_id}/roles/users`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (roleIds) {
        localVarQueryParameter['role_ids'] = roleIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용하려는 다수의 이름을 project 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 사용하려는 다수의 이름을 project 내애 존재하는 이름인지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} names user name
     * @param {string} userType user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersNameMatchGet: async (
      xAuthToken: string,
      projectId: string,
      names: Array<string>,
      userType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersNameMatchGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersNameMatchGet', 'projectId', projectId);
      // verify required parameter 'names' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersNameMatchGet', 'names', names);
      // verify required parameter 'userType' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersNameMatchGet', 'userType', userType);
      const localVarPath = `/api/v1/projects/{project_id}/users/name/match`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (names) {
        localVarQueryParameter['names'] = names;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * get Users Suggestions of Project Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users/name/suggest 로 대체되었다.
     * @summary Suggest Users of Project
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type( ex. user, account, agent, all), 대소문자 구분x
     * @param {string} [assignmentType] user search by Assignment Type (ex. UserProject, GroupProject, ALL ), 대소문자 구분
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersNameSuggestGet: async (
      xAuthToken: string,
      projectId: string,
      name?: string,
      userType?: string,
      assignmentType?: string,
      size?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersNameSuggestGet', 'projectId', projectId);
      const localVarPath = `/api/v1/projects/{project_id}/users/name/suggest`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (userType !== undefined) {
        localVarQueryParameter['user_type'] = userType;
      }

      if (assignmentType !== undefined) {
        localVarQueryParameter['assignment_type'] = assignmentType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
     * @summary 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} userIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersRolesDelete: async (
      xAuthToken: string,
      projectId: string,
      userIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersRolesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersRolesDelete', 'projectId', projectId);
      // verify required parameter 'userIds' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersRolesDelete', 'userIds', userIds);
      const localVarPath = `/api/v1/projects/{project_id}/users/roles`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userIds) {
        localVarQueryParameter['user_ids'] = userIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다수의 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 삭제 후 신규 요청한 role 로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 다수의 사용자에게 Project 의 role 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {RequestAssignToUsersOnProjectRequest} assignToUsersOnProjectRequest user ids and role ids, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersRolesPut: async (
      xAuthToken: string,
      projectId: string,
      assignToUsersOnProjectRequest: RequestAssignToUsersOnProjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersRolesPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersRolesPut', 'projectId', projectId);
      // verify required parameter 'assignToUsersOnProjectRequest' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdUsersRolesPut',
        'assignToUsersOnProjectRequest',
        assignToUsersOnProjectRequest,
      );
      const localVarPath = `/api/v1/projects/{project_id}/users/roles`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignToUsersOnProjectRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * effective-roles 와 같은 역할 집합(직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 콘솔 노출 대상 role 만 반환하므로(kic_role_extra 미등록 role 제외) 표시 정보가 없는 effective-roles 보다 결과가 적을 수 있다. role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 프로젝트에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet',
        'projectId',
        projectId,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet',
        'userId',
        userId,
      );
      const localVarPath = `/api/v1/projects/{project_id}/users/{user_id}/effective-roles/display`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에서 사용자가 가진 effective role 목록 조회 (직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개). 프로젝트 스코프 토큰 발급 시의 token.roles 와 동일하며, 토큰 role 캐시를 재사용한다.
     * @summary 프로젝트에서 사용자의 effective role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet',
        'projectId',
        projectId,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet', 'userId', userId);
      const localVarPath = `/api/v1/projects/{project_id}/users/{user_id}/effective-roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에 권한이 있는 사용자 상세 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자 포함) 멤버 판정 기준은 실효 멤버 목록 조회와 동일하다 — 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 반영한다. 미등록 role 로만 할당된 사용자는 멤버가 아니므로 조회되지 않는다.
     * @summary 프로젝트에 권한이 있는 사용자 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId user ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdGet: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdGet', 'projectId', projectId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdGet', 'userId', userId);
      const localVarPath = `/api/v1/projects/{project_id}/users/{user_id}`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 프로젝트에 권한이 있는 사용자의 role 목록 조회. (직접 할당만, 그룹·도메인 상속 미포함) Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 사용자의 role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdRolesGet: async (
      xAuthToken: string,
      projectId: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdRolesGet', 'projectId', projectId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdUsersUserIdRolesGet', 'userId', userId);
      const localVarPath = `/api/v1/projects/{project_id}/users/{user_id}/roles`
        .replace('{project_id}', encodeURIComponent(String(projectId)))
        .replace('{user_id}', encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProjectsApi - functional programming interface
 */
export const ProjectsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration);
  return {
    /**
     * 프로젝트에 권한이 있는 사용자 목록 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자는 제외) Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 사용자 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} [id] User ID, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type(user, service, all, account, agent), 대소문자 구분x
     * @param {Array<string>} [role] user search by role id, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0인 경우 전체 반환
     * @param {ApiV11ProjectsProjectIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV11ProjectsProjectIdUsersGet(
      xAuthToken: string,
      projectId: string,
      id?: string,
      name?: string,
      userType?: string,
      role?: Array<string>,
      offset?: number,
      size?: number,
      sortOrder?: ApiV11ProjectsProjectIdUsersGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListByProjectMemberExcludeGroupResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11ProjectsProjectIdUsersGet(
        xAuthToken,
        projectId,
        id,
        name,
        userType,
        role,
        offset,
        size,
        sortOrder,
        sortColumn,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV11ProjectsProjectIdUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트의 실효 그룹 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 그룹 판정에 반영한다 — 미등록 role 로만 할당된 그룹은 제외된다.
     * @summary 프로젝트의 실효 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 전체 반환
     * @param {string} [id] search by group id, 영소문자+숫자 32자
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {ApiV12ProjectsProjectIdGroupsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12ProjectsProjectIdGroupsGet(
      xAuthToken: string,
      projectId: string,
      offset?: number,
      size?: number,
      id?: string,
      name?: string,
      sortOrder?: ApiV12ProjectsProjectIdGroupsGetSortOrderEnum,
      sortColumn?: string,
      inherited?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseGetGroupListByProjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV12ProjectsProjectIdGroupsGet(
        xAuthToken,
        projectId,
        offset,
        size,
        id,
        name,
        sortOrder,
        sortColumn,
        inherited,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV12ProjectsProjectIdGroupsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트-그룹 역할 조회. 직접 할당 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 도메인 상속(inherited=true, 해당 도메인 하위 전체 프로젝트에 적용)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. actor_type 은 항상 Group 이고 group 은 항상 조회 대상 그룹(URL 의 group_id)을 가리킨다(유저 조회 응답과 모양을 맞춤). role 은 display_order 순, grant_types 는 그룹 직접 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#9 위 groupRoles API 대체)
     * @summary 프로젝트-그룹 역할 조회 (할당 타입별)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체. role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
      xAuthToken: string,
      projectId: string,
      groupId: string,
      inherited?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssignedRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
          xAuthToken,
          projectId,
          groupId,
          inherited,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV12ProjectsProjectIdGroupsGroupIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트 실효 멤버 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 프로젝트 실효 멤버 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} [id] User ID, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type(user, service, all, account, agent), 대소문자 구분x
     * @param {Array<string>} [role] user search by role id, 영소문자+숫자 32자
     * @param {string} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0인 경우 전체 반환
     * @param {ApiV12ProjectsProjectIdUsersGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12ProjectsProjectIdUsersGet(
      xAuthToken: string,
      projectId: string,
      id?: string,
      name?: string,
      userType?: string,
      role?: Array<string>,
      actorType?: string,
      inherited?: boolean,
      offset?: number,
      size?: number,
      sortOrder?: ApiV12ProjectsProjectIdUsersGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListProjectMembersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV12ProjectsProjectIdUsersGet(
        xAuthToken,
        projectId,
        id,
        name,
        userType,
        role,
        actorType,
        inherited,
        offset,
        size,
        sortOrder,
        sortColumn,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV12ProjectsProjectIdUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트 실효 멤버(직접 할당 + 그룹 경유 + 도메인 상속 포함) 대상 이름 자동완성. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 프로젝트 실효 멤버 이름 자동완성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} name user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type( ex. user, account, agent, all), 대소문자 구분x
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12ProjectsProjectIdUsersNameSuggestGet(
      xAuthToken: string,
      projectId: string,
      name: string,
      userType?: string,
      size?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuggestedUsers>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12ProjectsProjectIdUsersNameSuggestGet(
          xAuthToken,
          projectId,
          name,
          userType,
          size,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV12ProjectsProjectIdUsersNameSuggestGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트-유저 역할 조회. 직접 할당 + 그룹 경유 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 직접(actor_type=User, group=null)인지 어느 그룹을 경유했는지(actor_type=Group, group 채워짐), 도메인 상속(inherited=true)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 직접 → 유저 상속 → 그룹 상속 순(동일 순위 내 그룹명 순)으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#1 GET /api/v1/users/{user_id}/projects/{project_id}/roles, #2 위 roles API 대체)
     * @summary 프로젝트-유저 역할 조회 (할당 타입별)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체. role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체. actor_type 과 마찬가지로 부여 경로에 걸린다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12ProjectsProjectIdUsersUserIdRolesGet(
      xAuthToken: string,
      projectId: string,
      userId: string,
      actorType?: string,
      inherited?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssignedRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12ProjectsProjectIdUsersUserIdRolesGet(
          xAuthToken,
          projectId,
          userId,
          actorType,
          inherited,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV12ProjectsProjectIdUsersUserIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트 전체 목록 조회.(인증 token 의 domain 기준)
     * @summary 프로젝트 전체 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [domainId] project search by domain id, 영소문자+숫자 32자
     * @param {string} [domainName] project search by domain name, 영대소문자+숫자+특수문자(-)
     * @param {string} [id] project search by project id, 영소문자+숫자 32자
     * @param {string} [name] project search by project name, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [nameLike] true 인 경우 name 검색 시 like 검색. false 인 경우 name equal 검색
     * @param {string} [nickname] project search by project nickname, 영대소문자+숫자+특수문자(-)
     * @param {boolean} [nicknameLike] true 인 경우 nickname 검색 시 like 검색. false 인 경우 nickname equal 검색
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      domainId?: string,
      domainName?: string,
      id?: string,
      name?: string,
      nameLike?: boolean,
      nickname?: string,
      nicknameLike?: boolean,
      includeDisabled?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudProjects>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsGet(
        xAuthToken,
        size,
        offset,
        domainId,
        domainName,
        id,
        name,
        nameLike,
        nickname,
        nicknameLike,
        includeDisabled,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용하려는 Project Name 가 이미 존재하는지 확인. 이미 존재하는 경우 http status 204, 존재하지 않는 경우 404
     * @summary 사용하려는 Project Name 이 이미 존재하는지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectName Project name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsNameProjectNameHead(
      xAuthToken: string,
      projectName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsNameProjectNameHead(
        xAuthToken,
        projectName,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsNameProjectNameHead']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Project 생성
     * @summary Project 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudProjectCreateRequest} project Project 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsPost(
      xAuthToken: string,
      project: RequestCloudProjectCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudProject>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsPost(
        xAuthToken,
        project,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Project 정보 삭제 (DB 상에서 삭제)
     * @summary Project 정보 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdDelete(
      xAuthToken: string,
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdDelete(
        xAuthToken,
        projectId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Project 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
     * @summary Project 활성/비활성화
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {boolean} enabled true: 활성화, false: 비활성화
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdEnabledPatch(
      xAuthToken: string,
      projectId: string,
      enabled: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdEnabledPatch(
        xAuthToken,
        projectId,
        enabled,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdEnabledPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 Project 정보 상세 조회
     * @summary 지정한 Project 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdGet(
      xAuthToken: string,
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudProject>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdGet(
        xAuthToken,
        projectId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에 권한이 있는 그룹 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 그룹 목록 조회.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0일 경우 전체 반환
     * @param {string} [id] search by group id, 영소문자+숫자 32자
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {ApiV1ProjectsProjectIdGroupsGetSortOrderEnum} [sortOrder] sort ordering (asc or desc)
     * @param {string} [sortColumn] sort by (name)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdGroupsGet(
      xAuthToken: string,
      projectId: string,
      offset?: number,
      size?: number,
      id?: string,
      name?: string,
      sortOrder?: ApiV1ProjectsProjectIdGroupsGetSortOrderEnum,
      sortColumn?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseGetGroupListByProjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdGroupsGet(
        xAuthToken,
        projectId,
        offset,
        size,
        id,
        name,
        sortOrder,
        sortColumn,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdGroupsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에 권한이 있는 그룹의 role 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups/{group_id}/roles 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 그룹의 role 목록 조회.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} groupId Group ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
      xAuthToken: string,
      projectId: string,
      groupId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
          xAuthToken,
          projectId,
          groupId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdGroupsGroupIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
     * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} groupIds Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdGroupsRolesDelete(
      xAuthToken: string,
      projectId: string,
      groupIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdGroupsRolesDelete(
          xAuthToken,
          projectId,
          groupIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdGroupsRolesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {RequestAssignGroupsToProjectRequest} cloudGroupRoleRequest group ids, role ids, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdGroupsRolesPut(
      xAuthToken: string,
      projectId: string,
      cloudGroupRoleRequest: RequestAssignGroupsToProjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdGroupsRolesPut(
          xAuthToken,
          projectId,
          cloudGroupRoleRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdGroupsRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Project 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Project 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {RequestCloudProjectUpdateRequest} project Project 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdPatch(
      xAuthToken: string,
      projectId: string,
      project: RequestCloudProjectUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudProject>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdPatch(
        xAuthToken,
        projectId,
        project,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 Project 에서 role_ids 로 주어진 role 을 **실효적으로 보유한(= 그 role 로 프로젝트 스코프 토큰 발급이 가능한) 활성 user** 를 중복 없이(distinct) 조회한다. 장애/점검 시 admin·member 등 특정 권한 보유자에게 일괄 연락(메일/SMS)하기 위한 대상자 산출 용도.  **포함(반환) 조건 — 아래 3가지를 모두 만족하는 user:** 1. (도달 경로) 다음 4경로 중 하나 이상으로 project 에 role 이 도달한다. ① User→Project 직접 부여, ② Group→Project 부여 + 해당 group 소속, ③ User→Domain 부여(상속, inherited=1), ④ Group→Domain 부여(상속) + 해당 group 소속. — 즉 프로젝트 스코프 토큰 발급 시 token.roles 에 실리는 경로와 동일하다. 2. (implied 전개) 부여된 role 의 상속 관계(admin ⊇ member ⊇ reader)를 전개한 실효 role 이 role_ids 와 겹친다. 예) admin 보유자는 role_ids=member 조회에도 포함된다. 3. (활성) user.enabled = true. 비활성 계정은 토큰 발급이 불가하므로 제외된다.  **제외되는 경우:** 일반 domain 할당(비상속, inherited=0)은 project 로 내려오지 않아 제외 · 순수 system 스코프 role(system-admin 등)만 보유한 경우 제외(프로젝트 토큰 role 에 안 섞임) · 비활성 user 제외.  **응답:** 각 user 는 1건만 반환되며(distinct), user 의 전체 정보(id/name/email/telephone/enabled/status 등)와 함께 `role_ids`(해당 user 의 실효 role 중 요청한 role_ids 에 해당하는 것)를 포함한다. role_ids 를 여러 개 주면 그 합집합으로 조회한다. 연락처(email/telephone)는 개인정보 암호화가 켜진 환경(공공)에서만 복호화되어 내려간다.
     * @summary 지정한 Project 내 지정한 role 을 가진 user 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} roleIds 조회할 Role ID 목록(최소 1개, 최대 100개). 각 32자. 여러 개 지정 시 합집합. 반환 user 는 이 role 들을 implied 전개 기준으로 실효 보유한 활성 user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdRolesUsersGet(
      xAuthToken: string,
      projectId: string,
      roleIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListUserAssignmentsByProjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdRolesUsersGet(
        xAuthToken,
        projectId,
        roleIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdRolesUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용하려는 다수의 이름을 project 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 사용하려는 다수의 이름을 project 내애 존재하는 이름인지 확인
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} names user name
     * @param {string} userType user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersNameMatchGet(
      xAuthToken: string,
      projectId: string,
      names: Array<string>,
      userType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUserIdMap>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersNameMatchGet(
          xAuthToken,
          projectId,
          names,
          userType,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersNameMatchGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * get Users Suggestions of Project Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users/name/suggest 로 대체되었다.
     * @summary Suggest Users of Project
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} [name] user prefix search by name, 이메일 사용 가능 문자
     * @param {string} [userType] user search by User Type( ex. user, account, agent, all), 대소문자 구분x
     * @param {string} [assignmentType] user search by Assignment Type (ex. UserProject, GroupProject, ALL ), 대소문자 구분
     * @param {number} [size] list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersNameSuggestGet(
      xAuthToken: string,
      projectId: string,
      name?: string,
      userType?: string,
      assignmentType?: string,
      size?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuggestedUsers>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersNameSuggestGet(
          xAuthToken,
          projectId,
          name,
          userType,
          assignmentType,
          size,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersNameSuggestGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
     * @summary 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {Array<string>} userIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersRolesDelete(
      xAuthToken: string,
      projectId: string,
      userIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersRolesDelete(
          xAuthToken,
          projectId,
          userIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersRolesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다수의 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 삭제 후 신규 요청한 role 로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 다수의 사용자에게 Project 의 role 부여
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {RequestAssignToUsersOnProjectRequest} assignToUsersOnProjectRequest user ids and role ids, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersRolesPut(
      xAuthToken: string,
      projectId: string,
      assignToUsersOnProjectRequest: RequestAssignToUsersOnProjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersRolesPut(
        xAuthToken,
        projectId,
        assignToUsersOnProjectRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersRolesPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * effective-roles 와 같은 역할 집합(직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 콘솔 노출 대상 role 만 반환하므로(kic_role_extra 미등록 role 제외) 표시 정보가 없는 effective-roles 보다 결과가 적을 수 있다. role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 프로젝트에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
      xAuthToken: string,
      projectId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEffectiveRolesDisplay>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
          xAuthToken,
          projectId,
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ProjectsApi.apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에서 사용자가 가진 effective role 목록 조회 (직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개). 프로젝트 스코프 토큰 발급 시의 token.roles 와 동일하며, 토큰 role 캐시를 재사용한다.
     * @summary 프로젝트에서 사용자의 effective role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
      xAuthToken: string,
      projectId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectUserEffectiveRoles>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
          xAuthToken,
          projectId,
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에 권한이 있는 사용자 상세 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자 포함) 멤버 판정 기준은 실효 멤버 목록 조회와 동일하다 — 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 반영한다. 미등록 role 로만 할당된 사용자는 멤버가 아니므로 조회되지 않는다.
     * @summary 프로젝트에 권한이 있는 사용자 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId user ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersUserIdGet(
      xAuthToken: string,
      projectId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserGetByProjectResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersUserIdGet(
          xAuthToken,
          projectId,
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersUserIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 프로젝트에 권한이 있는 사용자의 role 목록 조회. (직접 할당만, 그룹·도메인 상속 미포함) Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 사용자의 role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdUsersUserIdRolesGet(
      xAuthToken: string,
      projectId: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdUsersUserIdRolesGet(
          xAuthToken,
          projectId,
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.apiV1ProjectsProjectIdUsersUserIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ProjectsApi - factory interface
 */
export const ProjectsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ProjectsApiFp(configuration);
  return {
    /**
     * 프로젝트에 권한이 있는 사용자 목록 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자는 제외) Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 사용자 목록 조회
     * @param {ProjectsApiApiV11ProjectsProjectIdUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV11ProjectsProjectIdUsersGet(
      requestParameters: ProjectsApiApiV11ProjectsProjectIdUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListByProjectMemberExcludeGroupResponse> {
      return localVarFp
        .apiV11ProjectsProjectIdUsersGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.id,
          requestParameters.name,
          requestParameters.userType,
          requestParameters.role,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트의 실효 그룹 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 그룹 판정에 반영한다 — 미등록 role 로만 할당된 그룹은 제외된다.
     * @summary 프로젝트의 실효 그룹 목록 조회
     * @param {ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdGroupsGet(
      requestParameters: ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGetGroupListByProjectResponse> {
      return localVarFp
        .apiV12ProjectsProjectIdGroupsGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.id,
          requestParameters.name,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          requestParameters.inherited,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트-그룹 역할 조회. 직접 할당 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 도메인 상속(inherited=true, 해당 도메인 하위 전체 프로젝트에 적용)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. actor_type 은 항상 Group 이고 group 은 항상 조회 대상 그룹(URL 의 group_id)을 가리킨다(유저 조회 응답과 모양을 맞춤). role 은 display_order 순, grant_types 는 그룹 직접 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#9 위 groupRoles API 대체)
     * @summary 프로젝트-그룹 역할 조회 (할당 타입별)
     * @param {ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
      requestParameters: ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAssignedRoles> {
      return localVarFp
        .apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.groupId,
          requestParameters.inherited,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트 실효 멤버 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 프로젝트 실효 멤버 목록 조회
     * @param {ProjectsApiApiV12ProjectsProjectIdUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdUsersGet(
      requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListProjectMembersResponse> {
      return localVarFp
        .apiV12ProjectsProjectIdUsersGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.id,
          requestParameters.name,
          requestParameters.userType,
          requestParameters.role,
          requestParameters.actorType,
          requestParameters.inherited,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트 실효 멤버(직접 할당 + 그룹 경유 + 도메인 상속 포함) 대상 이름 자동완성. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 프로젝트 실효 멤버 이름 자동완성
     * @param {ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdUsersNameSuggestGet(
      requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSuggestedUsers> {
      return localVarFp
        .apiV12ProjectsProjectIdUsersNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.name,
          requestParameters.userType,
          requestParameters.size,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트-유저 역할 조회. 직접 할당 + 그룹 경유 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 직접(actor_type=User, group=null)인지 어느 그룹을 경유했는지(actor_type=Group, group 채워짐), 도메인 상속(inherited=true)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 직접 → 유저 상속 → 그룹 상속 순(동일 순위 내 그룹명 순)으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#1 GET /api/v1/users/{user_id}/projects/{project_id}/roles, #2 위 roles API 대체)
     * @summary 프로젝트-유저 역할 조회 (할당 타입별)
     * @param {ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ProjectsProjectIdUsersUserIdRolesGet(
      requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseAssignedRoles> {
      return localVarFp
        .apiV12ProjectsProjectIdUsersUserIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          requestParameters.actorType,
          requestParameters.inherited,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트 전체 목록 조회.(인증 token 의 domain 기준)
     * @summary 프로젝트 전체 목록 조회
     * @param {ProjectsApiApiV1ProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsGet(
      requestParameters: ProjectsApiApiV1ProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudProjects> {
      return localVarFp
        .apiV1ProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.domainId,
          requestParameters.domainName,
          requestParameters.id,
          requestParameters.name,
          requestParameters.nameLike,
          requestParameters.nickname,
          requestParameters.nicknameLike,
          requestParameters.includeDisabled,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용하려는 Project Name 가 이미 존재하는지 확인. 이미 존재하는 경우 http status 204, 존재하지 않는 경우 404
     * @summary 사용하려는 Project Name 이 이미 존재하는지 확인
     * @param {ProjectsApiApiV1ProjectsNameProjectNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsNameProjectNameHead(
      requestParameters: ProjectsApiApiV1ProjectsNameProjectNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsNameProjectNameHead(
          requestParameters.xAuthToken,
          requestParameters.projectName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Project 생성
     * @summary Project 생성
     * @param {ProjectsApiApiV1ProjectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsPost(
      requestParameters: ProjectsApiApiV1ProjectsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudProject> {
      return localVarFp
        .apiV1ProjectsPost(requestParameters.xAuthToken, requestParameters.project, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Project 정보 삭제 (DB 상에서 삭제)
     * @summary Project 정보 삭제
     * @param {ProjectsApiApiV1ProjectsProjectIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdDelete(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Project 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
     * @summary Project 활성/비활성화
     * @param {ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdEnabledPatch(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdEnabledPatch(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.enabled,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 Project 정보 상세 조회
     * @summary 지정한 Project 정보 상세 조회
     * @param {ProjectsApiApiV1ProjectsProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudProject> {
      return localVarFp
        .apiV1ProjectsProjectIdGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에 권한이 있는 그룹 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 그룹 목록 조회.
     * @param {ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGetGroupListByProjectResponse> {
      return localVarFp
        .apiV1ProjectsProjectIdGroupsGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.offset,
          requestParameters.size,
          requestParameters.id,
          requestParameters.name,
          requestParameters.sortOrder,
          requestParameters.sortColumn,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에 권한이 있는 그룹의 role 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups/{group_id}/roles 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 그룹의 role 목록 조회.
     * @param {ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoles> {
      return localVarFp
        .apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.groupId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
     * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
     * @param {ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsRolesDelete(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdGroupsRolesDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.groupIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정
     * @param {ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdGroupsRolesPut(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdGroupsRolesPut(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.cloudGroupRoleRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Project 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Project 정보 수정
     * @param {ProjectsApiApiV1ProjectsProjectIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdPatch(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudProject> {
      return localVarFp
        .apiV1ProjectsProjectIdPatch(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.project,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 Project 에서 role_ids 로 주어진 role 을 **실효적으로 보유한(= 그 role 로 프로젝트 스코프 토큰 발급이 가능한) 활성 user** 를 중복 없이(distinct) 조회한다. 장애/점검 시 admin·member 등 특정 권한 보유자에게 일괄 연락(메일/SMS)하기 위한 대상자 산출 용도.  **포함(반환) 조건 — 아래 3가지를 모두 만족하는 user:** 1. (도달 경로) 다음 4경로 중 하나 이상으로 project 에 role 이 도달한다. ① User→Project 직접 부여, ② Group→Project 부여 + 해당 group 소속, ③ User→Domain 부여(상속, inherited=1), ④ Group→Domain 부여(상속) + 해당 group 소속. — 즉 프로젝트 스코프 토큰 발급 시 token.roles 에 실리는 경로와 동일하다. 2. (implied 전개) 부여된 role 의 상속 관계(admin ⊇ member ⊇ reader)를 전개한 실효 role 이 role_ids 와 겹친다. 예) admin 보유자는 role_ids=member 조회에도 포함된다. 3. (활성) user.enabled = true. 비활성 계정은 토큰 발급이 불가하므로 제외된다.  **제외되는 경우:** 일반 domain 할당(비상속, inherited=0)은 project 로 내려오지 않아 제외 · 순수 system 스코프 role(system-admin 등)만 보유한 경우 제외(프로젝트 토큰 role 에 안 섞임) · 비활성 user 제외.  **응답:** 각 user 는 1건만 반환되며(distinct), user 의 전체 정보(id/name/email/telephone/enabled/status 등)와 함께 `role_ids`(해당 user 의 실효 role 중 요청한 role_ids 에 해당하는 것)를 포함한다. role_ids 를 여러 개 주면 그 합집합으로 조회한다. 연락처(email/telephone)는 개인정보 암호화가 켜진 환경(공공)에서만 복호화되어 내려간다.
     * @summary 지정한 Project 내 지정한 role 을 가진 user 목록 조회
     * @param {ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdRolesUsersGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListUserAssignmentsByProjectResponse> {
      return localVarFp
        .apiV1ProjectsProjectIdRolesUsersGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.roleIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용하려는 다수의 이름을 project 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
     * @summary 사용하려는 다수의 이름을 project 내애 존재하는 이름인지 확인
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersNameMatchGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUserIdMap> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersNameMatchGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.names,
          requestParameters.userType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * get Users Suggestions of Project Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users/name/suggest 로 대체되었다.
     * @summary Suggest Users of Project
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersNameSuggestGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSuggestedUsers> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.name,
          requestParameters.userType,
          requestParameters.assignmentType,
          requestParameters.size,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
     * @summary 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersRolesDelete(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersRolesDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다수의 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 삭제 후 신규 요청한 role 로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 다수의 사용자에게 Project 의 role 부여
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersRolesPut(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersRolesPut(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.assignToUsersOnProjectRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * effective-roles 와 같은 역할 집합(직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 콘솔 노출 대상 role 만 반환하므로(kic_role_extra 미등록 role 제외) 표시 정보가 없는 effective-roles 보다 결과가 적을 수 있다. role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
     * @summary 프로젝트에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseEffectiveRolesDisplay> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에서 사용자가 가진 effective role 목록 조회 (직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개). 프로젝트 스코프 토큰 발급 시의 token.roles 와 동일하며, 토큰 role 캐시를 재사용한다.
     * @summary 프로젝트에서 사용자의 effective role 목록 조회
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectUserEffectiveRoles> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에 권한이 있는 사용자 상세 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자 포함) 멤버 판정 기준은 실효 멤버 목록 조회와 동일하다 — 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 반영한다. 미등록 role 로만 할당된 사용자는 멤버가 아니므로 조회되지 않는다.
     * @summary 프로젝트에 권한이 있는 사용자 상세 조회
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseUserGetByProjectResponse> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersUserIdGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 프로젝트에 권한이 있는 사용자의 role 목록 조회. (직접 할당만, 그룹·도메인 상속 미포함) Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
     * @summary 프로젝트에 권한이 있는 사용자의 role 목록 조회
     * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdUsersUserIdRolesGet(
      requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoles> {
      return localVarFp
        .apiV1ProjectsProjectIdUsersUserIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ProjectsApi - interface
 */
export interface ProjectsApiInterface {
  /**
   * 프로젝트에 권한이 있는 사용자 목록 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자는 제외) Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 사용자 목록 조회
   * @param {ProjectsApiApiV11ProjectsProjectIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV11ProjectsProjectIdUsersGet(
    requestParameters: ProjectsApiApiV11ProjectsProjectIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListByProjectMemberExcludeGroupResponse>;

  /**
   * 프로젝트의 실효 그룹 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 그룹 판정에 반영한다 — 미등록 role 로만 할당된 그룹은 제외된다.
   * @summary 프로젝트의 실효 그룹 목록 조회
   * @param {ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12ProjectsProjectIdGroupsGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGetGroupListByProjectResponse>;

  /**
   * 프로젝트-그룹 역할 조회. 직접 할당 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 도메인 상속(inherited=true, 해당 도메인 하위 전체 프로젝트에 적용)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. actor_type 은 항상 Group 이고 group 은 항상 조회 대상 그룹(URL 의 group_id)을 가리킨다(유저 조회 응답과 모양을 맞춤). role 은 display_order 순, grant_types 는 그룹 직접 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#9 위 groupRoles API 대체)
   * @summary 프로젝트-그룹 역할 조회 (할당 타입별)
   * @param {ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAssignedRoles>;

  /**
   * 프로젝트 실효 멤버 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
   * @summary 프로젝트 실효 멤버 목록 조회
   * @param {ProjectsApiApiV12ProjectsProjectIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12ProjectsProjectIdUsersGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListProjectMembersResponse>;

  /**
   * 프로젝트 실효 멤버(직접 할당 + 그룹 경유 + 도메인 상속 포함) 대상 이름 자동완성. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
   * @summary 프로젝트 실효 멤버 이름 자동완성
   * @param {ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12ProjectsProjectIdUsersNameSuggestGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSuggestedUsers>;

  /**
   * 프로젝트-유저 역할 조회. 직접 할당 + 그룹 경유 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 직접(actor_type=User, group=null)인지 어느 그룹을 경유했는지(actor_type=Group, group 채워짐), 도메인 상속(inherited=true)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 직접 → 유저 상속 → 그룹 상속 순(동일 순위 내 그룹명 순)으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#1 GET /api/v1/users/{user_id}/projects/{project_id}/roles, #2 위 roles API 대체)
   * @summary 프로젝트-유저 역할 조회 (할당 타입별)
   * @param {ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12ProjectsProjectIdUsersUserIdRolesGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseAssignedRoles>;

  /**
   * 프로젝트 전체 목록 조회.(인증 token 의 domain 기준)
   * @summary 프로젝트 전체 목록 조회
   * @param {ProjectsApiApiV1ProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsGet(
    requestParameters: ProjectsApiApiV1ProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudProjects>;

  /**
   * 사용하려는 Project Name 가 이미 존재하는지 확인. 이미 존재하는 경우 http status 204, 존재하지 않는 경우 404
   * @summary 사용하려는 Project Name 이 이미 존재하는지 확인
   * @param {ProjectsApiApiV1ProjectsNameProjectNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsNameProjectNameHead(
    requestParameters: ProjectsApiApiV1ProjectsNameProjectNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Project 생성
   * @summary Project 생성
   * @param {ProjectsApiApiV1ProjectsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsPost(
    requestParameters: ProjectsApiApiV1ProjectsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudProject>;

  /**
   * Project 정보 삭제 (DB 상에서 삭제)
   * @summary Project 정보 삭제
   * @param {ProjectsApiApiV1ProjectsProjectIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdDelete(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Project 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
   * @summary Project 활성/비활성화
   * @param {ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdEnabledPatch(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 Project 정보 상세 조회
   * @summary 지정한 Project 정보 상세 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudProject>;

  /**
   * 프로젝트에 권한이 있는 그룹 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 그룹 목록 조회.
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdGroupsGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGetGroupListByProjectResponse>;

  /**
   * 프로젝트에 권한이 있는 그룹의 role 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups/{group_id}/roles 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 그룹의 role 목록 조회.
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoles>;

  /**
   * 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
   * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdGroupsRolesDelete(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdGroupsRolesPut(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Project 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Project 정보 수정
   * @param {ProjectsApiApiV1ProjectsProjectIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdPatch(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudProject>;

  /**
   * 지정한 Project 에서 role_ids 로 주어진 role 을 **실효적으로 보유한(= 그 role 로 프로젝트 스코프 토큰 발급이 가능한) 활성 user** 를 중복 없이(distinct) 조회한다. 장애/점검 시 admin·member 등 특정 권한 보유자에게 일괄 연락(메일/SMS)하기 위한 대상자 산출 용도.  **포함(반환) 조건 — 아래 3가지를 모두 만족하는 user:** 1. (도달 경로) 다음 4경로 중 하나 이상으로 project 에 role 이 도달한다. ① User→Project 직접 부여, ② Group→Project 부여 + 해당 group 소속, ③ User→Domain 부여(상속, inherited=1), ④ Group→Domain 부여(상속) + 해당 group 소속. — 즉 프로젝트 스코프 토큰 발급 시 token.roles 에 실리는 경로와 동일하다. 2. (implied 전개) 부여된 role 의 상속 관계(admin ⊇ member ⊇ reader)를 전개한 실효 role 이 role_ids 와 겹친다. 예) admin 보유자는 role_ids=member 조회에도 포함된다. 3. (활성) user.enabled = true. 비활성 계정은 토큰 발급이 불가하므로 제외된다.  **제외되는 경우:** 일반 domain 할당(비상속, inherited=0)은 project 로 내려오지 않아 제외 · 순수 system 스코프 role(system-admin 등)만 보유한 경우 제외(프로젝트 토큰 role 에 안 섞임) · 비활성 user 제외.  **응답:** 각 user 는 1건만 반환되며(distinct), user 의 전체 정보(id/name/email/telephone/enabled/status 등)와 함께 `role_ids`(해당 user 의 실효 role 중 요청한 role_ids 에 해당하는 것)를 포함한다. role_ids 를 여러 개 주면 그 합집합으로 조회한다. 연락처(email/telephone)는 개인정보 암호화가 켜진 환경(공공)에서만 복호화되어 내려간다.
   * @summary 지정한 Project 내 지정한 role 을 가진 user 목록 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdRolesUsersGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListUserAssignmentsByProjectResponse>;

  /**
   * 사용하려는 다수의 이름을 project 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
   * @summary 사용하려는 다수의 이름을 project 내애 존재하는 이름인지 확인
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersNameMatchGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUserIdMap>;

  /**
   * get Users Suggestions of Project Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users/name/suggest 로 대체되었다.
   * @summary Suggest Users of Project
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersNameSuggestGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSuggestedUsers>;

  /**
   * 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
   * @summary 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersRolesDelete(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 다수의 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 삭제 후 신규 요청한 role 로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 다수의 사용자에게 Project 의 role 부여
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersRolesPut(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * effective-roles 와 같은 역할 집합(직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 콘솔 노출 대상 role 만 반환하므로(kic_role_extra 미등록 role 제외) 표시 정보가 없는 effective-roles 보다 결과가 적을 수 있다. role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
   * @summary 프로젝트에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseEffectiveRolesDisplay>;

  /**
   * 프로젝트에서 사용자가 가진 effective role 목록 조회 (직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개). 프로젝트 스코프 토큰 발급 시의 token.roles 와 동일하며, 토큰 role 캐시를 재사용한다.
   * @summary 프로젝트에서 사용자의 effective role 목록 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectUserEffectiveRoles>;

  /**
   * 프로젝트에 권한이 있는 사용자 상세 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자 포함) 멤버 판정 기준은 실효 멤버 목록 조회와 동일하다 — 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 반영한다. 미등록 role 로만 할당된 사용자는 멤버가 아니므로 조회되지 않는다.
   * @summary 프로젝트에 권한이 있는 사용자 상세 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersUserIdGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseUserGetByProjectResponse>;

  /**
   * 프로젝트에 권한이 있는 사용자의 role 목록 조회. (직접 할당만, 그룹·도메인 상속 미포함) Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 사용자의 role 목록 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdUsersUserIdRolesGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoles>;
}

/**
 * Request parameters for apiV11ProjectsProjectIdUsersGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV11ProjectsProjectIdUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * user prefix search by name, 이메일 사용 가능 문자
   */
  readonly name?: string;

  /**
   * user search by User Type(user, service, all, account, agent), 대소문자 구분x
   */
  readonly userType?: string;

  /**
   * user search by role id, 영소문자+숫자 32자
   */
  readonly role?: Array<string>;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0인 경우 전체 반환
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV11ProjectsProjectIdUsersGetSortOrderEnum;

  /**
   * sort by (name)
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV12ProjectsProjectIdGroupsGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0일 경우 전체 반환
   */
  readonly size?: number;

  /**
   * search by group id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * group prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV12ProjectsProjectIdGroupsGetSortOrderEnum;

  /**
   * sort by (name)
   */
  readonly sortColumn?: string;

  /**
   * 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
   */
  readonly inherited?: boolean;
}

/**
 * Request parameters for apiV12ProjectsProjectIdGroupsGroupIdRolesGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;

  /**
   * 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체. role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다
   */
  readonly inherited?: boolean;
}

/**
 * Request parameters for apiV12ProjectsProjectIdUsersGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV12ProjectsProjectIdUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * user prefix search by name, 이메일 사용 가능 문자
   */
  readonly name?: string;

  /**
   * user search by User Type(user, service, all, account, agent), 대소문자 구분x
   */
  readonly userType?: string;

  /**
   * user search by role id, 영소문자+숫자 32자
   */
  readonly role?: Array<string>;

  /**
   * assignment 주체로 필터링 (user or group), 미지정 시 전체
   */
  readonly actorType?: string;

  /**
   * 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
   */
  readonly inherited?: boolean;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0인 경우 전체 반환
   */
  readonly size?: number;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV12ProjectsProjectIdUsersGetSortOrderEnum;

  /**
   * sort by (name)
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV12ProjectsProjectIdUsersNameSuggestGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * user prefix search by name, 이메일 사용 가능 문자
   */
  readonly name: string;

  /**
   * user search by User Type( ex. user, account, agent, all), 대소문자 구분x
   */
  readonly userType?: string;

  /**
   * list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;
}

/**
 * Request parameters for apiV12ProjectsProjectIdUsersUserIdRolesGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * assignment 주체로 필터링 (user or group), 미지정 시 전체. role 이 아니라 부여 경로에 걸리므로, 통과한 경로가 없는 role 은 응답에서 제외된다
   */
  readonly actorType?: string;

  /**
   * 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체. actor_type 과 마찬가지로 부여 경로에 걸린다
   */
  readonly inherited?: boolean;
}

/**
 * Request parameters for apiV1ProjectsGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * project search by domain id, 영소문자+숫자 32자
   */
  readonly domainId?: string;

  /**
   * project search by domain name, 영대소문자+숫자+특수문자(-)
   */
  readonly domainName?: string;

  /**
   * project search by project id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * project search by project name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * true 인 경우 name 검색 시 like 검색. false 인 경우 name equal 검색
   */
  readonly nameLike?: boolean;

  /**
   * project search by project nickname, 영대소문자+숫자+특수문자(-)
   */
  readonly nickname?: string;

  /**
   * true 인 경우 nickname 검색 시 like 검색. false 인 경우 nickname equal 검색
   */
  readonly nicknameLike?: boolean;

  /**
   * 비활성화 project 포함 여부
   */
  readonly includeDisabled?: boolean;
}

/**
 * Request parameters for apiV1ProjectsNameProjectNameHead operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsNameProjectNameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project name, 영대소문자+숫자+특수문자(-)
   */
  readonly projectName: string;
}

/**
 * Request parameters for apiV1ProjectsPost operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project 생성 정보
   */
  readonly project: RequestCloudProjectCreateRequest;
}

/**
 * Request parameters for apiV1ProjectsProjectIdDelete operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdEnabledPatch operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * true: 활성화, false: 비활성화
   */
  readonly enabled: boolean;
}

/**
 * Request parameters for apiV1ProjectsProjectIdGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdGroupsGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0일 경우 전체 반환
   */
  readonly size?: number;

  /**
   * search by group id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * group prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * sort ordering (asc or desc)
   */
  readonly sortOrder?: ApiV1ProjectsProjectIdGroupsGetSortOrderEnum;

  /**
   * sort by (name)
   */
  readonly sortColumn?: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdGroupsGroupIdRolesGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * Group ID, 영소문자+숫자 32자
   */
  readonly groupId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdGroupsRolesDelete operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
   */
  readonly groupIds: Array<string>;
}

/**
 * Request parameters for apiV1ProjectsProjectIdGroupsRolesPut operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * group ids, role ids, 영소문자+숫자 32자
   */
  readonly cloudGroupRoleRequest: RequestAssignGroupsToProjectRequest;
}

/**
 * Request parameters for apiV1ProjectsProjectIdPatch operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * Project 수정 정보
   */
  readonly project: RequestCloudProjectUpdateRequest;
}

/**
 * Request parameters for apiV1ProjectsProjectIdRolesUsersGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * 조회할 Role ID 목록(최소 1개, 최대 100개). 각 32자. 여러 개 지정 시 합집합. 반환 user 는 이 role 들을 implied 전개 기준으로 실효 보유한 활성 user.
   */
  readonly roleIds: Array<string>;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersNameMatchGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * user name
   */
  readonly names: Array<string>;

  /**
   * user | all | service 중 하나만 가능(대소문자 구분x, default&#x3D;all)
   */
  readonly userType: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersNameSuggestGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * user prefix search by name, 이메일 사용 가능 문자
   */
  readonly name?: string;

  /**
   * user search by User Type( ex. user, account, agent, all), 대소문자 구분x
   */
  readonly userType?: string;

  /**
   * user search by Assignment Type (ex. UserProject, GroupProject, ALL ), 대소문자 구분
   */
  readonly assignmentType?: string;

  /**
   * list size, size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersRolesDelete operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userIds: Array<string>;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersRolesPut operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * user ids and role ids, 영소문자+숫자 32자
   */
  readonly assignToUsersOnProjectRequest: RequestAssignToUsersOnProjectRequest;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersUserIdGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * user ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdUsersUserIdRolesGet operation in ProjectsApi.
 */
export interface ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * ProjectsApi - object-oriented interface
 */
export class ProjectsApi extends BaseAPI implements ProjectsApiInterface {
  /**
   * 프로젝트에 권한이 있는 사용자 목록 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자는 제외) Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 사용자 목록 조회
   * @param {ProjectsApiApiV11ProjectsProjectIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV11ProjectsProjectIdUsersGet(
    requestParameters: ProjectsApiApiV11ProjectsProjectIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV11ProjectsProjectIdUsersGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.id,
        requestParameters.name,
        requestParameters.userType,
        requestParameters.role,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트의 실효 그룹 목록 조회. (직접 할당(GroupProject) + 도메인 상속(GroupDomain) 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 그룹 판정에 반영한다 — 미등록 role 로만 할당된 그룹은 제외된다.
   * @summary 프로젝트의 실효 그룹 목록 조회
   * @param {ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12ProjectsProjectIdGroupsGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV12ProjectsProjectIdGroupsGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.id,
        requestParameters.name,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        requestParameters.inherited,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트-그룹 역할 조회. 직접 할당 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 도메인 상속(inherited=true, 해당 도메인 하위 전체 프로젝트에 적용)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. actor_type 은 항상 Group 이고 group 은 항상 조회 대상 그룹(URL 의 group_id)을 가리킨다(유저 조회 응답과 모양을 맞춤). role 은 display_order 순, grant_types 는 그룹 직접 → 그룹 상속 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#9 위 groupRoles API 대체)
   * @summary 프로젝트-그룹 역할 조회 (할당 타입별)
   * @param {ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV12ProjectsProjectIdGroupsGroupIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.groupId,
        requestParameters.inherited,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트 실효 멤버 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
   * @summary 프로젝트 실효 멤버 목록 조회
   * @param {ProjectsApiApiV12ProjectsProjectIdUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12ProjectsProjectIdUsersGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV12ProjectsProjectIdUsersGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.id,
        requestParameters.name,
        requestParameters.userType,
        requestParameters.role,
        requestParameters.actorType,
        requestParameters.inherited,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트 실효 멤버(직접 할당 + 그룹 경유 + 도메인 상속 포함) 대상 이름 자동완성. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
   * @summary 프로젝트 실효 멤버 이름 자동완성
   * @param {ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12ProjectsProjectIdUsersNameSuggestGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV12ProjectsProjectIdUsersNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.name,
        requestParameters.userType,
        requestParameters.size,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트-유저 역할 조회. 직접 할당 + 그룹 경유 + 도메인 상속을 모두 포함한다. 같은 role 을 여러 경로로 부여받았어도 role 은 한 번만 나오고, 부여 경로가 grant_types 로 펼쳐진다. 각 grant_type 은 직접(actor_type=User, group=null)인지 어느 그룹을 경유했는지(actor_type=Group, group 채워짐), 도메인 상속(inherited=true)인지 프로젝트 한정 직접 할당(inherited=false)인지 노출한다. role 은 display_order 순, grant_types 는 유저 직접 → 그룹 직접 → 유저 상속 → 그룹 상속 순(동일 순위 내 그룹명 순)으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). (#1 GET /api/v1/users/{user_id}/projects/{project_id}/roles, #2 위 roles API 대체)
   * @summary 프로젝트-유저 역할 조회 (할당 타입별)
   * @param {ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12ProjectsProjectIdUsersUserIdRolesGet(
    requestParameters: ProjectsApiApiV12ProjectsProjectIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV12ProjectsProjectIdUsersUserIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        requestParameters.actorType,
        requestParameters.inherited,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트 전체 목록 조회.(인증 token 의 domain 기준)
   * @summary 프로젝트 전체 목록 조회
   * @param {ProjectsApiApiV1ProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsGet(
    requestParameters: ProjectsApiApiV1ProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.domainId,
        requestParameters.domainName,
        requestParameters.id,
        requestParameters.name,
        requestParameters.nameLike,
        requestParameters.nickname,
        requestParameters.nicknameLike,
        requestParameters.includeDisabled,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용하려는 Project Name 가 이미 존재하는지 확인. 이미 존재하는 경우 http status 204, 존재하지 않는 경우 404
   * @summary 사용하려는 Project Name 이 이미 존재하는지 확인
   * @param {ProjectsApiApiV1ProjectsNameProjectNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsNameProjectNameHead(
    requestParameters: ProjectsApiApiV1ProjectsNameProjectNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsNameProjectNameHead(
        requestParameters.xAuthToken,
        requestParameters.projectName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Project 생성
   * @summary Project 생성
   * @param {ProjectsApiApiV1ProjectsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsPost(
    requestParameters: ProjectsApiApiV1ProjectsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsPost(requestParameters.xAuthToken, requestParameters.project, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Project 정보 삭제 (DB 상에서 삭제)
   * @summary Project 정보 삭제
   * @param {ProjectsApiApiV1ProjectsProjectIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdDelete(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Project 활성/비활성화 (DB 상에서 삭제는 되지 않고 enabled 속성이 true/false 로 변경)
   * @summary Project 활성/비활성화
   * @param {ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdEnabledPatch(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdEnabledPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdEnabledPatch(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.enabled,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 Project 정보 상세 조회
   * @summary 지정한 Project 정보 상세 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdGet(requestParameters.xAuthToken, requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에 권한이 있는 그룹 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 그룹 목록 조회.
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdGroupsGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdGroupsGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.offset,
        requestParameters.size,
        requestParameters.id,
        requestParameters.name,
        requestParameters.sortOrder,
        requestParameters.sortColumn,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에 권한이 있는 그룹의 role 목록 조회. Deprecated: 도메인 상속(D) 이 누락된다. GET /api/v1_2/projects/{project_id}/groups/{group_id}/roles 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 그룹의 role 목록 조회.
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsGroupIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdGroupsGroupIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.groupId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
   * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 일괄 제거
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdGroupsRolesDelete(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdGroupsRolesDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.groupIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 지정한 프로젝트에 지정한 그룹들에 대한 권한 설정
   * @param {ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdGroupsRolesPut(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdGroupsRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdGroupsRolesPut(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.cloudGroupRoleRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Project 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Project 정보 수정
   * @param {ProjectsApiApiV1ProjectsProjectIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdPatch(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdPatch(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.project,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 Project 에서 role_ids 로 주어진 role 을 **실효적으로 보유한(= 그 role 로 프로젝트 스코프 토큰 발급이 가능한) 활성 user** 를 중복 없이(distinct) 조회한다. 장애/점검 시 admin·member 등 특정 권한 보유자에게 일괄 연락(메일/SMS)하기 위한 대상자 산출 용도.  **포함(반환) 조건 — 아래 3가지를 모두 만족하는 user:** 1. (도달 경로) 다음 4경로 중 하나 이상으로 project 에 role 이 도달한다. ① User→Project 직접 부여, ② Group→Project 부여 + 해당 group 소속, ③ User→Domain 부여(상속, inherited=1), ④ Group→Domain 부여(상속) + 해당 group 소속. — 즉 프로젝트 스코프 토큰 발급 시 token.roles 에 실리는 경로와 동일하다. 2. (implied 전개) 부여된 role 의 상속 관계(admin ⊇ member ⊇ reader)를 전개한 실효 role 이 role_ids 와 겹친다. 예) admin 보유자는 role_ids=member 조회에도 포함된다. 3. (활성) user.enabled = true. 비활성 계정은 토큰 발급이 불가하므로 제외된다.  **제외되는 경우:** 일반 domain 할당(비상속, inherited=0)은 project 로 내려오지 않아 제외 · 순수 system 스코프 role(system-admin 등)만 보유한 경우 제외(프로젝트 토큰 role 에 안 섞임) · 비활성 user 제외.  **응답:** 각 user 는 1건만 반환되며(distinct), user 의 전체 정보(id/name/email/telephone/enabled/status 등)와 함께 `role_ids`(해당 user 의 실효 role 중 요청한 role_ids 에 해당하는 것)를 포함한다. role_ids 를 여러 개 주면 그 합집합으로 조회한다. 연락처(email/telephone)는 개인정보 암호화가 켜진 환경(공공)에서만 복호화되어 내려간다.
   * @summary 지정한 Project 내 지정한 role 을 가진 user 목록 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdRolesUsersGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdRolesUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdRolesUsersGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.roleIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용하려는 다수의 이름을 project 내에 존재하는 이름인지 확인. 존재하지 않거 유효하지 않은 사용자의 경우 응답 결과에 사용자 정보(이름, User Id)가 내려가지 않음. 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 멤버 판정에 반영한다 — 미등록 role 로만 할당된 사용자는 제외된다.
   * @summary 사용하려는 다수의 이름을 project 내애 존재하는 이름인지 확인
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersNameMatchGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersNameMatchGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersNameMatchGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.names,
        requestParameters.userType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * get Users Suggestions of Project Deprecated: 그룹·도메인 상속 멤버가 누락된다. GET /api/v1_2/projects/{project_id}/users/name/suggest 로 대체되었다.
   * @summary Suggest Users of Project
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersNameSuggestGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.name,
        requestParameters.userType,
        requestParameters.assignmentType,
        requestParameters.size,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
   * @summary 다수의 사용자에게 부여된 모든 Project 의 role 을 삭제.
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersRolesDelete(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersRolesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersRolesDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다수의 사용자에게 Project 의 role 부여. 기존에 부여된 role 은 삭제 후 신규 요청한 role 로 부여된다. payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 다수의 사용자에게 Project 의 role 부여
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersRolesPut(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersRolesPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersRolesPut(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.assignToUsersOnProjectRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * effective-roles 와 같은 역할 집합(직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개)에 콘솔 표기용 표시 정보(display_name 등)를 붙여 반환한다. 응답 키는 effective_roles_display 다. 콘솔 노출 대상 role 만 반환하므로(kic_role_extra 미등록 role 제외) 표시 정보가 없는 effective-roles 보다 결과가 적을 수 있다. role 은 display_order 순으로 정렬된다. 보유 role 이 없으면 빈 목록으로 200 반환하며, 호출 권한이 없으면 403 반환.
   * @summary 프로젝트에서 사용자의 effective role 목록 조회 (콘솔 표시 정보 포함)
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersUserIdEffectiveRolesDisplayGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에서 사용자가 가진 effective role 목록 조회 (직접 부여 + 그룹 경유 + 도메인 상속 + implied 전개). 프로젝트 스코프 토큰 발급 시의 token.roles 와 동일하며, 토큰 role 캐시를 재사용한다.
   * @summary 프로젝트에서 사용자의 effective role 목록 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdEffectiveRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersUserIdEffectiveRolesGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에 권한이 있는 사용자 상세 조회. (그룹으로 인해 Project 역할(Role)을 가진 사용자 포함) 멤버 판정 기준은 실효 멤버 목록 조회와 동일하다 — 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 반영한다. 미등록 role 로만 할당된 사용자는 멤버가 아니므로 조회되지 않는다.
   * @summary 프로젝트에 권한이 있는 사용자 상세 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersUserIdGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersUserIdGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 프로젝트에 권한이 있는 사용자의 role 목록 조회. (직접 할당만, 그룹·도메인 상속 미포함) Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
   * @summary 프로젝트에 권한이 있는 사용자의 role 목록 조회
   * @param {ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdUsersUserIdRolesGet(
    requestParameters: ProjectsApiApiV1ProjectsProjectIdUsersUserIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProjectsApiFp(this.configuration)
      .apiV1ProjectsProjectIdUsersUserIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV11ProjectsProjectIdUsersGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV11ProjectsProjectIdUsersGetSortOrderEnum =
  (typeof ApiV11ProjectsProjectIdUsersGetSortOrderEnum)[keyof typeof ApiV11ProjectsProjectIdUsersGetSortOrderEnum];
export const ApiV12ProjectsProjectIdGroupsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV12ProjectsProjectIdGroupsGetSortOrderEnum =
  (typeof ApiV12ProjectsProjectIdGroupsGetSortOrderEnum)[keyof typeof ApiV12ProjectsProjectIdGroupsGetSortOrderEnum];
export const ApiV12ProjectsProjectIdUsersGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV12ProjectsProjectIdUsersGetSortOrderEnum =
  (typeof ApiV12ProjectsProjectIdUsersGetSortOrderEnum)[keyof typeof ApiV12ProjectsProjectIdUsersGetSortOrderEnum];
export const ApiV1ProjectsProjectIdGroupsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1ProjectsProjectIdGroupsGetSortOrderEnum =
  (typeof ApiV1ProjectsProjectIdGroupsGetSortOrderEnum)[keyof typeof ApiV1ProjectsProjectIdGroupsGetSortOrderEnum];

/**
 * RegionApi - axios parameter creator
 */
export const RegionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Region 목록 조회
     * @summary Region 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RegionsGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RegionsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/regions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RegionApi - functional programming interface
 */
export const RegionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RegionApiAxiosParamCreator(configuration);
  return {
    /**
     * Region 목록 조회
     * @summary Region 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RegionsGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRegionListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RegionsGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RegionApi.apiV1RegionsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RegionApi - factory interface
 */
export const RegionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RegionApiFp(configuration);
  return {
    /**
     * Region 목록 조회
     * @summary Region 목록 조회
     * @param {RegionApiApiV1RegionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RegionsGet(
      requestParameters: RegionApiApiV1RegionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseRegionListResponse> {
      return localVarFp
        .apiV1RegionsGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * RegionApi - interface
 */
export interface RegionApiInterface {
  /**
   * Region 목록 조회
   * @summary Region 목록 조회
   * @param {RegionApiApiV1RegionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RegionsGet(
    requestParameters: RegionApiApiV1RegionsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseRegionListResponse>;
}

/**
 * Request parameters for apiV1RegionsGet operation in RegionApi.
 */
export interface RegionApiApiV1RegionsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * RegionApi - object-oriented interface
 */
export class RegionApi extends BaseAPI implements RegionApiInterface {
  /**
   * Region 목록 조회
   * @summary Region 목록 조회
   * @param {RegionApiApiV1RegionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RegionsGet(
    requestParameters: RegionApiApiV1RegionsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RegionApiFp(this.configuration)
      .apiV1RegionsGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * RolesApi - axios parameter creator
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Role extra bulk 수정
     * @summary Role extra bulk 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestRoleExtraBulkUpdateRequest} roleExtraList role extra 수정 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesExtraBulkUpdatePost: async (
      xAuthToken: string,
      roleExtraList: RequestRoleExtraBulkUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesExtraBulkUpdatePost', 'xAuthToken', xAuthToken);
      // verify required parameter 'roleExtraList' is not null or undefined
      assertParamExists('apiV1RolesExtraBulkUpdatePost', 'roleExtraList', roleExtraList);
      const localVarPath = `/api/v1/roles/extra/bulk-update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roleExtraList,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * system 관련 role 을 제외한 모든 role 정보 목록 조회 ( console 에 노출되지 않아도 포함 )
     * @summary 존재하는 모든 role 정보 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [roleName] Role Name, 영대소문자+숫자+특수문자(-)
     * @param {string} [domainId] domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {boolean} [systemRoleOnly] system 역할 조회 (system-xxx)
     * @param {boolean} [exceptSystemRole] system 역할을 제외하고 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesGet: async (
      xAuthToken: string,
      roleName?: string,
      domainId?: string,
      systemRoleOnly?: boolean,
      exceptSystemRole?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/roles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (roleName !== undefined) {
        localVarQueryParameter['role_name'] = roleName;
      }

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (systemRoleOnly !== undefined) {
        localVarQueryParameter['system_role_only'] = systemRoleOnly;
      }

      if (exceptSystemRole !== undefined) {
        localVarQueryParameter['except_system_role'] = exceptSystemRole;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * implied role 목록 조회
     * @summary implied role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesImpliedAllGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesImpliedAllGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/roles/implied/all`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * implied role 목록 조회
     * @summary implied role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesImpliedGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesImpliedGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/roles/implied`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cloud IAM Console role suggest
     * @summary Cloud IAM Console role suggest
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} displayName 검색하고자 하는 문자열. DisplayName 양방향 Like 검색 (정렬 기준: scope ASC, displayOrder ASC)
     * @param {string} [scope] filter by scope. \&#39;domain\&#39; 혹은 \&#39;project\&#39;
     * @param {string} [roleType] filter by role_type. \&#39;basic\&#39;, \&#39;standard\&#39; 또는 \&#39;custom\&#39;
     * @param {number} [size] list size. default&#x3D;20. size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesNameSuggestGet: async (
      xAuthToken: string,
      displayName: string,
      scope?: string,
      roleType?: string,
      size?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesNameSuggestGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'displayName' is not null or undefined
      assertParamExists('apiV1RolesNameSuggestGet', 'displayName', displayName);
      const localVarPath = `/api/v1/roles/name/suggest`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (scope !== undefined) {
        localVarQueryParameter['scope'] = scope;
      }

      if (roleType !== undefined) {
        localVarQueryParameter['role_type'] = roleType;
      }

      if (displayName !== undefined) {
        localVarQueryParameter['display_name'] = displayName;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Console 에서 이용 가능한 role 정보 목록
     * @summary Console 에서 이용 가능한 role 정보 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [id] Role ID, maxLength&#x3D;32
     * @param {string} [scope] filter by scope. \&#39;domain\&#39; or \&#39;project\&#39; scope is available
     * @param {string} [roleType] filter by role_type. Use one of \&#39;basic\&#39;, \&#39;standard\&#39;, \&#39;custom\&#39;
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesPlainGet: async (
      xAuthToken: string,
      id?: string,
      scope?: string,
      roleType?: string,
      size?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesPlainGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/roles/plain`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (scope !== undefined) {
        localVarQueryParameter['scope'] = scope;
      }

      if (roleType !== undefined) {
        localVarQueryParameter['role_type'] = roleType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Role 생성
     * @summary Role 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudRoleCreateRequest} role Role 생성 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesPost: async (
      xAuthToken: string,
      role: RequestCloudRoleCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'role' is not null or undefined
      assertParamExists('apiV1RolesPost', 'role', role);
      const localVarPath = `/api/v1/roles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        role,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Role 삭제
     * @summary Role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} roleId Role ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesRoleIdDelete: async (
      xAuthToken: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesRoleIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1RolesRoleIdDelete', 'roleId', roleId);
      const localVarPath = `/api/v1/roles/{role_id}`.replace(
        '{role_id}',
        encodeURIComponent(String(roleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 role 상세 정보 조회
     * @summary 지정한 role 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} roleId Role ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesRoleIdGet: async (
      xAuthToken: string,
      roleId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesRoleIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1RolesRoleIdGet', 'roleId', roleId);
      const localVarPath = `/api/v1/roles/{role_id}`.replace(
        '{role_id}',
        encodeURIComponent(String(roleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Role 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Role 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} roleId Role ID, 영소문자+숫자 32자
     * @param {RequestCloudRoleUpdateRequest} role Role 수정 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesRoleIdPut: async (
      xAuthToken: string,
      roleId: string,
      role: RequestCloudRoleUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1RolesRoleIdPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists('apiV1RolesRoleIdPut', 'roleId', roleId);
      // verify required parameter 'role' is not null or undefined
      assertParamExists('apiV1RolesRoleIdPut', 'role', role);
      const localVarPath = `/api/v1/roles/{role_id}`.replace(
        '{role_id}',
        encodeURIComponent(String(roleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        role,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RolesApi - functional programming interface
 */
export const RolesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration);
  return {
    /**
     * Role extra bulk 수정
     * @summary Role extra bulk 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestRoleExtraBulkUpdateRequest} roleExtraList role extra 수정 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesExtraBulkUpdatePost(
      xAuthToken: string,
      roleExtraList: RequestRoleExtraBulkUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesExtraBulkUpdatePost(
        xAuthToken,
        roleExtraList,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesExtraBulkUpdatePost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * system 관련 role 을 제외한 모든 role 정보 목록 조회 ( console 에 노출되지 않아도 포함 )
     * @summary 존재하는 모든 role 정보 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [roleName] Role Name, 영대소문자+숫자+특수문자(-)
     * @param {string} [domainId] domain id, 영소문자+숫자 32자 혹은 예외 ID
     * @param {boolean} [systemRoleOnly] system 역할 조회 (system-xxx)
     * @param {boolean} [exceptSystemRole] system 역할을 제외하고 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesGet(
      xAuthToken: string,
      roleName?: string,
      domainId?: string,
      systemRoleOnly?: boolean,
      exceptSystemRole?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoleWithExtraList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesGet(
        xAuthToken,
        roleName,
        domainId,
        systemRoleOnly,
        exceptSystemRole,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * implied role 목록 조회
     * @summary implied role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesImpliedAllGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListRoleWithImpliedResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesImpliedAllGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesImpliedAllGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * implied role 목록 조회
     * @summary implied role 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesImpliedGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseListRoleWithImpliedResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesImpliedGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesImpliedGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Cloud IAM Console role suggest
     * @summary Cloud IAM Console role suggest
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} displayName 검색하고자 하는 문자열. DisplayName 양방향 Like 검색 (정렬 기준: scope ASC, displayOrder ASC)
     * @param {string} [scope] filter by scope. \&#39;domain\&#39; 혹은 \&#39;project\&#39;
     * @param {string} [roleType] filter by role_type. \&#39;basic\&#39;, \&#39;standard\&#39; 또는 \&#39;custom\&#39;
     * @param {number} [size] list size. default&#x3D;20. size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesNameSuggestGet(
      xAuthToken: string,
      displayName: string,
      scope?: string,
      roleType?: string,
      size?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoleExtraList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesNameSuggestGet(
        xAuthToken,
        displayName,
        scope,
        roleType,
        size,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesNameSuggestGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Console 에서 이용 가능한 role 정보 목록
     * @summary Console 에서 이용 가능한 role 정보 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [id] Role ID, maxLength&#x3D;32
     * @param {string} [scope] filter by scope. \&#39;domain\&#39; or \&#39;project\&#39; scope is available
     * @param {string} [roleType] filter by role_type. Use one of \&#39;basic\&#39;, \&#39;standard\&#39;, \&#39;custom\&#39;
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesPlainGet(
      xAuthToken: string,
      id?: string,
      scope?: string,
      roleType?: string,
      size?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoleDisplayList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesPlainGet(
        xAuthToken,
        id,
        scope,
        roleType,
        size,
        offset,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesPlainGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Role 생성
     * @summary Role 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudRoleCreateRequest} role Role 생성 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesPost(
      xAuthToken: string,
      role: RequestCloudRoleCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRoleCreateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesPost(
        xAuthToken,
        role,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Role 삭제
     * @summary Role 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} roleId Role ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesRoleIdDelete(
      xAuthToken: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesRoleIdDelete(
        xAuthToken,
        roleId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesRoleIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 role 상세 정보 조회
     * @summary 지정한 role 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} roleId Role ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesRoleIdGet(
      xAuthToken: string,
      roleId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoleWithExtra>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesRoleIdGet(
        xAuthToken,
        roleId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesRoleIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Role 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Role 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} roleId Role ID, 영소문자+숫자 32자
     * @param {RequestCloudRoleUpdateRequest} role Role 수정 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1RolesRoleIdPut(
      xAuthToken: string,
      roleId: string,
      role: RequestCloudRoleUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRoleCreateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1RolesRoleIdPut(
        xAuthToken,
        roleId,
        role,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RolesApi.apiV1RolesRoleIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RolesApi - factory interface
 */
export const RolesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RolesApiFp(configuration);
  return {
    /**
     * Role extra bulk 수정
     * @summary Role extra bulk 수정
     * @param {RolesApiApiV1RolesExtraBulkUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesExtraBulkUpdatePost(
      requestParameters: RolesApiApiV1RolesExtraBulkUpdatePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1RolesExtraBulkUpdatePost(
          requestParameters.xAuthToken,
          requestParameters.roleExtraList,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * system 관련 role 을 제외한 모든 role 정보 목록 조회 ( console 에 노출되지 않아도 포함 )
     * @summary 존재하는 모든 role 정보 목록 조회
     * @param {RolesApiApiV1RolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesGet(
      requestParameters: RolesApiApiV1RolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoleWithExtraList> {
      return localVarFp
        .apiV1RolesGet(
          requestParameters.xAuthToken,
          requestParameters.roleName,
          requestParameters.domainId,
          requestParameters.systemRoleOnly,
          requestParameters.exceptSystemRole,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * implied role 목록 조회
     * @summary implied role 목록 조회
     * @param {RolesApiApiV1RolesImpliedAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesImpliedAllGet(
      requestParameters: RolesApiApiV1RolesImpliedAllGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListRoleWithImpliedResponse> {
      return localVarFp
        .apiV1RolesImpliedAllGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * implied role 목록 조회
     * @summary implied role 목록 조회
     * @param {RolesApiApiV1RolesImpliedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesImpliedGet(
      requestParameters: RolesApiApiV1RolesImpliedGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListRoleWithImpliedResponse> {
      return localVarFp
        .apiV1RolesImpliedGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Cloud IAM Console role suggest
     * @summary Cloud IAM Console role suggest
     * @param {RolesApiApiV1RolesNameSuggestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesNameSuggestGet(
      requestParameters: RolesApiApiV1RolesNameSuggestGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoleExtraList> {
      return localVarFp
        .apiV1RolesNameSuggestGet(
          requestParameters.xAuthToken,
          requestParameters.displayName,
          requestParameters.scope,
          requestParameters.roleType,
          requestParameters.size,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Console 에서 이용 가능한 role 정보 목록
     * @summary Console 에서 이용 가능한 role 정보 목록
     * @param {RolesApiApiV1RolesPlainGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesPlainGet(
      requestParameters: RolesApiApiV1RolesPlainGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoleDisplayList> {
      return localVarFp
        .apiV1RolesPlainGet(
          requestParameters.xAuthToken,
          requestParameters.id,
          requestParameters.scope,
          requestParameters.roleType,
          requestParameters.size,
          requestParameters.offset,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Role 생성
     * @summary Role 생성
     * @param {RolesApiApiV1RolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesPost(
      requestParameters: RolesApiApiV1RolesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseRoleCreateResponse> {
      return localVarFp
        .apiV1RolesPost(requestParameters.xAuthToken, requestParameters.role, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Role 삭제
     * @summary Role 삭제
     * @param {RolesApiApiV1RolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesRoleIdDelete(
      requestParameters: RolesApiApiV1RolesRoleIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1RolesRoleIdDelete(requestParameters.xAuthToken, requestParameters.roleId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 role 상세 정보 조회
     * @summary 지정한 role 상세 정보 조회
     * @param {RolesApiApiV1RolesRoleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesRoleIdGet(
      requestParameters: RolesApiApiV1RolesRoleIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoleWithExtra> {
      return localVarFp
        .apiV1RolesRoleIdGet(requestParameters.xAuthToken, requestParameters.roleId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Role 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Role 정보 수정
     * @param {RolesApiApiV1RolesRoleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1RolesRoleIdPut(
      requestParameters: RolesApiApiV1RolesRoleIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseRoleCreateResponse> {
      return localVarFp
        .apiV1RolesRoleIdPut(
          requestParameters.xAuthToken,
          requestParameters.roleId,
          requestParameters.role,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * RolesApi - interface
 */
export interface RolesApiInterface {
  /**
   * Role extra bulk 수정
   * @summary Role extra bulk 수정
   * @param {RolesApiApiV1RolesExtraBulkUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesExtraBulkUpdatePost(
    requestParameters: RolesApiApiV1RolesExtraBulkUpdatePostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * system 관련 role 을 제외한 모든 role 정보 목록 조회 ( console 에 노출되지 않아도 포함 )
   * @summary 존재하는 모든 role 정보 목록 조회
   * @param {RolesApiApiV1RolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesGet(
    requestParameters: RolesApiApiV1RolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoleWithExtraList>;

  /**
   * implied role 목록 조회
   * @summary implied role 목록 조회
   * @param {RolesApiApiV1RolesImpliedAllGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesImpliedAllGet(
    requestParameters: RolesApiApiV1RolesImpliedAllGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListRoleWithImpliedResponse>;

  /**
   * implied role 목록 조회
   * @summary implied role 목록 조회
   * @param {RolesApiApiV1RolesImpliedGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesImpliedGet(
    requestParameters: RolesApiApiV1RolesImpliedGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListRoleWithImpliedResponse>;

  /**
   * Cloud IAM Console role suggest
   * @summary Cloud IAM Console role suggest
   * @param {RolesApiApiV1RolesNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesNameSuggestGet(
    requestParameters: RolesApiApiV1RolesNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoleExtraList>;

  /**
   * Console 에서 이용 가능한 role 정보 목록
   * @summary Console 에서 이용 가능한 role 정보 목록
   * @param {RolesApiApiV1RolesPlainGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesPlainGet(
    requestParameters: RolesApiApiV1RolesPlainGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoleDisplayList>;

  /**
   * Role 생성
   * @summary Role 생성
   * @param {RolesApiApiV1RolesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesPost(
    requestParameters: RolesApiApiV1RolesPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseRoleCreateResponse>;

  /**
   * Role 삭제
   * @summary Role 삭제
   * @param {RolesApiApiV1RolesRoleIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesRoleIdDelete(
    requestParameters: RolesApiApiV1RolesRoleIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 지정한 role 상세 정보 조회
   * @summary 지정한 role 상세 정보 조회
   * @param {RolesApiApiV1RolesRoleIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesRoleIdGet(
    requestParameters: RolesApiApiV1RolesRoleIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoleWithExtra>;

  /**
   * Role 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Role 정보 수정
   * @param {RolesApiApiV1RolesRoleIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1RolesRoleIdPut(
    requestParameters: RolesApiApiV1RolesRoleIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseRoleCreateResponse>;
}

/**
 * Request parameters for apiV1RolesExtraBulkUpdatePost operation in RolesApi.
 */
export interface RolesApiApiV1RolesExtraBulkUpdatePostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * role extra 수정 내용
   */
  readonly roleExtraList: RequestRoleExtraBulkUpdateRequest;
}

/**
 * Request parameters for apiV1RolesGet operation in RolesApi.
 */
export interface RolesApiApiV1RolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Role Name, 영대소문자+숫자+특수문자(-)
   */
  readonly roleName?: string;

  /**
   * domain id, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId?: string;

  /**
   * system 역할 조회 (system-xxx)
   */
  readonly systemRoleOnly?: boolean;

  /**
   * system 역할을 제외하고 조회
   */
  readonly exceptSystemRole?: boolean;
}

/**
 * Request parameters for apiV1RolesImpliedAllGet operation in RolesApi.
 */
export interface RolesApiApiV1RolesImpliedAllGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1RolesImpliedGet operation in RolesApi.
 */
export interface RolesApiApiV1RolesImpliedGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1RolesNameSuggestGet operation in RolesApi.
 */
export interface RolesApiApiV1RolesNameSuggestGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 검색하고자 하는 문자열. DisplayName 양방향 Like 검색 (정렬 기준: scope ASC, displayOrder ASC)
   */
  readonly displayName: string;

  /**
   * filter by scope. \&#39;domain\&#39; 혹은 \&#39;project\&#39;
   */
  readonly scope?: string;

  /**
   * filter by role_type. \&#39;basic\&#39;, \&#39;standard\&#39; 또는 \&#39;custom\&#39;
   */
  readonly roleType?: string;

  /**
   * list size. default&#x3D;20. size &lt;&#x3D; 0 혹은 size &gt; 20 인 경우 20으로 설정
   */
  readonly size?: number;
}

/**
 * Request parameters for apiV1RolesPlainGet operation in RolesApi.
 */
export interface RolesApiApiV1RolesPlainGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Role ID, maxLength&#x3D;32
   */
  readonly id?: string;

  /**
   * filter by scope. \&#39;domain\&#39; or \&#39;project\&#39; scope is available
   */
  readonly scope?: string;

  /**
   * filter by role_type. Use one of \&#39;basic\&#39;, \&#39;standard\&#39;, \&#39;custom\&#39;
   */
  readonly roleType?: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;
}

/**
 * Request parameters for apiV1RolesPost operation in RolesApi.
 */
export interface RolesApiApiV1RolesPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Role 생성 내용
   */
  readonly role: RequestCloudRoleCreateRequest;
}

/**
 * Request parameters for apiV1RolesRoleIdDelete operation in RolesApi.
 */
export interface RolesApiApiV1RolesRoleIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Role ID, 영소문자+숫자 32자
   */
  readonly roleId: string;
}

/**
 * Request parameters for apiV1RolesRoleIdGet operation in RolesApi.
 */
export interface RolesApiApiV1RolesRoleIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Role ID, 영소문자+숫자 32자
   */
  readonly roleId: string;
}

/**
 * Request parameters for apiV1RolesRoleIdPut operation in RolesApi.
 */
export interface RolesApiApiV1RolesRoleIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Role ID, 영소문자+숫자 32자
   */
  readonly roleId: string;

  /**
   * Role 수정 내용
   */
  readonly role: RequestCloudRoleUpdateRequest;
}

/**
 * RolesApi - object-oriented interface
 */
export class RolesApi extends BaseAPI implements RolesApiInterface {
  /**
   * Role extra bulk 수정
   * @summary Role extra bulk 수정
   * @param {RolesApiApiV1RolesExtraBulkUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesExtraBulkUpdatePost(
    requestParameters: RolesApiApiV1RolesExtraBulkUpdatePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesExtraBulkUpdatePost(
        requestParameters.xAuthToken,
        requestParameters.roleExtraList,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * system 관련 role 을 제외한 모든 role 정보 목록 조회 ( console 에 노출되지 않아도 포함 )
   * @summary 존재하는 모든 role 정보 목록 조회
   * @param {RolesApiApiV1RolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesGet(
    requestParameters: RolesApiApiV1RolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesGet(
        requestParameters.xAuthToken,
        requestParameters.roleName,
        requestParameters.domainId,
        requestParameters.systemRoleOnly,
        requestParameters.exceptSystemRole,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * implied role 목록 조회
   * @summary implied role 목록 조회
   * @param {RolesApiApiV1RolesImpliedAllGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesImpliedAllGet(
    requestParameters: RolesApiApiV1RolesImpliedAllGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesImpliedAllGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * implied role 목록 조회
   * @summary implied role 목록 조회
   * @param {RolesApiApiV1RolesImpliedGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesImpliedGet(
    requestParameters: RolesApiApiV1RolesImpliedGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesImpliedGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Cloud IAM Console role suggest
   * @summary Cloud IAM Console role suggest
   * @param {RolesApiApiV1RolesNameSuggestGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesNameSuggestGet(
    requestParameters: RolesApiApiV1RolesNameSuggestGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesNameSuggestGet(
        requestParameters.xAuthToken,
        requestParameters.displayName,
        requestParameters.scope,
        requestParameters.roleType,
        requestParameters.size,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Console 에서 이용 가능한 role 정보 목록
   * @summary Console 에서 이용 가능한 role 정보 목록
   * @param {RolesApiApiV1RolesPlainGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesPlainGet(
    requestParameters: RolesApiApiV1RolesPlainGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesPlainGet(
        requestParameters.xAuthToken,
        requestParameters.id,
        requestParameters.scope,
        requestParameters.roleType,
        requestParameters.size,
        requestParameters.offset,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Role 생성
   * @summary Role 생성
   * @param {RolesApiApiV1RolesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesPost(
    requestParameters: RolesApiApiV1RolesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesPost(requestParameters.xAuthToken, requestParameters.role, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Role 삭제
   * @summary Role 삭제
   * @param {RolesApiApiV1RolesRoleIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesRoleIdDelete(
    requestParameters: RolesApiApiV1RolesRoleIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesRoleIdDelete(requestParameters.xAuthToken, requestParameters.roleId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 role 상세 정보 조회
   * @summary 지정한 role 상세 정보 조회
   * @param {RolesApiApiV1RolesRoleIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesRoleIdGet(
    requestParameters: RolesApiApiV1RolesRoleIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesRoleIdGet(requestParameters.xAuthToken, requestParameters.roleId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Role 정보 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Role 정보 수정
   * @param {RolesApiApiV1RolesRoleIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1RolesRoleIdPut(
    requestParameters: RolesApiApiV1RolesRoleIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolesApiFp(this.configuration)
      .apiV1RolesRoleIdPut(
        requestParameters.xAuthToken,
        requestParameters.roleId,
        requestParameters.role,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ServiceAccountsApi - axios parameter creator
 */
export const ServiceAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Service Account 대량 삭제.(Service Agent는 불가)
     * @summary Service Account 대량 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {Array<string>} serviceAccountIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11ProjectsProjectIdServiceAccountsDelete: async (
      xAuthToken: string,
      projectId: string,
      serviceAccountIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11ProjectsProjectIdServiceAccountsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV11ProjectsProjectIdServiceAccountsDelete', 'projectId', projectId);
      // verify required parameter 'serviceAccountIds' is not null or undefined
      assertParamExists(
        'apiV11ProjectsProjectIdServiceAccountsDelete',
        'serviceAccountIds',
        serviceAccountIds,
      );
      const localVarPath = `/api/v1_1/projects/{project_id}/service_accounts`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (serviceAccountIds) {
        localVarQueryParameter['service_account_ids'] = serviceAccountIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 service account의 application credential 대량 삭제.(Service Agent 대상으로 불가)
     * @summary 지정한 service account의 application credential 대량 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {Array<string>} applicationCredentialIds ApplicationCredential ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete: async (
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'applicationCredentialIds' is not null or undefined
      assertParamExists(
        'apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete',
        'applicationCredentialIds',
        applicationCredentialIds,
      );
      const localVarPath =
        `/api/v1_1/service_accounts/{service_account_id}/application_credentials`.replace(
          '{service_account_id}',
          encodeURIComponent(String(serviceAccountId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (applicationCredentialIds) {
        localVarQueryParameter['application_credential_ids'] = applicationCredentialIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account의 지정한 application credential 상세 조회.(Service Agent 대상으로 불가) roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
     * @summary service account의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet: async (
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'applicationCredentialId' is not null or undefined
      assertParamExists(
        'apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet',
        'applicationCredentialId',
        applicationCredentialId,
      );
      const localVarPath =
        `/api/v1_2/service_accounts/{service_account_id}/application_credentials/{application_credential_id}`
          .replace('{service_account_id}', encodeURIComponent(String(serviceAccountId)))
          .replace(
            '{application_credential_id}',
            encodeURIComponent(String(applicationCredentialId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 Project 내에 주어진 이름이 Service Account에 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404.
     * @summary 지정한 Project 내에 Service Account 중복 이름 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {string} serviceAccountName Username, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead: async (
      xAuthToken: string,
      projectId: string,
      serviceAccountName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead',
        'projectId',
        projectId,
      );
      // verify required parameter 'serviceAccountName' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead',
        'serviceAccountName',
        serviceAccountName,
      );
      const localVarPath =
        `/api/v1/projects/{project_id}/service_accounts/name/{service_account_name}`
          .replace('{project_id}', encodeURIComponent(String(projectId)))
          .replace('{service_account_name}', encodeURIComponent(String(serviceAccountName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Service Account 생성
     * @summary Service Account 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {RequestProjectServiceAccountCreateRequest} userCreateRequest Service Account 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdServiceAccountsPost: async (
      xAuthToken: string,
      projectId: string,
      userCreateRequest: RequestProjectServiceAccountCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdServiceAccountsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ProjectsProjectIdServiceAccountsPost', 'projectId', projectId);
      // verify required parameter 'userCreateRequest' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsPost',
        'userCreateRequest',
        userCreateRequest,
      );
      const localVarPath = `/api/v1/projects/{project_id}/service_accounts`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Service Account에 대한 enabled 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Service Account에 대한 enabled 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestServiceAccountUpdateRequest} serviceAccountUpdateRequest Service Account Enabled 만 가능.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch: async (
      xAuthToken: string,
      projectId: string,
      serviceAccountId: string,
      serviceAccountUpdateRequest: RequestServiceAccountUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch',
        'projectId',
        projectId,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'serviceAccountUpdateRequest' is not null or undefined
      assertParamExists(
        'apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch',
        'serviceAccountUpdateRequest',
        serviceAccountUpdateRequest,
      );
      const localVarPath =
        `/api/v1/projects/{project_id}/service_accounts/{service_account_id}/enabled`
          .replace('{project_id}', encodeURIComponent(String(projectId)))
          .replace('{service_account_id}', encodeURIComponent(String(serviceAccountId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceAccountUpdateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account의 지정한 application credential 상세 정보 조회.(Service Agent 대상으로 불가) Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/service_accounts/{service_account_id}/application_credentials/{application_credential_id} 로 대체되었다.
     * @summary service account의 지정한 application credential 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet: async (
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'applicationCredentialId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet',
        'applicationCredentialId',
        applicationCredentialId,
      );
      const localVarPath =
        `/api/v1/service_accounts/{service_account_id}/application_credentials/{application_credential_id}`
          .replace('{service_account_id}', encodeURIComponent(String(serviceAccountId)))
          .replace(
            '{application_credential_id}',
            encodeURIComponent(String(applicationCredentialId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account의 application credential 목록 조회.(Service Agent 대상으로 불가)
     * @summary service account의 application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet: async (
      xAuthToken: string,
      serviceAccountId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet',
        'serviceAccountId',
        serviceAccountId,
      );
      const localVarPath =
        `/api/v1/service_accounts/{service_account_id}/application_credentials`.replace(
          '{service_account_id}',
          encodeURIComponent(String(serviceAccountId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialName application_credential_name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead:
      async (
        xAuthToken: string,
        serviceAccountId: string,
        applicationCredentialName: string,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'xAuthToken' is not null or undefined
        assertParamExists(
          'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead',
          'xAuthToken',
          xAuthToken,
        );
        // verify required parameter 'serviceAccountId' is not null or undefined
        assertParamExists(
          'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead',
          'serviceAccountId',
          serviceAccountId,
        );
        // verify required parameter 'applicationCredentialName' is not null or undefined
        assertParamExists(
          'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead',
          'applicationCredentialName',
          applicationCredentialName,
        );
        const localVarPath =
          `/api/v1/service_accounts/{service_account_id}/application_credentials/name/{application_credential_name}`
            .replace('{service_account_id}', encodeURIComponent(String(serviceAccountId)))
            .replace(
              '{application_credential_name}',
              encodeURIComponent(String(applicationCredentialName)),
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        if (xAuthToken != null) {
          localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
        }
        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * service account의 application credential 생성.(Service Agent 대상으로 불가) application credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
     * @summary service account의 application credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestServiceAccountApplicationCredentialCreateRequest} request Name(required) and description(optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost: async (
      xAuthToken: string,
      serviceAccountId: string,
      request: RequestServiceAccountApplicationCredentialCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'request' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost',
        'request',
        request,
      );
      const localVarPath =
        `/api/v1/service_accounts/{service_account_id}/application_credentials`.replace(
          '{service_account_id}',
          encodeURIComponent(String(serviceAccountId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account credential 정보 상세 조회
     * @summary service account credential 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, sha256 value
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet: async (
      xAuthToken: string,
      credentialId: string,
      serviceAccountId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'credentialId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet',
        'credentialId',
        credentialId,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet',
        'serviceAccountId',
        serviceAccountId,
      );
      const localVarPath =
        `/api/v1/service_accounts/{service_account_id}/credentials/{credential_id}`
          .replace('{credential_id}', encodeURIComponent(String(credentialId)))
          .replace('{service_account_id}', encodeURIComponent(String(serviceAccountId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account credential 수정
     * @summary service account credential 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, sha256 value
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestCredentialUpdateRequest} credential credential 정보 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut: async (
      xAuthToken: string,
      credentialId: string,
      serviceAccountId: string,
      credential: RequestCredentialUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'credentialId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut',
        'credentialId',
        credentialId,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'credential' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut',
        'credential',
        credential,
      );
      const localVarPath =
        `/api/v1/service_accounts/{service_account_id}/credentials/{credential_id}`
          .replace('{credential_id}', encodeURIComponent(String(credentialId)))
          .replace('{service_account_id}', encodeURIComponent(String(serviceAccountId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        credential,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account credential 삭제
     * @summary service account credential 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {Array<string>} credentialIds Credential ID, sha256 value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsDelete: async (
      xAuthToken: string,
      serviceAccountId: string,
      credentialIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsDelete',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsDelete',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'credentialIds' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsDelete',
        'credentialIds',
        credentialIds,
      );
      const localVarPath = `/api/v1/service_accounts/{service_account_id}/credentials`.replace(
        '{service_account_id}',
        encodeURIComponent(String(serviceAccountId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (credentialIds) {
        localVarQueryParameter['credential_ids'] = credentialIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account credential 목록 조회
     * @summary service account credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsGet: async (
      xAuthToken: string,
      serviceAccountId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsGet',
        'serviceAccountId',
        serviceAccountId,
      );
      const localVarPath = `/api/v1/service_accounts/{service_account_id}/credentials`.replace(
        '{service_account_id}',
        encodeURIComponent(String(serviceAccountId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service account credential 생성
     * @summary service account credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestServiceAccountCredentialCreateRequest} credential credential 생성 request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsPost: async (
      xAuthToken: string,
      serviceAccountId: string,
      credential: RequestServiceAccountCredentialCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsPost',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'serviceAccountId' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsPost',
        'serviceAccountId',
        serviceAccountId,
      );
      // verify required parameter 'credential' is not null or undefined
      assertParamExists(
        'apiV1ServiceAccountsServiceAccountIdCredentialsPost',
        'credential',
        credential,
      );
      const localVarPath = `/api/v1/service_accounts/{service_account_id}/credentials`.replace(
        '{service_account_id}',
        encodeURIComponent(String(serviceAccountId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        credential,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ServiceAccountsApi - functional programming interface
 */
export const ServiceAccountsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ServiceAccountsApiAxiosParamCreator(configuration);
  return {
    /**
     * Service Account 대량 삭제.(Service Agent는 불가)
     * @summary Service Account 대량 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {Array<string>} serviceAccountIds User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11ProjectsProjectIdServiceAccountsDelete(
      xAuthToken: string,
      projectId: string,
      serviceAccountIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServersBulkResponse>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV11ProjectsProjectIdServiceAccountsDelete(
          xAuthToken,
          projectId,
          serviceAccountIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceAccountsApi.apiV11ProjectsProjectIdServiceAccountsDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 service account의 application credential 대량 삭제.(Service Agent 대상으로 불가)
     * @summary 지정한 service account의 application credential 대량 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {Array<string>} applicationCredentialIds ApplicationCredential ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServersBulkResponse>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
          xAuthToken,
          serviceAccountId,
          applicationCredentialIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account의 지정한 application credential 상세 조회.(Service Agent 대상으로 불가) roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
     * @summary service account의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDisplayDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
          xAuthToken,
          serviceAccountId,
          applicationCredentialId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 Project 내에 주어진 이름이 Service Account에 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404.
     * @summary 지정한 Project 내에 Service Account 중복 이름 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {string} serviceAccountName Username, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
      xAuthToken: string,
      projectId: string,
      serviceAccountName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
          xAuthToken,
          projectId,
          serviceAccountName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Service Account 생성
     * @summary Service Account 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {RequestProjectServiceAccountCreateRequest} userCreateRequest Service Account 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdServiceAccountsPost(
      xAuthToken: string,
      projectId: string,
      userCreateRequest: RequestProjectServiceAccountCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudServiceUserResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdServiceAccountsPost(
          xAuthToken,
          projectId,
          userCreateRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceAccountsApi.apiV1ProjectsProjectIdServiceAccountsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Service Account에 대한 enabled 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Service Account에 대한 enabled 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project id, 영소문자+숫자 32자
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestServiceAccountUpdateRequest} serviceAccountUpdateRequest Service Account Enabled 만 가능.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
      xAuthToken: string,
      projectId: string,
      serviceAccountId: string,
      serviceAccountUpdateRequest: RequestServiceAccountUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudServiceUserResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
          xAuthToken,
          projectId,
          serviceAccountId,
          serviceAccountUpdateRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account의 지정한 application credential 상세 정보 조회.(Service Agent 대상으로 불가) Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/service_accounts/{service_account_id}/application_credentials/{application_credential_id} 로 대체되었다.
     * @summary service account의 지정한 application credential 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialId application_credential_id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
          xAuthToken,
          serviceAccountId,
          applicationCredentialId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account의 application credential 목록 조회.(Service Agent 대상으로 불가)
     * @summary service account의 application credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
      xAuthToken: string,
      serviceAccountId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDtos>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
          xAuthToken,
          serviceAccountId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {string} applicationCredentialName application_credential_name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
      xAuthToken: string,
      serviceAccountId: string,
      applicationCredentialName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
          xAuthToken,
          serviceAccountId,
          applicationCredentialName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account의 application credential 생성.(Service Agent 대상으로 불가) application credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
     * @summary service account의 application credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestServiceAccountApplicationCredentialCreateRequest} request Name(required) and description(optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
      xAuthToken: string,
      serviceAccountId: string,
      request: RequestServiceAccountApplicationCredentialCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCloudApplicationCredentialDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
          xAuthToken,
          serviceAccountId,
          request,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account credential 정보 상세 조회
     * @summary service account credential 정보 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, sha256 value
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
      xAuthToken: string,
      credentialId: string,
      serviceAccountId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCredentialGetResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
          xAuthToken,
          credentialId,
          serviceAccountId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account credential 수정
     * @summary service account credential 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} credentialId credential_id, sha256 value
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestCredentialUpdateRequest} credential credential 정보 업데이트
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
      xAuthToken: string,
      credentialId: string,
      serviceAccountId: string,
      credential: RequestCredentialUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
          xAuthToken,
          credentialId,
          serviceAccountId,
          credential,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account credential 삭제
     * @summary service account credential 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {Array<string>} credentialIds Credential ID, sha256 value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
      xAuthToken: string,
      serviceAccountId: string,
      credentialIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
          xAuthToken,
          serviceAccountId,
          credentialIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdCredentialsDelete'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account credential 목록 조회
     * @summary service account credential 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdCredentialsGet(
      xAuthToken: string,
      serviceAccountId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseCredentialListByUserResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdCredentialsGet(
          xAuthToken,
          serviceAccountId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdCredentialsGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service account credential 생성
     * @summary service account credential 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceAccountId User ID, 영소문자+숫자 32자
     * @param {RequestServiceAccountCredentialCreateRequest} credential credential 생성 request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAccountsServiceAccountIdCredentialsPost(
      xAuthToken: string,
      serviceAccountId: string,
      credential: RequestServiceAccountCredentialCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCredentialCreateResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAccountsServiceAccountIdCredentialsPost(
          xAuthToken,
          serviceAccountId,
          credential,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ServiceAccountsApi.apiV1ServiceAccountsServiceAccountIdCredentialsPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ServiceAccountsApi - factory interface
 */
export const ServiceAccountsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ServiceAccountsApiFp(configuration);
  return {
    /**
     * Service Account 대량 삭제.(Service Agent는 불가)
     * @summary Service Account 대량 삭제
     * @param {ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11ProjectsProjectIdServiceAccountsDelete(
      requestParameters: ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServersBulkResponse> {
      return localVarFp
        .apiV11ProjectsProjectIdServiceAccountsDelete(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.serviceAccountIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 service account의 application credential 대량 삭제.(Service Agent 대상으로 불가)
     * @summary 지정한 service account의 application credential 대량 삭제
     * @param {ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
      requestParameters: ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServersBulkResponse> {
      return localVarFp
        .apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.applicationCredentialIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account의 지정한 application credential 상세 조회.(Service Agent 대상으로 불가) roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
     * @summary service account의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
     * @param {ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
      requestParameters: ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDisplayDto> {
      return localVarFp
        .apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.applicationCredentialId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 Project 내에 주어진 이름이 Service Account에 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404.
     * @summary 지정한 Project 내에 Service Account 중복 이름 조회
     * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
      requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.serviceAccountName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Service Account 생성
     * @summary Service Account 생성
     * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdServiceAccountsPost(
      requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudServiceUserResponse> {
      return localVarFp
        .apiV1ProjectsProjectIdServiceAccountsPost(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.userCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * Service Account에 대한 enabled 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary Service Account에 대한 enabled 변경
     * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
      requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudServiceUserResponse> {
      return localVarFp
        .apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          requestParameters.serviceAccountId,
          requestParameters.serviceAccountUpdateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account의 지정한 application credential 상세 정보 조회.(Service Agent 대상으로 불가) Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/service_accounts/{service_account_id}/application_credentials/{application_credential_id} 로 대체되었다.
     * @summary service account의 지정한 application credential 상세 정보 조회
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDto> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.applicationCredentialId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account의 application credential 목록 조회.(Service Agent 대상으로 불가)
     * @summary service account의 application credential 목록 조회
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDtos> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인.
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.applicationCredentialName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account의 application credential 생성.(Service Agent 대상으로 불가) application credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
     * @summary service account의 application credential 생성
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudApplicationCredentialDto> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account credential 정보 상세 조회
     * @summary service account credential 정보 상세 조회
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialGetResponse> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
          requestParameters.xAuthToken,
          requestParameters.credentialId,
          requestParameters.serviceAccountId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account credential 수정
     * @summary service account credential 수정
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
          requestParameters.xAuthToken,
          requestParameters.credentialId,
          requestParameters.serviceAccountId,
          requestParameters.credential,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account credential 삭제
     * @summary service account credential 삭제
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.credentialIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account credential 목록 조회
     * @summary service account credential 목록 조회
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsGet(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialListByUserResponse> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdCredentialsGet(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service account credential 생성
     * @summary service account credential 생성
     * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAccountsServiceAccountIdCredentialsPost(
      requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCredentialCreateResponse> {
      return localVarFp
        .apiV1ServiceAccountsServiceAccountIdCredentialsPost(
          requestParameters.xAuthToken,
          requestParameters.serviceAccountId,
          requestParameters.credential,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ServiceAccountsApi - interface
 */
export interface ServiceAccountsApiInterface {
  /**
   * Service Account 대량 삭제.(Service Agent는 불가)
   * @summary Service Account 대량 삭제
   * @param {ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11ProjectsProjectIdServiceAccountsDelete(
    requestParameters: ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ServersBulkResponse>;

  /**
   * 지정한 service account의 application credential 대량 삭제.(Service Agent 대상으로 불가)
   * @summary 지정한 service account의 application credential 대량 삭제
   * @param {ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
    requestParameters: ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ServersBulkResponse>;

  /**
   * service account의 지정한 application credential 상세 조회.(Service Agent 대상으로 불가) roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
   * @summary service account의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
   * @param {ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDisplayDto>;

  /**
   * 지정한 Project 내에 주어진 이름이 Service Account에 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404.
   * @summary 지정한 Project 내에 Service Account 중복 이름 조회
   * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
    requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Service Account 생성
   * @summary Service Account 생성
   * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdServiceAccountsPost(
    requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudServiceUserResponse>;

  /**
   * Service Account에 대한 enabled 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Service Account에 대한 enabled 변경
   * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
    requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudServiceUserResponse>;

  /**
   * service account의 지정한 application credential 상세 정보 조회.(Service Agent 대상으로 불가) Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/service_accounts/{service_account_id}/application_credentials/{application_credential_id} 로 대체되었다.
   * @summary service account의 지정한 application credential 상세 정보 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDto>;

  /**
   * service account의 application credential 목록 조회.(Service Agent 대상으로 불가)
   * @summary service account의 application credential 목록 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDtos>;

  /**
   * 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
   * @summary 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인.
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * service account의 application credential 생성.(Service Agent 대상으로 불가) application credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
   * @summary service account의 application credential 생성
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudApplicationCredentialDto>;

  /**
   * service account credential 정보 상세 조회
   * @summary service account credential 정보 상세 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialGetResponse>;

  /**
   * service account credential 수정
   * @summary service account credential 수정
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * service account credential 삭제
   * @summary service account credential 삭제
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * service account credential 목록 조회
   * @summary service account credential 목록 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdCredentialsGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialListByUserResponse>;

  /**
   * service account credential 생성
   * @summary service account credential 생성
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAccountsServiceAccountIdCredentialsPost(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCredentialCreateResponse>;
}

/**
 * Request parameters for apiV11ProjectsProjectIdServiceAccountsDelete operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project id, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountIds: Array<string>;
}

/**
 * Request parameters for apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * ApplicationCredential ID, 영소문자+숫자 32자
   */
  readonly applicationCredentialIds: Array<string>;
}

/**
 * Request parameters for apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * application_credential_id, 영소문자+숫자 32자
   */
  readonly applicationCredentialId: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project id, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * Username, 영대소문자+숫자+특수문자(-)
   */
  readonly serviceAccountName: string;
}

/**
 * Request parameters for apiV1ProjectsProjectIdServiceAccountsPost operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project id, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * Service Account 생성 정보
   */
  readonly userCreateRequest: RequestProjectServiceAccountCreateRequest;
}

/**
 * Request parameters for apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project id, 영소문자+숫자 32자
   */
  readonly projectId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * Service Account Enabled 만 가능.
   */
  readonly serviceAccountUpdateRequest: RequestServiceAccountUpdateRequest;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * application_credential_id, 영소문자+숫자 32자
   */
  readonly applicationCredentialId: string;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * application_credential_name, 영대소문자+숫자+특수문자(-)
   */
  readonly applicationCredentialName: string;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * Name(required) and description(optional)
   */
  readonly request: RequestServiceAccountApplicationCredentialCreateRequest;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * credential_id, sha256 value
   */
  readonly credentialId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * credential_id, sha256 value
   */
  readonly credentialId: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * credential 정보 업데이트
   */
  readonly credential: RequestCredentialUpdateRequest;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdCredentialsDelete operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * Credential ID, sha256 value
   */
  readonly credentialIds: Array<string>;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdCredentialsGet operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;
}

/**
 * Request parameters for apiV1ServiceAccountsServiceAccountIdCredentialsPost operation in ServiceAccountsApi.
 */
export interface ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly serviceAccountId: string;

  /**
   * credential 생성 request
   */
  readonly credential: RequestServiceAccountCredentialCreateRequest;
}

/**
 * ServiceAccountsApi - object-oriented interface
 */
export class ServiceAccountsApi extends BaseAPI implements ServiceAccountsApiInterface {
  /**
   * Service Account 대량 삭제.(Service Agent는 불가)
   * @summary Service Account 대량 삭제
   * @param {ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11ProjectsProjectIdServiceAccountsDelete(
    requestParameters: ServiceAccountsApiApiV11ProjectsProjectIdServiceAccountsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV11ProjectsProjectIdServiceAccountsDelete(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.serviceAccountIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 service account의 application credential 대량 삭제.(Service Agent 대상으로 불가)
   * @summary 지정한 service account의 application credential 대량 삭제
   * @param {ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
    requestParameters: ServiceAccountsApiApiV11ServiceAccountsServiceAccountIdApplicationCredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV11ServiceAccountsServiceAccountIdApplicationCredentialsDelete(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.applicationCredentialIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account의 지정한 application credential 상세 조회.(Service Agent 대상으로 불가) roles 는 **이 액세스키에 저장된 역할**이다. (토큰 발급 시 실제로 담기는 역할과 다를 수 있다) 콘솔 표기를 위해 display_name 등 표시 정보를 포함하며 display_order 순으로 정렬된다. 콘솔 노출 대상 role 만 반환한다(kic_role_extra 미등록 role 제외). 표시할 역할이 없으면 빈 배열이다.
   * @summary service account의 지정한 application credential 상세 조회 (표시 정보 포함 역할)
   * @param {ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ServiceAccountsApiApiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV12ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.applicationCredentialId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 Project 내에 주어진 이름이 Service Account에 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404.
   * @summary 지정한 Project 내에 Service Account 중복 이름 조회
   * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
    requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ProjectsProjectIdServiceAccountsNameServiceAccountNameHead(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.serviceAccountName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Service Account 생성
   * @summary Service Account 생성
   * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdServiceAccountsPost(
    requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ProjectsProjectIdServiceAccountsPost(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.userCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Service Account에 대한 enabled 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary Service Account에 대한 enabled 변경
   * @param {ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
    requestParameters: ServiceAccountsApiApiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ProjectsProjectIdServiceAccountsServiceAccountIdEnabledPatch(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        requestParameters.serviceAccountId,
        requestParameters.serviceAccountUpdateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account의 지정한 application credential 상세 정보 조회.(Service Agent 대상으로 불가) Deprecated: roles 에 콘솔 표기용 표시 정보(display_name 등)가 없다. GET /api/v1_2/service_accounts/{service_account_id}/application_credentials/{application_credential_id} 로 대체되었다.
   * @summary service account의 지정한 application credential 상세 정보 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsApplicationCredentialIdGet(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.applicationCredentialId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account의 application credential 목록 조회.(Service Agent 대상으로 불가)
   * @summary service account의 application credential 목록 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
   * @summary 지정한 Service Account의 application credential 중에 동일한 name 존재하는지 확인.
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsNameApplicationCredentialNameHead(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.applicationCredentialName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account의 application credential 생성.(Service Agent 대상으로 불가) application credential의 역할은 token에 포함되지 않은 역할은 할당 불가. request.roles에 id 혹은 name으로 요청 가능.
   * @summary service account의 application credential 생성
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdApplicationCredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdApplicationCredentialsPost(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account credential 정보 상세 조회
   * @summary service account credential 정보 상세 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdGet(
        requestParameters.xAuthToken,
        requestParameters.credentialId,
        requestParameters.serviceAccountId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account credential 수정
   * @summary service account credential 수정
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdCredentialsCredentialIdPut(
        requestParameters.xAuthToken,
        requestParameters.credentialId,
        requestParameters.serviceAccountId,
        requestParameters.credential,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account credential 삭제
   * @summary service account credential 삭제
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdCredentialsDelete(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.credentialIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account credential 목록 조회
   * @summary service account credential 목록 조회
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdCredentialsGet(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdCredentialsGet(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service account credential 생성
   * @summary service account credential 생성
   * @param {ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAccountsServiceAccountIdCredentialsPost(
    requestParameters: ServiceAccountsApiApiV1ServiceAccountsServiceAccountIdCredentialsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAccountsApiFp(this.configuration)
      .apiV1ServiceAccountsServiceAccountIdCredentialsPost(
        requestParameters.xAuthToken,
        requestParameters.serviceAccountId,
        requestParameters.credential,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ServiceAgentApi - axios parameter creator
 */
export const ServiceAgentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 생성. ServiceType은 Cloud IAM에 등록된 명칭만 사용이 가능하다. role_ids가  없는 경우, member role 부여. 생성된 경우 response header에 trust 기반으로 만들어진 인증 token도 함께 전달된다.
     * @summary Service Agent Trusts 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestServiceAgentCreateRequest} userCreateRequest Service Agent Trusts 생성 요청 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAgentPost: async (
      xAuthToken: string,
      userCreateRequest: RequestServiceAgentCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceAgentPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userCreateRequest' is not null or undefined
      assertParamExists('apiV1ServiceAgentPost', 'userCreateRequest', userCreateRequest);
      const localVarPath = `/api/v1/service_agent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 조회. response header에 trust 기반으로 만들어진 인증 token이 전달된다.
     * @summary Service Agent Trusts 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAgentProjectsProjectIdGet: async (
      xAuthToken: string,
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceAgentProjectsProjectIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1ServiceAgentProjectsProjectIdGet', 'projectId', projectId);
      const localVarPath = `/api/v1/service_agent/projects/{project_id}`.replace(
        '{project_id}',
        encodeURIComponent(String(projectId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ServiceAgentApi - functional programming interface
 */
export const ServiceAgentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ServiceAgentApiAxiosParamCreator(configuration);
  return {
    /**
     * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 생성. ServiceType은 Cloud IAM에 등록된 명칭만 사용이 가능하다. role_ids가  없는 경우, member role 부여. 생성된 경우 response header에 trust 기반으로 만들어진 인증 token도 함께 전달된다.
     * @summary Service Agent Trusts 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestServiceAgentCreateRequest} userCreateRequest Service Agent Trusts 생성 요청 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAgentPost(
      xAuthToken: string,
      userCreateRequest: RequestServiceAgentCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTrusts>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServiceAgentPost(
        xAuthToken,
        userCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceAgentApi.apiV1ServiceAgentPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 조회. response header에 trust 기반으로 만들어진 인증 token이 전달된다.
     * @summary Service Agent Trusts 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} projectId project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceAgentProjectsProjectIdGet(
      xAuthToken: string,
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTrusts>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1ServiceAgentProjectsProjectIdGet(
          xAuthToken,
          projectId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceAgentApi.apiV1ServiceAgentProjectsProjectIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ServiceAgentApi - factory interface
 */
export const ServiceAgentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ServiceAgentApiFp(configuration);
  return {
    /**
     * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 생성. ServiceType은 Cloud IAM에 등록된 명칭만 사용이 가능하다. role_ids가  없는 경우, member role 부여. 생성된 경우 response header에 trust 기반으로 만들어진 인증 token도 함께 전달된다.
     * @summary Service Agent Trusts 생성
     * @param {ServiceAgentApiApiV1ServiceAgentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAgentPost(
      requestParameters: ServiceAgentApiApiV1ServiceAgentPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTrusts> {
      return localVarFp
        .apiV1ServiceAgentPost(
          requestParameters.xAuthToken,
          requestParameters.userCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 조회. response header에 trust 기반으로 만들어진 인증 token이 전달된다.
     * @summary Service Agent Trusts 조회
     * @param {ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceAgentProjectsProjectIdGet(
      requestParameters: ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTrusts> {
      return localVarFp
        .apiV1ServiceAgentProjectsProjectIdGet(
          requestParameters.xAuthToken,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ServiceAgentApi - interface
 */
export interface ServiceAgentApiInterface {
  /**
   * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 생성. ServiceType은 Cloud IAM에 등록된 명칭만 사용이 가능하다. role_ids가  없는 경우, member role 부여. 생성된 경우 response header에 trust 기반으로 만들어진 인증 token도 함께 전달된다.
   * @summary Service Agent Trusts 생성
   * @param {ServiceAgentApiApiV1ServiceAgentPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAgentPost(
    requestParameters: ServiceAgentApiApiV1ServiceAgentPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTrusts>;

  /**
   * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 조회. response header에 trust 기반으로 만들어진 인증 token이 전달된다.
   * @summary Service Agent Trusts 조회
   * @param {ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceAgentProjectsProjectIdGet(
    requestParameters: ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTrusts>;
}

/**
 * Request parameters for apiV1ServiceAgentPost operation in ServiceAgentApi.
 */
export interface ServiceAgentApiApiV1ServiceAgentPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Service Agent Trusts 생성 요청 정보
   */
  readonly userCreateRequest: RequestServiceAgentCreateRequest;
}

/**
 * Request parameters for apiV1ServiceAgentProjectsProjectIdGet operation in ServiceAgentApi.
 */
export interface ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;
}

/**
 * ServiceAgentApi - object-oriented interface
 */
export class ServiceAgentApi extends BaseAPI implements ServiceAgentApiInterface {
  /**
   * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 생성. ServiceType은 Cloud IAM에 등록된 명칭만 사용이 가능하다. role_ids가  없는 경우, member role 부여. 생성된 경우 response header에 trust 기반으로 만들어진 인증 token도 함께 전달된다.
   * @summary Service Agent Trusts 생성
   * @param {ServiceAgentApiApiV1ServiceAgentPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAgentPost(
    requestParameters: ServiceAgentApiApiV1ServiceAgentPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAgentApiFp(this.configuration)
      .apiV1ServiceAgentPost(
        requestParameters.xAuthToken,
        requestParameters.userCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * IP ACL 적용이 되어 있어, 해당 API 사용 시 사전에 호출 가능한 IP로 등록되어 있는지 확인 필요. Service Agent Trusts 조회. response header에 trust 기반으로 만들어진 인증 token이 전달된다.
   * @summary Service Agent Trusts 조회
   * @param {ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceAgentProjectsProjectIdGet(
    requestParameters: ServiceAgentApiApiV1ServiceAgentProjectsProjectIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceAgentApiFp(this.configuration)
      .apiV1ServiceAgentProjectsProjectIdGet(
        requestParameters.xAuthToken,
        requestParameters.projectId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ServiceManageUsersApi - axios parameter creator
 */
export const ServiceManageUsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 서비스 운영 계정 목록 조회
     * @summary 서비스 운영 계정 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [userId] user id, 영소문자+숫자 32자
     * @param {string} [userName] service manage username, 이메일 사용 가능 문자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      userId?: string,
      userName?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/service_manage_users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (userId !== undefined) {
        localVarQueryParameter['user_id'] = userId;
      }

      if (userName !== undefined) {
        localVarQueryParameter['user_name'] = userName;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 서비스 운영 계정 생성
     * @summary 서비스 운영 계정 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestServiceManageUserCreateRequest} request 서비스 운영 계정 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersPost: async (
      xAuthToken: string,
      request: RequestServiceManageUserCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersPost', 'request', request);
      const localVarPath = `/api/v1/service_manage_users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 서비스 운영 계정 삭제
     * @summary 서비스 운영 계정 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId user id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersUserIdDelete: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdDelete', 'userId', userId);
      const localVarPath = `/api/v1/service_manage_users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 서비스 운영 계정 조회
     * @summary 서비스 운영 계정 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId user id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersUserIdGet: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdGet', 'userId', userId);
      const localVarPath = `/api/v1/service_manage_users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 서비스 운영 계정 수정
     * @summary 서비스 운영 계정 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId user id, 영소문자+숫자 32자
     * @param {RequestServiceManageUserUpdateRequest} request 서비스 운영 계정 정보 수정, 입력하지 않은 필드는 Default 값으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersUserIdPatch: async (
      xAuthToken: string,
      userId: string,
      request: RequestServiceManageUserUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdPatch', 'userId', userId);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1ServiceManageUsersUserIdPatch', 'request', request);
      const localVarPath = `/api/v1/service_manage_users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ServiceManageUsersApi - functional programming interface
 */
export const ServiceManageUsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ServiceManageUsersApiAxiosParamCreator(configuration);
  return {
    /**
     * 서비스 운영 계정 목록 조회
     * @summary 서비스 운영 계정 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [userId] user id, 영소문자+숫자 32자
     * @param {string} [userName] service manage username, 이메일 사용 가능 문자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceManageUsersGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      userId?: string,
      userName?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseServiceManageUserListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServiceManageUsersGet(
        xAuthToken,
        size,
        offset,
        userId,
        userName,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceManageUsersApi.apiV1ServiceManageUsersGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 서비스 운영 계정 생성
     * @summary 서비스 운영 계정 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestServiceManageUserCreateRequest} request 서비스 운영 계정 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceManageUsersPost(
      xAuthToken: string,
      request: RequestServiceManageUserCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseServiceManageUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServiceManageUsersPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceManageUsersApi.apiV1ServiceManageUsersPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 서비스 운영 계정 삭제
     * @summary 서비스 운영 계정 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId user id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceManageUsersUserIdDelete(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServiceManageUsersUserIdDelete(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceManageUsersApi.apiV1ServiceManageUsersUserIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 서비스 운영 계정 조회
     * @summary 서비스 운영 계정 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId user id, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceManageUsersUserIdGet(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseServiceManageUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServiceManageUsersUserIdGet(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceManageUsersApi.apiV1ServiceManageUsersUserIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 서비스 운영 계정 수정
     * @summary 서비스 운영 계정 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId user id, 영소문자+숫자 32자
     * @param {RequestServiceManageUserUpdateRequest} request 서비스 운영 계정 정보 수정, 입력하지 않은 필드는 Default 값으로 설정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServiceManageUsersUserIdPatch(
      xAuthToken: string,
      userId: string,
      request: RequestServiceManageUserUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServiceManageUsersUserIdPatch(
        xAuthToken,
        userId,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServiceManageUsersApi.apiV1ServiceManageUsersUserIdPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ServiceManageUsersApi - factory interface
 */
export const ServiceManageUsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ServiceManageUsersApiFp(configuration);
  return {
    /**
     * 서비스 운영 계정 목록 조회
     * @summary 서비스 운영 계정 목록 조회
     * @param {ServiceManageUsersApiApiV1ServiceManageUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersGet(
      requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseServiceManageUserListResponse> {
      return localVarFp
        .apiV1ServiceManageUsersGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.userId,
          requestParameters.userName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 서비스 운영 계정 생성
     * @summary 서비스 운영 계정 생성
     * @param {ServiceManageUsersApiApiV1ServiceManageUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersPost(
      requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseServiceManageUserResponse> {
      return localVarFp
        .apiV1ServiceManageUsersPost(
          requestParameters.xAuthToken,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 서비스 운영 계정 삭제
     * @summary 서비스 운영 계정 삭제
     * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersUserIdDelete(
      requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ServiceManageUsersUserIdDelete(
          requestParameters.xAuthToken,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 서비스 운영 계정 조회
     * @summary 서비스 운영 계정 조회
     * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersUserIdGet(
      requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseServiceManageUserResponse> {
      return localVarFp
        .apiV1ServiceManageUsersUserIdGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 서비스 운영 계정 수정
     * @summary 서비스 운영 계정 수정
     * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServiceManageUsersUserIdPatch(
      requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ServiceManageUsersUserIdPatch(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ServiceManageUsersApi - interface
 */
export interface ServiceManageUsersApiInterface {
  /**
   * 서비스 운영 계정 목록 조회
   * @summary 서비스 운영 계정 목록 조회
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceManageUsersGet(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseServiceManageUserListResponse>;

  /**
   * 서비스 운영 계정 생성
   * @summary 서비스 운영 계정 생성
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceManageUsersPost(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseServiceManageUserResponse>;

  /**
   * 서비스 운영 계정 삭제
   * @summary 서비스 운영 계정 삭제
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceManageUsersUserIdDelete(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 서비스 운영 계정 조회
   * @summary 서비스 운영 계정 조회
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceManageUsersUserIdGet(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseServiceManageUserResponse>;

  /**
   * 서비스 운영 계정 수정
   * @summary 서비스 운영 계정 수정
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServiceManageUsersUserIdPatch(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;
}

/**
 * Request parameters for apiV1ServiceManageUsersGet operation in ServiceManageUsersApi.
 */
export interface ServiceManageUsersApiApiV1ServiceManageUsersGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * user id, 영소문자+숫자 32자
   */
  readonly userId?: string;

  /**
   * service manage username, 이메일 사용 가능 문자
   */
  readonly userName?: string;
}

/**
 * Request parameters for apiV1ServiceManageUsersPost operation in ServiceManageUsersApi.
 */
export interface ServiceManageUsersApiApiV1ServiceManageUsersPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 서비스 운영 계정 생성
   */
  readonly request: RequestServiceManageUserCreateRequest;
}

/**
 * Request parameters for apiV1ServiceManageUsersUserIdDelete operation in ServiceManageUsersApi.
 */
export interface ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * user id, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1ServiceManageUsersUserIdGet operation in ServiceManageUsersApi.
 */
export interface ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * user id, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1ServiceManageUsersUserIdPatch operation in ServiceManageUsersApi.
 */
export interface ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * user id, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * 서비스 운영 계정 정보 수정, 입력하지 않은 필드는 Default 값으로 설정
   */
  readonly request: RequestServiceManageUserUpdateRequest;
}

/**
 * ServiceManageUsersApi - object-oriented interface
 */
export class ServiceManageUsersApi extends BaseAPI implements ServiceManageUsersApiInterface {
  /**
   * 서비스 운영 계정 목록 조회
   * @summary 서비스 운영 계정 목록 조회
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceManageUsersGet(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceManageUsersApiFp(this.configuration)
      .apiV1ServiceManageUsersGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.userId,
        requestParameters.userName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 서비스 운영 계정 생성
   * @summary 서비스 운영 계정 생성
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceManageUsersPost(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceManageUsersApiFp(this.configuration)
      .apiV1ServiceManageUsersPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 서비스 운영 계정 삭제
   * @summary 서비스 운영 계정 삭제
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceManageUsersUserIdDelete(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceManageUsersApiFp(this.configuration)
      .apiV1ServiceManageUsersUserIdDelete(
        requestParameters.xAuthToken,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 서비스 운영 계정 조회
   * @summary 서비스 운영 계정 조회
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceManageUsersUserIdGet(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceManageUsersApiFp(this.configuration)
      .apiV1ServiceManageUsersUserIdGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 서비스 운영 계정 수정
   * @summary 서비스 운영 계정 수정
   * @param {ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServiceManageUsersUserIdPatch(
    requestParameters: ServiceManageUsersApiApiV1ServiceManageUsersUserIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServiceManageUsersApiFp(this.configuration)
      .apiV1ServiceManageUsersUserIdPatch(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ServicesApi - axios parameter creator
 */
export const ServicesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * service 목록 조회
     * @summary service 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [serviceName] service name
     * @param {string} [serviceType] service type
     * @param {boolean} [withPermissionOnly] if true, Only services with permission are returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      serviceName?: string,
      serviceType?: string,
      withPermissionOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServicesGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/services`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (serviceName !== undefined) {
        localVarQueryParameter['service_name'] = serviceName;
      }

      if (serviceType !== undefined) {
        localVarQueryParameter['service_type'] = serviceType;
      }

      if (withPermissionOnly !== undefined) {
        localVarQueryParameter['with_permission_only'] = withPermissionOnly;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service 생성
     * @summary service 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestServiceCreateRequest} serviceCreateRequest ServiceCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesPost: async (
      xAuthToken: string,
      serviceCreateRequest: RequestServiceCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServicesPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'serviceCreateRequest' is not null or undefined
      assertParamExists('apiV1ServicesPost', 'serviceCreateRequest', serviceCreateRequest);
      const localVarPath = `/api/v1/services`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service 삭제
     * @summary service 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service_type, maxLength&#x3D;255
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesServiceTypeDelete: async (
      xAuthToken: string,
      serviceType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServicesServiceTypeDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'serviceType' is not null or undefined
      assertParamExists('apiV1ServicesServiceTypeDelete', 'serviceType', serviceType);
      const localVarPath = `/api/v1/services/{service_type}`.replace(
        '{service_type}',
        encodeURIComponent(String(serviceType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service 상세 조회
     * @summary service 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service_type, maxLength&#x3D;255
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesServiceTypeGet: async (
      xAuthToken: string,
      serviceType: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServicesServiceTypeGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'serviceType' is not null or undefined
      assertParamExists('apiV1ServicesServiceTypeGet', 'serviceType', serviceType);
      const localVarPath = `/api/v1/services/{service_type}`.replace(
        '{service_type}',
        encodeURIComponent(String(serviceType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * service 수정 수정 API 호출 시 body의 값은 GET /api/v1/services/{service_type}로 조회한 결과에 값을 수정 후 모든 필드 항목을 전부 body에 넣어주도록함. 수정 API의 항목이 추가 되거나 하는 경우 오류가 나는 것을 방지하려고 하는 목적임 (넣지 않는 경우 default 로 저장).
     * @summary service 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service_type, maxLength&#x3D;255
     * @param {RequestServiceUpdateRequest} serviceUpdateRequest ServiceUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesServiceTypePut: async (
      xAuthToken: string,
      serviceType: string,
      serviceUpdateRequest: RequestServiceUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1ServicesServiceTypePut', 'xAuthToken', xAuthToken);
      // verify required parameter 'serviceType' is not null or undefined
      assertParamExists('apiV1ServicesServiceTypePut', 'serviceType', serviceType);
      // verify required parameter 'serviceUpdateRequest' is not null or undefined
      assertParamExists(
        'apiV1ServicesServiceTypePut',
        'serviceUpdateRequest',
        serviceUpdateRequest,
      );
      const localVarPath = `/api/v1/services/{service_type}`.replace(
        '{service_type}',
        encodeURIComponent(String(serviceType)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        serviceUpdateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ServicesApi - functional programming interface
 */
export const ServicesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ServicesApiAxiosParamCreator(configuration);
  return {
    /**
     * service 목록 조회
     * @summary service 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [serviceName] service name
     * @param {string} [serviceType] service type
     * @param {boolean} [withPermissionOnly] if true, Only services with permission are returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServicesGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      serviceName?: string,
      serviceType?: string,
      withPermissionOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseServices>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServicesGet(
        xAuthToken,
        size,
        offset,
        serviceName,
        serviceType,
        withPermissionOnly,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServicesApi.apiV1ServicesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service 생성
     * @summary service 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestServiceCreateRequest} serviceCreateRequest ServiceCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServicesPost(
      xAuthToken: string,
      serviceCreateRequest: RequestServiceCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseService>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServicesPost(
        xAuthToken,
        serviceCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServicesApi.apiV1ServicesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service 삭제
     * @summary service 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service_type, maxLength&#x3D;255
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServicesServiceTypeDelete(
      xAuthToken: string,
      serviceType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServicesServiceTypeDelete(
        xAuthToken,
        serviceType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServicesApi.apiV1ServicesServiceTypeDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service 상세 조회
     * @summary service 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service_type, maxLength&#x3D;255
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServicesServiceTypeGet(
      xAuthToken: string,
      serviceType: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseService>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServicesServiceTypeGet(
        xAuthToken,
        serviceType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServicesApi.apiV1ServicesServiceTypeGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * service 수정 수정 API 호출 시 body의 값은 GET /api/v1/services/{service_type}로 조회한 결과에 값을 수정 후 모든 필드 항목을 전부 body에 넣어주도록함. 수정 API의 항목이 추가 되거나 하는 경우 오류가 나는 것을 방지하려고 하는 목적임 (넣지 않는 경우 default 로 저장).
     * @summary service 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} serviceType service_type, maxLength&#x3D;255
     * @param {RequestServiceUpdateRequest} serviceUpdateRequest ServiceUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1ServicesServiceTypePut(
      xAuthToken: string,
      serviceType: string,
      serviceUpdateRequest: RequestServiceUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseService>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ServicesServiceTypePut(
        xAuthToken,
        serviceType,
        serviceUpdateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ServicesApi.apiV1ServicesServiceTypePut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ServicesApi - factory interface
 */
export const ServicesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ServicesApiFp(configuration);
  return {
    /**
     * service 목록 조회
     * @summary service 목록 조회
     * @param {ServicesApiApiV1ServicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesGet(
      requestParameters: ServicesApiApiV1ServicesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseServices> {
      return localVarFp
        .apiV1ServicesGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.serviceName,
          requestParameters.serviceType,
          requestParameters.withPermissionOnly,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service 생성
     * @summary service 생성
     * @param {ServicesApiApiV1ServicesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesPost(
      requestParameters: ServicesApiApiV1ServicesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseService> {
      return localVarFp
        .apiV1ServicesPost(
          requestParameters.xAuthToken,
          requestParameters.serviceCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service 삭제
     * @summary service 삭제
     * @param {ServicesApiApiV1ServicesServiceTypeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesServiceTypeDelete(
      requestParameters: ServicesApiApiV1ServicesServiceTypeDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1ServicesServiceTypeDelete(
          requestParameters.xAuthToken,
          requestParameters.serviceType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service 상세 조회
     * @summary service 상세 조회
     * @param {ServicesApiApiV1ServicesServiceTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesServiceTypeGet(
      requestParameters: ServicesApiApiV1ServicesServiceTypeGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseService> {
      return localVarFp
        .apiV1ServicesServiceTypeGet(
          requestParameters.xAuthToken,
          requestParameters.serviceType,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * service 수정 수정 API 호출 시 body의 값은 GET /api/v1/services/{service_type}로 조회한 결과에 값을 수정 후 모든 필드 항목을 전부 body에 넣어주도록함. 수정 API의 항목이 추가 되거나 하는 경우 오류가 나는 것을 방지하려고 하는 목적임 (넣지 않는 경우 default 로 저장).
     * @summary service 수정
     * @param {ServicesApiApiV1ServicesServiceTypePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1ServicesServiceTypePut(
      requestParameters: ServicesApiApiV1ServicesServiceTypePutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseService> {
      return localVarFp
        .apiV1ServicesServiceTypePut(
          requestParameters.xAuthToken,
          requestParameters.serviceType,
          requestParameters.serviceUpdateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ServicesApi - interface
 */
export interface ServicesApiInterface {
  /**
   * service 목록 조회
   * @summary service 목록 조회
   * @param {ServicesApiApiV1ServicesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServicesGet(
    requestParameters: ServicesApiApiV1ServicesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseServices>;

  /**
   * service 생성
   * @summary service 생성
   * @param {ServicesApiApiV1ServicesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServicesPost(
    requestParameters: ServicesApiApiV1ServicesPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseService>;

  /**
   * service 삭제
   * @summary service 삭제
   * @param {ServicesApiApiV1ServicesServiceTypeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServicesServiceTypeDelete(
    requestParameters: ServicesApiApiV1ServicesServiceTypeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * service 상세 조회
   * @summary service 상세 조회
   * @param {ServicesApiApiV1ServicesServiceTypeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServicesServiceTypeGet(
    requestParameters: ServicesApiApiV1ServicesServiceTypeGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseService>;

  /**
   * service 수정 수정 API 호출 시 body의 값은 GET /api/v1/services/{service_type}로 조회한 결과에 값을 수정 후 모든 필드 항목을 전부 body에 넣어주도록함. 수정 API의 항목이 추가 되거나 하는 경우 오류가 나는 것을 방지하려고 하는 목적임 (넣지 않는 경우 default 로 저장).
   * @summary service 수정
   * @param {ServicesApiApiV1ServicesServiceTypePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1ServicesServiceTypePut(
    requestParameters: ServicesApiApiV1ServicesServiceTypePutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseService>;
}

/**
 * Request parameters for apiV1ServicesGet operation in ServicesApi.
 */
export interface ServicesApiApiV1ServicesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * service name
   */
  readonly serviceName?: string;

  /**
   * service type
   */
  readonly serviceType?: string;

  /**
   * if true, Only services with permission are returned
   */
  readonly withPermissionOnly?: boolean;
}

/**
 * Request parameters for apiV1ServicesPost operation in ServicesApi.
 */
export interface ServicesApiApiV1ServicesPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * ServiceCreateRequest
   */
  readonly serviceCreateRequest: RequestServiceCreateRequest;
}

/**
 * Request parameters for apiV1ServicesServiceTypeDelete operation in ServicesApi.
 */
export interface ServicesApiApiV1ServicesServiceTypeDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service_type, maxLength&#x3D;255
   */
  readonly serviceType: string;
}

/**
 * Request parameters for apiV1ServicesServiceTypeGet operation in ServicesApi.
 */
export interface ServicesApiApiV1ServicesServiceTypeGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service_type, maxLength&#x3D;255
   */
  readonly serviceType: string;
}

/**
 * Request parameters for apiV1ServicesServiceTypePut operation in ServicesApi.
 */
export interface ServicesApiApiV1ServicesServiceTypePutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * service_type, maxLength&#x3D;255
   */
  readonly serviceType: string;

  /**
   * ServiceUpdateRequest
   */
  readonly serviceUpdateRequest: RequestServiceUpdateRequest;
}

/**
 * ServicesApi - object-oriented interface
 */
export class ServicesApi extends BaseAPI implements ServicesApiInterface {
  /**
   * service 목록 조회
   * @summary service 목록 조회
   * @param {ServicesApiApiV1ServicesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServicesGet(
    requestParameters: ServicesApiApiV1ServicesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServicesApiFp(this.configuration)
      .apiV1ServicesGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.serviceName,
        requestParameters.serviceType,
        requestParameters.withPermissionOnly,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service 생성
   * @summary service 생성
   * @param {ServicesApiApiV1ServicesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServicesPost(
    requestParameters: ServicesApiApiV1ServicesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServicesApiFp(this.configuration)
      .apiV1ServicesPost(
        requestParameters.xAuthToken,
        requestParameters.serviceCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service 삭제
   * @summary service 삭제
   * @param {ServicesApiApiV1ServicesServiceTypeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServicesServiceTypeDelete(
    requestParameters: ServicesApiApiV1ServicesServiceTypeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServicesApiFp(this.configuration)
      .apiV1ServicesServiceTypeDelete(
        requestParameters.xAuthToken,
        requestParameters.serviceType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service 상세 조회
   * @summary service 상세 조회
   * @param {ServicesApiApiV1ServicesServiceTypeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServicesServiceTypeGet(
    requestParameters: ServicesApiApiV1ServicesServiceTypeGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServicesApiFp(this.configuration)
      .apiV1ServicesServiceTypeGet(
        requestParameters.xAuthToken,
        requestParameters.serviceType,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * service 수정 수정 API 호출 시 body의 값은 GET /api/v1/services/{service_type}로 조회한 결과에 값을 수정 후 모든 필드 항목을 전부 body에 넣어주도록함. 수정 API의 항목이 추가 되거나 하는 경우 오류가 나는 것을 방지하려고 하는 목적임 (넣지 않는 경우 default 로 저장).
   * @summary service 수정
   * @param {ServicesApiApiV1ServicesServiceTypePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1ServicesServiceTypePut(
    requestParameters: ServicesApiApiV1ServicesServiceTypePutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ServicesApiFp(this.configuration)
      .apiV1ServicesServiceTypePut(
        requestParameters.xAuthToken,
        requestParameters.serviceType,
        requestParameters.serviceUpdateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SrcAcApi - axios parameter creator
 */
export const SrcAcApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * domain 에서 선택 가능한 출발지기반 접근제어 host pool 목록 조회
     * @summary 출발지기반 접근제어 host pool 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} [host] Host supports prefix like search.
     * @param {string} [_interface]
     * @param {boolean} [isOpenapi]
     * @param {string} [serviceDisplayName] ServiceDisplayName supports prefix like search.
     * @param {ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum} [sortColumn]
     * @param {ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcHostPoolsGet: async (
      xAuthToken: string,
      domainId: string,
      host?: string,
      _interface?: string,
      isOpenapi?: boolean,
      serviceDisplayName?: string,
      sortColumn?: ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum,
      sortOrder?: ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcHostPoolsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcHostPoolsGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/host-pools`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (host !== undefined) {
        localVarQueryParameter['host'] = host;
      }

      if (_interface !== undefined) {
        localVarQueryParameter['interface'] = _interface;
      }

      if (isOpenapi !== undefined) {
        localVarQueryParameter['is_openapi'] = isOpenapi;
      }

      if (serviceDisplayName !== undefined) {
        localVarQueryParameter['service_display_name'] = serviceDisplayName;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 삭제
     * @summary 출발지기반 접근제어 정책 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {Array<string>} policyIds Policy ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesDelete: async (
      xAuthToken: string,
      domainId: string,
      policyIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesDelete', 'domainId', domainId);
      // verify required parameter 'policyIds' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesDelete', 'policyIds', policyIds);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (policyIds) {
        localVarQueryParameter['policy_ids'] = policyIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 목록 조회
     * @summary 출발지기반 접근제어 정책 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {boolean} [enabled]
     * @param {string} [name] Name supports prefix like search.
     * @param {number} [offset]
     * @param {string} [policyId] PolicyId uses exact match search.
     * @param {string} [policyType]
     * @param {number} [size]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum} [sortColumn]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum} [sortOrder]
     * @param {string} [source] Source uses exact match search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesGet: async (
      xAuthToken: string,
      domainId: string,
      enabled?: boolean,
      name?: string,
      offset?: number,
      policyId?: string,
      policyType?: string,
      size?: number,
      sortColumn?: ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum,
      sortOrder?: ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum,
      source?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesGet', 'domainId', domainId);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (enabled !== undefined) {
        localVarQueryParameter['enabled'] = enabled;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (policyId !== undefined) {
        localVarQueryParameter['policy_id'] = policyId;
      }

      if (policyType !== undefined) {
        localVarQueryParameter['policy_type'] = policyType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      if (source !== undefined) {
        localVarQueryParameter['source'] = source;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 상세 조회
     * @summary 출발지기반 접근제어 정책 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet: async (
      xAuthToken: string,
      domainId: string,
      policyId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet', 'domainId', domainId);
      // verify required parameter 'policyId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet', 'policyId', policyId);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies/{policy_id}`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{policy_id}', encodeURIComponent(String(policyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 출발지기반 접근제어 정책 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {RequestSrcAcUpdateRequest} request src ac update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch: async (
      xAuthToken: string,
      domainId: string,
      policyId: string,
      request: RequestSrcAcUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch', 'domainId', domainId);
      // verify required parameter 'policyId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch', 'policyId', policyId);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch', 'request', request);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies/{policy_id}`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{policy_id}', encodeURIComponent(String(policyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 target 목록 조회
     * @summary 출발지기반 접근제어 정책 target 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {string} [host] Host supports prefix like search.
     * @param {string} [_interface]
     * @param {boolean} [isOpenapi]
     * @param {number} [offset]
     * @param {string} [serviceDisplayName] ServiceDisplayName supports prefix like search.
     * @param {number} [size]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum} [sortColumn]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet: async (
      xAuthToken: string,
      domainId: string,
      policyId: string,
      host?: string,
      _interface?: string,
      isOpenapi?: boolean,
      offset?: number,
      serviceDisplayName?: string,
      size?: number,
      sortColumn?: ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum,
      sortOrder?: ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet',
        'domainId',
        domainId,
      );
      // verify required parameter 'policyId' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet',
        'policyId',
        policyId,
      );
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies/{policy_id}/targets`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{policy_id}', encodeURIComponent(String(policyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (host !== undefined) {
        localVarQueryParameter['host'] = host;
      }

      if (_interface !== undefined) {
        localVarQueryParameter['interface'] = _interface;
      }

      if (isOpenapi !== undefined) {
        localVarQueryParameter['is_openapi'] = isOpenapi;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (serviceDisplayName !== undefined) {
        localVarQueryParameter['service_display_name'] = serviceDisplayName;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 target 수정 (replace) is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
     * @summary 출발지기반 접근제어 정책 target 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {RequestSrcAcTargetUpdateRequest} request src ac target update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut: async (
      xAuthToken: string,
      domainId: string,
      policyId: string,
      request: RequestSrcAcTargetUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut',
        'domainId',
        domainId,
      );
      // verify required parameter 'policyId' is not null or undefined
      assertParamExists(
        'apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut',
        'policyId',
        policyId,
      );
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut', 'request', request);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies/{policy_id}/targets`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{policy_id}', encodeURIComponent(String(policyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain의 출발지기반 접근제어 정책 생성 is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
     * @summary 출발지기반 접근제어 정책 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {RequestSrcAcCreateRequest} request src ac create request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPost: async (
      xAuthToken: string,
      domainId: string,
      request: RequestSrcAcCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPost', 'domainId', domainId);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdSrcAcPoliciesPost', 'request', request);
      const localVarPath = `/api/v1/domains/{domain_id}/src-ac/policies`.replace(
        '{domain_id}',
        encodeURIComponent(String(domainId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SrcAcApi - functional programming interface
 */
export const SrcAcApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SrcAcApiAxiosParamCreator(configuration);
  return {
    /**
     * domain 에서 선택 가능한 출발지기반 접근제어 host pool 목록 조회
     * @summary 출발지기반 접근제어 host pool 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} [host] Host supports prefix like search.
     * @param {string} [_interface]
     * @param {boolean} [isOpenapi]
     * @param {string} [serviceDisplayName] ServiceDisplayName supports prefix like search.
     * @param {ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum} [sortColumn]
     * @param {ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcHostPoolsGet(
      xAuthToken: string,
      domainId: string,
      host?: string,
      _interface?: string,
      isOpenapi?: boolean,
      serviceDisplayName?: string,
      sortColumn?: ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum,
      sortOrder?: ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponseSrcAcPoolListForDomainResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcHostPoolsGet(
          xAuthToken,
          domainId,
          host,
          _interface,
          isOpenapi,
          serviceDisplayName,
          sortColumn,
          sortOrder,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcHostPoolsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 삭제
     * @summary 출발지기반 접근제어 정책 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {Array<string>} policyIds Policy ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesDelete(
      xAuthToken: string,
      domainId: string,
      policyIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesDelete(
          xAuthToken,
          domainId,
          policyIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 목록 조회
     * @summary 출발지기반 접근제어 정책 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {boolean} [enabled]
     * @param {string} [name] Name supports prefix like search.
     * @param {number} [offset]
     * @param {string} [policyId] PolicyId uses exact match search.
     * @param {string} [policyType]
     * @param {number} [size]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum} [sortColumn]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum} [sortOrder]
     * @param {string} [source] Source uses exact match search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesGet(
      xAuthToken: string,
      domainId: string,
      enabled?: boolean,
      name?: string,
      offset?: number,
      policyId?: string,
      policyType?: string,
      size?: number,
      sortColumn?: ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum,
      sortOrder?: ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum,
      source?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcListResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesGet(
          xAuthToken,
          domainId,
          enabled,
          name,
          offset,
          policyId,
          policyType,
          size,
          sortColumn,
          sortOrder,
          source,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 상세 조회
     * @summary 출발지기반 접근제어 정책 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
      xAuthToken: string,
      domainId: string,
      policyId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcGetResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
          xAuthToken,
          domainId,
          policyId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 출발지기반 접근제어 정책 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {RequestSrcAcUpdateRequest} request src ac update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
      xAuthToken: string,
      domainId: string,
      policyId: string,
      request: RequestSrcAcUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
          xAuthToken,
          domainId,
          policyId,
          request,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 target 목록 조회
     * @summary 출발지기반 접근제어 정책 target 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {string} [host] Host supports prefix like search.
     * @param {string} [_interface]
     * @param {boolean} [isOpenapi]
     * @param {number} [offset]
     * @param {string} [serviceDisplayName] ServiceDisplayName supports prefix like search.
     * @param {number} [size]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum} [sortColumn]
     * @param {ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
      xAuthToken: string,
      domainId: string,
      policyId: string,
      host?: string,
      _interface?: string,
      isOpenapi?: boolean,
      offset?: number,
      serviceDisplayName?: string,
      size?: number,
      sortColumn?: ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum,
      sortOrder?: ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcTargetListResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
          xAuthToken,
          domainId,
          policyId,
          host,
          _interface,
          isOpenapi,
          offset,
          serviceDisplayName,
          size,
          sortColumn,
          sortOrder,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 target 수정 (replace) is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
     * @summary 출발지기반 접근제어 정책 target 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {string} policyId Policy ID
     * @param {RequestSrcAcTargetUpdateRequest} request src ac target update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
      xAuthToken: string,
      domainId: string,
      policyId: string,
      request: RequestSrcAcTargetUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
          xAuthToken,
          domainId,
          policyId,
          request,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain의 출발지기반 접근제어 정책 생성 is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
     * @summary 출발지기반 접근제어 정책 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID
     * @param {RequestSrcAcCreateRequest} request src ac create request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdSrcAcPoliciesPost(
      xAuthToken: string,
      domainId: string,
      request: RequestSrcAcCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcGetResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdSrcAcPoliciesPost(
          xAuthToken,
          domainId,
          request,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcApi.apiV1DomainsDomainIdSrcAcPoliciesPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SrcAcApi - factory interface
 */
export const SrcAcApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SrcAcApiFp(configuration);
  return {
    /**
     * domain 에서 선택 가능한 출발지기반 접근제어 host pool 목록 조회
     * @summary 출발지기반 접근제어 host pool 목록 조회
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcHostPoolsGet(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcPoolListForDomainResponse> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcHostPoolsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.host,
          requestParameters._interface,
          requestParameters.isOpenapi,
          requestParameters.serviceDisplayName,
          requestParameters.sortColumn,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 삭제
     * @summary 출발지기반 접근제어 정책 삭제
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesDelete(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesDelete(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.policyIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 목록 조회
     * @summary 출발지기반 접근제어 정책 목록 조회
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesGet(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcListResponse> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.enabled,
          requestParameters.name,
          requestParameters.offset,
          requestParameters.policyId,
          requestParameters.policyType,
          requestParameters.size,
          requestParameters.sortColumn,
          requestParameters.sortOrder,
          requestParameters.source,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 상세 조회
     * @summary 출발지기반 접근제어 정책 상세 조회
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcGetResponse> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.policyId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 출발지기반 접근제어 정책 수정
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.policyId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 target 목록 조회
     * @summary 출발지기반 접근제어 정책 target 목록 조회
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcTargetListResponse> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.policyId,
          requestParameters.host,
          requestParameters._interface,
          requestParameters.isOpenapi,
          requestParameters.offset,
          requestParameters.serviceDisplayName,
          requestParameters.size,
          requestParameters.sortColumn,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 target 수정 (replace) is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
     * @summary 출발지기반 접근제어 정책 target 수정
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.policyId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain의 출발지기반 접근제어 정책 생성 is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
     * @summary 출발지기반 접근제어 정책 생성
     * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdSrcAcPoliciesPost(
      requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcGetResponse> {
      return localVarFp
        .apiV1DomainsDomainIdSrcAcPoliciesPost(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * SrcAcApi - interface
 */
export interface SrcAcApiInterface {
  /**
   * domain 에서 선택 가능한 출발지기반 접근제어 host pool 목록 조회
   * @summary 출발지기반 접근제어 host pool 목록 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcHostPoolsGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcPoolListForDomainResponse>;

  /**
   * domain의 출발지기반 접근제어 정책 삭제
   * @summary 출발지기반 접근제어 정책 삭제
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesDelete(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain의 출발지기반 접근제어 정책 목록 조회
   * @summary 출발지기반 접근제어 정책 목록 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcListResponse>;

  /**
   * domain의 출발지기반 접근제어 정책 상세 조회
   * @summary 출발지기반 접근제어 정책 상세 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcGetResponse>;

  /**
   * domain의 출발지기반 접근제어 정책 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 출발지기반 접근제어 정책 수정
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain의 출발지기반 접근제어 정책 target 목록 조회
   * @summary 출발지기반 접근제어 정책 target 목록 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcTargetListResponse>;

  /**
   * domain의 출발지기반 접근제어 정책 target 수정 (replace) is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
   * @summary 출발지기반 접근제어 정책 target 수정
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * domain의 출발지기반 접근제어 정책 생성 is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
   * @summary 출발지기반 접근제어 정책 생성
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdSrcAcPoliciesPost(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcGetResponse>;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcHostPoolsGet operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * Host supports prefix like search.
   */
  readonly host?: string;

  readonly _interface?: string;

  readonly isOpenapi?: boolean;

  /**
   * ServiceDisplayName supports prefix like search.
   */
  readonly serviceDisplayName?: string;

  readonly sortColumn?: ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum;

  readonly sortOrder?: ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesDelete operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * Policy ID
   */
  readonly policyIds: Array<string>;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesGet operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  readonly enabled?: boolean;

  /**
   * Name supports prefix like search.
   */
  readonly name?: string;

  readonly offset?: number;

  /**
   * PolicyId uses exact match search.
   */
  readonly policyId?: string;

  readonly policyType?: string;

  readonly size?: number;

  readonly sortColumn?: ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum;

  readonly sortOrder?: ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum;

  /**
   * Source uses exact match search.
   */
  readonly source?: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * Policy ID
   */
  readonly policyId: string;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * Policy ID
   */
  readonly policyId: string;

  /**
   * src ac update request
   */
  readonly request: RequestSrcAcUpdateRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * Policy ID
   */
  readonly policyId: string;

  /**
   * Host supports prefix like search.
   */
  readonly host?: string;

  readonly _interface?: string;

  readonly isOpenapi?: boolean;

  readonly offset?: number;

  /**
   * ServiceDisplayName supports prefix like search.
   */
  readonly serviceDisplayName?: string;

  readonly size?: number;

  readonly sortColumn?: ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum;

  readonly sortOrder?: ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * Policy ID
   */
  readonly policyId: string;

  /**
   * src ac target update request
   */
  readonly request: RequestSrcAcTargetUpdateRequest;
}

/**
 * Request parameters for apiV1DomainsDomainIdSrcAcPoliciesPost operation in SrcAcApi.
 */
export interface SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID
   */
  readonly domainId: string;

  /**
   * src ac create request
   */
  readonly request: RequestSrcAcCreateRequest;
}

/**
 * SrcAcApi - object-oriented interface
 */
export class SrcAcApi extends BaseAPI implements SrcAcApiInterface {
  /**
   * domain 에서 선택 가능한 출발지기반 접근제어 host pool 목록 조회
   * @summary 출발지기반 접근제어 host pool 목록 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcHostPoolsGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcHostPoolsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcHostPoolsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.host,
        requestParameters._interface,
        requestParameters.isOpenapi,
        requestParameters.serviceDisplayName,
        requestParameters.sortColumn,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 삭제
   * @summary 출발지기반 접근제어 정책 삭제
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesDelete(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesDelete(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.policyIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 목록 조회
   * @summary 출발지기반 접근제어 정책 목록 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.enabled,
        requestParameters.name,
        requestParameters.offset,
        requestParameters.policyId,
        requestParameters.policyType,
        requestParameters.size,
        requestParameters.sortColumn,
        requestParameters.sortOrder,
        requestParameters.source,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 상세 조회
   * @summary 출발지기반 접근제어 정책 상세 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.policyId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 출발지기반 접근제어 정책 수정
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdPatch(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.policyId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 target 목록 조회
   * @summary 출발지기반 접근제어 정책 target 목록 조회
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.policyId,
        requestParameters.host,
        requestParameters._interface,
        requestParameters.isOpenapi,
        requestParameters.offset,
        requestParameters.serviceDisplayName,
        requestParameters.size,
        requestParameters.sortColumn,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 target 수정 (replace) is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
   * @summary 출발지기반 접근제어 정책 target 수정
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsPut(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.policyId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain의 출발지기반 접근제어 정책 생성 is_all_targets = true 인 경우 targets 값은 무시됨. is_all_targets = false 인 경우 targets 값 필수
   * @summary 출발지기반 접근제어 정책 생성
   * @param {SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdSrcAcPoliciesPost(
    requestParameters: SrcAcApiApiV1DomainsDomainIdSrcAcPoliciesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcApiFp(this.configuration)
      .apiV1DomainsDomainIdSrcAcPoliciesPost(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum = {
  Interface: 'interface',
  IsOpenapi: 'is_openapi',
  ServiceDisplayName: 'service_display_name',
} as const;
export type ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum =
  (typeof ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum)[keyof typeof ApiV1DomainsDomainIdSrcAcHostPoolsGetSortColumnEnum];
export const ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdSrcAcHostPoolsGetSortOrderEnum];
export const ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum = {
  Name: 'name',
  CreatedAt: 'created_at',
} as const;
export type ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum =
  (typeof ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum)[keyof typeof ApiV1DomainsDomainIdSrcAcPoliciesGetSortColumnEnum];
export const ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdSrcAcPoliciesGetSortOrderEnum];
export const ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum = {
  Interface: 'interface',
  IsOpenapi: 'is_openapi',
  ServiceDisplayName: 'service_display_name',
} as const;
export type ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum =
  (typeof ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum)[keyof typeof ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortColumnEnum];
export const ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum =
  (typeof ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum)[keyof typeof ApiV1DomainsDomainIdSrcAcPoliciesPolicyIdTargetsGetSortOrderEnum];

/**
 * SrcAcPoolApi - axios parameter creator
 */
export const SrcAcPoolApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 출발지기반 접근제어 host pool 삭제
     * @summary 출발지기반 접근제어 host pool 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} hostPoolIds Host Pool ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsDelete: async (
      xAuthToken: string,
      hostPoolIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'hostPoolIds' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsDelete', 'hostPoolIds', hostPoolIds);
      const localVarPath = `/api/v1/src-ac/host-pools`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (hostPoolIds) {
        localVarQueryParameter['host_pool_ids'] = hostPoolIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 출발지기반 접근제어 host pool 목록 조회
     * @summary 출발지기반 접근제어 host pool 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId]
     * @param {string} [host] Host supports prefix like search.
     * @param {string} [_interface]
     * @param {boolean} [isOpenapi]
     * @param {number} [offset]
     * @param {string} [serviceDisplayName] ServiceDisplayName supports prefix like search.
     * @param {number} [size]
     * @param {ApiV1SrcAcHostPoolsGetSortColumnEnum} [sortColumn]
     * @param {ApiV1SrcAcHostPoolsGetSortOrderEnum} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsGet: async (
      xAuthToken: string,
      domainId?: string,
      host?: string,
      _interface?: string,
      isOpenapi?: boolean,
      offset?: number,
      serviceDisplayName?: string,
      size?: number,
      sortColumn?: ApiV1SrcAcHostPoolsGetSortColumnEnum,
      sortOrder?: ApiV1SrcAcHostPoolsGetSortOrderEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/src-ac/host-pools`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (domainId !== undefined) {
        localVarQueryParameter['domain_id'] = domainId;
      }

      if (host !== undefined) {
        localVarQueryParameter['host'] = host;
      }

      if (_interface !== undefined) {
        localVarQueryParameter['interface'] = _interface;
      }

      if (isOpenapi !== undefined) {
        localVarQueryParameter['is_openapi'] = isOpenapi;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (serviceDisplayName !== undefined) {
        localVarQueryParameter['service_display_name'] = serviceDisplayName;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sortColumn !== undefined) {
        localVarQueryParameter['sort_column'] = sortColumn;
      }

      if (sortOrder !== undefined) {
        localVarQueryParameter['sort_order'] = sortOrder;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 출발지기반 접근제어 host pool 상세 조회
     * @summary 출발지기반 접근제어 host pool 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} hostPoolId Host Pool ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsHostPoolIdGet: async (
      xAuthToken: string,
      hostPoolId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsHostPoolIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'hostPoolId' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsHostPoolIdGet', 'hostPoolId', hostPoolId);
      const localVarPath = `/api/v1/src-ac/host-pools/{host_pool_id}`.replace(
        '{host_pool_id}',
        encodeURIComponent(String(hostPoolId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 출발지기반 접근제어 host pool 수정
     * @summary 출발지기반 접근제어 host pool 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} hostPoolId Host Pool ID
     * @param {RequestSrcAcPoolUpdateRequest} request src ac host pool update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsHostPoolIdPatch: async (
      xAuthToken: string,
      hostPoolId: string,
      request: RequestSrcAcPoolUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsHostPoolIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'hostPoolId' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsHostPoolIdPatch', 'hostPoolId', hostPoolId);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsHostPoolIdPatch', 'request', request);
      const localVarPath = `/api/v1/src-ac/host-pools/{host_pool_id}`.replace(
        '{host_pool_id}',
        encodeURIComponent(String(hostPoolId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 출발지기반 접근제어 host pool 생성
     * @summary 출발지기반 접근제어 host pool 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestSrcAcPoolCreateRequest} request src ac host pool create request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsPost: async (
      xAuthToken: string,
      request: RequestSrcAcPoolCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'request' is not null or undefined
      assertParamExists('apiV1SrcAcHostPoolsPost', 'request', request);
      const localVarPath = `/api/v1/src-ac/host-pools`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        request,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SrcAcPoolApi - functional programming interface
 */
export const SrcAcPoolApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SrcAcPoolApiAxiosParamCreator(configuration);
  return {
    /**
     * 출발지기반 접근제어 host pool 삭제
     * @summary 출발지기반 접근제어 host pool 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} hostPoolIds Host Pool ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1SrcAcHostPoolsDelete(
      xAuthToken: string,
      hostPoolIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SrcAcHostPoolsDelete(
        xAuthToken,
        hostPoolIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcPoolApi.apiV1SrcAcHostPoolsDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 출발지기반 접근제어 host pool 목록 조회
     * @summary 출발지기반 접근제어 host pool 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} [domainId]
     * @param {string} [host] Host supports prefix like search.
     * @param {string} [_interface]
     * @param {boolean} [isOpenapi]
     * @param {number} [offset]
     * @param {string} [serviceDisplayName] ServiceDisplayName supports prefix like search.
     * @param {number} [size]
     * @param {ApiV1SrcAcHostPoolsGetSortColumnEnum} [sortColumn]
     * @param {ApiV1SrcAcHostPoolsGetSortOrderEnum} [sortOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1SrcAcHostPoolsGet(
      xAuthToken: string,
      domainId?: string,
      host?: string,
      _interface?: string,
      isOpenapi?: boolean,
      offset?: number,
      serviceDisplayName?: string,
      size?: number,
      sortColumn?: ApiV1SrcAcHostPoolsGetSortColumnEnum,
      sortOrder?: ApiV1SrcAcHostPoolsGetSortOrderEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcPoolListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SrcAcHostPoolsGet(
        xAuthToken,
        domainId,
        host,
        _interface,
        isOpenapi,
        offset,
        serviceDisplayName,
        size,
        sortColumn,
        sortOrder,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcPoolApi.apiV1SrcAcHostPoolsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 출발지기반 접근제어 host pool 상세 조회
     * @summary 출발지기반 접근제어 host pool 상세 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} hostPoolId Host Pool ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1SrcAcHostPoolsHostPoolIdGet(
      xAuthToken: string,
      hostPoolId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcPoolGetResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SrcAcHostPoolsHostPoolIdGet(
        xAuthToken,
        hostPoolId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcPoolApi.apiV1SrcAcHostPoolsHostPoolIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 출발지기반 접근제어 host pool 수정
     * @summary 출발지기반 접근제어 host pool 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} hostPoolId Host Pool ID
     * @param {RequestSrcAcPoolUpdateRequest} request src ac host pool update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1SrcAcHostPoolsHostPoolIdPatch(
      xAuthToken: string,
      hostPoolId: string,
      request: RequestSrcAcPoolUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SrcAcHostPoolsHostPoolIdPatch(
        xAuthToken,
        hostPoolId,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcPoolApi.apiV1SrcAcHostPoolsHostPoolIdPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 출발지기반 접근제어 host pool 생성
     * @summary 출발지기반 접근제어 host pool 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestSrcAcPoolCreateRequest} request src ac host pool create request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1SrcAcHostPoolsPost(
      xAuthToken: string,
      request: RequestSrcAcPoolCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSrcAcPoolCreateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SrcAcHostPoolsPost(
        xAuthToken,
        request,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SrcAcPoolApi.apiV1SrcAcHostPoolsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SrcAcPoolApi - factory interface
 */
export const SrcAcPoolApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SrcAcPoolApiFp(configuration);
  return {
    /**
     * 출발지기반 접근제어 host pool 삭제
     * @summary 출발지기반 접근제어 host pool 삭제
     * @param {SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsDelete(
      requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1SrcAcHostPoolsDelete(
          requestParameters.xAuthToken,
          requestParameters.hostPoolIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 출발지기반 접근제어 host pool 목록 조회
     * @summary 출발지기반 접근제어 host pool 목록 조회
     * @param {SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsGet(
      requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcPoolListResponse> {
      return localVarFp
        .apiV1SrcAcHostPoolsGet(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.host,
          requestParameters._interface,
          requestParameters.isOpenapi,
          requestParameters.offset,
          requestParameters.serviceDisplayName,
          requestParameters.size,
          requestParameters.sortColumn,
          requestParameters.sortOrder,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 출발지기반 접근제어 host pool 상세 조회
     * @summary 출발지기반 접근제어 host pool 상세 조회
     * @param {SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsHostPoolIdGet(
      requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcPoolGetResponse> {
      return localVarFp
        .apiV1SrcAcHostPoolsHostPoolIdGet(
          requestParameters.xAuthToken,
          requestParameters.hostPoolId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 출발지기반 접근제어 host pool 수정
     * @summary 출발지기반 접근제어 host pool 수정
     * @param {SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsHostPoolIdPatch(
      requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1SrcAcHostPoolsHostPoolIdPatch(
          requestParameters.xAuthToken,
          requestParameters.hostPoolId,
          requestParameters.request,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 출발지기반 접근제어 host pool 생성
     * @summary 출발지기반 접근제어 host pool 생성
     * @param {SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1SrcAcHostPoolsPost(
      requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSrcAcPoolCreateResponse> {
      return localVarFp
        .apiV1SrcAcHostPoolsPost(requestParameters.xAuthToken, requestParameters.request, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * SrcAcPoolApi - interface
 */
export interface SrcAcPoolApiInterface {
  /**
   * 출발지기반 접근제어 host pool 삭제
   * @summary 출발지기반 접근제어 host pool 삭제
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1SrcAcHostPoolsDelete(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 출발지기반 접근제어 host pool 목록 조회
   * @summary 출발지기반 접근제어 host pool 목록 조회
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1SrcAcHostPoolsGet(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcPoolListResponse>;

  /**
   * 출발지기반 접근제어 host pool 상세 조회
   * @summary 출발지기반 접근제어 host pool 상세 조회
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1SrcAcHostPoolsHostPoolIdGet(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcPoolGetResponse>;

  /**
   * 출발지기반 접근제어 host pool 수정
   * @summary 출발지기반 접근제어 host pool 수정
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1SrcAcHostPoolsHostPoolIdPatch(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 출발지기반 접근제어 host pool 생성
   * @summary 출발지기반 접근제어 host pool 생성
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1SrcAcHostPoolsPost(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSrcAcPoolCreateResponse>;
}

/**
 * Request parameters for apiV1SrcAcHostPoolsDelete operation in SrcAcPoolApi.
 */
export interface SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Host Pool ID
   */
  readonly hostPoolIds: Array<string>;
}

/**
 * Request parameters for apiV1SrcAcHostPoolsGet operation in SrcAcPoolApi.
 */
export interface SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  readonly domainId?: string;

  /**
   * Host supports prefix like search.
   */
  readonly host?: string;

  readonly _interface?: string;

  readonly isOpenapi?: boolean;

  readonly offset?: number;

  /**
   * ServiceDisplayName supports prefix like search.
   */
  readonly serviceDisplayName?: string;

  readonly size?: number;

  readonly sortColumn?: ApiV1SrcAcHostPoolsGetSortColumnEnum;

  readonly sortOrder?: ApiV1SrcAcHostPoolsGetSortOrderEnum;
}

/**
 * Request parameters for apiV1SrcAcHostPoolsHostPoolIdGet operation in SrcAcPoolApi.
 */
export interface SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Host Pool ID
   */
  readonly hostPoolId: string;
}

/**
 * Request parameters for apiV1SrcAcHostPoolsHostPoolIdPatch operation in SrcAcPoolApi.
 */
export interface SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Host Pool ID
   */
  readonly hostPoolId: string;

  /**
   * src ac host pool update request
   */
  readonly request: RequestSrcAcPoolUpdateRequest;
}

/**
 * Request parameters for apiV1SrcAcHostPoolsPost operation in SrcAcPoolApi.
 */
export interface SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * src ac host pool create request
   */
  readonly request: RequestSrcAcPoolCreateRequest;
}

/**
 * SrcAcPoolApi - object-oriented interface
 */
export class SrcAcPoolApi extends BaseAPI implements SrcAcPoolApiInterface {
  /**
   * 출발지기반 접근제어 host pool 삭제
   * @summary 출발지기반 접근제어 host pool 삭제
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1SrcAcHostPoolsDelete(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcPoolApiFp(this.configuration)
      .apiV1SrcAcHostPoolsDelete(
        requestParameters.xAuthToken,
        requestParameters.hostPoolIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 출발지기반 접근제어 host pool 목록 조회
   * @summary 출발지기반 접근제어 host pool 목록 조회
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1SrcAcHostPoolsGet(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcPoolApiFp(this.configuration)
      .apiV1SrcAcHostPoolsGet(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.host,
        requestParameters._interface,
        requestParameters.isOpenapi,
        requestParameters.offset,
        requestParameters.serviceDisplayName,
        requestParameters.size,
        requestParameters.sortColumn,
        requestParameters.sortOrder,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 출발지기반 접근제어 host pool 상세 조회
   * @summary 출발지기반 접근제어 host pool 상세 조회
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1SrcAcHostPoolsHostPoolIdGet(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcPoolApiFp(this.configuration)
      .apiV1SrcAcHostPoolsHostPoolIdGet(
        requestParameters.xAuthToken,
        requestParameters.hostPoolId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 출발지기반 접근제어 host pool 수정
   * @summary 출발지기반 접근제어 host pool 수정
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1SrcAcHostPoolsHostPoolIdPatch(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsHostPoolIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcPoolApiFp(this.configuration)
      .apiV1SrcAcHostPoolsHostPoolIdPatch(
        requestParameters.xAuthToken,
        requestParameters.hostPoolId,
        requestParameters.request,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 출발지기반 접근제어 host pool 생성
   * @summary 출발지기반 접근제어 host pool 생성
   * @param {SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1SrcAcHostPoolsPost(
    requestParameters: SrcAcPoolApiApiV1SrcAcHostPoolsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SrcAcPoolApiFp(this.configuration)
      .apiV1SrcAcHostPoolsPost(requestParameters.xAuthToken, requestParameters.request, options)
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV1SrcAcHostPoolsGetSortColumnEnum = {
  Interface: 'interface',
  IsOpenapi: 'is_openapi',
  ServiceDisplayName: 'service_display_name',
} as const;
export type ApiV1SrcAcHostPoolsGetSortColumnEnum =
  (typeof ApiV1SrcAcHostPoolsGetSortColumnEnum)[keyof typeof ApiV1SrcAcHostPoolsGetSortColumnEnum];
export const ApiV1SrcAcHostPoolsGetSortOrderEnum = {
  Asc: 'asc',
  Desc: 'desc',
} as const;
export type ApiV1SrcAcHostPoolsGetSortOrderEnum =
  (typeof ApiV1SrcAcHostPoolsGetSortOrderEnum)[keyof typeof ApiV1SrcAcHostPoolsGetSortOrderEnum];

/**
 * TermsApi - axios parameter creator
 */
export const TermsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 약관 공지 사항 목록조회 API
     * @summary 약관 공지 사항 목록 조회 API
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termNoticesGet: async (
      size?: number,
      offset?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/term-notices`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 약관 공지 사항 상세 조회 API
     * @summary 약관 공지 사항 상세 조회 API
     * @param {number} termNoticeSeq 약관공지 seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termNoticesTermNoticeSeqGet: async (
      termNoticeSeq: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'termNoticeSeq' is not null or undefined
      assertParamExists('termNoticesTermNoticeSeqGet', 'termNoticeSeq', termNoticeSeq);
      const localVarPath = `/term-notices/{term_notice_seq}`.replace(
        '{term_notice_seq}',
        encodeURIComponent(String(termNoticeSeq)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 약관 조회 API. 약관 상세정보와 약관명을 기준으로 버전 리스트를 반환하며, version 생략시 최신 버전의 약관을 반환
     * @summary 약관 조회 API
     * @param {string} termCode 약관명
     * @param {number} [version] version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermCodeGet: async (
      termCode: string,
      version?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'termCode' is not null or undefined
      assertParamExists('termsTermCodeGet', 'termCode', termCode);
      const localVarPath = `/terms/{term_code}`.replace(
        '{term_code}',
        encodeURIComponent(String(termCode)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TermsApi - functional programming interface
 */
export const TermsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TermsApiAxiosParamCreator(configuration);
  return {
    /**
     * 약관 공지 사항 목록조회 API
     * @summary 약관 공지 사항 목록 조회 API
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termNoticesGet(
      size?: number,
      offset?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTermNoticeList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termNoticesGet(
        size,
        offset,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termNoticesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 약관 공지 사항 상세 조회 API
     * @summary 약관 공지 사항 상세 조회 API
     * @param {number} termNoticeSeq 약관공지 seq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termNoticesTermNoticeSeqGet(
      termNoticeSeq: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTermNotice>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termNoticesTermNoticeSeqGet(
        termNoticeSeq,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termNoticesTermNoticeSeqGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 약관 조회 API. 약관 상세정보와 약관명을 기준으로 버전 리스트를 반환하며, version 생략시 최신 버전의 약관을 반환
     * @summary 약관 조회 API
     * @param {string} termCode 약관명
     * @param {number} [version] version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termsTermCodeGet(
      termCode: string,
      version?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTermWithVersions>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termsTermCodeGet(
        termCode,
        version,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termsTermCodeGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TermsApi - factory interface
 */
export const TermsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TermsApiFp(configuration);
  return {
    /**
     * 약관 공지 사항 목록조회 API
     * @summary 약관 공지 사항 목록 조회 API
     * @param {TermsApiTermNoticesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termNoticesGet(
      requestParameters: TermsApiTermNoticesGetRequest = {},
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTermNoticeList> {
      return localVarFp
        .termNoticesGet(requestParameters.size, requestParameters.offset, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 약관 공지 사항 상세 조회 API
     * @summary 약관 공지 사항 상세 조회 API
     * @param {TermsApiTermNoticesTermNoticeSeqGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termNoticesTermNoticeSeqGet(
      requestParameters: TermsApiTermNoticesTermNoticeSeqGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTermNotice> {
      return localVarFp
        .termNoticesTermNoticeSeqGet(requestParameters.termNoticeSeq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 약관 조회 API. 약관 상세정보와 약관명을 기준으로 버전 리스트를 반환하며, version 생략시 최신 버전의 약관을 반환
     * @summary 약관 조회 API
     * @param {TermsApiTermsTermCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermCodeGet(
      requestParameters: TermsApiTermsTermCodeGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTermWithVersions> {
      return localVarFp
        .termsTermCodeGet(requestParameters.termCode, requestParameters.version, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * TermsApi - interface
 */
export interface TermsApiInterface {
  /**
   * 약관 공지 사항 목록조회 API
   * @summary 약관 공지 사항 목록 조회 API
   * @param {TermsApiTermNoticesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  termNoticesGet(
    requestParameters?: TermsApiTermNoticesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTermNoticeList>;

  /**
   * 약관 공지 사항 상세 조회 API
   * @summary 약관 공지 사항 상세 조회 API
   * @param {TermsApiTermNoticesTermNoticeSeqGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  termNoticesTermNoticeSeqGet(
    requestParameters: TermsApiTermNoticesTermNoticeSeqGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTermNotice>;

  /**
   * 약관 조회 API. 약관 상세정보와 약관명을 기준으로 버전 리스트를 반환하며, version 생략시 최신 버전의 약관을 반환
   * @summary 약관 조회 API
   * @param {TermsApiTermsTermCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  termsTermCodeGet(
    requestParameters: TermsApiTermsTermCodeGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTermWithVersions>;
}

/**
 * Request parameters for termNoticesGet operation in TermsApi.
 */
export interface TermsApiTermNoticesGetRequest {
  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;
}

/**
 * Request parameters for termNoticesTermNoticeSeqGet operation in TermsApi.
 */
export interface TermsApiTermNoticesTermNoticeSeqGetRequest {
  /**
   * 약관공지 seq
   */
  readonly termNoticeSeq: number;
}

/**
 * Request parameters for termsTermCodeGet operation in TermsApi.
 */
export interface TermsApiTermsTermCodeGetRequest {
  /**
   * 약관명
   */
  readonly termCode: string;

  /**
   * version
   */
  readonly version?: number;
}

/**
 * TermsApi - object-oriented interface
 */
export class TermsApi extends BaseAPI implements TermsApiInterface {
  /**
   * 약관 공지 사항 목록조회 API
   * @summary 약관 공지 사항 목록 조회 API
   * @param {TermsApiTermNoticesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termNoticesGet(
    requestParameters: TermsApiTermNoticesGetRequest = {},
    options?: RawAxiosRequestConfig,
  ) {
    return TermsApiFp(this.configuration)
      .termNoticesGet(requestParameters.size, requestParameters.offset, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 약관 공지 사항 상세 조회 API
   * @summary 약관 공지 사항 상세 조회 API
   * @param {TermsApiTermNoticesTermNoticeSeqGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termNoticesTermNoticeSeqGet(
    requestParameters: TermsApiTermNoticesTermNoticeSeqGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TermsApiFp(this.configuration)
      .termNoticesTermNoticeSeqGet(requestParameters.termNoticeSeq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 약관 조회 API. 약관 상세정보와 약관명을 기준으로 버전 리스트를 반환하며, version 생략시 최신 버전의 약관을 반환
   * @summary 약관 조회 API
   * @param {TermsApiTermsTermCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termsTermCodeGet(
    requestParameters: TermsApiTermsTermCodeGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TermsApiFp(this.configuration)
      .termsTermCodeGet(requestParameters.termCode, requestParameters.version, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * TranslationApi - axios parameter creator
 */
export const TranslationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 제공되는 언어 목록 조회
     * @summary 제공되는 언어 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TranslationLanguagesGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/account/v1/translation/languages`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 content 삭제
     * @summary 다국어 content 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} contentId translation content id, maxLength&#x3D;255
     * @param {string} languageCode language_code (ko,en), length&#x3D;2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete: async (
      xAuthToken: string,
      contentId: string,
      languageCode: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'contentId' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete',
        'contentId',
        contentId,
      );
      // verify required parameter 'languageCode' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete',
        'languageCode',
        languageCode,
      );
      const localVarPath = `/api/v1/translation/contents/{content_id}/languages/{language_code}`
        .replace('{content_id}', encodeURIComponent(String(contentId)))
        .replace('{language_code}', encodeURIComponent(String(languageCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 content 조회
     * @summary 다국어 content 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} contentId translation content id, maxLength&#x3D;255
     * @param {string} languageCode language_code (ko,en), length&#x3D;2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsContentIdLanguagesLanguageCodeGet: async (
      xAuthToken: string,
      contentId: string,
      languageCode: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodeGet',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'contentId' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodeGet',
        'contentId',
        contentId,
      );
      // verify required parameter 'languageCode' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodeGet',
        'languageCode',
        languageCode,
      );
      const localVarPath = `/api/v1/translation/contents/{content_id}/languages/{language_code}`
        .replace('{content_id}', encodeURIComponent(String(contentId)))
        .replace('{language_code}', encodeURIComponent(String(languageCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 content 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 다국어 content 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} contentId translation content id, maxLength&#x3D;255
     * @param {string} languageCode language_code (ko,en), length&#x3D;2
     * @param {RequestTranslationContentUpdateRequest} translationContentUpdateRequest 다국어 content 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsContentIdLanguagesLanguageCodePut: async (
      xAuthToken: string,
      contentId: string,
      languageCode: string,
      translationContentUpdateRequest: RequestTranslationContentUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodePut',
        'xAuthToken',
        xAuthToken,
      );
      // verify required parameter 'contentId' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodePut',
        'contentId',
        contentId,
      );
      // verify required parameter 'languageCode' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodePut',
        'languageCode',
        languageCode,
      );
      // verify required parameter 'translationContentUpdateRequest' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsContentIdLanguagesLanguageCodePut',
        'translationContentUpdateRequest',
        translationContentUpdateRequest,
      );
      const localVarPath = `/api/v1/translation/contents/{content_id}/languages/{language_code}`
        .replace('{content_id}', encodeURIComponent(String(contentId)))
        .replace('{language_code}', encodeURIComponent(String(languageCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        translationContentUpdateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 contents 목록 조회
     * @summary 다국어 contents 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [languageCode] language_code (ko,en)
     * @param {string} [contentId] translation content id
     * @param {boolean} [idLike] true 인 경우 id 검색 시 like 검색. false 인 경우 id equal 검색
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsGet: async (
      xAuthToken: string,
      size?: number,
      offset?: number,
      languageCode?: string,
      contentId?: string,
      idLike?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1TranslationContentsGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/translation/contents`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (languageCode !== undefined) {
        localVarQueryParameter['language_code'] = languageCode;
      }

      if (contentId !== undefined) {
        localVarQueryParameter['content_id'] = contentId;
      }

      if (idLike !== undefined) {
        localVarQueryParameter['id_like'] = idLike;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 content source (ko) json 추출
     * @summary 다국어 content source (ko) json 추출
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsJsonGet: async (
      xAuthToken: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1TranslationContentsJsonGet', 'xAuthToken', xAuthToken);
      const localVarPath = `/api/v1/translation/contents/json`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 contents 번역 결과 반영 (json file)
     * @summary 다국어 contents 번역 결과 반영 (json file)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestTranslationUpdateWithJsonRequest} translationUpdateWithJsonRequest 번역 완료된 다국어 contents 업데이트 반영 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsJsonPost: async (
      xAuthToken: string,
      translationUpdateWithJsonRequest: RequestTranslationUpdateWithJsonRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1TranslationContentsJsonPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'translationUpdateWithJsonRequest' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsJsonPost',
        'translationUpdateWithJsonRequest',
        translationUpdateWithJsonRequest,
      );
      const localVarPath = `/api/v1/translation/contents/json`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        translationUpdateWithJsonRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 다국어 content 생성
     * @summary 다국어 content 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestTranslationContentCreateRequest} translationContentCreateRequest 다국어 content 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsPost: async (
      xAuthToken: string,
      translationContentCreateRequest: RequestTranslationContentCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1TranslationContentsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'translationContentCreateRequest' is not null or undefined
      assertParamExists(
        'apiV1TranslationContentsPost',
        'translationContentCreateRequest',
        translationContentCreateRequest,
      );
      const localVarPath = `/api/v1/translation/contents`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        translationContentCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TranslationApi - functional programming interface
 */
export const TranslationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TranslationApiAxiosParamCreator(configuration);
  return {
    /**
     * 제공되는 언어 목록 조회
     * @summary 제공되는 언어 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountV1TranslationLanguagesGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProvidedLanguageList>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountV1TranslationLanguagesGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TranslationApi.accountV1TranslationLanguagesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 content 삭제
     * @summary 다국어 content 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} contentId translation content id, maxLength&#x3D;255
     * @param {string} languageCode language_code (ko,en), length&#x3D;2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
      xAuthToken: string,
      contentId: string,
      languageCode: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
          xAuthToken,
          contentId,
          languageCode,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'TranslationApi.apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 content 조회
     * @summary 다국어 content 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} contentId translation content id, maxLength&#x3D;255
     * @param {string} languageCode language_code (ko,en), length&#x3D;2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
      xAuthToken: string,
      contentId: string,
      languageCode: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTranslationContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
          xAuthToken,
          contentId,
          languageCode,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'TranslationApi.apiV1TranslationContentsContentIdLanguagesLanguageCodeGet'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 content 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 다국어 content 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} contentId translation content id, maxLength&#x3D;255
     * @param {string} languageCode language_code (ko,en), length&#x3D;2
     * @param {RequestTranslationContentUpdateRequest} translationContentUpdateRequest 다국어 content 수정 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
      xAuthToken: string,
      contentId: string,
      languageCode: string,
      translationContentUpdateRequest: RequestTranslationContentUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTranslationContent>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
          xAuthToken,
          contentId,
          languageCode,
          translationContentUpdateRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'TranslationApi.apiV1TranslationContentsContentIdLanguagesLanguageCodePut'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 contents 목록 조회
     * @summary 다국어 contents 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {string} [languageCode] language_code (ko,en)
     * @param {string} [contentId] translation content id
     * @param {boolean} [idLike] true 인 경우 id 검색 시 like 검색. false 인 경우 id equal 검색
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsGet(
      xAuthToken: string,
      size?: number,
      offset?: number,
      languageCode?: string,
      contentId?: string,
      idLike?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTranslationContentList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TranslationContentsGet(
        xAuthToken,
        size,
        offset,
        languageCode,
        contentId,
        idLike,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TranslationApi.apiV1TranslationContentsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 content source (ko) json 추출
     * @summary 다국어 content source (ko) json 추출
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsJsonGet(
      xAuthToken: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TranslationContentsJsonGet(
        xAuthToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TranslationApi.apiV1TranslationContentsJsonGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 contents 번역 결과 반영 (json file)
     * @summary 다국어 contents 번역 결과 반영 (json file)
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestTranslationUpdateWithJsonRequest} translationUpdateWithJsonRequest 번역 완료된 다국어 contents 업데이트 반영 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsJsonPost(
      xAuthToken: string,
      translationUpdateWithJsonRequest: RequestTranslationUpdateWithJsonRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TranslationContentsJsonPost(
        xAuthToken,
        translationUpdateWithJsonRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TranslationApi.apiV1TranslationContentsJsonPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 다국어 content 생성
     * @summary 다국어 content 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestTranslationContentCreateRequest} translationContentCreateRequest 다국어 content 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1TranslationContentsPost(
      xAuthToken: string,
      translationContentCreateRequest: RequestTranslationContentCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTranslationContent>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TranslationContentsPost(
        xAuthToken,
        translationContentCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TranslationApi.apiV1TranslationContentsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TranslationApi - factory interface
 */
export const TranslationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TranslationApiFp(configuration);
  return {
    /**
     * 제공되는 언어 목록 조회
     * @summary 제공되는 언어 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountV1TranslationLanguagesGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProvidedLanguageList> {
      return localVarFp
        .accountV1TranslationLanguagesGet(options)
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 content 삭제
     * @summary 다국어 content 삭제
     * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
      requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
          requestParameters.xAuthToken,
          requestParameters.contentId,
          requestParameters.languageCode,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 content 조회
     * @summary 다국어 content 조회
     * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
      requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTranslationContent> {
      return localVarFp
        .apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
          requestParameters.xAuthToken,
          requestParameters.contentId,
          requestParameters.languageCode,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 content 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 다국어 content 수정
     * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
      requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTranslationContent> {
      return localVarFp
        .apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
          requestParameters.xAuthToken,
          requestParameters.contentId,
          requestParameters.languageCode,
          requestParameters.translationContentUpdateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 contents 목록 조회
     * @summary 다국어 contents 목록 조회
     * @param {TranslationApiApiV1TranslationContentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsGet(
      requestParameters: TranslationApiApiV1TranslationContentsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTranslationContentList> {
      return localVarFp
        .apiV1TranslationContentsGet(
          requestParameters.xAuthToken,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.languageCode,
          requestParameters.contentId,
          requestParameters.idLike,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 content source (ko) json 추출
     * @summary 다국어 content source (ko) json 추출
     * @param {TranslationApiApiV1TranslationContentsJsonGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsJsonGet(
      requestParameters: TranslationApiApiV1TranslationContentsJsonGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .apiV1TranslationContentsJsonGet(requestParameters.xAuthToken, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 contents 번역 결과 반영 (json file)
     * @summary 다국어 contents 번역 결과 반영 (json file)
     * @param {TranslationApiApiV1TranslationContentsJsonPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsJsonPost(
      requestParameters: TranslationApiApiV1TranslationContentsJsonPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1TranslationContentsJsonPost(
          requestParameters.xAuthToken,
          requestParameters.translationUpdateWithJsonRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 다국어 content 생성
     * @summary 다국어 content 생성
     * @param {TranslationApiApiV1TranslationContentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1TranslationContentsPost(
      requestParameters: TranslationApiApiV1TranslationContentsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseTranslationContent> {
      return localVarFp
        .apiV1TranslationContentsPost(
          requestParameters.xAuthToken,
          requestParameters.translationContentCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * TranslationApi - interface
 */
export interface TranslationApiInterface {
  /**
   * 제공되는 언어 목록 조회
   * @summary 제공되는 언어 목록 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  accountV1TranslationLanguagesGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProvidedLanguageList>;

  /**
   * 다국어 content 삭제
   * @summary 다국어 content 삭제
   * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
    requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 다국어 content 조회
   * @summary 다국어 content 조회
   * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
    requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTranslationContent>;

  /**
   * 다국어 content 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 다국어 content 수정
   * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
    requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTranslationContent>;

  /**
   * 다국어 contents 목록 조회
   * @summary 다국어 contents 목록 조회
   * @param {TranslationApiApiV1TranslationContentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsGet(
    requestParameters: TranslationApiApiV1TranslationContentsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTranslationContentList>;

  /**
   * 다국어 content source (ko) json 추출
   * @summary 다국어 content source (ko) json 추출
   * @param {TranslationApiApiV1TranslationContentsJsonGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsJsonGet(
    requestParameters: TranslationApiApiV1TranslationContentsJsonGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<{ [key: string]: string }>;

  /**
   * 다국어 contents 번역 결과 반영 (json file)
   * @summary 다국어 contents 번역 결과 반영 (json file)
   * @param {TranslationApiApiV1TranslationContentsJsonPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsJsonPost(
    requestParameters: TranslationApiApiV1TranslationContentsJsonPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 다국어 content 생성
   * @summary 다국어 content 생성
   * @param {TranslationApiApiV1TranslationContentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1TranslationContentsPost(
    requestParameters: TranslationApiApiV1TranslationContentsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseTranslationContent>;
}

/**
 * Request parameters for apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * translation content id, maxLength&#x3D;255
   */
  readonly contentId: string;

  /**
   * language_code (ko,en), length&#x3D;2
   */
  readonly languageCode: string;
}

/**
 * Request parameters for apiV1TranslationContentsContentIdLanguagesLanguageCodeGet operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * translation content id, maxLength&#x3D;255
   */
  readonly contentId: string;

  /**
   * language_code (ko,en), length&#x3D;2
   */
  readonly languageCode: string;
}

/**
 * Request parameters for apiV1TranslationContentsContentIdLanguagesLanguageCodePut operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * translation content id, maxLength&#x3D;255
   */
  readonly contentId: string;

  /**
   * language_code (ko,en), length&#x3D;2
   */
  readonly languageCode: string;

  /**
   * 다국어 content 수정 정보
   */
  readonly translationContentUpdateRequest: RequestTranslationContentUpdateRequest;
}

/**
 * Request parameters for apiV1TranslationContentsGet operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * language_code (ko,en)
   */
  readonly languageCode?: string;

  /**
   * translation content id
   */
  readonly contentId?: string;

  /**
   * true 인 경우 id 검색 시 like 검색. false 인 경우 id equal 검색
   */
  readonly idLike?: boolean;
}

/**
 * Request parameters for apiV1TranslationContentsJsonGet operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsJsonGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;
}

/**
 * Request parameters for apiV1TranslationContentsJsonPost operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsJsonPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 번역 완료된 다국어 contents 업데이트 반영 정보
   */
  readonly translationUpdateWithJsonRequest: RequestTranslationUpdateWithJsonRequest;
}

/**
 * Request parameters for apiV1TranslationContentsPost operation in TranslationApi.
 */
export interface TranslationApiApiV1TranslationContentsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 다국어 content 생성 정보
   */
  readonly translationContentCreateRequest: RequestTranslationContentCreateRequest;
}

/**
 * TranslationApi - object-oriented interface
 */
export class TranslationApi extends BaseAPI implements TranslationApiInterface {
  /**
   * 제공되는 언어 목록 조회
   * @summary 제공되는 언어 목록 조회
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public accountV1TranslationLanguagesGet(options?: RawAxiosRequestConfig) {
    return TranslationApiFp(this.configuration)
      .accountV1TranslationLanguagesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 content 삭제
   * @summary 다국어 content 삭제
   * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
    requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsContentIdLanguagesLanguageCodeDelete(
        requestParameters.xAuthToken,
        requestParameters.contentId,
        requestParameters.languageCode,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 content 조회
   * @summary 다국어 content 조회
   * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
    requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodeGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsContentIdLanguagesLanguageCodeGet(
        requestParameters.xAuthToken,
        requestParameters.contentId,
        requestParameters.languageCode,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 content 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 다국어 content 수정
   * @param {TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
    requestParameters: TranslationApiApiV1TranslationContentsContentIdLanguagesLanguageCodePutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsContentIdLanguagesLanguageCodePut(
        requestParameters.xAuthToken,
        requestParameters.contentId,
        requestParameters.languageCode,
        requestParameters.translationContentUpdateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 contents 목록 조회
   * @summary 다국어 contents 목록 조회
   * @param {TranslationApiApiV1TranslationContentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsGet(
    requestParameters: TranslationApiApiV1TranslationContentsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsGet(
        requestParameters.xAuthToken,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.languageCode,
        requestParameters.contentId,
        requestParameters.idLike,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 content source (ko) json 추출
   * @summary 다국어 content source (ko) json 추출
   * @param {TranslationApiApiV1TranslationContentsJsonGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsJsonGet(
    requestParameters: TranslationApiApiV1TranslationContentsJsonGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsJsonGet(requestParameters.xAuthToken, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 contents 번역 결과 반영 (json file)
   * @summary 다국어 contents 번역 결과 반영 (json file)
   * @param {TranslationApiApiV1TranslationContentsJsonPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsJsonPost(
    requestParameters: TranslationApiApiV1TranslationContentsJsonPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsJsonPost(
        requestParameters.xAuthToken,
        requestParameters.translationUpdateWithJsonRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 다국어 content 생성
   * @summary 다국어 content 생성
   * @param {TranslationApiApiV1TranslationContentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1TranslationContentsPost(
    requestParameters: TranslationApiApiV1TranslationContentsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TranslationApiFp(this.configuration)
      .apiV1TranslationContentsPost(
        requestParameters.xAuthToken,
        requestParameters.translationContentCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 사용자 대량 생성
     * @summary 사용자 대량 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudUserBulkCreateRequest} userCreateRequest 대량 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11UsersBulkCreatePost: async (
      xAuthToken: string,
      userCreateRequest: RequestCloudUserBulkCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11UsersBulkCreatePost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userCreateRequest' is not null or undefined
      assertParamExists('apiV11UsersBulkCreatePost', 'userCreateRequest', userCreateRequest);
      const localVarPath = `/api/v1_1/users/bulk_create`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자가 속한 그룹 목록 조회
     * @summary 사용자가 속한 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} [id] search by group id, 영소문자+숫자 32자
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0인 경우 전체 반환
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11UsersUserIdGroupsGet: async (
      xAuthToken: string,
      userId: string,
      id?: string,
      name?: string,
      offset?: number,
      size?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11UsersUserIdGroupsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV11UsersUserIdGroupsGet', 'userId', userId);
      const localVarPath = `/api/v1_1/users/{user_id}/groups`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자가 접근 가능한 role을 가진 Project 목록 조회.(오직 billing-viewer role만을 가지고 있는 Project 제외) Deprecated: 도메인 상속 프로젝트가 누락된다. GET /api/v1_2/users/{user_id}/projects 로 대체되었다.
     * @summary 사용자가 접근 가능한 role을 가진 Project 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부
     * @param {boolean} [excludeGroup] 그룹으로 인해 소속되는 Project 제외여부
     * @param {string} [id] search by project id, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV11UsersUserIdProjectsGet: async (
      xAuthToken: string,
      userId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      excludeGroup?: boolean,
      id?: string,
      name?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV11UsersUserIdProjectsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV11UsersUserIdProjectsGet', 'userId', userId);
      const localVarPath = `/api/v1_1/users/{user_id}/projects`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      if (excludeGroup !== undefined) {
        localVarQueryParameter['exclude_group'] = excludeGroup;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 실효 프로젝트 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
     * @summary 사용자의 실효 프로젝트 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부
     * @param {string} [id] search by project id, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {string} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12UsersUserIdProjectsGet: async (
      xAuthToken: string,
      userId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      id?: string,
      name?: string,
      actorType?: string,
      inherited?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV12UsersUserIdProjectsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV12UsersUserIdProjectsGet', 'userId', userId);
      const localVarPath = `/api/v1_2/users/{user_id}/projects`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      if (includeDisabled !== undefined) {
        localVarQueryParameter['include_disabled'] = includeDisabled;
      }

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (actorType !== undefined) {
        localVarQueryParameter['actor_type'] = actorType;
      }

      if (inherited !== undefined) {
        localVarQueryParameter['inherited'] = inherited;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userName UserName, 이메일 사용 가능 문자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersNameUserNameHead: async (
      xAuthToken: string,
      domainId: string,
      userName: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameUserNameHead', 'xAuthToken', xAuthToken);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameUserNameHead', 'domainId', domainId);
      // verify required parameter 'userName' is not null or undefined
      assertParamExists('apiV1DomainsDomainIdUsersNameUserNameHead', 'userName', userName);
      const localVarPath = `/api/v1/domains/{domain_id}/users/name/{user_name}`
        .replace('{domain_id}', encodeURIComponent(String(domainId)))
        .replace('{user_name}', encodeURIComponent(String(userName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 대량 삭제
     * @summary 사용자 대량 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} userIds 삭제할 User Id 목록, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersBulkDeleteDelete: async (
      xAuthToken: string,
      userIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersBulkDeleteDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userIds' is not null or undefined
      assertParamExists('apiV1UsersBulkDeleteDelete', 'userIds', userIds);
      const localVarPath = `/api/v1/users/bulk_delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userIds) {
        localVarQueryParameter['user_ids'] = userIds;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 복수 사용자 상세 정보 조회. id가 존재하지 않거나 해당 유저에 대해 조회 권한이 없는 경우 결과를 내려주지 않음. id 가 존재하는 경우 모두 결과를 내려줌 (서비스 계정 포함)
     * @summary 복수 사용자 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestListByIdsRequest} listByIdsRequest ListByIdsRequest, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersListDetailsPost: async (
      xAuthToken: string,
      listByIdsRequest: RequestListByIdsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersListDetailsPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'listByIdsRequest' is not null or undefined
      assertParamExists('apiV1UsersListDetailsPost', 'listByIdsRequest', listByIdsRequest);
      const localVarPath = `/api/v1/users/list-details`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        listByIdsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 생성 아이디(Name): 이메일 형식만 가능 이름(RealName) 및 닉네임(NickName): 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용 휴대전화 번호(Telephone): 국제번호를 포함해 하이픈이 없는 형태만 가능 (ex. 821012345678)
     * @summary 사용자 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudUserCreateRequest} userCreateRequest 사용자 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersPost: async (
      xAuthToken: string,
      userCreateRequest: RequestCloudUserCreateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userCreateRequest' is not null or undefined
      assertParamExists('apiV1UsersPost', 'userCreateRequest', userCreateRequest);
      const localVarPath = `/api/v1/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userCreateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
     * @summary 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestReinviteRequest} reinviteRequest users to reinvite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersReinvitePost: async (
      xAuthToken: string,
      reinviteRequest: RequestReinviteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersReinvitePost', 'xAuthToken', xAuthToken);
      // verify required parameter 'reinviteRequest' is not null or undefined
      assertParamExists('apiV1UsersReinvitePost', 'reinviteRequest', reinviteRequest);
      const localVarPath = `/api/v1/users/reinvite`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        reinviteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 삭제
     * @summary 사용자 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdDelete: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdDelete', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 신규 API 는 같은 범위(직접+그룹 경유)를 반환하면서 부여 경로와 role 표시 정보를 함께 제공한다. 사용자가 가진 domain 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함).
     * @summary [Deprecated] 사용자가 가진 조직 권한 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1UsersUserIdDomainsDomainIdRolesGet: async (
      xAuthToken: string,
      userId: string,
      domainId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdDomainsDomainIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdDomainsDomainIdRolesGet', 'userId', userId);
      // verify required parameter 'domainId' is not null or undefined
      assertParamExists('apiV1UsersUserIdDomainsDomainIdRolesGet', 'domainId', domainId);
      const localVarPath = `/api/v1/users/{user_id}/domains/{domain_id}/roles`
        .replace('{user_id}', encodeURIComponent(String(userId)))
        .replace('{domain_id}', encodeURIComponent(String(domainId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자가 접근 가능한 domain 목록 조회. 도메인에 상속(inherited) 으로만 권한을 부여받은 사용자도 하위 프로젝트에 접근 가능하므로 목록에 포함된다.
     * @summary 사용자가 접근 가능한 domain 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {ApiV1UsersUserIdDomainsGetEnabledEnum} [enabled] domain 활성화 여부. 미지정 시 필터 없음
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdDomainsGet: async (
      xAuthToken: string,
      userId: string,
      enabled?: ApiV1UsersUserIdDomainsGetEnabledEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdDomainsGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdDomainsGet', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}/domains`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (enabled !== undefined) {
        localVarQueryParameter['enabled'] = enabled;
      }

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 상세 정보 조회
     * @summary 사용자 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdGet: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdGet', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자를 여러 그룹에서 삭제
     * @summary 사용자를 여러 그룹에서 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {Array<string>} groupIds Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdGroupsDelete: async (
      xAuthToken: string,
      userId: string,
      groupIds: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdGroupsDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdGroupsDelete', 'userId', userId);
      // verify required parameter 'groupIds' is not null or undefined
      assertParamExists('apiV1UsersUserIdGroupsDelete', 'groupIds', groupIds);
      const localVarPath = `/api/v1/users/{user_id}/groups`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (groupIds) {
        localVarQueryParameter['group_ids'] = groupIds;
      }

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자를 여러 그룹에 등록
     * @summary 사용자를 여러 그룹에 등록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestAddUserToGroupsRequest} groupIds Group IDs, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdGroupsPut: async (
      xAuthToken: string,
      userId: string,
      groupIds: RequestAddUserToGroupsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdGroupsPut', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdGroupsPut', 'userId', userId);
      // verify required parameter 'groupIds' is not null or undefined
      assertParamExists('apiV1UsersUserIdGroupsPut', 'groupIds', groupIds);
      const localVarPath = `/api/v1/users/{user_id}/groups`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        groupIds,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 유저 OTP 삭제
     * @summary 유저 OTP 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdOtpDelete: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpDelete', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpDelete', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}/otp`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 유저 OTP 활성화
     * @summary 유저 OTP 활성화
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestValidateOtpRequest} validateOtpRequest ValidateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdOtpEnablePost: async (
      xAuthToken: string,
      userId: string,
      validateOtpRequest: RequestValidateOtpRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpEnablePost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpEnablePost', 'userId', userId);
      // verify required parameter 'validateOtpRequest' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpEnablePost', 'validateOtpRequest', validateOtpRequest);
      const localVarPath = `/api/v1/users/{user_id}/otp/enable`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        validateOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 유저 OTP 생성
     * @summary 유저 OTP 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdOtpPost: async (
      xAuthToken: string,
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdOtpPost', 'userId', userId);
      const localVarPath = `/api/v1/users/{user_id}/otp`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자 정보 수정.(enabled 값이 없는 경우 default=false) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) 이름(RealName) 및 닉네임(NickName)의 경우 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용
     * @summary 사용자 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestCloudUserUpdateRequest} user 사용자 정보 수정 내용, 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdPatch: async (
      xAuthToken: string,
      userId: string,
      user: RequestCloudUserUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdPatch', 'userId', userId);
      // verify required parameter 'user' is not null or undefined
      assertParamExists('apiV1UsersUserIdPatch', 'user', user);
      const localVarPath = `/api/v1/users/{user_id}`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        user,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자가 가진 프로젝트 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함, 도메인 상속 미포함). Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
     * @summary 사용자가 가진 프로젝트 권한 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1UsersUserIdProjectsProjectIdRolesGet: async (
      xAuthToken: string,
      userId: string,
      projectId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdProjectsProjectIdRolesGet', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdProjectsProjectIdRolesGet', 'userId', userId);
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('apiV1UsersUserIdProjectsProjectIdRolesGet', 'projectId', projectId);
      const localVarPath = `/api/v1/users/{user_id}/projects/{project_id}/roles`
        .replace('{user_id}', encodeURIComponent(String(userId)))
        .replace('{project_id}', encodeURIComponent(String(projectId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 default project 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 default project 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestDefaultProjectUpdateRequest} user DefaultProjectUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdateDefaultProjectPatch: async (
      xAuthToken: string,
      userId: string,
      user: RequestDefaultProjectUpdateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateDefaultProjectPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateDefaultProjectPatch', 'userId', userId);
      // verify required parameter 'user' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateDefaultProjectPatch', 'user', user);
      const localVarPath = `/api/v1/users/{user_id}/update-default-project`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Accept'] = '*/*';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        user,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestUpdateEmailRequest} updateEmailRequest UpdateEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdateEmailPatch: async (
      xAuthToken: string,
      userId: string,
      updateEmailRequest: RequestUpdateEmailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateEmailPatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateEmailPatch', 'userId', userId);
      // verify required parameter 'updateEmailRequest' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdUpdateEmailPatch',
        'updateEmailRequest',
        updateEmailRequest,
      );
      const localVarPath = `/api/v1/users/{user_id}/update-email`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEmailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
     * @summary 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestSendMfaEmailRequest} sendMfaEmailRequest SendMfaEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdateEmailSendPost: async (
      xAuthToken: string,
      userId: string,
      sendMfaEmailRequest: RequestSendMfaEmailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateEmailSendPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdateEmailSendPost', 'userId', userId);
      // verify required parameter 'sendMfaEmailRequest' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdUpdateEmailSendPost',
        'sendMfaEmailRequest',
        sendMfaEmailRequest,
      );
      const localVarPath = `/api/v1/users/{user_id}/update-email/send`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendMfaEmailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestUpdatePhoneRequest} updatePhoneRequest UpdatePhoneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdatePhonePatch: async (
      xAuthToken: string,
      userId: string,
      updatePhoneRequest: RequestUpdatePhoneRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdatePhonePatch', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdatePhonePatch', 'userId', userId);
      // verify required parameter 'updatePhoneRequest' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdUpdatePhonePatch',
        'updatePhoneRequest',
        updatePhoneRequest,
      );
      const localVarPath = `/api/v1/users/{user_id}/update-phone`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePhoneRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
     * @summary 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestSendMfaAlarmTalkRequest} sendMfaAlarmTalkRequest SendMfaAlarmTalkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdatePhoneSendPost: async (
      xAuthToken: string,
      userId: string,
      sendMfaAlarmTalkRequest: RequestSendMfaAlarmTalkRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xAuthToken' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdatePhoneSendPost', 'xAuthToken', xAuthToken);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiV1UsersUserIdUpdatePhoneSendPost', 'userId', userId);
      // verify required parameter 'sendMfaAlarmTalkRequest' is not null or undefined
      assertParamExists(
        'apiV1UsersUserIdUpdatePhoneSendPost',
        'sendMfaAlarmTalkRequest',
        sendMfaAlarmTalkRequest,
      );
      const localVarPath = `/api/v1/users/{user_id}/update-phone/send`.replace(
        '{user_id}',
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (xAuthToken != null) {
        localVarHeaderParameter['X-Auth-Token'] = String(xAuthToken);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendMfaAlarmTalkRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
  return {
    /**
     * 사용자 대량 생성
     * @summary 사용자 대량 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudUserBulkCreateRequest} userCreateRequest 대량 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11UsersBulkCreatePost(
      xAuthToken: string,
      userCreateRequest: RequestCloudUserBulkCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServersBulkResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11UsersBulkCreatePost(
        xAuthToken,
        userCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV11UsersBulkCreatePost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자가 속한 그룹 목록 조회
     * @summary 사용자가 속한 그룹 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} [id] search by group id, 영소문자+숫자 32자
     * @param {string} [name] group prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {number} [offset] offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
     * @param {number} [size] list size, 0인 경우 전체 반환
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV11UsersUserIdGroupsGet(
      xAuthToken: string,
      userId: string,
      id?: string,
      name?: string,
      offset?: number,
      size?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetGroupListByUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11UsersUserIdGroupsGet(
        xAuthToken,
        userId,
        id,
        name,
        offset,
        size,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV11UsersUserIdGroupsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자가 접근 가능한 role을 가진 Project 목록 조회.(오직 billing-viewer role만을 가지고 있는 Project 제외) Deprecated: 도메인 상속 프로젝트가 누락된다. GET /api/v1_2/users/{user_id}/projects 로 대체되었다.
     * @summary 사용자가 접근 가능한 role을 가진 Project 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부
     * @param {boolean} [excludeGroup] 그룹으로 인해 소속되는 Project 제외여부
     * @param {string} [id] search by project id, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV11UsersUserIdProjectsGet(
      xAuthToken: string,
      userId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      excludeGroup?: boolean,
      id?: string,
      name?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectListByUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV11UsersUserIdProjectsGet(
        xAuthToken,
        userId,
        size,
        offset,
        includeDisabled,
        excludeGroup,
        id,
        name,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV11UsersUserIdProjectsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 실효 프로젝트 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
     * @summary 사용자의 실효 프로젝트 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {number} [size] paging size. 0인 경우 전체 목록 반환
     * @param {number} [offset] paging offset
     * @param {boolean} [includeDisabled] 비활성화 project 포함 여부
     * @param {string} [id] search by project id, 영소문자+숫자 32자
     * @param {string} [name] project prefix search by name, 영대소문자+숫자+특수문자(-)
     * @param {string} [actorType] assignment 주체로 필터링 (user or group), 미지정 시 전체
     * @param {boolean} [inherited] 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV12UsersUserIdProjectsGet(
      xAuthToken: string,
      userId: string,
      size?: number,
      offset?: number,
      includeDisabled?: boolean,
      id?: string,
      name?: string,
      actorType?: string,
      inherited?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseListUserProjectsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV12UsersUserIdProjectsGet(
        xAuthToken,
        userId,
        size,
        offset,
        includeDisabled,
        id,
        name,
        actorType,
        inherited,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV12UsersUserIdProjectsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {string} userName UserName, 이메일 사용 가능 문자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1DomainsDomainIdUsersNameUserNameHead(
      xAuthToken: string,
      domainId: string,
      userName: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1DomainsDomainIdUsersNameUserNameHead(
          xAuthToken,
          domainId,
          userName,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1DomainsDomainIdUsersNameUserNameHead']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 대량 삭제
     * @summary 사용자 대량 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {Array<string>} userIds 삭제할 User Id 목록, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersBulkDeleteDelete(
      xAuthToken: string,
      userIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServersBulkResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersBulkDeleteDelete(
        xAuthToken,
        userIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersBulkDeleteDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 복수 사용자 상세 정보 조회. id가 존재하지 않거나 해당 유저에 대해 조회 권한이 없는 경우 결과를 내려주지 않음. id 가 존재하는 경우 모두 결과를 내려줌 (서비스 계정 포함)
     * @summary 복수 사용자 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestListByIdsRequest} listByIdsRequest ListByIdsRequest, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersListDetailsPost(
      xAuthToken: string,
      listByIdsRequest: RequestListByIdsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserListByIdsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersListDetailsPost(
        xAuthToken,
        listByIdsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersListDetailsPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 생성 아이디(Name): 이메일 형식만 가능 이름(RealName) 및 닉네임(NickName): 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용 휴대전화 번호(Telephone): 국제번호를 포함해 하이픈이 없는 형태만 가능 (ex. 821012345678)
     * @summary 사용자 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestCloudUserCreateRequest} userCreateRequest 사용자 생성 정보
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersPost(
      xAuthToken: string,
      userCreateRequest: RequestCloudUserCreateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUser>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersPost(
        xAuthToken,
        userCreateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
     * @summary 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {RequestReinviteRequest} reinviteRequest users to reinvite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersReinvitePost(
      xAuthToken: string,
      reinviteRequest: RequestReinviteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersReinvitePost(
        xAuthToken,
        reinviteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersReinvitePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 삭제
     * @summary 사용자 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdDelete(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdDelete(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 신규 API 는 같은 범위(직접+그룹 경유)를 반환하면서 부여 경로와 role 표시 정보를 함께 제공한다. 사용자가 가진 domain 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함).
     * @summary [Deprecated] 사용자가 가진 조직 권한 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} domainId Domain ID, 영소문자+숫자 32자 혹은 예외 ID
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdDomainsDomainIdRolesGet(
      xAuthToken: string,
      userId: string,
      domainId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdDomainsDomainIdRolesGet(
          xAuthToken,
          userId,
          domainId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdDomainsDomainIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자가 접근 가능한 domain 목록 조회. 도메인에 상속(inherited) 으로만 권한을 부여받은 사용자도 하위 프로젝트에 접근 가능하므로 목록에 포함된다.
     * @summary 사용자가 접근 가능한 domain 목록 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {ApiV1UsersUserIdDomainsGetEnabledEnum} [enabled] domain 활성화 여부. 미지정 시 필터 없음
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdDomainsGet(
      xAuthToken: string,
      userId: string,
      enabled?: ApiV1UsersUserIdDomainsGetEnabledEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSimpleCloudDomainList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdDomainsGet(
        xAuthToken,
        userId,
        enabled,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdDomainsGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 상세 정보 조회
     * @summary 사용자 상세 정보 조회
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdGet(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUser>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdGet(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자를 여러 그룹에서 삭제
     * @summary 사용자를 여러 그룹에서 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {Array<string>} groupIds Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdGroupsDelete(
      xAuthToken: string,
      userId: string,
      groupIds: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdGroupsDelete(
        xAuthToken,
        userId,
        groupIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdGroupsDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자를 여러 그룹에 등록
     * @summary 사용자를 여러 그룹에 등록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestAddUserToGroupsRequest} groupIds Group IDs, maxLength&#x3D;100, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdGroupsPut(
      xAuthToken: string,
      userId: string,
      groupIds: RequestAddUserToGroupsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdGroupsPut(
        xAuthToken,
        userId,
        groupIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdGroupsPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 유저 OTP 삭제
     * @summary 유저 OTP 삭제
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdOtpDelete(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdOtpDelete(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdOtpDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 유저 OTP 활성화
     * @summary 유저 OTP 활성화
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestValidateOtpRequest} validateOtpRequest ValidateOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdOtpEnablePost(
      xAuthToken: string,
      userId: string,
      validateOtpRequest: RequestValidateOtpRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdOtpEnablePost(
        xAuthToken,
        userId,
        validateOtpRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdOtpEnablePost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 유저 OTP 생성
     * @summary 유저 OTP 생성
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdOtpPost(
      xAuthToken: string,
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGenerateOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdOtpPost(
        xAuthToken,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdOtpPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자 정보 수정.(enabled 값이 없는 경우 default=false) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) 이름(RealName) 및 닉네임(NickName)의 경우 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용
     * @summary 사용자 정보 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestCloudUserUpdateRequest} user 사용자 정보 수정 내용, 값이 입력되지 않을 경우 무조건 default 값으로 수정
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdPatch(
      xAuthToken: string,
      userId: string,
      user: RequestCloudUserUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUser>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdPatch(
        xAuthToken,
        userId,
        user,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자가 가진 프로젝트 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함, 도메인 상속 미포함). Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
     * @summary 사용자가 가진 프로젝트 권한 목록
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {string} projectId Project ID, 영소문자+숫자 32자
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdProjectsProjectIdRolesGet(
      xAuthToken: string,
      userId: string,
      projectId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudRoles>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdProjectsProjectIdRolesGet(
          xAuthToken,
          userId,
          projectId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdProjectsProjectIdRolesGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 default project 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 default project 수정
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestDefaultProjectUpdateRequest} user DefaultProjectUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdUpdateDefaultProjectPatch(
      xAuthToken: string,
      userId: string,
      user: RequestDefaultProjectUpdateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCloudUser>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiV1UsersUserIdUpdateDefaultProjectPatch(
          xAuthToken,
          userId,
          user,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdUpdateDefaultProjectPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestUpdateEmailRequest} updateEmailRequest UpdateEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdUpdateEmailPatch(
      xAuthToken: string,
      userId: string,
      updateEmailRequest: RequestUpdateEmailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdUpdateEmailPatch(
        xAuthToken,
        userId,
        updateEmailRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdUpdateEmailPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
     * @summary 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestSendMfaEmailRequest} sendMfaEmailRequest SendMfaEmailRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdUpdateEmailSendPost(
      xAuthToken: string,
      userId: string,
      sendMfaEmailRequest: RequestSendMfaEmailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdUpdateEmailSendPost(
        xAuthToken,
        userId,
        sendMfaEmailRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdUpdateEmailSendPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestUpdatePhoneRequest} updatePhoneRequest UpdatePhoneRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdUpdatePhonePatch(
      xAuthToken: string,
      userId: string,
      updatePhoneRequest: RequestUpdatePhoneRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdUpdatePhonePatch(
        xAuthToken,
        userId,
        updatePhoneRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdUpdatePhonePatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
     * @summary 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
     * @param {string} xAuthToken authentication token, maxLength&#x3D;256
     * @param {string} userId User ID, 영소문자+숫자 32자
     * @param {RequestSendMfaAlarmTalkRequest} sendMfaAlarmTalkRequest SendMfaAlarmTalkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiV1UsersUserIdUpdatePhoneSendPost(
      xAuthToken: string,
      userId: string,
      sendMfaAlarmTalkRequest: RequestSendMfaAlarmTalkRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersUserIdUpdatePhoneSendPost(
        xAuthToken,
        userId,
        sendMfaAlarmTalkRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.apiV1UsersUserIdUpdatePhoneSendPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UsersApiFp(configuration);
  return {
    /**
     * 사용자 대량 생성
     * @summary 사용자 대량 생성
     * @param {UsersApiApiV11UsersBulkCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11UsersBulkCreatePost(
      requestParameters: UsersApiApiV11UsersBulkCreatePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServersBulkResponse> {
      return localVarFp
        .apiV11UsersBulkCreatePost(
          requestParameters.xAuthToken,
          requestParameters.userCreateRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자가 속한 그룹 목록 조회
     * @summary 사용자가 속한 그룹 목록 조회
     * @param {UsersApiApiV11UsersUserIdGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV11UsersUserIdGroupsGet(
      requestParameters: UsersApiApiV11UsersUserIdGroupsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGetGroupListByUserResponse> {
      return localVarFp
        .apiV11UsersUserIdGroupsGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.id,
          requestParameters.name,
          requestParameters.offset,
          requestParameters.size,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자가 접근 가능한 role을 가진 Project 목록 조회.(오직 billing-viewer role만을 가지고 있는 Project 제외) Deprecated: 도메인 상속 프로젝트가 누락된다. GET /api/v1_2/users/{user_id}/projects 로 대체되었다.
     * @summary 사용자가 접근 가능한 role을 가진 Project 목록 조회
     * @param {UsersApiApiV11UsersUserIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV11UsersUserIdProjectsGet(
      requestParameters: UsersApiApiV11UsersUserIdProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseProjectListByUserResponse> {
      return localVarFp
        .apiV11UsersUserIdProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.includeDisabled,
          requestParameters.excludeGroup,
          requestParameters.id,
          requestParameters.name,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 실효 프로젝트 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
     * @summary 사용자의 실효 프로젝트 목록 조회
     * @param {UsersApiApiV12UsersUserIdProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV12UsersUserIdProjectsGet(
      requestParameters: UsersApiApiV12UsersUserIdProjectsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseListUserProjectsResponse> {
      return localVarFp
        .apiV12UsersUserIdProjectsGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.size,
          requestParameters.offset,
          requestParameters.includeDisabled,
          requestParameters.id,
          requestParameters.name,
          requestParameters.actorType,
          requestParameters.inherited,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
     * @summary domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인.
     * @param {UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1DomainsDomainIdUsersNameUserNameHead(
      requestParameters: UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1DomainsDomainIdUsersNameUserNameHead(
          requestParameters.xAuthToken,
          requestParameters.domainId,
          requestParameters.userName,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 대량 삭제
     * @summary 사용자 대량 삭제
     * @param {UsersApiApiV1UsersBulkDeleteDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersBulkDeleteDelete(
      requestParameters: UsersApiApiV1UsersBulkDeleteDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServersBulkResponse> {
      return localVarFp
        .apiV1UsersBulkDeleteDelete(
          requestParameters.xAuthToken,
          requestParameters.userIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 복수 사용자 상세 정보 조회. id가 존재하지 않거나 해당 유저에 대해 조회 권한이 없는 경우 결과를 내려주지 않음. id 가 존재하는 경우 모두 결과를 내려줌 (서비스 계정 포함)
     * @summary 복수 사용자 상세 정보 조회
     * @param {UsersApiApiV1UsersListDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersListDetailsPost(
      requestParameters: UsersApiApiV1UsersListDetailsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseUserListByIdsResponse> {
      return localVarFp
        .apiV1UsersListDetailsPost(
          requestParameters.xAuthToken,
          requestParameters.listByIdsRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 생성 아이디(Name): 이메일 형식만 가능 이름(RealName) 및 닉네임(NickName): 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용 휴대전화 번호(Telephone): 국제번호를 포함해 하이픈이 없는 형태만 가능 (ex. 821012345678)
     * @summary 사용자 생성
     * @param {UsersApiApiV1UsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersPost(
      requestParameters: UsersApiApiV1UsersPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUser> {
      return localVarFp
        .apiV1UsersPost(requestParameters.xAuthToken, requestParameters.userCreateRequest, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
     * @summary 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
     * @param {UsersApiApiV1UsersReinvitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersReinvitePost(
      requestParameters: UsersApiApiV1UsersReinvitePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersReinvitePost(
          requestParameters.xAuthToken,
          requestParameters.reinviteRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 삭제
     * @summary 사용자 삭제
     * @param {UsersApiApiV1UsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdDelete(
      requestParameters: UsersApiApiV1UsersUserIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdDelete(requestParameters.xAuthToken, requestParameters.userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 신규 API 는 같은 범위(직접+그룹 경유)를 반환하면서 부여 경로와 role 표시 정보를 함께 제공한다. 사용자가 가진 domain 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함).
     * @summary [Deprecated] 사용자가 가진 조직 권한 목록
     * @param {UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1UsersUserIdDomainsDomainIdRolesGet(
      requestParameters: UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoles> {
      return localVarFp
        .apiV1UsersUserIdDomainsDomainIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.domainId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자가 접근 가능한 domain 목록 조회. 도메인에 상속(inherited) 으로만 권한을 부여받은 사용자도 하위 프로젝트에 접근 가능하므로 목록에 포함된다.
     * @summary 사용자가 접근 가능한 domain 목록 조회
     * @param {UsersApiApiV1UsersUserIdDomainsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdDomainsGet(
      requestParameters: UsersApiApiV1UsersUserIdDomainsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseSimpleCloudDomainList> {
      return localVarFp
        .apiV1UsersUserIdDomainsGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.enabled,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 상세 정보 조회
     * @summary 사용자 상세 정보 조회
     * @param {UsersApiApiV1UsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdGet(
      requestParameters: UsersApiApiV1UsersUserIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUser> {
      return localVarFp
        .apiV1UsersUserIdGet(requestParameters.xAuthToken, requestParameters.userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자를 여러 그룹에서 삭제
     * @summary 사용자를 여러 그룹에서 삭제
     * @param {UsersApiApiV1UsersUserIdGroupsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdGroupsDelete(
      requestParameters: UsersApiApiV1UsersUserIdGroupsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdGroupsDelete(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.groupIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자를 여러 그룹에 등록
     * @summary 사용자를 여러 그룹에 등록
     * @param {UsersApiApiV1UsersUserIdGroupsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdGroupsPut(
      requestParameters: UsersApiApiV1UsersUserIdGroupsPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdGroupsPut(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.groupIds,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 유저 OTP 삭제
     * @summary 유저 OTP 삭제
     * @param {UsersApiApiV1UsersUserIdOtpDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdOtpDelete(
      requestParameters: UsersApiApiV1UsersUserIdOtpDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdOtpDelete(requestParameters.xAuthToken, requestParameters.userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 유저 OTP 활성화
     * @summary 유저 OTP 활성화
     * @param {UsersApiApiV1UsersUserIdOtpEnablePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdOtpEnablePost(
      requestParameters: UsersApiApiV1UsersUserIdOtpEnablePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdOtpEnablePost(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.validateOtpRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 유저 OTP 생성
     * @summary 유저 OTP 생성
     * @param {UsersApiApiV1UsersUserIdOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdOtpPost(
      requestParameters: UsersApiApiV1UsersUserIdOtpPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseGenerateOtpResponse> {
      return localVarFp
        .apiV1UsersUserIdOtpPost(requestParameters.xAuthToken, requestParameters.userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자 정보 수정.(enabled 값이 없는 경우 default=false) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) 이름(RealName) 및 닉네임(NickName)의 경우 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용
     * @summary 사용자 정보 수정
     * @param {UsersApiApiV1UsersUserIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdPatch(
      requestParameters: UsersApiApiV1UsersUserIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUser> {
      return localVarFp
        .apiV1UsersUserIdPatch(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.user,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자가 가진 프로젝트 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함, 도메인 상속 미포함). Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
     * @summary 사용자가 가진 프로젝트 권한 목록
     * @param {UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiV1UsersUserIdProjectsProjectIdRolesGet(
      requestParameters: UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudRoles> {
      return localVarFp
        .apiV1UsersUserIdProjectsProjectIdRolesGet(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.projectId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 default project 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 사용자의 default project 수정
     * @param {UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdateDefaultProjectPatch(
      requestParameters: UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ResponseCloudUser> {
      return localVarFp
        .apiV1UsersUserIdUpdateDefaultProjectPatch(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.user,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경
     * @param {UsersApiApiV1UsersUserIdUpdateEmailPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdateEmailPatch(
      requestParameters: UsersApiApiV1UsersUserIdUpdateEmailPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdUpdateEmailPatch(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.updateEmailRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
     * @summary 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
     * @param {UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdateEmailSendPost(
      requestParameters: UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdUpdateEmailSendPost(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.sendMfaEmailRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
     * @summary 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경
     * @param {UsersApiApiV1UsersUserIdUpdatePhonePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdatePhonePatch(
      requestParameters: UsersApiApiV1UsersUserIdUpdatePhonePatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdUpdatePhonePatch(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.updatePhoneRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     * 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
     * @summary 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
     * @param {UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV1UsersUserIdUpdatePhoneSendPost(
      requestParameters: UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiV1UsersUserIdUpdatePhoneSendPost(
          requestParameters.xAuthToken,
          requestParameters.userId,
          requestParameters.sendMfaAlarmTalkRequest,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - interface
 */
export interface UsersApiInterface {
  /**
   * 사용자 대량 생성
   * @summary 사용자 대량 생성
   * @param {UsersApiApiV11UsersBulkCreatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11UsersBulkCreatePost(
    requestParameters: UsersApiApiV11UsersBulkCreatePostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ServersBulkResponse>;

  /**
   * 사용자가 속한 그룹 목록 조회
   * @summary 사용자가 속한 그룹 목록 조회
   * @param {UsersApiApiV11UsersUserIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV11UsersUserIdGroupsGet(
    requestParameters: UsersApiApiV11UsersUserIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGetGroupListByUserResponse>;

  /**
   * 사용자가 접근 가능한 role을 가진 Project 목록 조회.(오직 billing-viewer role만을 가지고 있는 Project 제외) Deprecated: 도메인 상속 프로젝트가 누락된다. GET /api/v1_2/users/{user_id}/projects 로 대체되었다.
   * @summary 사용자가 접근 가능한 role을 가진 Project 목록 조회
   * @param {UsersApiApiV11UsersUserIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV11UsersUserIdProjectsGet(
    requestParameters: UsersApiApiV11UsersUserIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseProjectListByUserResponse>;

  /**
   * 사용자의 실효 프로젝트 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
   * @summary 사용자의 실효 프로젝트 목록 조회
   * @param {UsersApiApiV12UsersUserIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV12UsersUserIdProjectsGet(
    requestParameters: UsersApiApiV12UsersUserIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseListUserProjectsResponse>;

  /**
   * domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
   * @summary domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인.
   * @param {UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1DomainsDomainIdUsersNameUserNameHead(
    requestParameters: UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자 대량 삭제
   * @summary 사용자 대량 삭제
   * @param {UsersApiApiV1UsersBulkDeleteDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersBulkDeleteDelete(
    requestParameters: UsersApiApiV1UsersBulkDeleteDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ServersBulkResponse>;

  /**
   * 복수 사용자 상세 정보 조회. id가 존재하지 않거나 해당 유저에 대해 조회 권한이 없는 경우 결과를 내려주지 않음. id 가 존재하는 경우 모두 결과를 내려줌 (서비스 계정 포함)
   * @summary 복수 사용자 상세 정보 조회
   * @param {UsersApiApiV1UsersListDetailsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersListDetailsPost(
    requestParameters: UsersApiApiV1UsersListDetailsPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseUserListByIdsResponse>;

  /**
   * 사용자 생성 아이디(Name): 이메일 형식만 가능 이름(RealName) 및 닉네임(NickName): 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용 휴대전화 번호(Telephone): 국제번호를 포함해 하이픈이 없는 형태만 가능 (ex. 821012345678)
   * @summary 사용자 생성
   * @param {UsersApiApiV1UsersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersPost(
    requestParameters: UsersApiApiV1UsersPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUser>;

  /**
   * 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
   * @summary 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
   * @param {UsersApiApiV1UsersReinvitePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersReinvitePost(
    requestParameters: UsersApiApiV1UsersReinvitePostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자 삭제
   * @summary 사용자 삭제
   * @param {UsersApiApiV1UsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdDelete(
    requestParameters: UsersApiApiV1UsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 신규 API 는 같은 범위(직접+그룹 경유)를 반환하면서 부여 경로와 role 표시 정보를 함께 제공한다. 사용자가 가진 domain 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함).
   * @summary [Deprecated] 사용자가 가진 조직 권한 목록
   * @param {UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1UsersUserIdDomainsDomainIdRolesGet(
    requestParameters: UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoles>;

  /**
   * 사용자가 접근 가능한 domain 목록 조회. 도메인에 상속(inherited) 으로만 권한을 부여받은 사용자도 하위 프로젝트에 접근 가능하므로 목록에 포함된다.
   * @summary 사용자가 접근 가능한 domain 목록 조회
   * @param {UsersApiApiV1UsersUserIdDomainsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdDomainsGet(
    requestParameters: UsersApiApiV1UsersUserIdDomainsGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseSimpleCloudDomainList>;

  /**
   * 사용자 상세 정보 조회
   * @summary 사용자 상세 정보 조회
   * @param {UsersApiApiV1UsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdGet(
    requestParameters: UsersApiApiV1UsersUserIdGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUser>;

  /**
   * 사용자를 여러 그룹에서 삭제
   * @summary 사용자를 여러 그룹에서 삭제
   * @param {UsersApiApiV1UsersUserIdGroupsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdGroupsDelete(
    requestParameters: UsersApiApiV1UsersUserIdGroupsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자를 여러 그룹에 등록
   * @summary 사용자를 여러 그룹에 등록
   * @param {UsersApiApiV1UsersUserIdGroupsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdGroupsPut(
    requestParameters: UsersApiApiV1UsersUserIdGroupsPutRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 유저 OTP 삭제
   * @summary 유저 OTP 삭제
   * @param {UsersApiApiV1UsersUserIdOtpDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdOtpDelete(
    requestParameters: UsersApiApiV1UsersUserIdOtpDeleteRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 유저 OTP 활성화
   * @summary 유저 OTP 활성화
   * @param {UsersApiApiV1UsersUserIdOtpEnablePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdOtpEnablePost(
    requestParameters: UsersApiApiV1UsersUserIdOtpEnablePostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 유저 OTP 생성
   * @summary 유저 OTP 생성
   * @param {UsersApiApiV1UsersUserIdOtpPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdOtpPost(
    requestParameters: UsersApiApiV1UsersUserIdOtpPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseGenerateOtpResponse>;

  /**
   * 사용자 정보 수정.(enabled 값이 없는 경우 default=false) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) 이름(RealName) 및 닉네임(NickName)의 경우 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용
   * @summary 사용자 정보 수정
   * @param {UsersApiApiV1UsersUserIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdPatch(
    requestParameters: UsersApiApiV1UsersUserIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUser>;

  /**
   * 사용자가 가진 프로젝트 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함, 도메인 상속 미포함). Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
   * @summary 사용자가 가진 프로젝트 권한 목록
   * @param {UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  apiV1UsersUserIdProjectsProjectIdRolesGet(
    requestParameters: UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudRoles>;

  /**
   * 사용자의 default project 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자의 default project 수정
   * @param {UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdUpdateDefaultProjectPatch(
    requestParameters: UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<ResponseCloudUser>;

  /**
   * 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경
   * @param {UsersApiApiV1UsersUserIdUpdateEmailPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdUpdateEmailPatch(
    requestParameters: UsersApiApiV1UsersUserIdUpdateEmailPatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
   * @summary 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
   * @param {UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdUpdateEmailSendPost(
    requestParameters: UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경
   * @param {UsersApiApiV1UsersUserIdUpdatePhonePatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdUpdatePhonePatch(
    requestParameters: UsersApiApiV1UsersUserIdUpdatePhonePatchRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;

  /**
   * 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
   * @summary 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
   * @param {UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  apiV1UsersUserIdUpdatePhoneSendPost(
    requestParameters: UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<void>;
}

/**
 * Request parameters for apiV11UsersBulkCreatePost operation in UsersApi.
 */
export interface UsersApiApiV11UsersBulkCreatePostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 대량 생성 정보
   */
  readonly userCreateRequest: RequestCloudUserBulkCreateRequest;
}

/**
 * Request parameters for apiV11UsersUserIdGroupsGet operation in UsersApi.
 */
export interface UsersApiApiV11UsersUserIdGroupsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * search by group id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * group prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * offset((page-1) * size). row 시작위치, 1 page offset &#x3D; 0 * size, 2 page offset &#x3D; 1 * size...
   */
  readonly offset?: number;

  /**
   * list size, 0인 경우 전체 반환
   */
  readonly size?: number;
}

/**
 * Request parameters for apiV11UsersUserIdProjectsGet operation in UsersApi.
 */
export interface UsersApiApiV11UsersUserIdProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * 비활성화 project 포함 여부
   */
  readonly includeDisabled?: boolean;

  /**
   * 그룹으로 인해 소속되는 Project 제외여부
   */
  readonly excludeGroup?: boolean;

  /**
   * search by project id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * project prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;
}

/**
 * Request parameters for apiV12UsersUserIdProjectsGet operation in UsersApi.
 */
export interface UsersApiApiV12UsersUserIdProjectsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * paging size. 0인 경우 전체 목록 반환
   */
  readonly size?: number;

  /**
   * paging offset
   */
  readonly offset?: number;

  /**
   * 비활성화 project 포함 여부
   */
  readonly includeDisabled?: boolean;

  /**
   * search by project id, 영소문자+숫자 32자
   */
  readonly id?: string;

  /**
   * project prefix search by name, 영대소문자+숫자+특수문자(-)
   */
  readonly name?: string;

  /**
   * assignment 주체로 필터링 (user or group), 미지정 시 전체
   */
  readonly actorType?: string;

  /**
   * 도메인 상속 여부로 필터링 (true: 상속만, false: 직접 할당만), 미지정 시 전체
   */
  readonly inherited?: boolean;
}

/**
 * Request parameters for apiV1DomainsDomainIdUsersNameUserNameHead operation in UsersApi.
 */
export interface UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;

  /**
   * UserName, 이메일 사용 가능 문자
   */
  readonly userName: string;
}

/**
 * Request parameters for apiV1UsersBulkDeleteDelete operation in UsersApi.
 */
export interface UsersApiApiV1UsersBulkDeleteDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 삭제할 User Id 목록, 영소문자+숫자 32자
   */
  readonly userIds: Array<string>;
}

/**
 * Request parameters for apiV1UsersListDetailsPost operation in UsersApi.
 */
export interface UsersApiApiV1UsersListDetailsPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * ListByIdsRequest, 영소문자+숫자 32자
   */
  readonly listByIdsRequest: RequestListByIdsRequest;
}

/**
 * Request parameters for apiV1UsersPost operation in UsersApi.
 */
export interface UsersApiApiV1UsersPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * 사용자 생성 정보
   */
  readonly userCreateRequest: RequestCloudUserCreateRequest;
}

/**
 * Request parameters for apiV1UsersReinvitePost operation in UsersApi.
 */
export interface UsersApiApiV1UsersReinvitePostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * users to reinvite
   */
  readonly reinviteRequest: RequestReinviteRequest;
}

/**
 * Request parameters for apiV1UsersUserIdDelete operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1UsersUserIdDomainsDomainIdRolesGet operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * Domain ID, 영소문자+숫자 32자 혹은 예외 ID
   */
  readonly domainId: string;
}

/**
 * Request parameters for apiV1UsersUserIdDomainsGet operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdDomainsGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * domain 활성화 여부. 미지정 시 필터 없음
   */
  readonly enabled?: ApiV1UsersUserIdDomainsGetEnabledEnum;
}

/**
 * Request parameters for apiV1UsersUserIdGet operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1UsersUserIdGroupsDelete operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdGroupsDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * Group ID, maxLength&#x3D;100, 영소문자+숫자 32자
   */
  readonly groupIds: Array<string>;
}

/**
 * Request parameters for apiV1UsersUserIdGroupsPut operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdGroupsPutRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * Group IDs, maxLength&#x3D;100, 영소문자+숫자 32자
   */
  readonly groupIds: RequestAddUserToGroupsRequest;
}

/**
 * Request parameters for apiV1UsersUserIdOtpDelete operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdOtpDeleteRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1UsersUserIdOtpEnablePost operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdOtpEnablePostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * ValidateOtpRequest
   */
  readonly validateOtpRequest: RequestValidateOtpRequest;
}

/**
 * Request parameters for apiV1UsersUserIdOtpPost operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdOtpPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;
}

/**
 * Request parameters for apiV1UsersUserIdPatch operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * 사용자 정보 수정 내용, 값이 입력되지 않을 경우 무조건 default 값으로 수정
   */
  readonly user: RequestCloudUserUpdateRequest;
}

/**
 * Request parameters for apiV1UsersUserIdProjectsProjectIdRolesGet operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * Project ID, 영소문자+숫자 32자
   */
  readonly projectId: string;
}

/**
 * Request parameters for apiV1UsersUserIdUpdateDefaultProjectPatch operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * DefaultProjectUpdateRequest
   */
  readonly user: RequestDefaultProjectUpdateRequest;
}

/**
 * Request parameters for apiV1UsersUserIdUpdateEmailPatch operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdUpdateEmailPatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * UpdateEmailRequest
   */
  readonly updateEmailRequest: RequestUpdateEmailRequest;
}

/**
 * Request parameters for apiV1UsersUserIdUpdateEmailSendPost operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * SendMfaEmailRequest
   */
  readonly sendMfaEmailRequest: RequestSendMfaEmailRequest;
}

/**
 * Request parameters for apiV1UsersUserIdUpdatePhonePatch operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdUpdatePhonePatchRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * UpdatePhoneRequest
   */
  readonly updatePhoneRequest: RequestUpdatePhoneRequest;
}

/**
 * Request parameters for apiV1UsersUserIdUpdatePhoneSendPost operation in UsersApi.
 */
export interface UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest {
  /**
   * authentication token, maxLength&#x3D;256
   */
  readonly xAuthToken: string;

  /**
   * User ID, 영소문자+숫자 32자
   */
  readonly userId: string;

  /**
   * SendMfaAlarmTalkRequest
   */
  readonly sendMfaAlarmTalkRequest: RequestSendMfaAlarmTalkRequest;
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
  /**
   * 사용자 대량 생성
   * @summary 사용자 대량 생성
   * @param {UsersApiApiV11UsersBulkCreatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11UsersBulkCreatePost(
    requestParameters: UsersApiApiV11UsersBulkCreatePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV11UsersBulkCreatePost(
        requestParameters.xAuthToken,
        requestParameters.userCreateRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자가 속한 그룹 목록 조회
   * @summary 사용자가 속한 그룹 목록 조회
   * @param {UsersApiApiV11UsersUserIdGroupsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV11UsersUserIdGroupsGet(
    requestParameters: UsersApiApiV11UsersUserIdGroupsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV11UsersUserIdGroupsGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.id,
        requestParameters.name,
        requestParameters.offset,
        requestParameters.size,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자가 접근 가능한 role을 가진 Project 목록 조회.(오직 billing-viewer role만을 가지고 있는 Project 제외) Deprecated: 도메인 상속 프로젝트가 누락된다. GET /api/v1_2/users/{user_id}/projects 로 대체되었다.
   * @summary 사용자가 접근 가능한 role을 가진 Project 목록 조회
   * @param {UsersApiApiV11UsersUserIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV11UsersUserIdProjectsGet(
    requestParameters: UsersApiApiV11UsersUserIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV11UsersUserIdProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.includeDisabled,
        requestParameters.excludeGroup,
        requestParameters.id,
        requestParameters.name,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 실효 프로젝트 목록 조회. (직접 할당 + 그룹 경유 + 도메인 상속 포함) 콘솔 노출 대상 role(kic_role_extra 에 project scope 로 등록) 할당만 접근 권한으로 인정한다 — project scope 로 등록되지 않은 role 로만 할당된 프로젝트는 제외된다.
   * @summary 사용자의 실효 프로젝트 목록 조회
   * @param {UsersApiApiV12UsersUserIdProjectsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV12UsersUserIdProjectsGet(
    requestParameters: UsersApiApiV12UsersUserIdProjectsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV12UsersUserIdProjectsGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.size,
        requestParameters.offset,
        requestParameters.includeDisabled,
        requestParameters.id,
        requestParameters.name,
        requestParameters.actorType,
        requestParameters.inherited,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인. 존재하는 경우 http status 204, 아닌 경우 404
   * @summary domain내에서 사용자들 중에 동일한 이름을 가지고 있는지 확인.
   * @param {UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1DomainsDomainIdUsersNameUserNameHead(
    requestParameters: UsersApiApiV1DomainsDomainIdUsersNameUserNameHeadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1DomainsDomainIdUsersNameUserNameHead(
        requestParameters.xAuthToken,
        requestParameters.domainId,
        requestParameters.userName,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 대량 삭제
   * @summary 사용자 대량 삭제
   * @param {UsersApiApiV1UsersBulkDeleteDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersBulkDeleteDelete(
    requestParameters: UsersApiApiV1UsersBulkDeleteDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersBulkDeleteDelete(requestParameters.xAuthToken, requestParameters.userIds, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 복수 사용자 상세 정보 조회. id가 존재하지 않거나 해당 유저에 대해 조회 권한이 없는 경우 결과를 내려주지 않음. id 가 존재하는 경우 모두 결과를 내려줌 (서비스 계정 포함)
   * @summary 복수 사용자 상세 정보 조회
   * @param {UsersApiApiV1UsersListDetailsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersListDetailsPost(
    requestParameters: UsersApiApiV1UsersListDetailsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersListDetailsPost(
        requestParameters.xAuthToken,
        requestParameters.listByIdsRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 생성 아이디(Name): 이메일 형식만 가능 이름(RealName) 및 닉네임(NickName): 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용 휴대전화 번호(Telephone): 국제번호를 포함해 하이픈이 없는 형태만 가능 (ex. 821012345678)
   * @summary 사용자 생성
   * @param {UsersApiApiV1UsersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersPost(
    requestParameters: UsersApiApiV1UsersPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersPost(requestParameters.xAuthToken, requestParameters.userCreateRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
   * @summary 아직 인증/가입을 하지 않은 사용자에게 password initialization하는 초대 email 발송.
   * @param {UsersApiApiV1UsersReinvitePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersReinvitePost(
    requestParameters: UsersApiApiV1UsersReinvitePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersReinvitePost(
        requestParameters.xAuthToken,
        requestParameters.reinviteRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 삭제
   * @summary 사용자 삭제
   * @param {UsersApiApiV1UsersUserIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdDelete(
    requestParameters: UsersApiApiV1UsersUserIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdDelete(requestParameters.xAuthToken, requestParameters.userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Deprecated: GET /api/v1_2/domains/{domain_id}/users/{user_id}/roles 를 사용한다. 신규 API 는 같은 범위(직접+그룹 경유)를 반환하면서 부여 경로와 role 표시 정보를 함께 제공한다. 사용자가 가진 domain 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함).
   * @summary [Deprecated] 사용자가 가진 조직 권한 목록
   * @param {UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdDomainsDomainIdRolesGet(
    requestParameters: UsersApiApiV1UsersUserIdDomainsDomainIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdDomainsDomainIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.domainId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자가 접근 가능한 domain 목록 조회. 도메인에 상속(inherited) 으로만 권한을 부여받은 사용자도 하위 프로젝트에 접근 가능하므로 목록에 포함된다.
   * @summary 사용자가 접근 가능한 domain 목록 조회
   * @param {UsersApiApiV1UsersUserIdDomainsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdDomainsGet(
    requestParameters: UsersApiApiV1UsersUserIdDomainsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdDomainsGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.enabled,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 상세 정보 조회
   * @summary 사용자 상세 정보 조회
   * @param {UsersApiApiV1UsersUserIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdGet(
    requestParameters: UsersApiApiV1UsersUserIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdGet(requestParameters.xAuthToken, requestParameters.userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자를 여러 그룹에서 삭제
   * @summary 사용자를 여러 그룹에서 삭제
   * @param {UsersApiApiV1UsersUserIdGroupsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdGroupsDelete(
    requestParameters: UsersApiApiV1UsersUserIdGroupsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdGroupsDelete(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.groupIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자를 여러 그룹에 등록
   * @summary 사용자를 여러 그룹에 등록
   * @param {UsersApiApiV1UsersUserIdGroupsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdGroupsPut(
    requestParameters: UsersApiApiV1UsersUserIdGroupsPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdGroupsPut(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.groupIds,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 유저 OTP 삭제
   * @summary 유저 OTP 삭제
   * @param {UsersApiApiV1UsersUserIdOtpDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdOtpDelete(
    requestParameters: UsersApiApiV1UsersUserIdOtpDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdOtpDelete(requestParameters.xAuthToken, requestParameters.userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 유저 OTP 활성화
   * @summary 유저 OTP 활성화
   * @param {UsersApiApiV1UsersUserIdOtpEnablePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdOtpEnablePost(
    requestParameters: UsersApiApiV1UsersUserIdOtpEnablePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdOtpEnablePost(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.validateOtpRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 유저 OTP 생성
   * @summary 유저 OTP 생성
   * @param {UsersApiApiV1UsersUserIdOtpPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdOtpPost(
    requestParameters: UsersApiApiV1UsersUserIdOtpPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdOtpPost(requestParameters.xAuthToken, requestParameters.userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자 정보 수정.(enabled 값이 없는 경우 default=false) payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨) 이름(RealName) 및 닉네임(NickName)의 경우 1.시작과 끝은 공백이 불가능하며, 2.문자 사이 공백은 1자만 허용
   * @summary 사용자 정보 수정
   * @param {UsersApiApiV1UsersUserIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdPatch(
    requestParameters: UsersApiApiV1UsersUserIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdPatch(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.user,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자가 가진 프로젝트 권한 목록 (그룹을 통해 얻은 권한까지 모두 포함, 도메인 상속 미포함). Deprecated: GET /api/v1_2/projects/{project_id}/users/{user_id}/roles 로 대체되었다.
   * @summary 사용자가 가진 프로젝트 권한 목록
   * @param {UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdProjectsProjectIdRolesGet(
    requestParameters: UsersApiApiV1UsersUserIdProjectsProjectIdRolesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdProjectsProjectIdRolesGet(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.projectId,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 default project 수정 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 사용자의 default project 수정
   * @param {UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdUpdateDefaultProjectPatch(
    requestParameters: UsersApiApiV1UsersUserIdUpdateDefaultProjectPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdUpdateDefaultProjectPatch(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.user,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 연락처 이메일 수정. 인증번호가 발송되었던 이메일로 변경
   * @param {UsersApiApiV1UsersUserIdUpdateEmailPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdUpdateEmailPatch(
    requestParameters: UsersApiApiV1UsersUserIdUpdateEmailPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdUpdateEmailPatch(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.updateEmailRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
   * @summary 사용자의 이메일 수정을 위해 수정하고자 하는 이메일로 인증코드 발송
   * @param {UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdUpdateEmailSendPost(
    requestParameters: UsersApiApiV1UsersUserIdUpdateEmailSendPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdUpdateEmailSendPost(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.sendMfaEmailRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경 payload 내 모든 항목이 필수 (주의 - 빠진 항목은 default 값으로 수정됨)
   * @summary 휴대폰 번호 수정. 인증번호가 발송되었던 번호로 변경
   * @param {UsersApiApiV1UsersUserIdUpdatePhonePatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdUpdatePhonePatch(
    requestParameters: UsersApiApiV1UsersUserIdUpdatePhonePatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdUpdatePhonePatch(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.updatePhoneRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
   * @summary 사용자의 전화번호 수정을 위해 수정하고자 하는 전화번호로 인증코드 발송
   * @param {UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public apiV1UsersUserIdUpdatePhoneSendPost(
    requestParameters: UsersApiApiV1UsersUserIdUpdatePhoneSendPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UsersApiFp(this.configuration)
      .apiV1UsersUserIdUpdatePhoneSendPost(
        requestParameters.xAuthToken,
        requestParameters.userId,
        requestParameters.sendMfaAlarmTalkRequest,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

export const ApiV1UsersUserIdDomainsGetEnabledEnum = {
  True: 'true',
  False: 'false',
} as const;
export type ApiV1UsersUserIdDomainsGetEnabledEnum =
  (typeof ApiV1UsersUserIdDomainsGetEnabledEnum)[keyof typeof ApiV1UsersUserIdDomainsGetEnabledEnum];
